import { createTheme, Stack, IconButton, Avatar, Menu, MenuItem, ListItemIcon, TextField, InputAdornment, Toolbar, Box, MenuList, Typography, styled as styled$1, Button, StepLabel, StepContent, Step, AccordionDetails, AccordionSummary, Paper, List, Link as Link$1 } from '@mui/material';
import { typography as typography$1, colors, spacing, borders, PrivateTokens } from '@loggi/front-design-tokens';
import require$$1, { useState, useCallback, useMemo, useEffect, forwardRef, useRef, createElement, cloneElement, Component, useContext, useLayoutEffect, memo, isValidElement, createContext } from 'react';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _taggedTemplateLiteral from '@babel/runtime/helpers/taggedTemplateLiteral';
import { keyframes } from '@emotion/react';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import styled from '@emotion/styled';
import MuiAppBar from '@mui/material/AppBar';
import PropTypes from 'prop-types';
import MuiChip from '@mui/material/Chip';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import _extends$1 from '@babel/runtime/helpers/extends';
import { createPortal } from 'react-dom';
import MuiDrawer from '@mui/material/Drawer';
import Box$1 from '@mui/material/Box';
import MuiStepper from '@mui/material/Stepper';
import MuiAccordion from '@mui/material/Accordion';
import MuiDialog from '@mui/material/Dialog';
import { styled as styled$2 } from '@mui/material/styles';
import Collapse$1 from '@mui/material/Collapse';

var MuiTypography = {
  defaultProps: {
    variantMapping: {
      // Mapeamento de novas classes tipográficas
      displayLarge: "div",
      displayMedium: "div",
      displaySmall: "div",
      headingExtraLarge: "h1",
      headingLarge: "h2",
      headingMedium: "h3",
      headingSmall: "h4",
      subtitleLarge: "div",
      subtitleMedium: "div",
      subtitleSmall: "div",
      bodyTextLarge: "p",
      bodyTextMedium: "p",
      bodyLinkLarge: "p",
      bodyLinkMedium: "p",
      bodyHighlightLarge: "strong",
      bodyHighlightMedium: "strong",
      supportOverline: "span",
      supportCaption: "span",
      // Desabilitar variantes [MUI]
      h1: undefined,
      h2: undefined,
      h3: undefined,
      h4: undefined,
      h5: undefined,
      h6: undefined,
      subtitle1: undefined,
      subtitle2: undefined,
      body1: undefined,
      body2: undefined,
      button: undefined
    }
  }
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getAugmentedNamespace(n) {
  if (n.__esModule) return n;
  var f = n.default;
	if (typeof f == "function") {
		var a = function a () {
			if (this instanceof a) {
        return Reflect.construct(f, arguments, this.constructor);
			}
			return f.apply(this, arguments);
		};
		a.prototype = f.prototype;
  } else a = {};
  Object.defineProperty(a, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

var dist = {};

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */

var extendStatics = function(d, b) {
  extendStatics = Object.setPrototypeOf ||
      ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
      function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
  return extendStatics(d, b);
};

function __extends(d, b) {
  if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);
  function __() { this.constructor = d; }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
  __assign = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
  };
  return __assign.apply(this, arguments);
};

function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
              t[p[i]] = s[p[i]];
      }
  return t;
}

function __decorate(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
  return function (target, key) { decorator(target, key, paramIndex); }
}

function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
  function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
  var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
  var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
  var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
  var _, done = false;
  for (var i = decorators.length - 1; i >= 0; i--) {
      var context = {};
      for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
      for (var p in contextIn.access) context.access[p] = contextIn.access[p];
      context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
      var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
      if (kind === "accessor") {
          if (result === void 0) continue;
          if (result === null || typeof result !== "object") throw new TypeError("Object expected");
          if (_ = accept(result.get)) descriptor.get = _;
          if (_ = accept(result.set)) descriptor.set = _;
          if (_ = accept(result.init)) initializers.unshift(_);
      }
      else if (_ = accept(result)) {
          if (kind === "field") initializers.unshift(_);
          else descriptor[key] = _;
      }
  }
  if (target) Object.defineProperty(target, contextIn.name, descriptor);
  done = true;
}
function __runInitializers(thisArg, initializers, value) {
  var useValue = arguments.length > 2;
  for (var i = 0; i < initializers.length; i++) {
      value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
  }
  return useValue ? value : void 0;
}
function __propKey(x) {
  return typeof x === "symbol" ? x : "".concat(x);
}
function __setFunctionName(f, name, prefix) {
  if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
  return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
}
function __metadata(metadataKey, metadataValue) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
  return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
      function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
      function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
  function verb(n) { return function (v) { return step([n, v]); }; }
  function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (g && (g = 0, op[0] && (_ = 0)), _) try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
          if (y = 0, t) op = [op[0] & 2, t.value];
          switch (op[0]) {
              case 0: case 1: t = op; break;
              case 4: _.label++; return { value: op[1], done: false };
              case 5: _.label++; y = op[1]; op = [0]; continue;
              case 7: op = _.ops.pop(); _.trys.pop(); continue;
              default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                  if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                  if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                  if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                  if (t[2]) _.ops.pop();
                  _.trys.pop(); continue;
          }
          op = body.call(thisArg, _);
      } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
      if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
  }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
  }
  Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

function __exportStar(m, o) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
      next: function () {
          if (o && i >= o.length) o = void 0;
          return { value: o && o[i++], done: !o };
      }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  }
  catch (error) { e = { error: error }; }
  finally {
      try {
          if (r && !r.done && (m = i["return"])) m.call(i);
      }
      finally { if (e) throw e.error; }
  }
  return ar;
}

/** @deprecated */
function __spread() {
  for (var ar = [], i = 0; i < arguments.length; i++)
      ar = ar.concat(__read(arguments[i]));
  return ar;
}

/** @deprecated */
function __spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++)
      for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
          r[k] = a[j];
  return r;
}

function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
          ar[i] = from[i];
      }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
  return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var g = generator.apply(thisArg, _arguments || []), i, q = [];
  return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
  function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
  function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
  function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
  function fulfill(value) { resume("next", value); }
  function reject(value) { resume("throw", value); }
  function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
  var i, p;
  return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
  function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var m = o[Symbol.asyncIterator], i;
  return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
  function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
  function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
  return cooked;
}
var __setModuleDefault = Object.create ? (function(o, v) {
  Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
  o["default"] = v;
};

function __importStar(mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
}

function __importDefault(mod) {
  return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
  if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
  return typeof state === "function" ? receiver === state : state.has(receiver);
}

function __addDisposableResource(env, value, async) {
  if (value !== null && value !== void 0) {
    if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
    var dispose;
    if (async) {
        if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
        dispose = value[Symbol.asyncDispose];
    }
    if (dispose === void 0) {
        if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
        dispose = value[Symbol.dispose];
    }
    if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
    env.stack.push({ value: value, dispose: dispose, async: async });
  }
  else if (async) {
    env.stack.push({ async: true });
  }
  return value;
}

var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function __disposeResources(env) {
  function fail(e) {
    env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
    env.hasError = true;
  }
  function next() {
    while (env.stack.length) {
      var rec = env.stack.pop();
      try {
        var result = rec.dispose && rec.dispose.call(rec.value);
        if (rec.async) return Promise.resolve(result).then(next, function(e) { fail(e); return next(); });
      }
      catch (e) {
          fail(e);
      }
    }
    if (env.hasError) throw env.error;
  }
  return next();
}

var tslib_es6 = {
  __extends,
  __assign,
  __rest,
  __decorate,
  __param,
  __metadata,
  __awaiter,
  __generator,
  __createBinding,
  __exportStar,
  __values,
  __read,
  __spread,
  __spreadArrays,
  __spreadArray,
  __await,
  __asyncGenerator,
  __asyncDelegator,
  __asyncValues,
  __makeTemplateObject,
  __importStar,
  __importDefault,
  __classPrivateFieldGet,
  __classPrivateFieldSet,
  __classPrivateFieldIn,
  __addDisposableResource,
  __disposeResources,
};

var tslib_es6$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    __addDisposableResource: __addDisposableResource,
    get __assign () { return __assign; },
    __asyncDelegator: __asyncDelegator,
    __asyncGenerator: __asyncGenerator,
    __asyncValues: __asyncValues,
    __await: __await,
    __awaiter: __awaiter,
    __classPrivateFieldGet: __classPrivateFieldGet,
    __classPrivateFieldIn: __classPrivateFieldIn,
    __classPrivateFieldSet: __classPrivateFieldSet,
    __createBinding: __createBinding,
    __decorate: __decorate,
    __disposeResources: __disposeResources,
    __esDecorate: __esDecorate,
    __exportStar: __exportStar,
    __extends: __extends,
    __generator: __generator,
    __importDefault: __importDefault,
    __importStar: __importStar,
    __makeTemplateObject: __makeTemplateObject,
    __metadata: __metadata,
    __param: __param,
    __propKey: __propKey,
    __read: __read,
    __rest: __rest,
    __runInitializers: __runInitializers,
    __setFunctionName: __setFunctionName,
    __spread: __spread,
    __spreadArray: __spreadArray,
    __spreadArrays: __spreadArrays,
    __values: __values,
    default: tslib_es6
});

var require$$0 = /*@__PURE__*/getAugmentedNamespace(tslib_es6$1);

var icons = {};

var web = {};

var ActionArchive01 = {};

var hasRequiredActionArchive01;

function requireActionArchive01 () {
	if (hasRequiredActionArchive01) return ActionArchive01;
	hasRequiredActionArchive01 = 1;
	Object.defineProperty(ActionArchive01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgActionArchive01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M5.333 10.662a3 3 0 0 1-.52-.047A2.67 2.67 0 0 1 2.718 8.52c-.051-.257-.051-.567-.051-1.187s0-.929.051-1.187a2.67 2.67 0 0 1 2.095-2.095C5.071 4 5.381 4 6 4h20c.62 0 .93 0 1.187.051a2.67 2.67 0 0 1 2.095 2.095c.051.258.051.568.051 1.187s0 .93-.05 1.187a2.67 2.67 0 0 1-2.096 2.095 3 3 0 0 1-.52.047m-13.334 6.671h5.334M5.333 10.667h21.334V21.6c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748c-.856.436-1.976.436-4.216.436h-8.534c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748c-.436-.856-.436-1.976-.436-4.216z" }))); };
	ActionArchive01.default = SvgActionArchive01;
	
	return ActionArchive01;
}

var ActionArchive02 = {};

var hasRequiredActionArchive02;

function requireActionArchive02 () {
	if (hasRequiredActionArchive02) return ActionArchive02;
	hasRequiredActionArchive02 = 1;
	Object.defineProperty(ActionArchive02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgActionArchive02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M27.333 10.667V21.6c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748c-.855.436-1.976.436-4.216.436h-9.866c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748c-.436-.856-.436-1.976-.436-4.216V10.667M4.8 4h22.4c.747 0 1.12 0 1.405.145.251.128.455.332.583.583.145.285.145.659.145 1.405v2.4c0 .747 0 1.12-.145 1.406-.128.25-.332.454-.583.582-.285.146-.658.146-1.405.146H4.8c-.747 0-1.12 0-1.405-.146a1.33 1.33 0 0 1-.583-.582c-.145-.286-.145-.659-.145-1.406v-2.4c0-.746 0-1.12.145-1.405.128-.25.332-.455.583-.583C3.68 4 4.053 4 4.8 4m8 11.333h6.4c.747 0 1.12 0 1.405.146.251.128.455.332.583.582.145.286.145.659.145 1.406v1.066c0 .747 0 1.12-.145 1.406-.128.25-.332.454-.583.582-.285.146-.658.146-1.405.146h-6.4c-.747 0-1.12 0-1.405-.146a1.33 1.33 0 0 1-.583-.582c-.145-.286-.145-.659-.145-1.406v-1.066c0-.747 0-1.12.145-1.406.128-.25.332-.454.583-.582.285-.146.658-.146 1.405-.146" }))); };
	ActionArchive02.default = SvgActionArchive02;
	
	return ActionArchive02;
}

var ActionAttach01 = {};

var hasRequiredActionAttach01;

function requireActionAttach01 () {
	if (hasRequiredActionAttach01) return ActionAttach01;
	hasRequiredActionAttach01 = 1;
	Object.defineProperty(ActionAttach01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgActionAttach01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m28.203 14.533-12.02 12.02a7 7 0 1 1-9.9-9.899l12.02-12.02a4.667 4.667 0 1 1 6.6 6.599l-11.549 11.55a2.333 2.333 0 1 1-3.3-3.3L20.19 9.346" }))); };
	ActionAttach01.default = SvgActionAttach01;
	
	return ActionAttach01;
}

var ActionAttach02 = {};

var hasRequiredActionAttach02;

function requireActionAttach02 () {
	if (hasRequiredActionAttach02) return ActionAttach02;
	hasRequiredActionAttach02 = 1;
	Object.defineProperty(ActionAttach02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgActionAttach02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M23.333 7.008V22a7.333 7.333 0 1 1-14.666 0V7.556a4.889 4.889 0 0 1 9.778 0v14.372a2.444 2.444 0 1 1-4.89 0V8.868" }))); };
	ActionAttach02.default = SvgActionAttach02;
	
	return ActionAttach02;
}

var ActionBlock = {};

var hasRequiredActionBlock;

function requireActionBlock () {
	if (hasRequiredActionBlock) return ActionBlock;
	hasRequiredActionBlock = 1;
	Object.defineProperty(ActionBlock, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgActionBlock = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m6.573 6.573 18.854 18.854M29.333 16c0 7.364-5.97 13.333-13.333 13.333S2.667 23.363 2.667 16 8.637 2.667 16 2.667 29.333 8.637 29.333 16" }))); };
	ActionBlock.default = SvgActionBlock;
	
	return ActionBlock;
}

var ActionCheck = {};

var hasRequiredActionCheck;

function requireActionCheck () {
	if (hasRequiredActionCheck) return ActionCheck;
	hasRequiredActionCheck = 1;
	Object.defineProperty(ActionCheck, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgActionCheck = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M26.667 8 12 22.667 5.333 16" }))); };
	ActionCheck.default = SvgActionCheck;
	
	return ActionCheck;
}

var ActionClear01 = {};

var hasRequiredActionClear01;

function requireActionClear01 () {
	if (hasRequiredActionClear01) return ActionClear01;
	hasRequiredActionClear01 = 1;
	Object.defineProperty(ActionClear01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgActionClear01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M24 17.333 14.665 8m13.333 20H10.666m3.916-1.25L26.14 15.192c1.585-1.584 2.377-2.376 2.673-3.29a4 4 0 0 0 0-2.471c-.296-.914-1.088-1.706-2.672-3.29l-.283-.282c-1.584-1.584-2.376-2.376-3.29-2.673a4 4 0 0 0-2.471 0c-.914.297-1.706 1.089-3.29 2.673L5.858 16.808c-1.584 1.584-2.376 2.376-2.673 3.29a4 4 0 0 0 0 2.471c.297.914 1.09 1.706 2.673 3.29l.892.891c.46.462.691.692.96.857.24.146.5.254.771.32.307.073.633.073 1.286.073h1.798c.653 0 .979 0 1.286-.074a2.7 2.7 0 0 0 .77-.319c.27-.165.5-.395.961-.857" }))); };
	ActionClear01.default = SvgActionClear01;
	
	return ActionClear01;
}

var ActionClear02 = {};

var hasRequiredActionClear02;

function requireActionClear02 () {
	if (hasRequiredActionClear02) return ActionClear02;
	hasRequiredActionClear02 = 1;
	Object.defineProperty(ActionClear02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgActionClear02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m22.667 12-8 8m0-8 8 8m-19.04-2.72 5.76 7.68c.469.626.704.939 1.001 1.164.264.2.562.35.88.44.359.103.75.103 1.532.103h10.133c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748c.436-.856.436-1.976.436-4.216v-8.534c0-2.24 0-3.36-.436-4.216A4 4 0 0 0 27.15 5.77c-.855-.436-1.976-.436-4.216-.436H12.8c-.782 0-1.173 0-1.532.103-.318.09-.617.24-.88.44-.297.225-.532.538-1.001 1.164l-5.76 7.68c-.345.46-.517.689-.583.94a1.33 1.33 0 0 0 0 .68c.066.252.238.481.583.94" }))); };
	ActionClear02.default = SvgActionClear02;
	
	return ActionClear02;
}

var ActionClose = {};

var hasRequiredActionClose;

function requireActionClose () {
	if (hasRequiredActionClose) return ActionClose;
	hasRequiredActionClose = 1;
	Object.defineProperty(ActionClose, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgActionClose = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M24 8 8 24M8 8l16 16" }))); };
	ActionClose.default = SvgActionClose;
	
	return ActionClose;
}

var ActionCopy = {};

var hasRequiredActionCopy;

function requireActionCopy () {
	if (hasRequiredActionCopy) return ActionCopy;
	hasRequiredActionCopy = 1;
	Object.defineProperty(ActionCopy, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgActionCopy = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M6.667 20c-1.243 0-1.864 0-2.354-.203a2.67 2.67 0 0 1-1.443-1.443c-.203-.49-.203-1.111-.203-2.354V6.933c0-1.493 0-2.24.29-2.81.256-.502.664-.91 1.166-1.166.57-.29 1.317-.29 2.81-.29H16c1.243 0 1.864 0 2.354.203.653.27 1.172.79 1.443 1.443.203.49.203 1.111.203 2.354m-3.733 22.666h8.8c1.493 0 2.24 0 2.81-.29.502-.256.91-.664 1.166-1.166.29-.57.29-1.317.29-2.81v-8.8c0-1.494 0-2.24-.29-2.81a2.67 2.67 0 0 0-1.166-1.166c-.57-.29-1.317-.29-2.81-.29h-8.8c-1.494 0-2.24 0-2.81.29-.503.255-.91.663-1.166 1.165-.29.57-.29 1.317-.29 2.81v8.8c0 1.494 0 2.241.29 2.811.255.502.663.91 1.165 1.166.57.29 1.317.29 2.81.29" }))); };
	ActionCopy.default = SvgActionCopy;
	
	return ActionCopy;
}

var ActionCut01 = {};

var hasRequiredActionCut01;

function requireActionCut01 () {
	if (hasRequiredActionCut01) return ActionCut01;
	hasRequiredActionCut01 = 1;
	Object.defineProperty(ActionCut01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgActionCut01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m6 11.467 22 11.2m0-13.334-22 11.2M8 4a4 4 0 1 1 0 8 4 4 0 0 1 0-8m0 16a4 4 0 1 1 0 8 4 4 0 0 1 0-8" }))); };
	ActionCut01.default = SvgActionCut01;
	
	return ActionCut01;
}

var ActionCut02 = {};

var hasRequiredActionCut02;

function requireActionCut02 () {
	if (hasRequiredActionCut02) return ActionCut02;
	hasRequiredActionCut02 = 1;
	Object.defineProperty(ActionCut02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgActionCut02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m6 11.467 22 11.2m0-13.334-22 11.2M23.333 16h.014m5.986 0h.014M8 4a4 4 0 1 1 0 8 4 4 0 0 1 0-8m0 16a4 4 0 1 1 0 8 4 4 0 0 1 0-8" }))); };
	ActionCut02.default = SvgActionCut02;
	
	return ActionCut02;
}

var ActionEdit01 = {};

var hasRequiredActionEdit01;

function requireActionEdit01 () {
	if (hasRequiredActionEdit01) return ActionEdit01;
	hasRequiredActionEdit01 = 1;
	Object.defineProperty(ActionEdit01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgActionEdit01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M3.835 24.154c.06-.551.092-.827.175-1.084q.112-.345.31-.647c.15-.226.346-.422.738-.815L22.667 4A3.771 3.771 0 0 1 28 9.333L10.392 26.942c-.393.392-.589.588-.815.737q-.302.2-.647.311c-.257.084-.533.114-1.084.175l-4.513.502z" }))); };
	ActionEdit01.default = SvgActionEdit01;
	
	return ActionEdit01;
}

var ActionEdit02 = {};

var hasRequiredActionEdit02;

function requireActionEdit02 () {
	if (hasRequiredActionEdit02) return ActionEdit02;
	hasRequiredActionEdit02 = 1;
	Object.defineProperty(ActionEdit02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgActionEdit02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M16 26.667h12m-24 0h2.233c.652 0 .978 0 1.285-.074.272-.065.532-.173.77-.32.27-.164.5-.395.962-.856L26 8.667a2.828 2.828 0 1 0-4-4L5.25 21.417c-.462.461-.692.692-.857.96a2.7 2.7 0 0 0-.32.772C4 23.456 4 23.782 4 24.434z" }))); };
	ActionEdit02.default = SvgActionEdit02;
	
	return ActionEdit02;
}

var ActionEdit03 = {};

var hasRequiredActionEdit03;

function requireActionEdit03 () {
	if (hasRequiredActionEdit03) return ActionEdit03;
	hasRequiredActionEdit03 = 1;
	Object.defineProperty(ActionEdit03, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgActionEdit03 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M14.667 5.333h-5.6c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.749 1.748c-.435.856-.435 1.976-.435 4.216v11.2c0 2.24 0 3.36.435 4.216a4 4 0 0 0 1.749 1.748c.855.436 1.975.436 4.216.436h11.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.747-1.748c.436-.855.436-1.976.436-4.216v-5.6m-16 4H12.9c.652 0 .979 0 1.286-.073.272-.066.532-.173.77-.32.27-.165.5-.395.961-.856l12.75-12.75a2.828 2.828 0 1 0-4-4l-12.75 12.75c-.461.46-.692.691-.857.96a2.7 2.7 0 0 0-.319.771c-.074.307-.074.633-.074 1.286z" }))); };
	ActionEdit03.default = SvgActionEdit03;
	
	return ActionEdit03;
}

var ActionFavorite01 = {};

var hasRequiredActionFavorite01;

function requireActionFavorite01 () {
	if (hasRequiredActionFavorite01) return ActionFavorite01;
	hasRequiredActionFavorite01 = 1;
	Object.defineProperty(ActionFavorite01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgActionFavorite01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M15.044 4.605c.307-.623.46-.934.67-1.034a.67.67 0 0 1 .573 0c.209.1.362.411.67 1.034l2.915 5.906c.09.184.136.276.202.347q.09.096.208.151c.088.041.19.056.392.085l6.522.954c.687.1 1.03.15 1.189.318a.67.67 0 0 1 .177.546c-.03.229-.279.471-.776.955l-4.717 4.595c-.147.143-.221.215-.268.3a.7.7 0 0 0-.08.244c-.012.097.006.198.04.4l1.114 6.49c.117.685.176 1.027.065 1.23a.67.67 0 0 1-.464.337c-.227.043-.534-.119-1.15-.442l-5.83-3.066c-.181-.096-.272-.144-.368-.162a.7.7 0 0 0-.256 0c-.096.018-.187.066-.368.162l-5.83 3.066c-.615.323-.923.485-1.15.442a.67.67 0 0 1-.464-.337c-.11-.203-.052-.545.065-1.23l1.113-6.49c.035-.202.053-.303.04-.4a.7.7 0 0 0-.079-.244c-.047-.085-.12-.157-.268-.3l-4.717-4.595c-.497-.484-.746-.726-.776-.955-.026-.2.039-.4.177-.546.159-.168.502-.218 1.189-.318l6.522-.953c.202-.03.304-.045.392-.086a.7.7 0 0 0 .207-.15c.067-.072.112-.164.203-.348z" }))); };
	ActionFavorite01.default = SvgActionFavorite01;
	
	return ActionFavorite01;
}

var ActionFavorite02 = {};

var hasRequiredActionFavorite02;

function requireActionFavorite02 () {
	if (hasRequiredActionFavorite02) return ActionFavorite02;
	hasRequiredActionFavorite02 = 1;
	Object.defineProperty(ActionFavorite02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgActionFavorite02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M15.99 6.848C13.326 3.73 8.88 2.893 5.54 5.747s-3.81 7.625-1.188 11c2.181 2.807 8.781 8.725 10.944 10.64.242.215.363.322.504.364a.67.67 0 0 0 .381 0c.142-.042.263-.149.505-.363 2.163-1.916 8.763-7.835 10.944-10.64 2.623-3.376 2.21-8.178-1.188-11.001-3.397-2.824-7.785-2.016-10.451 1.1", clipRule: "evenodd" }))); };
	ActionFavorite02.default = SvgActionFavorite02;
	
	return ActionFavorite02;
}

var ActionMinus = {};

var hasRequiredActionMinus;

function requireActionMinus () {
	if (hasRequiredActionMinus) return ActionMinus;
	hasRequiredActionMinus = 1;
	Object.defineProperty(ActionMinus, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgActionMinus = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M6.667 16h18.666" }))); };
	ActionMinus.default = SvgActionMinus;
	
	return ActionMinus;
}

var ActionPaste = {};

var hasRequiredActionPaste;

function requireActionPaste () {
	if (hasRequiredActionPaste) return ActionPaste;
	hasRequiredActionPaste = 1;
	Object.defineProperty(ActionPaste, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgActionPaste = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M21.333 5.333c1.24 0 1.86 0 2.369.137a4 4 0 0 1 2.828 2.828c.137.509.137 1.129.137 2.369v12.266c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748c-.856.436-1.976.436-4.216.436h-8.534c-2.24 0-3.36 0-4.216-.436A4 4 0 0 1 5.77 27.15c-.436-.855-.436-1.975-.436-4.216V10.667c0-1.24 0-1.86.137-2.369A4 4 0 0 1 8.298 5.47c.509-.137 1.129-.137 2.369-.137M12.8 8h6.4c.747 0 1.12 0 1.405-.145.251-.128.455-.332.583-.583.145-.285.145-.659.145-1.405V4.8c0-.747 0-1.12-.145-1.405a1.33 1.33 0 0 0-.583-.583c-.285-.145-.658-.145-1.405-.145h-6.4c-.747 0-1.12 0-1.405.145-.251.128-.455.332-.583.583-.145.285-.145.658-.145 1.405v1.067c0 .746 0 1.12.145 1.405.128.25.332.455.583.583C11.68 8 12.053 8 12.8 8" }))); };
	ActionPaste.default = SvgActionPaste;
	
	return ActionPaste;
}

var ActionPlus = {};

var hasRequiredActionPlus;

function requireActionPlus () {
	if (hasRequiredActionPlus) return ActionPlus;
	hasRequiredActionPlus = 1;
	Object.defineProperty(ActionPlus, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgActionPlus = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M16 6.667v18.666M6.667 16h18.666" }))); };
	ActionPlus.default = SvgActionPlus;
	
	return ActionPlus;
}

var ActionTrash01 = {};

var hasRequiredActionTrash01;

function requireActionTrash01 () {
	if (hasRequiredActionTrash01) return ActionTrash01;
	hasRequiredActionTrash01 = 1;
	Object.defineProperty(ActionTrash01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgActionTrash01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M21.333 8V6.933c0-1.493 0-2.24-.29-2.81a2.67 2.67 0 0 0-1.166-1.166c-.57-.29-1.317-.29-2.81-.29h-2.134c-1.493 0-2.24 0-2.81.29-.502.256-.91.664-1.166 1.166-.29.57-.29 1.317-.29 2.81V8m2.666 7.333V22m5.334-6.667V22M4 8h24m-2.667 0v14.933c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748c-.855.436-1.976.436-4.216.436h-5.866c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748c-.436-.855-.436-1.975-.436-4.216V8" }))); };
	ActionTrash01.default = SvgActionTrash01;
	
	return ActionTrash01;
}

var ActionTrash02 = {};

var hasRequiredActionTrash02;

function requireActionTrash02 () {
	if (hasRequiredActionTrash02) return ActionTrash02;
	hasRequiredActionTrash02 = 1;
	Object.defineProperty(ActionTrash02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgActionTrash02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M21.333 8V6.933c0-1.493 0-2.24-.29-2.81a2.67 2.67 0 0 0-1.166-1.166c-.57-.29-1.317-.29-2.81-.29h-2.134c-1.493 0-2.24 0-2.81.29-.502.256-.91.664-1.166 1.166-.29.57-.29 1.317-.29 2.81V8M4 8h24m-2.667 0v14.933c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748c-.855.436-1.976.436-4.216.436h-5.866c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748c-.436-.855-.436-1.975-.436-4.216V8" }))); };
	ActionTrash02.default = SvgActionTrash02;
	
	return ActionTrash02;
}

var ActionsBackward = {};

var hasRequiredActionsBackward;

function requireActionsBackward () {
	if (hasRequiredActionsBackward) return ActionsBackward;
	hasRequiredActionsBackward = 1;
	Object.defineProperty(ActionsBackward, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgActionsBackward = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M29.333 21.916c0 1.507 0 2.26-.304 2.63-.265.32-.664.5-1.08.484-.478-.018-1.04-.518-2.167-1.52l-6.655-5.916c-.62-.55-.93-.827-1.045-1.152-.1-.286-.1-.598 0-.884.114-.325.424-.601 1.045-1.152l6.655-5.916c1.126-1.001 1.69-1.502 2.168-1.52.415-.015.814.164 1.079.485.304.369.304 1.122.304 2.629zM14.666 21.916c0 1.507 0 2.26-.304 2.63-.264.32-.664.5-1.079.484-.478-.018-1.041-.518-2.167-1.52L4.46 17.595c-.62-.55-.93-.827-1.045-1.152-.1-.286-.1-.598 0-.884.114-.325.425-.601 1.045-1.152l6.656-5.916c1.126-1.001 1.689-1.502 2.167-1.52.415-.015.815.164 1.079.485.304.369.304 1.122.304 2.629z" }))); };
	ActionsBackward.default = SvgActionsBackward;
	
	return ActionsBackward;
}

var ActionsForward = {};

var hasRequiredActionsForward;

function requireActionsForward () {
	if (hasRequiredActionsForward) return ActionsForward;
	hasRequiredActionsForward = 1;
	Object.defineProperty(ActionsForward, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgActionsForward = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M17.333 21.916c0 1.507 0 2.26.305 2.63.264.32.663.5 1.078.484.479-.018 1.042-.518 2.168-1.52l6.656-5.916c.62-.55.93-.827 1.044-1.152.1-.286.1-.598 0-.884-.114-.325-.424-.601-1.044-1.152L20.884 8.49c-1.126-1.001-1.69-1.502-2.168-1.52a1.33 1.33 0 0 0-1.078.485c-.305.369-.305 1.122-.305 2.629zM2.667 21.916c0 1.507 0 2.26.304 2.63.264.32.663.5 1.079.484.478-.018 1.041-.518 2.167-1.52l6.656-5.916c.62-.55.93-.827 1.045-1.152.1-.286.1-.598 0-.884-.115-.325-.425-.601-1.045-1.152L6.217 8.49C5.091 7.489 4.528 6.988 4.05 6.97a1.33 1.33 0 0 0-1.079.485c-.304.369-.304 1.122-.304 2.629z" }))); };
	ActionsForward.default = SvgActionsForward;
	
	return ActionsForward;
}

var ActionsPlay = {};

var hasRequiredActionsPlay;

function requireActionsPlay () {
	if (hasRequiredActionsPlay) return ActionsPlay;
	hasRequiredActionsPlay = 1;
	Object.defineProperty(ActionsPlay, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgActionsPlay = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M6.667 6.653c0-1.295 0-1.942.27-2.3.235-.31.594-.503.984-.526.446-.027.985.333 2.062 1.05l14.021 9.348c.89.594 1.335.89 1.49 1.264.136.327.136.695 0 1.022-.154.374-.6.67-1.49 1.264l-14.02 9.347c-1.078.718-1.617 1.078-2.063 1.051a1.33 1.33 0 0 1-.984-.526c-.27-.357-.27-1.005-.27-2.3z" }))); };
	ActionsPlay.default = SvgActionsPlay;
	
	return ActionsPlay;
}

var ActionsPower = {};

var hasRequiredActionsPower;

function requireActionsPower () {
	if (hasRequiredActionsPower) return ActionsPower;
	hasRequiredActionsPower = 1;
	Object.defineProperty(ActionsPower, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgActionsPower = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M16 2.667V16m8.48-7.147a12 12 0 1 1-16.973 0" }))); };
	ActionsPower.default = SvgActionsPower;
	
	return ActionsPower;
}

var ActionsSkipBack = {};

var hasRequiredActionsSkipBack;

function requireActionsSkipBack () {
	if (hasRequiredActionsSkipBack) return ActionsSkipBack;
	hasRequiredActionsSkipBack = 1;
	Object.defineProperty(ActionsSkipBack, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgActionsSkipBack = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M6.667 25.333V6.667m15.2 1.44-7.785 6.227c-.711.57-1.067.854-1.196 1.198a1.33 1.33 0 0 0 0 .936c.129.344.485.628 1.196 1.198l7.785 6.228c1.11.888 1.665 1.331 2.132 1.332.406 0 .79-.184 1.043-.502.291-.364.291-1.075.291-2.496V9.772c0-1.42 0-2.131-.29-2.496a1.33 1.33 0 0 0-1.044-.502c-.467 0-1.022.445-2.132 1.332" }))); };
	ActionsSkipBack.default = SvgActionsSkipBack;
	
	return ActionsSkipBack;
}

var ActionsSkipForward = {};

var hasRequiredActionsSkipForward;

function requireActionsSkipForward () {
	if (hasRequiredActionsSkipForward) return ActionsSkipForward;
	hasRequiredActionsSkipForward = 1;
	Object.defineProperty(ActionsSkipForward, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgActionsSkipForward = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M25.333 6.667v18.666m-15.2-1.44 7.785-6.227c.711-.57 1.067-.854 1.196-1.198a1.33 1.33 0 0 0 0-.936c-.129-.344-.485-.628-1.196-1.198l-7.785-6.228C9.023 7.22 8.468 6.775 8 6.774c-.406 0-.79.184-1.043.502-.291.365-.291 1.075-.291 2.496v12.456c0 1.421 0 2.131.29 2.496.254.318.638.502 1.044.502.467 0 1.022-.444 2.132-1.332" }))); };
	ActionsSkipForward.default = SvgActionsSkipForward;
	
	return ActionsSkipForward;
}

var ActionsStop = {};

var hasRequiredActionsStop;

function requireActionsStop () {
	if (hasRequiredActionsStop) return ActionsStop;
	hasRequiredActionsStop = 1;
	Object.defineProperty(ActionsStop, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgActionsStop = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M4 10.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C7.04 4 8.16 4 10.4 4h11.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C28 7.04 28 8.16 28 10.4v11.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C24.96 28 23.84 28 21.6 28H10.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C4 24.96 4 23.84 4 21.6z" }))); };
	ActionsStop.default = SvgActionsStop;
	
	return ActionsStop;
}

var ActionsVolumeMax = {};

var hasRequiredActionsVolumeMax;

function requireActionsVolumeMax () {
	if (hasRequiredActionsVolumeMax) return ActionsVolumeMax;
	hasRequiredActionsVolumeMax = 1;
	Object.defineProperty(ActionsVolumeMax, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgActionsVolumeMax = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M26.33 6.667A15.93 15.93 0 0 1 29.334 16c0 3.483-1.113 6.706-3.002 9.334m-5.337-14.667A9.3 9.3 0 0 1 22.667 16a9.3 9.3 0 0 1-1.673 5.334m-8.148-14.18-4.221 4.221c-.23.23-.346.346-.48.429q-.181.11-.386.16C7.606 12 7.443 12 7.116 12H4.8c-.747 0-1.12 0-1.405.146-.251.127-.455.331-.583.582-.145.285-.145.659-.145 1.406v3.733c0 .747 0 1.12.145 1.405.128.251.332.455.583.583C3.68 20 4.053 20 4.8 20h2.316c.327 0 .49 0 .643.037q.205.05.385.16c.135.082.25.197.48.428l4.222 4.22c.571.572.857.858 1.102.877.213.017.42-.07.559-.232.16-.187.16-.59.16-1.398V7.909c0-.808 0-1.212-.16-1.399a.67.67 0 0 0-.56-.232c-.244.02-.53.305-1.101.876" }))); };
	ActionsVolumeMax.default = SvgActionsVolumeMax;
	
	return ActionsVolumeMax;
}

var ActionsVolumeMin = {};

var hasRequiredActionsVolumeMin;

function requireActionsVolumeMin () {
	if (hasRequiredActionsVolumeMin) return ActionsVolumeMin;
	hasRequiredActionsVolumeMin = 1;
	Object.defineProperty(ActionsVolumeMin, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgActionsVolumeMin = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M24.327 10.667A9.3 9.3 0 0 1 26 16a9.3 9.3 0 0 1-1.673 5.334M16.179 5.82l-4.22 4.221c-.231.23-.347.346-.481.428q-.181.11-.386.16c-.153.037-.316.037-.642.037H8.133c-.746 0-1.12 0-1.405.145-.25.128-.455.332-.583.583C6 11.68 6 12.053 6 12.8v6.4c0 .747 0 1.12.145 1.405.128.251.332.455.583.583.285.146.659.146 1.405.146h2.317c.326 0 .489 0 .642.036q.205.05.386.16c.134.082.25.198.48.428l4.221 4.221c.571.571.857.857 1.102.876.213.017.42-.07.56-.231.159-.187.159-.591.159-1.399V6.575c0-.807 0-1.211-.16-1.398a.67.67 0 0 0-.559-.232c-.245.02-.53.305-1.102.876" }))); };
	ActionsVolumeMin.default = SvgActionsVolumeMin;
	
	return ActionsVolumeMin;
}

var ActionsVolumeMinus = {};

var hasRequiredActionsVolumeMinus;

function requireActionsVolumeMinus () {
	if (hasRequiredActionsVolumeMinus) return ActionsVolumeMinus;
	hasRequiredActionsVolumeMinus = 1;
	Object.defineProperty(ActionsVolumeMinus, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgActionsVolumeMinus = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M20 16h9.333M12.846 5.821l-4.221 4.221c-.23.23-.346.346-.48.428q-.181.11-.386.16c-.154.037-.317.037-.643.037H4.8c-.747 0-1.12 0-1.405.145-.251.128-.455.332-.583.583-.145.285-.145.658-.145 1.405v6.4c0 .747 0 1.12.145 1.405.128.251.332.455.583.583.285.146.658.146 1.405.146h2.316c.326 0 .49 0 .643.036q.205.05.385.16c.135.082.25.198.48.428l4.222 4.221c.57.571.857.857 1.102.876.212.017.42-.07.559-.231.16-.187.16-.591.16-1.399V6.575c0-.807 0-1.211-.16-1.398a.67.67 0 0 0-.56-.232c-.244.02-.53.305-1.101.876" }))); };
	ActionsVolumeMinus.default = SvgActionsVolumeMinus;
	
	return ActionsVolumeMinus;
}

var ActionsVolumePlus = {};

var hasRequiredActionsVolumePlus;

function requireActionsVolumePlus () {
	if (hasRequiredActionsVolumePlus) return ActionsVolumePlus;
	hasRequiredActionsVolumePlus = 1;
	Object.defineProperty(ActionsVolumePlus, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgActionsVolumePlus = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M24.667 20.667v-9.333M20 16h9.333M12.846 5.821l-4.221 4.221c-.23.23-.346.346-.48.428q-.181.11-.386.16c-.153.037-.316.037-.643.037H4.8c-.747 0-1.12 0-1.405.145-.251.128-.455.332-.583.583-.145.285-.145.658-.145 1.405v6.4c0 .747 0 1.12.145 1.405.128.251.332.455.583.583.285.146.658.146 1.405.146h2.316c.327 0 .49 0 .643.036q.205.05.385.16c.135.082.25.198.48.428l4.222 4.221c.571.571.857.857 1.102.876.213.017.42-.07.559-.231.16-.187.16-.591.16-1.399V6.575c0-.807 0-1.211-.16-1.398a.67.67 0 0 0-.56-.232c-.244.02-.53.305-1.101.876" }))); };
	ActionsVolumePlus.default = SvgActionsVolumePlus;
	
	return ActionsVolumePlus;
}

var ActionsVolumeX = {};

var hasRequiredActionsVolumeX;

function requireActionsVolumeX () {
	if (hasRequiredActionsVolumeX) return ActionsVolumeX;
	hasRequiredActionsVolumeX = 1;
	Object.defineProperty(ActionsVolumeX, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgActionsVolumeX = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m29.333 12-8 8m0-8 8 8M12.846 5.821l-4.221 4.221c-.23.23-.346.346-.48.428q-.181.11-.386.16c-.154.037-.317.037-.643.037H4.8c-.747 0-1.12 0-1.405.145-.251.128-.455.332-.583.583-.145.285-.145.658-.145 1.405v6.4c0 .747 0 1.12.145 1.405.128.251.332.455.583.583.285.146.658.146 1.405.146h2.316c.326 0 .49 0 .643.036q.205.05.385.16c.135.082.25.198.48.428l4.222 4.221c.57.571.857.857 1.102.876.212.017.42-.07.559-.231.16-.187.16-.591.16-1.399V6.575c0-.807 0-1.211-.16-1.398a.67.67 0 0 0-.56-.232c-.244.02-.53.305-1.101.876" }))); };
	ActionsVolumeX.default = SvgActionsVolumeX;
	
	return ActionsVolumeX;
}

var AlarmOff = {};

var hasRequiredAlarmOff;

function requireAlarmOff () {
	if (hasRequiredAlarmOff) return AlarmOff;
	hasRequiredAlarmOff = 1;
	Object.defineProperty(AlarmOff, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgAlarmOff = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M14 6.856a10.66 10.66 0 0 1 9.543 2.935 10.67 10.67 0 0 1 2.935 9.542m-2.297 4.845A10.67 10.67 0 0 1 16 28 10.667 10.667 0 0 1 9.147 9.158M5.333 5.333 2.667 8m26.666 0-4-4M8 25.333 5.333 28M28 28 4 4" }))); };
	AlarmOff.default = SvgAlarmOff;
	
	return AlarmOff;
}

var Alarm = {};

var hasRequiredAlarm;

function requireAlarm () {
	if (hasRequiredAlarm) return Alarm;
	hasRequiredAlarm = 1;
	Object.defineProperty(Alarm, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgAlarm = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m6.667 4-4 4m26.666 0-4-4M8 25.333 5.333 28M24 25.333 26.667 28M16 12v5.333L18.667 20M16 28a10.667 10.667 0 1 0 0-21.333A10.667 10.667 0 0 0 16 28" }))); };
	Alarm.default = SvgAlarm;
	
	return Alarm;
}

var Announcement = {};

var hasRequiredAnnouncement;

function requireAnnouncement () {
	if (hasRequiredAnnouncement) return Announcement;
	hasRequiredAnnouncement = 1;
	Object.defineProperty(Announcement, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgAnnouncement = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M29.333 10.667V16M13.667 7.333h-4.6c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748c-.436.856-.436 1.976-.436 4.216v1.6c0 1.243 0 1.864.203 2.354.27.654.79 1.173 1.443 1.443.49.203 1.111.203 2.354.203V25c0 .31 0 .464.013.595a2.67 2.67 0 0 0 2.392 2.392c.13.013.285.013.595.013s.464 0 .594-.013a2.67 2.67 0 0 0 2.393-2.392c.013-.13.013-.285.013-.595v-5.667h1c2.355 0 5.236 1.263 7.459 2.475 1.296.706 1.945 1.06 2.37 1.008.393-.048.691-.225.922-.548.249-.348.249-1.044.249-2.436V6.835c0-1.392 0-2.089-.25-2.436-.23-.323-.528-.5-.922-.548-.424-.052-1.073.301-2.37 1.008-2.222 1.212-5.103 2.474-7.458 2.474" }))); };
	Announcement.default = SvgAnnouncement;
	
	return Announcement;
}

var ArrowDown = {};

var hasRequiredArrowDown;

function requireArrowDown () {
	if (hasRequiredArrowDown) return ArrowDown;
	hasRequiredArrowDown = 1;
	Object.defineProperty(ArrowDown, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgArrowDown = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M16 5.334v21.333m0 0 8-8m-8 8-8-8" }))); };
	ArrowDown.default = SvgArrowDown;
	
	return ArrowDown;
}

var ArrowDownload = {};

var hasRequiredArrowDownload;

function requireArrowDownload () {
	if (hasRequiredArrowDownload) return ArrowDownload;
	hasRequiredArrowDownload = 1;
	Object.defineProperty(ArrowDownload, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgArrowDownload = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M28 20v1.6c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C24.96 28 23.84 28 21.6 28H10.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C4 24.96 4 23.84 4 21.6V20m18.667-6.667L16 20m0 0-6.667-6.667M16 20V4" }))); };
	ArrowDownload.default = SvgArrowDownload;
	
	return ArrowDownload;
}

var ArrowGoingDown = {};

var hasRequiredArrowGoingDown;

function requireArrowGoingDown () {
	if (hasRequiredArrowGoingDown) return ArrowGoingDown;
	hasRequiredArrowGoingDown = 1;
	Object.defineProperty(ArrowGoingDown, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgArrowGoingDown = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M29.333 22.667 18.842 12.175c-.528-.528-.792-.792-1.097-.89a1.33 1.33 0 0 0-.824 0c-.304.098-.568.362-1.096.89l-3.65 3.65c-.528.528-.792.792-1.096.89a1.33 1.33 0 0 1-.824 0c-.305-.098-.569-.362-1.097-.89L2.667 9.333m26.666 13.334H20m9.333 0v-9.334" }))); };
	ArrowGoingDown.default = SvgArrowGoingDown;
	
	return ArrowGoingDown;
}

var ArrowGoingUp = {};

var hasRequiredArrowGoingUp;

function requireArrowGoingUp () {
	if (hasRequiredArrowGoingUp) return ArrowGoingUp;
	hasRequiredArrowGoingUp = 1;
	Object.defineProperty(ArrowGoingUp, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgArrowGoingUp = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M29.333 9.333 18.842 19.825c-.528.528-.792.792-1.097.89a1.33 1.33 0 0 1-.824 0c-.304-.098-.568-.362-1.096-.89l-3.65-3.65c-.528-.528-.792-.792-1.096-.89a1.33 1.33 0 0 0-.824 0c-.305.098-.569.362-1.097.89l-6.491 6.492M29.333 9.333H20m9.333 0v9.334" }))); };
	ArrowGoingUp.default = SvgArrowGoingUp;
	
	return ArrowGoingUp;
}

var ArrowLeft = {};

var hasRequiredArrowLeft;

function requireArrowLeft () {
	if (hasRequiredArrowLeft) return ArrowLeft;
	hasRequiredArrowLeft = 1;
	Object.defineProperty(ArrowLeft, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgArrowLeft = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M26.667 16H5.333m0 0 8 8m-8-8 8-8" }))); };
	ArrowLeft.default = SvgArrowLeft;
	
	return ArrowLeft;
}

var ArrowRight = {};

var hasRequiredArrowRight;

function requireArrowRight () {
	if (hasRequiredArrowRight) return ArrowRight;
	hasRequiredArrowRight = 1;
	Object.defineProperty(ArrowRight, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgArrowRight = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M5.333 16h21.334m0 0-8-8m8 8-8 8" }))); };
	ArrowRight.default = SvgArrowRight;
	
	return ArrowRight;
}

var ArrowUp = {};

var hasRequiredArrowUp;

function requireArrowUp () {
	if (hasRequiredArrowUp) return ArrowUp;
	hasRequiredArrowUp = 1;
	Object.defineProperty(ArrowUp, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgArrowUp = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M16 26.667V5.334m0 0-8 8m8-8 8 8" }))); };
	ArrowUp.default = SvgArrowUp;
	
	return ArrowUp;
}

var ArrowUpload = {};

var hasRequiredArrowUpload;

function requireArrowUpload () {
	if (hasRequiredArrowUpload) return ArrowUpload;
	hasRequiredArrowUpload = 1;
	Object.defineProperty(ArrowUpload, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgArrowUpload = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M28 20v1.6c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C24.96 28 23.84 28 21.6 28H10.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C4 24.96 4 23.84 4 21.6V20m18.667-9.333L16 4m0 0-6.667 6.667M16 4v16" }))); };
	ArrowUpload.default = SvgArrowUpload;
	
	return ArrowUpload;
}

var AtSign = {};

var hasRequiredAtSign;

function requireAtSign () {
	if (hasRequiredAtSign) return AtSign;
	hasRequiredAtSign = 1;
	Object.defineProperty(AtSign, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgAtSign = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M21.333 10.667v6.666a4 4 0 1 0 8 0V16a13.334 13.334 0 1 0-5.226 10.587M21.333 16a5.333 5.333 0 1 1-10.666 0 5.333 5.333 0 0 1 10.666 0" }))); };
	AtSign.default = SvgAtSign;
	
	return AtSign;
}

var Attention = {};

var hasRequiredAttention;

function requireAttention () {
	if (hasRequiredAttention) return Attention;
	hasRequiredAttention = 1;
	Object.defineProperty(Attention, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgAttention = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M16 12v5.333m0 5.334h.013m-1.86-17.478L3.188 24.131c-.608 1.05-.912 1.576-.867 2.007.039.376.236.718.542.94.35.255.957.255 2.171.255h21.933c1.214 0 1.821 0 2.172-.255.306-.222.503-.564.542-.94.045-.43-.26-.956-.867-2.007L17.846 5.19c-.606-1.047-.91-1.57-1.305-1.746a1.33 1.33 0 0 0-1.083 0c-.395.176-.698.7-1.305 1.746" }))); };
	Attention.default = SvgAttention;
	
	return Attention;
}

var Bank = {};

var hasRequiredBank;

function requireBank () {
	if (hasRequiredBank) return Bank;
	hasRequiredBank = 1;
	Object.defineProperty(Bank, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgBank = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M6.667 12v10.667m6-10.667v10.667M19.334 12v10.667m6-10.667v10.667M4 24.8v1.067c0 .746 0 1.12.145 1.405.128.25.332.455.583.583.285.145.659.145 1.405.145h19.734c.746 0 1.12 0 1.405-.145.251-.128.455-.332.583-.583.145-.285.145-.659.145-1.405V24.8c0-.747 0-1.12-.145-1.405a1.33 1.33 0 0 0-.583-.583c-.285-.145-.659-.145-1.405-.145H6.133c-.746 0-1.12 0-1.405.145-.25.128-.455.332-.583.583C4 23.68 4 24.053 4 24.8M15.537 4.103 5.671 6.295c-.596.133-.894.2-1.117.36-.196.14-.35.333-.446.555C4 7.462 4 7.767 4 8.378v1.489c0 .746 0 1.12.145 1.405.128.25.332.455.583.583.285.145.659.145 1.405.145h19.734c.746 0 1.12 0 1.405-.145.251-.128.455-.332.583-.583.145-.285.145-.659.145-1.405V8.378c0-.61 0-.916-.108-1.168a1.33 1.33 0 0 0-.446-.556c-.222-.16-.52-.226-1.116-.359l-9.867-2.192c-.173-.039-.26-.058-.346-.065a1.3 1.3 0 0 0-.233 0 3 3 0 0 0-.347.065" }))); };
	Bank.default = SvgBank;
	
	return Bank;
}

var Base01 = {};

var hasRequiredBase01;

function requireBase01 () {
	if (hasRequiredBase01) return Base01;
	hasRequiredBase01 = 1;
	Object.defineProperty(Base01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgBase01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M4 28V9.333L16 4l12 5.333V28M16 13.333h5.333c.737 0 1.334.597 1.334 1.334v12c0 .736-.597 1.333-1.334 1.333H16m0-14.667h-5.333c-.737 0-1.334.597-1.334 1.334v12c0 .736.597 1.333 1.334 1.333H16m0-14.667V28M14.667 9.333h2.666" }))); };
	Base01.default = SvgBase01;
	
	return Base01;
}

var Base02 = {};

var hasRequiredBase02;

function requireBase02 () {
	if (hasRequiredBase02) return Base02;
	hasRequiredBase02 = 1;
	Object.defineProperty(Base02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgBase02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M4 28V9.333L16 4l12 5.333V28M16 13.333h5.333c.737 0 1.334.597 1.334 1.334v6M16 13.333h-5.333c-.737 0-1.334.597-1.334 1.334v6M16 13.333V28m0 0h-5.333a1.333 1.333 0 0 1-1.334-1.333v-6M16 28h5.333c.737 0 1.334-.597 1.334-1.333v-6m0 0H9.333m5.334-11.334h2.666" }))); };
	Base02.default = SvgBase02;
	
	return Base02;
}

var Base03 = {};

var hasRequiredBase03;

function requireBase03 () {
	if (hasRequiredBase03) return Base03;
	hasRequiredBase03 = 1;
	Object.defineProperty(Base03, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgBase03 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M4 28V9.333L16 4l12 5.333V28M9.333 20.667v-6c0-.737.597-1.334 1.334-1.334h10.666c.737 0 1.334.597 1.334 1.334v6m-13.334 0v6c0 .736.597 1.333 1.334 1.333h10.666c.737 0 1.334-.597 1.334-1.333v-6m-13.334 0h13.334m-8-11.334h2.666" }))); };
	Base03.default = SvgBase03;
	
	return Base03;
}

var Base04 = {};

var hasRequiredBase04;

function requireBase04 () {
	if (hasRequiredBase04) return Base04;
	hasRequiredBase04 = 1;
	Object.defineProperty(Base04, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgBase04 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M14.667 9.333h2.666M16 4 4 9.333V28h5.333V14.667h13.334V28H28V9.333zm2.133 24h-4.266a.533.533 0 0 1-.534-.533V23.2c0-.295.24-.533.534-.533h4.266c.295 0 .534.238.534.533v4.267a.533.533 0 0 1-.534.533" }))); };
	Base04.default = SvgBase04;
	
	return Base04;
}

var Base05 = {};

var hasRequiredBase05;

function requireBase05 () {
	if (hasRequiredBase05) return Base05;
	hasRequiredBase05 = 1;
	Object.defineProperty(Base05, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgBase05 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M14.667 9.333h2.666m-4 14V19.2c0-.295.24-.533.534-.533h4.266c.295 0 .534.238.534.533v4.133m-5.334 0v4.134c0 .294.24.533.534.533h4.266a.533.533 0 0 0 .534-.533v-4.134m-5.334 0h5.334M16 4 4 9.333V28h5.333V14.667h13.334V28H28V9.333z" }))); };
	Base05.default = SvgBase05;
	
	return Base05;
}

var Base06 = {};

var hasRequiredBase06;

function requireBase06 () {
	if (hasRequiredBase06) return Base06;
	hasRequiredBase06 = 1;
	Object.defineProperty(Base06, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgBase06 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M14.667 9.333h2.666M16 4 4 9.333V28h5.333V14.667h13.334V28H28V9.333z" }))); };
	Base06.default = SvgBase06;
	
	return Base06;
}

var BaseArrowDown = {};

var hasRequiredBaseArrowDown;

function requireBaseArrowDown () {
	if (hasRequiredBaseArrowDown) return BaseArrowDown;
	hasRequiredBaseArrowDown = 1;
	Object.defineProperty(BaseArrowDown, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgBaseArrowDown = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M14.667 9.333h2.666M16 4 4 9.333V28h4.333V14.667h15.334V28H28V9.333zM16 18.667v10.667m0 0-4-4m4 4 4-4" }))); };
	BaseArrowDown.default = SvgBaseArrowDown;
	
	return BaseArrowDown;
}

var BaseArrowUp = {};

var hasRequiredBaseArrowUp;

function requireBaseArrowUp () {
	if (hasRequiredBaseArrowUp) return BaseArrowUp;
	hasRequiredBaseArrowUp = 1;
	Object.defineProperty(BaseArrowUp, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgBaseArrowUp = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M14.667 9.333h2.666M16 4 4 9.333V28h4.333V14.667h15.334V28H28V9.333zM16 29.334V18.667m0 0-4 4m4-4 4 4" }))); };
	BaseArrowUp.default = SvgBaseArrowUp;
	
	return BaseArrowUp;
}

var Battery01 = {};

var hasRequiredBattery01;

function requireBattery01 () {
	if (hasRequiredBattery01) return Battery01;
	hasRequiredBattery01 = 1;
	Object.defineProperty(Battery01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgBattery01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M29.333 17.333v-2.666M9.067 24h9.866c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748c.436-.856.436-1.976.436-4.216v-3.2c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C22.294 8 21.174 8 18.933 8H9.067c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748c-.436.856-.436 1.976-.436 4.216v3.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C5.706 24 6.827 24 9.067 24" }))); };
	Battery01.default = SvgBattery01;
	
	return Battery01;
}

var Battery02 = {};

var hasRequiredBattery02;

function requireBattery02 () {
	if (hasRequiredBattery02) return Battery02;
	hasRequiredBattery02 = 1;
	Object.defineProperty(Battery02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgBattery02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M8.667 13.333v5.334m20.666-1.334v-2.666M9.067 24h9.866c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748c.436-.856.436-1.976.436-4.216v-3.2c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C22.294 8 21.173 8 18.933 8H9.067c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.749 1.748c-.435.856-.435 1.976-.435 4.216v3.2c0 2.24 0 3.36.435 4.216a4 4 0 0 0 1.749 1.748C5.706 24 6.826 24 9.067 24" }))); };
	Battery02.default = SvgBattery02;
	
	return Battery02;
}

var Battery03 = {};

var hasRequiredBattery03;

function requireBattery03 () {
	if (hasRequiredBattery03) return Battery03;
	hasRequiredBattery03 = 1;
	Object.defineProperty(Battery03, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgBattery03 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M8.667 13.333v5.334M14 13.333v5.334m15.333-1.334v-2.666M9.067 24h9.866c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748c.436-.856.436-1.976.436-4.216v-3.2c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C22.294 8 21.174 8 18.933 8H9.067c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748c-.436.856-.436 1.976-.436 4.216v3.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C5.706 24 6.827 24 9.067 24" }))); };
	Battery03.default = SvgBattery03;
	
	return Battery03;
}

var Battery04 = {};

var hasRequiredBattery04;

function requireBattery04 () {
	if (hasRequiredBattery04) return Battery04;
	hasRequiredBattery04 = 1;
	Object.defineProperty(Battery04, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgBattery04 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M8.667 13.333v5.334M14 13.333v5.334m5.333-5.334v5.334m10-1.334v-2.666M9.067 24h9.866c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748c.436-.856.436-1.976.436-4.216v-3.2c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C22.294 8 21.174 8 18.933 8H9.067c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748c-.436.856-.436 1.976-.436 4.216v3.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C5.706 24 6.827 24 9.067 24" }))); };
	Battery04.default = SvgBattery04;
	
	return Battery04;
}

var Battery05 = {};

var hasRequiredBattery05;

function requireBattery05 () {
	if (hasRequiredBattery05) return Battery05;
	hasRequiredBattery05 = 1;
	Object.defineProperty(Battery05, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgBattery05 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M12.667 24 18 16h-8l5.333-8m14 9.333v-2.666M18.667 24h.266c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748c.436-.856.436-1.976.436-4.216v-4.267c0-1.24 0-1.86-.136-2.368a4 4 0 0 0-2.828-2.829C21.86 8 21.24 8 20 8M9.333 8h-.266c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748c-.436.856-.436 1.976-.436 4.216v4.267c0 1.24 0 1.86.136 2.368a4 4 0 0 0 2.828 2.829c.51.136 1.13.136 2.37.136" }))); };
	Battery05.default = SvgBattery05;
	
	return Battery05;
}

var Bike = {};

var hasRequiredBike;

function requireBike () {
	if (hasRequiredBike) return Bike;
	hasRequiredBike = 1;
	Object.defineProperty(Bike, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgBike = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M19.636 20.381c0 2.735 2.171 4.952 4.849 4.952s4.848-2.217 4.848-4.952-2.17-4.952-4.848-4.952-4.849 2.217-4.849 4.952m0 0H8.727m1.819-8.667h4.848m-2.424 0L16 20.381M16.606 8h2.699c.2 0 .38.125.452.316l4.122 10.827M12.364 20.38c0 2.735-2.171 4.952-4.849 4.952s-4.848-2.217-4.848-4.952 2.17-4.952 4.848-4.952 4.849 2.217 4.849 4.952" }))); };
	Bike.default = SvgBike;
	
	return Bike;
}

var BluetoothOff = {};

var hasRequiredBluetoothOff;

function requireBluetoothOff () {
	if (hasRequiredBluetoothOff) return BluetoothOff;
	hasRequiredBluetoothOff = 1;
	Object.defineProperty(BluetoothOff, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgBluetoothOff = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M8 22.667 16 16v13.333l7.253-6.044M16 9.333V2.667l8 6.666-3.891 3.243M28 28 4 4" }))); };
	BluetoothOff.default = SvgBluetoothOff;
	
	return BluetoothOff;
}

var BluetoothSignal = {};

var hasRequiredBluetoothSignal;

function requireBluetoothSignal () {
	if (hasRequiredBluetoothSignal) return BluetoothSignal;
	hasRequiredBluetoothSignal = 1;
	Object.defineProperty(BluetoothSignal, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgBluetoothSignal = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m2.667 9.333 16 13.334-8 6.666V2.667l8 6.666-16 13.334m24.192-14A12.5 12.5 0 0 1 29.22 16c0 2.737-.875 5.27-2.36 7.333M22.667 11.81A7.3 7.3 0 0 1 23.98 16a7.3 7.3 0 0 1-1.314 4.19" }))); };
	BluetoothSignal.default = SvgBluetoothSignal;
	
	return BluetoothSignal;
}

var Bluetooth = {};

var hasRequiredBluetooth;

function requireBluetooth () {
	if (hasRequiredBluetooth) return Bluetooth;
	hasRequiredBluetooth = 1;
	Object.defineProperty(Bluetooth, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgBluetooth = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m8 9.333 16 13.334-8 6.666V2.667l8 6.666L8 22.667" }))); };
	Bluetooth.default = SvgBluetooth;
	
	return Bluetooth;
}

var Book = {};

var hasRequiredBook;

function requireBook () {
	if (hasRequiredBook) return Book;
	hasRequiredBook = 1;
	Object.defineProperty(Book, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgBook = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m16 28-.133-.2c-.927-1.39-1.39-2.084-2.001-2.587a5.3 5.3 0 0 0-1.837-.983C11.27 24 10.436 24 8.766 24H6.933c-1.493 0-2.24 0-2.81-.29a2.67 2.67 0 0 1-1.166-1.166c-.29-.57-.29-1.317-.29-2.81V8.266c0-1.494 0-2.24.29-2.811.256-.502.664-.91 1.166-1.165C4.693 4 5.44 4 6.933 4h.534c2.987 0 4.48 0 5.62.581a5.33 5.33 0 0 1 2.332 2.331C16 8.052 16 9.546 16 12.533M16 28V12.533M16 28l.133-.2c.927-1.39 1.39-2.084 2.002-2.587a5.3 5.3 0 0 1 1.836-.983c.758-.23 1.593-.23 3.263-.23h1.833c1.493 0 2.24 0 2.81-.29.502-.256.91-.664 1.166-1.166.29-.57.29-1.317.29-2.81V8.266c0-1.494 0-2.24-.29-2.811a2.67 2.67 0 0 0-1.166-1.165C27.307 4 26.56 4 25.067 4h-.534c-2.987 0-4.48 0-5.621.581a5.33 5.33 0 0 0-2.33 2.331C16 8.052 16 9.546 16 12.533" }))); };
	Book.default = SvgBook;
	
	return Book;
}

var CalendarCheck = {};

var hasRequiredCalendarCheck;

function requireCalendarCheck () {
	if (hasRequiredCalendarCheck) return CalendarCheck;
	hasRequiredCalendarCheck = 1;
	Object.defineProperty(CalendarCheck, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgCalendarCheck = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M28 13.333H4m24 3.334v-4.934c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748c-.856-.436-1.976-.436-4.216-.436H10.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C4 8.373 4 9.493 4 11.733v11.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748c.856.436 1.976.436 4.216.436H16m5.334-26.666V8M10.667 2.667V8m8.667 17.333L22 28l6-6" }))); };
	CalendarCheck.default = SvgCalendarCheck;
	
	return CalendarCheck;
}

var CalendarHeart = {};

var hasRequiredCalendarHeart;

function requireCalendarHeart () {
	if (hasRequiredCalendarHeart) return CalendarHeart;
	hasRequiredCalendarHeart = 1;
	Object.defineProperty(CalendarHeart, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgCalendarHeart = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M28 13.333H4m24 2v-3.6c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748c-.856-.436-1.976-.436-4.216-.436H10.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C4 8.373 4 9.493 4 11.733v11.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748c.856.436 1.976.436 4.216.436h6.267m4.666-26.666V8M10.667 2.667V8M23.33 20.95c-.933-1.04-2.489-1.32-3.658-.368-1.169.951-1.333 2.542-.415 3.667S23.33 28 23.33 28s3.156-2.626 4.074-3.751.773-2.726-.416-3.667-2.725-.672-3.658.367" }))); };
	CalendarHeart.default = SvgCalendarHeart;
	
	return CalendarHeart;
}

var CalendarMinus = {};

var hasRequiredCalendarMinus;

function requireCalendarMinus () {
	if (hasRequiredCalendarMinus) return CalendarMinus;
	hasRequiredCalendarMinus = 1;
	Object.defineProperty(CalendarMinus, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgCalendarMinus = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M20 24h8m0-8.667v-3.6c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748c-.856-.436-1.976-.436-4.216-.436H10.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C4 8.373 4 9.493 4 11.733v11.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748c.856.436 1.976.436 4.216.436h6.267m11.333-16H4M21.333 2.667V8M10.667 2.667V8" }))); };
	CalendarMinus.default = SvgCalendarMinus;
	
	return CalendarMinus;
}

var CalendarPlus = {};

var hasRequiredCalendarPlus;

function requireCalendarPlus () {
	if (hasRequiredCalendarPlus) return CalendarPlus;
	hasRequiredCalendarPlus = 1;
	Object.defineProperty(CalendarPlus, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgCalendarPlus = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M28 15.333v-3.6c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748c-.856-.436-1.976-.436-4.216-.436H10.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C4 8.373 4 9.493 4 11.733v11.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748c.856.436 1.976.436 4.216.436h6.267m11.333-16H4M21.333 2.667V8M10.667 2.667V8M24 28v-8m-4 4h8" }))); };
	CalendarPlus.default = SvgCalendarPlus;
	
	return CalendarPlus;
}

var Calendar = {};

var hasRequiredCalendar;

function requireCalendar () {
	if (hasRequiredCalendar) return Calendar;
	hasRequiredCalendar = 1;
	Object.defineProperty(Calendar, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgCalendar = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M28 13.333H4M21.333 2.667V8M10.667 2.667V8M10.4 29.333h11.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748c.436-.855.436-1.976.436-4.216v-11.2c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748c-.856-.436-1.976-.436-4.216-.436H10.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C4 8.373 4 9.493 4 11.733v11.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748c.856.436 1.976.436 4.216.436" }))); };
	Calendar.default = SvgCalendar;
	
	return Calendar;
}

var CallOff = {};

var hasRequiredCallOff;

function requireCallOff () {
	if (hasRequiredCallOff) return CallOff;
	hasRequiredCallOff = 1;
	Object.defineProperty(CallOff, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgCallOff = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M7.3 17.15a25.3 25.3 0 0 1-3.072-6.802c-.213-.752-.32-1.129-.322-1.68-.002-.61.214-1.437.513-1.97.27-.48.623-.833 1.329-1.54l.21-.21C6.666 4.24 7.02 3.886 7.4 3.693a2.67 2.67 0 0 1 2.407 0c.381.193.735.547 1.444 1.255l.26.26c.466.466.699.7.851.934a2.67 2.67 0 0 1 0 2.907c-.152.234-.385.467-.851.934-.153.152-.229.228-.293.317a1.4 1.4 0 0 0-.196 1.15c.03.105.07.188.15.354q.242.504.515.995m3.22 4.291.06.06a19.5 19.5 0 0 0 5.347 3.796c.166.08.25.12.355.15.374.11.833.03 1.15-.196.088-.063.165-.14.317-.292.466-.466.7-.7.933-.852a2.67 2.67 0 0 1 2.908 0c.234.153.467.386.933.852l.26.26c.709.708 1.063 1.063 1.255 1.443.383.757.383 1.65 0 2.407-.192.38-.546.735-1.255 1.444l-.21.21c-.706.706-1.06 1.059-1.54 1.329-.532.299-1.36.514-1.97.512-.55-.001-.927-.108-1.68-.322a25.4 25.4 0 0 1-11.045-6.498l-.06-.06M28 4 4 28" }))); };
	CallOff.default = SvgCallOff;
	
	return CallOff;
}

var Call = {};

var hasRequiredCall;

function requireCall () {
	if (hasRequiredCall) return Call;
	hasRequiredCall = 1;
	Object.defineProperty(Call, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgCall = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M11.174 11.804a19.5 19.5 0 0 0 3.795 5.347 19.5 19.5 0 0 0 5.346 3.795c.166.08.25.12.355.15.374.11.833.03 1.15-.196.088-.063.165-.14.317-.292.466-.466.7-.7.933-.852a2.67 2.67 0 0 1 2.908 0c.234.153.467.386.933.852l.26.26c.709.708 1.063 1.063 1.255 1.443.383.757.383 1.65 0 2.407-.192.38-.546.735-1.255 1.444l-.21.21c-.706.706-1.06 1.059-1.54 1.329-.532.299-1.36.514-1.97.512-.551-.001-.927-.108-1.68-.322a25.4 25.4 0 0 1-11.045-6.498c-3.184-3.184-5.35-7-6.498-11.045-.213-.752-.32-1.129-.322-1.68-.002-.61.214-1.437.513-1.97.27-.48.623-.833 1.329-1.54l.21-.21C6.666 4.24 7.02 3.886 7.4 3.693a2.67 2.67 0 0 1 2.407 0c.38.193.735.547 1.444 1.255l.26.26c.466.466.699.7.851.934a2.67 2.67 0 0 1 0 2.907c-.152.234-.385.467-.851.934-.153.152-.229.228-.293.317a1.4 1.4 0 0 0-.196 1.15c.03.105.07.188.15.354" }))); };
	Call.default = SvgCall;
	
	return Call;
}

var CameraOff = {};

var hasRequiredCameraOff;

function requireCameraOff () {
	if (hasRequiredCameraOff) return CameraOff;
	hasRequiredCameraOff = 1;
	Object.defineProperty(CameraOff, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgCameraOff = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M6.667 6.667h.558c.178 0 .267 0 .348-.005a2.67 2.67 0 0 0 2.313-1.667c.03-.075.058-.16.114-.328.056-.169.084-.253.114-.328a2.67 2.67 0 0 1 2.313-1.667c.081-.005.17-.005.348-.005h6.45c.178 0 .267 0 .348.005a2.67 2.67 0 0 1 2.313 1.667c.03.075.058.159.114.328a6 6 0 0 0 .114.328 2.67 2.67 0 0 0 2.313 1.667c.081.005.176.005.366.005.492 0 .738 0 .935.02a4 4 0 0 1 3.586 3.585c.02.197.02.43.02.898V24a4 4 0 0 1-1.919 3.416m-7.33-7.32a5.333 5.333 0 0 0-7.512-7.516m16.76 16.753L2.667 2.667m0 7.333v11.6c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C5.706 28 6.826 28 9.067 28h11.6M16 22a5.333 5.333 0 0 1-5.333-5.333" }))); };
	CameraOff.default = SvgCameraOff;
	
	return CameraOff;
}

var Camera = {};

var hasRequiredCamera;

function requireCamera () {
	if (hasRequiredCamera) return Camera;
	hasRequiredCamera = 1;
	Object.defineProperty(Camera, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgCamera = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M2.667 11.17c0-.467 0-.7.02-.898a4 4 0 0 1 3.585-3.586c.197-.02.443-.02.935-.02.19 0 .285 0 .365-.004a2.67 2.67 0 0 0 2.314-1.667c.03-.075.058-.16.114-.328.056-.169.084-.253.114-.328a2.67 2.67 0 0 1 2.313-1.667c.081-.005.17-.005.348-.005h6.45c.178 0 .267 0 .348.005a2.67 2.67 0 0 1 2.313 1.667c.03.075.058.159.114.328a6 6 0 0 0 .114.328 2.67 2.67 0 0 0 2.313 1.667c.081.005.176.005.366.005.492 0 .738 0 .935.02a4 4 0 0 1 3.586 3.585c.02.197.02.43.02.898V21.6c0 2.24 0 3.36-.437 4.216a4 4 0 0 1-1.748 1.748c-.855.436-1.976.436-4.216.436H9.067c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748c-.436-.856-.436-1.976-.436-4.216z" }),
	    React.createElement("path", { d: "M16 22a5.333 5.333 0 1 0 0-10.667A5.333 5.333 0 0 0 16 22" }))); };
	Camera.default = SvgCamera;
	
	return Camera;
}

var Car01 = {};

var hasRequiredCar01;

function requireCar01 () {
	if (hasRequiredCar01) return Car01;
	hasRequiredCar01 = 1;
	Object.defineProperty(Car01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgCar01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M10.667 20a2.667 2.667 0 1 1-5.334 0m5.334 0a2.667 2.667 0 0 0-5.334 0m5.334 0h10M5.333 20a2.667 2.667 0 0 1-2.666-2.667v-.9c0-.287.046-.572.136-.844l1.922-5.766A2.67 2.67 0 0 1 7.255 8h10.388c.66 0 1.295.244 1.784.685l5.328 4.795c.378.34.845.564 1.346.648M12 8v6m14.1.128 2.12.353a1.33 1.33 0 0 1 1.113 1.315v2.87c0 .737-.597 1.334-1.333 1.334h-1.333m-.566-5.872L3.333 14m22.665 5.99a2.667 2.667 0 1 1-5.333 0 2.667 2.667 0 0 1 5.333 0" }))); };
	Car01.default = SvgCar01;
	
	return Car01;
}

var Car02 = {};

var hasRequiredCar02;

function requireCar02 () {
	if (hasRequiredCar02) return Car02;
	hasRequiredCar02 = 1;
	Object.defineProperty(Car02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgCar02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M10.667 22H20M5.417 22H4.412a1.745 1.745 0 0 1-1.745-1.745v-4.197c0-.68.259-1.333.724-1.828m19.276.97-5.24-5.182a2.67 2.67 0 0 0-1.784-.685H8M25.333 22h.3a2.667 2.667 0 0 0 2.666-2.667v-.785c0-.674-.248-1.33-.743-1.787-.712-.659-1.607-1.35-2.223-1.428L3.391 14.23M8 9.333H6m2 0L3.391 14.23M12 9.333l-1.333 5.095m14.666 6.905a2.667 2.667 0 1 1-5.333 0 2.667 2.667 0 0 1 5.333 0m-14.666 0a2.667 2.667 0 1 1-5.334 0 2.667 2.667 0 0 1 5.334 0" }))); };
	Car02.default = SvgCar02;
	
	return Car02;
}

var ChartArrowGoingDown = {};

var hasRequiredChartArrowGoingDown;

function requireChartArrowGoingDown () {
	if (hasRequiredChartArrowGoingDown) return ChartArrowGoingDown;
	hasRequiredChartArrowGoingDown = 1;
	Object.defineProperty(ChartArrowGoingDown, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgChartArrowGoingDown = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m22.667 20-7.246-7.246c-.264-.264-.396-.396-.548-.445a.67.67 0 0 0-.412 0c-.152.05-.284.181-.549.445l-2.491 2.492c-.264.264-.396.396-.548.445a.67.67 0 0 1-.412 0c-.152-.05-.284-.181-.548-.445L4 9.333M22.667 20h-5.334m5.334 0v-5.333M10.4 28h11.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C28 24.96 28 23.84 28 21.6V10.4c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C24.96 4 23.84 4 21.6 4H10.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C4 7.04 4 8.16 4 10.4v11.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C7.04 28 8.16 28 10.4 28" }))); };
	ChartArrowGoingDown.default = SvgChartArrowGoingDown;
	
	return ChartArrowGoingDown;
}

var ChartArrowGoingUp = {};

var hasRequiredChartArrowGoingUp;

function requireChartArrowGoingUp () {
	if (hasRequiredChartArrowGoingUp) return ChartArrowGoingUp;
	hasRequiredChartArrowGoingUp = 1;
	Object.defineProperty(ChartArrowGoingUp, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgChartArrowGoingUp = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m22.667 12-7.246 7.246c-.264.264-.396.396-.548.445a.67.67 0 0 1-.412 0c-.153-.05-.285-.181-.549-.445l-2.491-2.492c-.264-.264-.396-.396-.548-.445a.67.67 0 0 0-.412 0c-.153.05-.285.181-.549.445L4 22.667M22.667 12h-5.334m5.334 0v5.334M10.4 28h11.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C28 24.96 28 23.84 28 21.6V10.4c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C24.96 4 23.84 4 21.6 4H10.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C4 7.04 4 8.16 4 10.4v11.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C7.04 28 8.16 28 10.4 28" }))); };
	ChartArrowGoingUp.default = SvgChartArrowGoingUp;
	
	return ChartArrowGoingUp;
}

var ChartArrowOutlier = {};

var hasRequiredChartArrowOutlier;

function requireChartArrowOutlier () {
	if (hasRequiredChartArrowOutlier) return ChartArrowOutlier;
	hasRequiredChartArrowOutlier = 1;
	Object.defineProperty(ChartArrowOutlier, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgChartArrowOutlier = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M14.667 4H10.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C4 7.04 4 8.16 4 10.4v11.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C7.04 28 8.16 28 10.4 28h11.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C28 24.96 28 23.84 28 21.6v-4.267m-12-6.666h5.333V16m-.666-11.333v-2m5.252 3.414 1.414-1.414m.014 6.666h2M4 17.796Q5.306 18 6.667 18c5.848 0 11.02-2.896 14.16-7.333" }))); };
	ChartArrowOutlier.default = SvgChartArrowOutlier;
	
	return ChartArrowOutlier;
}

var ChartDown = {};

var hasRequiredChartDown;

function requireChartDown () {
	if (hasRequiredChartDown) return ChartDown;
	hasRequiredChartDown = 1;
	Object.defineProperty(ChartDown, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgChartDown = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M16 4h5.6c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C28 7.04 28 8.16 28 10.4v11.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C24.96 28 23.84 28 21.6 28H10.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C4 24.96 4 23.84 4 21.6V16m6.667 1.333v5.334m10.666-8v8M16 9.333v13.334m-13.333-16 4 4m0 0 4-4m-4 4v-8" }))); };
	ChartDown.default = SvgChartDown;
	
	return ChartDown;
}

var ChartGoingDown = {};

var hasRequiredChartGoingDown;

function requireChartGoingDown () {
	if (hasRequiredChartGoingDown) return ChartGoingDown;
	hasRequiredChartGoingDown = 1;
	Object.defineProperty(ChartGoingDown, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgChartGoingDown = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m4 12 8.874 6.339c.265.189.628.159.859-.072l4.534-4.534c.23-.23.594-.26.86-.071L28 20M8 28h16a4 4 0 0 0 4-4V8a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4" }))); };
	ChartGoingDown.default = SvgChartGoingDown;
	
	return ChartGoingDown;
}

var ChartGoingUp = {};

var hasRequiredChartGoingUp;

function requireChartGoingUp () {
	if (hasRequiredChartGoingUp) return ChartGoingUp;
	hasRequiredChartGoingUp = 1;
	Object.defineProperty(ChartGoingUp, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgChartGoingUp = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m28 12-8.598 6.142c-.261.186-.392.28-.532.308a.67.67 0 0 1-.368-.03c-.134-.052-.247-.165-.474-.392l-4.056-4.056c-.227-.227-.34-.34-.474-.39a.67.67 0 0 0-.368-.031c-.14.028-.27.121-.532.308L4 20m6.4 8h11.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C28 24.96 28 23.84 28 21.6V10.4c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C24.96 4 23.84 4 21.6 4H10.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C4 7.04 4 8.16 4 10.4v11.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C7.04 28 8.16 28 10.4 28" }))); };
	ChartGoingUp.default = SvgChartGoingUp;
	
	return ChartGoingUp;
}

var ChartLine01 = {};

var hasRequiredChartLine01;

function requireChartLine01 () {
	if (hasRequiredChartLine01) return ChartLine01;
	hasRequiredChartLine01 = 1;
	Object.defineProperty(ChartLine01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgChartLine01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M29.333 16H24l-4 12-8-24-4 12H2.667" }))); };
	ChartLine01.default = SvgChartLine01;
	
	return ChartLine01;
}

var ChartLine02 = {};

var hasRequiredChartLine02;

function requireChartLine02 () {
	if (hasRequiredChartLine02) return ChartLine02;
	hasRequiredChartLine02 = 1;
	Object.defineProperty(ChartLine02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgChartLine02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M26.667 26.667v-9.333M16 26.667V13.334M5.333 26.667v-5.334m12.542-14.63 6.892 2.585M14.398 7.2 6.934 12.8M28.08 8.586a2 2 0 1 1-2.829 2.828 2 2 0 0 1 2.829-2.828m-21.334 4a2 2 0 1 1-2.828 2.828 2 2 0 0 1 2.828-2.828m10.667-8a2 2 0 1 1-2.828 2.828 2 2 0 0 1 2.828-2.828" }))); };
	ChartLine02.default = SvgChartLine02;
	
	return ChartLine02;
}

var ChartMinus = {};

var hasRequiredChartMinus;

function requireChartMinus () {
	if (hasRequiredChartMinus) return ChartMinus;
	hasRequiredChartMinus = 1;
	Object.defineProperty(ChartMinus, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgChartMinus = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M16 4h5.6c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C28 7.04 28 8.16 28 10.4v11.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C24.96 28 23.84 28 21.6 28H10.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C4 24.96 4 23.84 4 21.6V16m6.666 1.334v5.333m10.667-8v8M16 9.333v13.334m-13.333-16h8" }))); };
	ChartMinus.default = SvgChartMinus;
	
	return ChartMinus;
}

var ChartPie01 = {};

var hasRequiredChartPie01;

function requireChartPie01 () {
	if (hasRequiredChartPie01) return ChartPie01;
	hasRequiredChartPie01 = 1;
	Object.defineProperty(ChartPie01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgChartPie01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M28.28 21.187A13.333 13.333 0 1 1 10.668 3.773m17.652 7.125c.534 1.288.861 2.65.972 4.037.028.342.041.513-.026.667a.7.7 0 0 1-.294.318c-.148.08-.333.08-.704.08h-11.2c-.373 0-.56 0-.702-.073a.67.67 0 0 1-.292-.291c-.072-.143-.072-.33-.072-.703v-11.2c0-.37 0-.555.08-.704a.7.7 0 0 1 .317-.293c.155-.068.326-.054.668-.027a13.33 13.33 0 0 1 11.253 8.189" }))); };
	ChartPie01.default = SvgChartPie01;
	
	return ChartPie01;
}

var ChartPie02 = {};

var hasRequiredChartPie02;

function requireChartPie02 () {
	if (hasRequiredChartPie02) return ChartPie02;
	hasRequiredChartPie02 = 1;
	Object.defineProperty(ChartPie02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgChartPie02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M16 2.667A13.333 13.333 0 0 1 29.333 16M16 2.667V16m0-13.333C8.636 2.667 2.667 8.637 2.667 16S8.637 29.333 16 29.333 29.333 23.363 29.333 16M16 2.667c7.364 0 13.333 5.97 13.333 13.333m0 0H16m13.333 0a13.33 13.33 0 0 1-5.496 10.787L16 16" }))); };
	ChartPie02.default = SvgChartPie02;
	
	return ChartPie02;
}

var ChartPie03 = {};

var hasRequiredChartPie03;

function requireChartPie03 () {
	if (hasRequiredChartPie03) return ChartPie03;
	hasRequiredChartPie03 = 1;
	Object.defineProperty(ChartPie03, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgChartPie03 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M16 16 3.109 12.594a13.33 13.33 0 0 0 7.896 15.769zm0 0 .14-13.333A13.33 13.33 0 0 0 3.12 12.55zm13.333 0c0 7.364-5.97 13.333-13.333 13.333S2.667 23.363 2.667 16 8.637 2.667 16 2.667 29.333 8.637 29.333 16" }))); };
	ChartPie03.default = SvgChartPie03;
	
	return ChartPie03;
}

var ChartPlus = {};

var hasRequiredChartPlus;

function requireChartPlus () {
	if (hasRequiredChartPlus) return ChartPlus;
	hasRequiredChartPlus = 1;
	Object.defineProperty(ChartPlus, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgChartPlus = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M16 4h5.6c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C28 7.04 28 8.16 28 10.4v11.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C24.96 28 23.84 28 21.6 28H10.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C4 24.96 4 23.84 4 21.6V16m6.667 1.333v5.334m10.666-8v8M16 9.333v13.334m-9.333-12v-8m-4 4h8" }))); };
	ChartPlus.default = SvgChartPlus;
	
	return ChartPlus;
}

var ChartUp = {};

var hasRequiredChartUp;

function requireChartUp () {
	if (hasRequiredChartUp) return ChartUp;
	hasRequiredChartUp = 1;
	Object.defineProperty(ChartUp, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgChartUp = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M16 4h5.6c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C28 7.04 28 8.16 28 10.4v11.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C24.96 28 23.84 28 21.6 28H10.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C4 24.96 4 23.84 4 21.6V16m6.667 1.333v5.334m10.666-8v8M16 9.333v13.334m-13.333-16 4-4m0 0 4 4m-4-4v8" }))); };
	ChartUp.default = SvgChartUp;
	
	return ChartUp;
}

var Chart = {};

var hasRequiredChart;

function requireChart () {
	if (hasRequiredChart) return Chart;
	hasRequiredChart = 1;
	Object.defineProperty(Chart, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgChart = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M10.667 17.334v5.333m10.666-8v8M16 9.333v13.334M10.4 28h11.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C28 24.96 28 23.84 28 21.6V10.4c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C24.96 4 23.84 4 21.6 4H10.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C4 7.04 4 8.16 4 10.4v11.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C7.04 28 8.16 28 10.4 28" }))); };
	Chart.default = SvgChart;
	
	return Chart;
}

var CheckVerified01 = {};

var hasRequiredCheckVerified01;

function requireCheckVerified01 () {
	if (hasRequiredCheckVerified01) return CheckVerified01;
	hasRequiredCheckVerified01 = 1;
	Object.defineProperty(CheckVerified01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgCheckVerified01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m12 16 2.667 2.667 6-6M9.778 5.092a5.1 5.1 0 0 0 2.908-1.205 5.11 5.11 0 0 1 6.628 0 5.1 5.1 0 0 0 2.908 1.205 5.11 5.11 0 0 1 4.686 4.686 5.1 5.1 0 0 0 1.205 2.908 5.11 5.11 0 0 1 0 6.628 5.1 5.1 0 0 0-1.204 2.908 5.11 5.11 0 0 1-4.687 4.686 5.1 5.1 0 0 0-2.908 1.205 5.11 5.11 0 0 1-6.628 0 5.1 5.1 0 0 0-2.908-1.205 5.11 5.11 0 0 1-4.686-4.686 5.1 5.1 0 0 0-1.205-2.908 5.11 5.11 0 0 1 0-6.628 5.1 5.1 0 0 0 1.205-2.908 5.11 5.11 0 0 1 4.686-4.686" }))); };
	CheckVerified01.default = SvgCheckVerified01;
	
	return CheckVerified01;
}

var CheckVerified02 = {};

var hasRequiredCheckVerified02;

function requireCheckVerified02 () {
	if (hasRequiredCheckVerified02) return CheckVerified02;
	hasRequiredCheckVerified02 = 1;
	Object.defineProperty(CheckVerified02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgCheckVerified02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m12 16 2.666 2.667 6-6m-8.397 14.8c.437-.057.879.062 1.227.33l1.604 1.23c.53.408 1.268.408 1.797 0l1.665-1.278a1.47 1.47 0 0 1 1.092-.292l2.082.274c.663.088 1.301-.281 1.557-.899l.802-1.937c.15-.363.437-.65.8-.8l1.937-.802c.618-.255.987-.895.9-1.557l-.264-2.007c-.058-.437.06-.879.329-1.227l1.23-1.604a1.474 1.474 0 0 0 0-1.797l-1.278-1.665a1.47 1.47 0 0 1-.292-1.092l.274-2.083a1.48 1.48 0 0 0-.899-1.557l-1.937-.802a1.47 1.47 0 0 1-.8-.8l-.802-1.937a1.476 1.476 0 0 0-1.557-.9l-2.082.275a1.47 1.47 0 0 1-1.09-.29l-1.666-1.278a1.474 1.474 0 0 0-1.797 0l-1.665 1.279a1.49 1.49 0 0 1-1.091.292l-2.083-.275a1.48 1.48 0 0 0-1.557.9l-.8 1.937a1.5 1.5 0 0 1-.8.8l-1.938.8a1.48 1.48 0 0 0-.899 1.557l.274 2.083c.05.388-.055.781-.292 1.09l-1.278 1.666a1.474 1.474 0 0 0 0 1.797l1.278 1.665c.239.311.344.704.292 1.092l-.274 2.083c-.087.662.282 1.3.9 1.557l1.937.801c.363.15.65.437.8.8l.801 1.938c.255.617.895.986 1.557.899z" }))); };
	CheckVerified02.default = SvgCheckVerified02;
	
	return CheckVerified02;
}

var ChevronDown = {};

var hasRequiredChevronDown;

function requireChevronDown () {
	if (hasRequiredChevronDown) return ChevronDown;
	hasRequiredChevronDown = 1;
	Object.defineProperty(ChevronDown, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgChevronDown = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m8 12 8 8 8-8" }))); };
	ChevronDown.default = SvgChevronDown;
	
	return ChevronDown;
}

var ChevronLeft = {};

var hasRequiredChevronLeft;

function requireChevronLeft () {
	if (hasRequiredChevronLeft) return ChevronLeft;
	hasRequiredChevronLeft = 1;
	Object.defineProperty(ChevronLeft, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgChevronLeft = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m20 24-8-8 8-8" }))); };
	ChevronLeft.default = SvgChevronLeft;
	
	return ChevronLeft;
}

var ChevronRight = {};

var hasRequiredChevronRight;

function requireChevronRight () {
	if (hasRequiredChevronRight) return ChevronRight;
	hasRequiredChevronRight = 1;
	Object.defineProperty(ChevronRight, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgChevronRight = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m12 24 8-8-8-8" }))); };
	ChevronRight.default = SvgChevronRight;
	
	return ChevronRight;
}

var ChevronUp = {};

var hasRequiredChevronUp;

function requireChevronUp () {
	if (hasRequiredChevronUp) return ChevronUp;
	hasRequiredChevronUp = 1;
	Object.defineProperty(ChevronUp, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgChevronUp = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m24 20-8-8-8 8" }))); };
	ChevronUp.default = SvgChevronUp;
	
	return ChevronUp;
}

var CircleAdd = {};

var hasRequiredCircleAdd;

function requireCircleAdd () {
	if (hasRequiredCircleAdd) return CircleAdd;
	hasRequiredCircleAdd = 1;
	Object.defineProperty(CircleAdd, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgCircleAdd = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M16 10.667v10.666M10.667 16h10.666m8 0c0 7.364-5.97 13.333-13.333 13.333S2.667 23.363 2.667 16 8.637 2.667 16 2.667 29.333 8.637 29.333 16" }))); };
	CircleAdd.default = SvgCircleAdd;
	
	return CircleAdd;
}

var CircleAlert = {};

var hasRequiredCircleAlert;

function requireCircleAlert () {
	if (hasRequiredCircleAlert) return CircleAlert;
	hasRequiredCircleAlert = 1;
	Object.defineProperty(CircleAlert, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgCircleAlert = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M16 10.667V16m0 5.333h.013M29.333 16c0 7.364-5.97 13.333-13.333 13.333S2.667 23.363 2.667 16 8.637 2.667 16 2.667 29.333 8.637 29.333 16" }))); };
	CircleAlert.default = SvgCircleAlert;
	
	return CircleAlert;
}

var CircleError = {};

var hasRequiredCircleError;

function requireCircleError () {
	if (hasRequiredCircleError) return CircleError;
	hasRequiredCircleError = 1;
	Object.defineProperty(CircleError, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgCircleError = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m20 12-8 8m0-8 8 8m9.333-4c0 7.364-5.97 13.333-13.333 13.333S2.667 23.363 2.667 16 8.637 2.667 16 2.667 29.333 8.637 29.333 16" }))); };
	CircleError.default = SvgCircleError;
	
	return CircleError;
}

var CircleHeart = {};

var hasRequiredCircleHeart;

function requireCircleHeart () {
	if (hasRequiredCircleHeart) return CircleHeart;
	hasRequiredCircleHeart = 1;
	Object.defineProperty(CircleHeart, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgCircleHeart = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M16 29.333c7.364 0 13.333-5.97 13.333-13.333S23.363 2.667 16 2.667 2.667 8.637 2.667 16 8.637 29.333 16 29.333" }),
	    React.createElement("path", { d: "M15.995 12.09c-1.332-1.558-3.555-1.977-5.225-.55s-1.905 3.813-.594 5.5c.84 1.081 2.991 3.086 4.43 4.387.478.433.716.649 1.003.736.246.074.527.074.773 0 .286-.087.525-.303 1.003-.736 1.438-1.301 3.59-3.306 4.43-4.387 1.311-1.687 1.105-4.088-.594-5.5s-3.893-1.008-5.226.55", clipRule: "evenodd" }))); };
	CircleHeart.default = SvgCircleHeart;
	
	return CircleHeart;
}

var CircleHelp = {};

var hasRequiredCircleHelp;

function requireCircleHelp () {
	if (hasRequiredCircleHelp) return CircleHelp;
	hasRequiredCircleHelp = 1;
	Object.defineProperty(CircleHelp, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgCircleHelp = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M11.286 11.286 6.572 6.572m0 18.856 4.714-4.714m9.428 0 4.714 4.714m0-18.856-4.714 4.714M29.334 16c0 7.364-5.97 13.333-13.334 13.333S2.667 23.363 2.667 16 8.637 2.667 16 2.667 29.333 8.637 29.333 16m-6.667 0a6.667 6.667 0 1 1-13.334 0 6.667 6.667 0 0 1 13.334 0" }))); };
	CircleHelp.default = SvgCircleHelp;
	
	return CircleHelp;
}

var CircleInfo = {};

var hasRequiredCircleInfo;

function requireCircleInfo () {
	if (hasRequiredCircleInfo) return CircleInfo;
	hasRequiredCircleInfo = 1;
	Object.defineProperty(CircleInfo, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgCircleInfo = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M16 21.333V16m0-5.333h.013M29.333 16c0 7.364-5.97 13.333-13.333 13.333S2.667 23.363 2.667 16 8.637 2.667 16 2.667 29.333 8.637 29.333 16" }))); };
	CircleInfo.default = SvgCircleInfo;
	
	return CircleInfo;
}

var CircleQuestion = {};

var hasRequiredCircleQuestion;

function requireCircleQuestion () {
	if (hasRequiredCircleQuestion) return CircleQuestion;
	hasRequiredCircleQuestion = 1;
	Object.defineProperty(CircleQuestion, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgCircleQuestion = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M12.12 12a4 4 0 0 1 7.773 1.333c0 2.667-4 4-4 4M16 22.667h.013M29.333 16c0 7.364-5.97 13.333-13.333 13.333S2.667 23.363 2.667 16 8.637 2.667 16 2.667 29.333 8.637 29.333 16" }))); };
	CircleQuestion.default = SvgCircleQuestion;
	
	return CircleQuestion;
}

var CircleRemove = {};

var hasRequiredCircleRemove;

function requireCircleRemove () {
	if (hasRequiredCircleRemove) return CircleRemove;
	hasRequiredCircleRemove = 1;
	Object.defineProperty(CircleRemove, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgCircleRemove = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M10.667 16h10.666m8 0c0 7.364-5.97 13.333-13.333 13.333S2.667 23.363 2.667 16 8.637 2.667 16 2.667 29.333 8.637 29.333 16" }))); };
	CircleRemove.default = SvgCircleRemove;
	
	return CircleRemove;
}

var CircleSuccess = {};

var hasRequiredCircleSuccess;

function requireCircleSuccess () {
	if (hasRequiredCircleSuccess) return CircleSuccess;
	hasRequiredCircleSuccess = 1;
	Object.defineProperty(CircleSuccess, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgCircleSuccess = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m10 16 4 4 8-8m7.333 4c0 7.364-5.97 13.333-13.333 13.333S2.667 23.363 2.667 16 8.636 2.667 16 2.667 29.333 8.637 29.333 16" }))); };
	CircleSuccess.default = SvgCircleSuccess;
	
	return CircleSuccess;
}

var CircleUser = {};

var hasRequiredCircleUser;

function requireCircleUser () {
	if (hasRequiredCircleUser) return CircleUser;
	hasRequiredCircleUser = 1;
	Object.defineProperty(CircleUser, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgCircleUser = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M7.088 25.918A5.34 5.34 0 0 1 12 22.667h8c2.207 0 4.1 1.34 4.912 3.251m-3.579-13.251a5.333 5.333 0 1 1-10.666 0 5.333 5.333 0 0 1 10.666 0m8 3.333c0 7.364-5.97 13.333-13.333 13.333S2.667 23.363 2.667 16 8.637 2.667 16 2.667 29.333 8.637 29.333 16" }))); };
	CircleUser.default = SvgCircleUser;
	
	return CircleUser;
}

var Circles01 = {};

var hasRequiredCircles01;

function requireCircles01 () {
	if (hasRequiredCircles01) return Circles01;
	hasRequiredCircles01 = 1;
	Object.defineProperty(Circles01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgCircles01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M12 21.333a9.333 9.333 0 1 0 0-18.666 9.333 9.333 0 0 0 0 18.666" }),
	    React.createElement("path", { d: "M20 29.333a9.333 9.333 0 1 0 0-18.666 9.333 9.333 0 0 0 0 18.666" }))); };
	Circles01.default = SvgCircles01;
	
	return Circles01;
}

var Circles02 = {};

var hasRequiredCircles02;

function requireCircles02 () {
	if (hasRequiredCircles02) return Circles02;
	hasRequiredCircles02 = 1;
	Object.defineProperty(Circles02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgCircles02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M16 27.296a8 8 0 1 0 7.44-13.683m-14.88 0a8 8 0 1 0 9.546 4.773M24 10.666a8 8 0 1 1-16 0 8 8 0 0 1 16 0" }))); };
	Circles02.default = SvgCircles02;
	
	return Circles02;
}

var CloudDownload = {};

var hasRequiredCloudDownload;

function requireCloudDownload () {
	if (hasRequiredCloudDownload) return CloudDownload;
	hasRequiredCloudDownload = 1;
	Object.defineProperty(CloudDownload, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgCloudDownload = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M5.333 21.656a6 6 0 0 1 2.773-10.964 8.002 8.002 0 0 1 15.788 0 6 6 0 0 1 2.773 10.964m-16 1.01L16 28m0 0 5.333-5.333M16 28V16" }))); };
	CloudDownload.default = SvgCloudDownload;
	
	return CloudDownload;
}

var CloudOff = {};

var hasRequiredCloudOff;

function requireCloudOff () {
	if (hasRequiredCloudOff) return CloudOff;
	hasRequiredCloudOff = 1;
	Object.defineProperty(CloudOff, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgCloudOff = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M28.934 21.49a6 6 0 0 0-5.04-8.132 8 8 0 0 0-9.628-6.503m-4.55 2.86a7.96 7.96 0 0 0-1.61 3.644 6 6 0 0 0 .56 11.974h14.667a6 6 0 0 0 1.749-.258M4 4l24 24" }))); };
	CloudOff.default = SvgCloudOff;
	
	return CloudOff;
}

var CloudUpload = {};

var hasRequiredCloudUpload;

function requireCloudUpload () {
	if (hasRequiredCloudUpload) return CloudUpload;
	hasRequiredCloudUpload = 1;
	Object.defineProperty(CloudUpload, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgCloudUpload = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M5.333 21.656a6 6 0 0 1 2.773-10.964 8.002 8.002 0 0 1 15.788 0 6 6 0 0 1 2.773 10.964m-16-.323L16 16m0 0 5.333 5.333M16 16v12" }))); };
	CloudUpload.default = SvgCloudUpload;
	
	return CloudUpload;
}

var Cloud = {};

var hasRequiredCloud;

function requireCloud () {
	if (hasRequiredCloud) return Cloud;
	hasRequiredCloud = 1;
	Object.defineProperty(Cloud, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgCloud = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M8.667 25.333a6 6 0 0 1-.56-11.974 8.002 8.002 0 0 1 15.787 0 6 6 0 0 1-.56 11.974z" }))); };
	Cloud.default = SvgCloud;
	
	return Cloud;
}

var Coins01 = {};

var hasRequiredCoins01;

function requireCoins01 () {
	if (hasRequiredCoins01) return Coins01;
	hasRequiredCoins01 = 1;
	Object.defineProperty(Coins01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgCoins01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M26.667 6.667c0 2.209-4.776 4-10.667 4s-10.667-1.791-10.667-4m21.334 0c0-2.21-4.776-4-10.667-4s-10.667 1.79-10.667 4m21.334 0v18.666c0 2.21-4.776 4-10.667 4s-10.667-1.79-10.667-4V6.667m21.334 6.222c0 2.209-4.776 4-10.667 4s-10.667-1.791-10.667-4m21.334 6.218c0 2.209-4.776 4-10.667 4s-10.667-1.791-10.667-4" }))); };
	Coins01.default = SvgCoins01;
	
	return Coins01;
}

var Coins02 = {};

var hasRequiredCoins02;

function requireCoins02 () {
	if (hasRequiredCoins02) return Coins02;
	hasRequiredCoins02 = 1;
	Object.defineProperty(Coins02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgCoins02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M17.333 6.667c0 1.472-3.283 2.666-7.333 2.666S2.667 8.14 2.667 6.667m14.666 0C17.333 5.194 14.05 4 10 4S2.667 5.194 2.667 6.667m14.666 0v5.943c-1.628.489-2.666 1.229-2.666 2.057m-12-8v16c0 1.472 3.283 2.666 7.333 2.666 1.773 0 3.399-.228 4.667-.61V14.668M2.667 12c0 1.473 3.283 2.667 7.333 2.667 1.773 0 3.399-.23 4.667-.61m-12 3.276C2.667 18.806 5.95 20 10 20c1.773 0 3.399-.229 4.667-.61m14.666-4.723c0 1.472-3.283 2.666-7.333 2.666s-7.333-1.194-7.333-2.666m14.666 0C29.333 13.194 26.05 12 22 12s-7.333 1.194-7.333 2.667m14.666 0v10.666C29.333 26.806 26.05 28 22 28s-7.333-1.194-7.333-2.667V14.667M29.333 20c0 1.473-3.283 2.667-7.333 2.667S14.667 21.473 14.667 20" }))); };
	Coins02.default = SvgCoins02;
	
	return Coins02;
}

var Columns02 = {};

var hasRequiredColumns02;

function requireColumns02 () {
	if (hasRequiredColumns02) return Columns02;
	hasRequiredColumns02 = 1;
	Object.defineProperty(Columns02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgColumns02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M16 4v24M10.4 4h11.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C28 7.04 28 8.16 28 10.4v11.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C24.96 28 23.84 28 21.6 28H10.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C4 24.96 4 23.84 4 21.6V10.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C7.04 4 8.16 4 10.4 4" }))); };
	Columns02.default = SvgColumns02;
	
	return Columns02;
}

var Columns03 = {};

var hasRequiredColumns03;

function requireColumns03 () {
	if (hasRequiredColumns03) return Columns03;
	hasRequiredColumns03 = 1;
	Object.defineProperty(Columns03, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgColumns03 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M12 4v24m8-24v24M10.4 4h11.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C28 7.04 28 8.16 28 10.4v11.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C24.96 28 23.84 28 21.6 28H10.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C4 24.96 4 23.84 4 21.6V10.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C7.04 4 8.16 4 10.4 4" }))); };
	Columns03.default = SvgColumns03;
	
	return Columns03;
}

var Compass = {};

var hasRequiredCompass;

function requireCompass () {
	if (hasRequiredCompass) return Compass;
	hasRequiredCompass = 1;
	Object.defineProperty(Compass, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgCompass = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M16 29.333c7.364 0 13.333-5.97 13.333-13.333S23.363 2.667 16 2.667 2.667 8.637 2.667 16 8.637 29.333 16 29.333" }),
	    React.createElement("path", { d: "M19.63 11.021c.65-.217.977-.326 1.193-.248a.67.67 0 0 1 .404.404c.077.216-.031.542-.248 1.194l-1.984 5.95c-.062.185-.093.278-.145.355a.7.7 0 0 1-.174.174c-.077.052-.17.083-.355.145l-5.95 1.984c-.652.217-.978.325-1.194.248a.67.67 0 0 1-.404-.404c-.078-.216.031-.542.248-1.194l1.984-5.95c.061-.185.092-.278.145-.355a.7.7 0 0 1 .174-.174c.077-.053.17-.084.355-.145z" }))); };
	Compass.default = SvgCompass;
	
	return Compass;
}

var Condominium01 = {};

var hasRequiredCondominium01;

function requireCondominium01 () {
	if (hasRequiredCondominium01) return Condominium01;
	hasRequiredCondominium01 = 1;
	Object.defineProperty(Condominium01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgCondominium01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M17.333 14.667h6.4c1.494 0 2.24 0 2.81.29.503.256.91.664 1.166 1.166.291.57.291 1.317.291 2.81V28m-10.667 0V8.267c0-1.494 0-2.24-.29-2.811a2.67 2.67 0 0 0-1.166-1.165C15.307 4 14.56 4 13.067 4h-4.8c-1.494 0-2.24 0-2.811.29-.502.256-.91.664-1.165 1.166C4 6.026 4 6.773 4 8.266V28m25.333 0H2.667m6-18.667h4m-4 5.334h4m-4 5.333h4" }))); };
	Condominium01.default = SvgCondominium01;
	
	return Condominium01;
}

var Condominium02 = {};

var hasRequiredCondominium02;

function requireCondominium02 () {
	if (hasRequiredCondominium02) return Condominium02;
	hasRequiredCondominium02 = 1;
	Object.defineProperty(Condominium02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgCondominium02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M10 14.667H6.133c-.746 0-1.12 0-1.405.145-.25.128-.455.332-.583.583C4 15.68 4 16.053 4 16.8V28m18-13.333h3.867c.746 0 1.12 0 1.405.145.25.128.455.332.583.583.145.285.145.658.145 1.405V28m-6 0V8.267c0-1.494 0-2.24-.29-2.811a2.67 2.67 0 0 0-1.166-1.165C19.974 4 19.227 4 17.734 4h-3.467c-1.494 0-2.24 0-2.811.29-.502.256-.91.664-1.165 1.166C10 6.026 10 6.773 10 8.266V28m19.333 0H2.667m12-18.667h2.666m-2.666 5.334h2.666M14.667 20h2.666" }))); };
	Condominium02.default = SvgCondominium02;
	
	return Condominium02;
}

var Condominium03 = {};

var hasRequiredCondominium03;

function requireCondominium03 () {
	if (hasRequiredCondominium03) return Condominium03;
	hasRequiredCondominium03 = 1;
	Object.defineProperty(Condominium03, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgCondominium03 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M14.667 14.667h-6.4c-1.494 0-2.24 0-2.81.29-.503.256-.91.664-1.166 1.166-.29.57-.29 1.317-.29 2.81V28m24 0V8.267c0-1.494 0-2.24-.292-2.811a2.67 2.67 0 0 0-1.165-1.165C25.974 4 25.227 4 23.734 4h-4.8c-1.494 0-2.24 0-2.811.29-.502.256-.91.664-1.166 1.166-.29.57-.29 1.317-.29 2.81V28m14.666 0H2.667M19.333 9.333h4m-4 5.334h4m-4 5.333h4" }))); };
	Condominium03.default = SvgCondominium03;
	
	return Condominium03;
}

var CreditCard01 = {};

var hasRequiredCreditCard01;

function requireCreditCard01 () {
	if (hasRequiredCreditCard01) return CreditCard01;
	hasRequiredCreditCard01 = 1;
	Object.defineProperty(CreditCard01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgCreditCard01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M29.333 13.333H2.667m0-2.4v10.134c0 1.493 0 2.24.29 2.81.256.502.664.91 1.166 1.166.57.29 1.317.29 2.81.29h18.134c1.493 0 2.24 0 2.81-.29.502-.256.91-.664 1.166-1.166.29-.57.29-1.317.29-2.81V10.933c0-1.493 0-2.24-.29-2.81a2.67 2.67 0 0 0-1.166-1.166c-.57-.29-1.317-.29-2.81-.29H6.933c-1.493 0-2.24 0-2.81.29-.502.256-.91.664-1.166 1.166-.29.57-.29 1.317-.29 2.81" }))); };
	CreditCard01.default = SvgCreditCard01;
	
	return CreditCard01;
}

var CreditCard02 = {};

var hasRequiredCreditCard02;

function requireCreditCard02 () {
	if (hasRequiredCreditCard02) return CreditCard02;
	hasRequiredCreditCard02 = 1;
	Object.defineProperty(CreditCard02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgCreditCard02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M29.333 13.333H2.667m12 5.334H8m-5.333-7.734v10.134c0 1.493 0 2.24.29 2.81.256.502.664.91 1.166 1.166.57.29 1.317.29 2.81.29h18.134c1.493 0 2.24 0 2.81-.29.502-.256.91-.664 1.166-1.166.29-.57.29-1.317.29-2.81V10.933c0-1.493 0-2.24-.29-2.81a2.67 2.67 0 0 0-1.166-1.166c-.57-.29-1.317-.29-2.81-.29H6.933c-1.493 0-2.24 0-2.81.29-.502.256-.91.664-1.166 1.166-.29.57-.29 1.317-.29 2.81" }))); };
	CreditCard02.default = SvgCreditCard02;
	
	return CreditCard02;
}

var CreditCardCheck = {};

var hasRequiredCreditCardCheck;

function requireCreditCardCheck () {
	if (hasRequiredCreditCardCheck) return CreditCardCheck;
	hasRequiredCreditCardCheck = 1;
	Object.defineProperty(CreditCardCheck, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgCreditCardCheck = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M21.333 24 24 26.667l5.333-5.334m0-8H2.667M29.333 16v-5.067c0-1.493 0-2.24-.29-2.81a2.67 2.67 0 0 0-1.166-1.166c-.57-.29-1.317-.29-2.81-.29H6.933c-1.493 0-2.24 0-2.81.29-.502.256-.91.664-1.166 1.166-.29.57-.29 1.317-.29 2.81v10.134c0 1.493 0 2.24.29 2.81.256.502.664.91 1.166 1.166.57.29 1.317.29 2.81.29H16" }))); };
	CreditCardCheck.default = SvgCreditCardCheck;
	
	return CreditCardCheck;
}

var CreditCardClose = {};

var hasRequiredCreditCardClose;

function requireCreditCardClose () {
	if (hasRequiredCreditCardClose) return CreditCardClose;
	hasRequiredCreditCardClose = 1;
	Object.defineProperty(CreditCardClose, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgCreditCardClose = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M22 21.333 28.667 28m0-6.667L22 28m7.333-14.667H2.667M29.333 16v-5.067c0-1.493 0-2.24-.29-2.81a2.67 2.67 0 0 0-1.166-1.166c-.57-.29-1.317-.29-2.81-.29H6.933c-1.493 0-2.24 0-2.81.29-.502.256-.91.664-1.166 1.166-.29.57-.29 1.317-.29 2.81v10.134c0 1.493 0 2.24.29 2.81.256.502.664.91 1.166 1.166.57.29 1.317.29 2.81.29H16" }))); };
	CreditCardClose.default = SvgCreditCardClose;
	
	return CreditCardClose;
}

var CreditCardDown = {};

var hasRequiredCreditCardDown;

function requireCreditCardDown () {
	if (hasRequiredCreditCardDown) return CreditCardDown;
	hasRequiredCreditCardDown = 1;
	Object.defineProperty(CreditCardDown, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgCreditCardDown = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m21.333 24 4 4m0 0 4-4m-4 4v-8m4-6.667H2.667M29.333 16v-5.067c0-1.493 0-2.24-.29-2.81a2.67 2.67 0 0 0-1.166-1.166c-.57-.29-1.317-.29-2.81-.29H6.933c-1.493 0-2.24 0-2.81.29-.502.256-.91.664-1.166 1.166-.29.57-.29 1.317-.29 2.81v10.134c0 1.493 0 2.24.29 2.81.256.502.664.91 1.166 1.166.57.29 1.317.29 2.81.29H16" }))); };
	CreditCardDown.default = SvgCreditCardDown;
	
	return CreditCardDown;
}

var CreditCardDownload = {};

var hasRequiredCreditCardDownload;

function requireCreditCardDownload () {
	if (hasRequiredCreditCardDownload) return CreditCardDownload;
	hasRequiredCreditCardDownload = 1;
	Object.defineProperty(CreditCardDownload, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgCreditCardDownload = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m12 22.667 4 4m0 0 4-4m-4 4v-9.334M29.333 12H2.667m4.666 12h-.4c-1.493 0-2.24 0-2.81-.29a2.67 2.67 0 0 1-1.166-1.166c-.29-.57-.29-1.317-.29-2.81V9.6c0-1.494 0-2.24.29-2.81.256-.502.664-.91 1.166-1.166.57-.29 1.317-.29 2.81-.29h18.134c1.493 0 2.24 0 2.81.29.502.256.91.664 1.166 1.165.29.57.29 1.317.29 2.811v10.133c0 1.494 0 2.24-.29 2.81-.256.503-.664.91-1.166 1.166-.57.29-1.317.29-2.81.29h-.4" }))); };
	CreditCardDownload.default = SvgCreditCardDownload;
	
	return CreditCardDownload;
}

var CreditCardEdit = {};

var hasRequiredCreditCardEdit;

function requireCreditCardEdit () {
	if (hasRequiredCreditCardEdit) return CreditCardEdit;
	hasRequiredCreditCardEdit = 1;
	Object.defineProperty(CreditCardEdit, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgCreditCardEdit = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M2.667 13.333h26.666v-2.4c0-1.493 0-2.24-.29-2.81a2.67 2.67 0 0 0-1.166-1.166c-.57-.29-1.317-.29-2.81-.29H6.933c-1.493 0-2.24 0-2.81.29-.502.256-.91.664-1.166 1.166-.29.57-.29 1.317-.29 2.81v10.134c0 1.493 0 2.24.29 2.81.256.502.664.91 1.166 1.166.57.29 1.317.29 2.81.29h7.734M19.333 28l2.7-.54c.236-.047.354-.07.463-.114q.147-.057.276-.147c.097-.068.182-.153.352-.322l5.543-5.544A1.886 1.886 0 0 0 26 18.667l-5.543 5.543c-.17.17-.255.255-.322.351q-.09.13-.148.276c-.043.11-.066.228-.114.463z" }))); };
	CreditCardEdit.default = SvgCreditCardEdit;
	
	return CreditCardEdit;
}

var CreditCardLock = {};

var hasRequiredCreditCardLock;

function requireCreditCardLock () {
	if (hasRequiredCreditCardLock) return CreditCardLock;
	hasRequiredCreditCardLock = 1;
	Object.defineProperty(CreditCardLock, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgCreditCardLock = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M27 23.333V21a2.333 2.333 0 0 0-4.667 0v2.333m7-10H2.667m26.666 1.334v-3.734c0-1.493 0-2.24-.29-2.81a2.67 2.67 0 0 0-1.166-1.166c-.57-.29-1.317-.29-2.81-.29H6.933c-1.493 0-2.24 0-2.81.29-.502.256-.91.664-1.166 1.166-.29.57-.29 1.317-.29 2.81v10.134c0 1.493 0 2.24.29 2.81.256.502.664.91 1.166 1.166.57.29 1.317.29 2.81.29h7.734m7.466 3.334H27.2c.747 0 1.12 0 1.405-.146.251-.128.455-.332.583-.582.145-.286.145-.659.145-1.406v-1.066c0-.747 0-1.12-.145-1.406a1.33 1.33 0 0 0-.583-.582c-.285-.146-.658-.146-1.405-.146h-5.067c-.746 0-1.12 0-1.405.146-.25.127-.455.331-.583.582-.145.285-.145.659-.145 1.406v1.066c0 .747 0 1.12.145 1.406.128.25.332.454.583.582.285.146.659.146 1.405.146" }))); };
	CreditCardLock.default = SvgCreditCardLock;
	
	return CreditCardLock;
}

var CreditCardMinus = {};

var hasRequiredCreditCardMinus;

function requireCreditCardMinus () {
	if (hasRequiredCreditCardMinus) return CreditCardMinus;
	hasRequiredCreditCardMinus = 1;
	Object.defineProperty(CreditCardMinus, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgCreditCardMinus = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M21.333 24h8m0-10.667H2.667M29.333 18v-7.067c0-1.493 0-2.24-.29-2.81a2.67 2.67 0 0 0-1.166-1.166c-.57-.29-1.317-.29-2.81-.29H6.933c-1.493 0-2.24 0-2.81.29-.502.256-.91.664-1.166 1.166-.29.57-.29 1.317-.29 2.81v10.134c0 1.493 0 2.24.29 2.81.256.502.664.91 1.166 1.166.57.29 1.317.29 2.81.29H16" }))); };
	CreditCardMinus.default = SvgCreditCardMinus;
	
	return CreditCardMinus;
}

var CreditCardPlus = {};

var hasRequiredCreditCardPlus;

function requireCreditCardPlus () {
	if (hasRequiredCreditCardPlus) return CreditCardPlus;
	hasRequiredCreditCardPlus = 1;
	Object.defineProperty(CreditCardPlus, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgCreditCardPlus = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M25.333 28v-8m-4 4h8m0-10.667H2.667M29.333 16v-5.067c0-1.493 0-2.24-.29-2.81a2.67 2.67 0 0 0-1.166-1.166c-.57-.29-1.317-.29-2.81-.29H6.933c-1.493 0-2.24 0-2.81.29-.502.256-.91.664-1.166 1.166-.29.57-.29 1.317-.29 2.81v10.134c0 1.493 0 2.24.29 2.81.256.502.664.91 1.166 1.166.57.29 1.317.29 2.81.29H16" }))); };
	CreditCardPlus.default = SvgCreditCardPlus;
	
	return CreditCardPlus;
}

var CreditCardRefresh = {};

var hasRequiredCreditCardRefresh;

function requireCreditCardRefresh () {
	if (hasRequiredCreditCardRefresh) return CreditCardRefresh;
	hasRequiredCreditCardRefresh = 1;
	Object.defineProperty(CreditCardRefresh, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgCreditCardRefresh = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M29.333 13.333H2.667m12 12h10.4c1.493 0 2.24 0 2.81-.29.502-.256.91-.664 1.166-1.166.29-.57.29-1.317.29-2.81V10.933c0-1.493 0-2.24-.29-2.81a2.67 2.67 0 0 0-1.166-1.166c-.57-.29-1.317-.29-2.81-.29h-2.4m-8 18.666L17.333 28m-2.666-2.667 2.666-2.666m-8 2.666h-2.4c-1.493 0-2.24 0-2.81-.29a2.67 2.67 0 0 1-1.166-1.166c-.29-.57-.29-1.317-.29-2.81V10.933c0-1.493 0-2.24.29-2.81.256-.502.664-.91 1.166-1.166.57-.29 1.317-.29 2.81-.29h10.4m0 0-2.666 2.666m2.666-2.666L14.667 4" }))); };
	CreditCardRefresh.default = SvgCreditCardRefresh;
	
	return CreditCardRefresh;
}

var CreditCardSearch = {};

var hasRequiredCreditCardSearch;

function requireCreditCardSearch () {
	if (hasRequiredCreditCardSearch) return CreditCardSearch;
	hasRequiredCreditCardSearch = 1;
	Object.defineProperty(CreditCardSearch, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgCreditCardSearch = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m29.333 29.333-2-2m2-14H2.667M29.333 16v-5.067c0-1.493 0-2.24-.29-2.81a2.67 2.67 0 0 0-1.166-1.166c-.57-.29-1.317-.29-2.81-.29H6.933c-1.493 0-2.24 0-2.81.29-.502.256-.91.664-1.166 1.166-.29.57-.29 1.317-.29 2.81v10.134c0 1.493 0 2.24.29 2.81.256.502.664.91 1.166 1.166.57.29 1.317.29 2.81.29H14M28.667 24a4.667 4.667 0 1 1-9.334 0 4.667 4.667 0 0 1 9.334 0" }))); };
	CreditCardSearch.default = SvgCreditCardSearch;
	
	return CreditCardSearch;
}

var CreditCardShield = {};

var hasRequiredCreditCardShield;

function requireCreditCardShield () {
	if (hasRequiredCreditCardShield) return CreditCardShield;
	hasRequiredCreditCardShield = 1;
	Object.defineProperty(CreditCardShield, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgCreditCardShield = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M29.333 13.333H2.667m26.666 1.334v-3.734c0-1.493 0-2.24-.29-2.81a2.67 2.67 0 0 0-1.166-1.166c-.57-.29-1.317-.29-2.81-.29H6.933c-1.493 0-2.24 0-2.81.29-.502.256-.91.664-1.166 1.166-.29.57-.29 1.317-.29 2.81v10.134c0 1.493 0 2.24.29 2.81.256.502.664.91 1.166 1.166.57.29 1.317.29 2.81.29h8.4M24 28s4-1.907 4-4.766v-3.337l-2.917-1.042a3.2 3.2 0 0 0-2.168 0L20 19.897v3.337C20 26.094 24 28 24 28" }))); };
	CreditCardShield.default = SvgCreditCardShield;
	
	return CreditCardShield;
}

var CreditCardUp = {};

var hasRequiredCreditCardUp;

function requireCreditCardUp () {
	if (hasRequiredCreditCardUp) return CreditCardUp;
	hasRequiredCreditCardUp = 1;
	Object.defineProperty(CreditCardUp, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgCreditCardUp = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m21.333 24 4-4m0 0 4 4m-4-4v8m4-14.667H2.667M29.333 16v-5.067c0-1.493 0-2.24-.29-2.81a2.67 2.67 0 0 0-1.166-1.166c-.57-.29-1.317-.29-2.81-.29H6.933c-1.493 0-2.24 0-2.81.29-.502.256-.91.664-1.166 1.166-.29.57-.29 1.317-.29 2.81v10.134c0 1.493 0 2.24.29 2.81.256.502.664.91 1.166 1.166.57.29 1.317.29 2.81.29H16" }))); };
	CreditCardUp.default = SvgCreditCardUp;
	
	return CreditCardUp;
}

var CreditCardUpload = {};

var hasRequiredCreditCardUpload;

function requireCreditCardUpload () {
	if (hasRequiredCreditCardUpload) return CreditCardUpload;
	hasRequiredCreditCardUpload = 1;
	Object.defineProperty(CreditCardUpload, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgCreditCardUpload = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m12 21.333 4-4m0 0 4 4m-4-4v9.334M29.333 12H2.667m4.666 12h-.4c-1.493 0-2.24 0-2.81-.29a2.67 2.67 0 0 1-1.166-1.166c-.29-.57-.29-1.317-.29-2.81V9.6c0-1.494 0-2.24.29-2.81.256-.502.664-.91 1.166-1.166.57-.29 1.317-.29 2.81-.29h18.134c1.493 0 2.24 0 2.81.29.502.256.91.664 1.166 1.165.29.57.29 1.317.29 2.811v10.133c0 1.494 0 2.24-.29 2.81-.256.503-.664.91-1.166 1.166-.57.29-1.317.29-2.81.29h-.4" }))); };
	CreditCardUpload.default = SvgCreditCardUpload;
	
	return CreditCardUpload;
}

var CurrencyCircle = {};

var hasRequiredCurrencyCircle;

function requireCurrencyCircle () {
	if (hasRequiredCurrencyCircle) return CurrencyCircle;
	hasRequiredCurrencyCircle = 1;
	Object.defineProperty(CurrencyCircle, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgCurrencyCircle = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M11.333 19.556a3.11 3.11 0 0 0 3.111 3.11h2.89a3.333 3.333 0 0 0 0-6.666h-2.667a3.333 3.333 0 0 1 0-6.667h2.888a3.11 3.11 0 0 1 3.112 3.111M16 7.334v2m0 13.333v2M29.333 16c0 7.364-5.97 13.333-13.333 13.333S2.667 23.363 2.667 16 8.637 2.667 16 2.667 29.333 8.637 29.333 16" }))); };
	CurrencyCircle.default = SvgCurrencyCircle;
	
	return CurrencyCircle;
}

var CurrencyNote = {};

var hasRequiredCurrencyNote;

function requireCurrencyNote () {
	if (hasRequiredCurrencyNote) return CurrencyNote;
	hasRequiredCurrencyNote = 1;
	Object.defineProperty(CurrencyNote, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgCurrencyNote = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M18.667 12h-3.334a2 2 0 1 0 0 4h1.334a2 2 0 1 1 0 4h-3.334M16 10.667V12m0 8v1.333M24 16h.013M8 16h.013m-5.346-5.067v10.134c0 1.493 0 2.24.29 2.81.256.502.664.91 1.166 1.166.57.29 1.317.29 2.81.29h18.134c1.493 0 2.24 0 2.81-.29.502-.256.91-.664 1.166-1.166.29-.57.29-1.317.29-2.81V10.933c0-1.493 0-2.24-.29-2.81a2.67 2.67 0 0 0-1.166-1.166c-.57-.29-1.317-.29-2.81-.29H6.933c-1.493 0-2.24 0-2.81.29-.502.256-.91.664-1.166 1.166-.29.57-.29 1.317-.29 2.81m22 5.067a.667.667 0 1 1-1.334 0 .667.667 0 0 1 1.334 0m-16 0a.667.667 0 1 1-1.334 0 .667.667 0 0 1 1.334 0" }))); };
	CurrencyNote.default = SvgCurrencyNote;
	
	return CurrencyNote;
}

var Currency = {};

var hasRequiredCurrency;

function requireCurrency () {
	if (hasRequiredCurrency) return Currency;
	hasRequiredCurrency = 1;
	Object.defineProperty(Currency, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgCurrency = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M8 21.333a5.333 5.333 0 0 0 5.333 5.334h5.333a5.333 5.333 0 1 0 0-10.667h-5.333a5.333 5.333 0 0 1 0-10.667h5.333A5.333 5.333 0 0 1 24 10.667m-8-8v26.666" }))); };
	Currency.default = SvgCurrency;
	
	return Currency;
}

var CursorPointer = {};

var hasRequiredCursorPointer;

function requireCursorPointer () {
	if (hasRequiredCursorPointer) return CursorPointer;
	hasRequiredCursorPointer = 1;
	Object.defineProperty(CursorPointer, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgCursorPointer = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M12 4.667v-2m-5.252 4.08L5.333 5.334m1.415 12-1.415 1.415m12-12 1.415-1.415M4.667 12h-2m8.666-.667 5.482 17.038 3.852-3.852 4.815 4.814 3.851-3.851-4.814-4.815 3.852-3.852z" }))); };
	CursorPointer.default = SvgCursorPointer;
	
	return CursorPointer;
}

var Cursor = {};

var hasRequiredCursor;

function requireCursor () {
	if (hasRequiredCursor) return Cursor;
	hasRequiredCursor = 1;
	Object.defineProperty(Cursor, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgCursor = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M5.876 4.552c-.61-.18-.916-.27-1.124-.192a.67.67 0 0 0-.392.392c-.078.208.012.513.192 1.124l5.608 19.067c.167.568.25.851.419.983a.67.67 0 0 0 .52.133c.21-.035.42-.244.838-.663L16 21.333l5.912 5.913c.264.264.396.396.549.445a.67.67 0 0 0 .412 0c.152-.05.284-.181.548-.445l3.825-3.825c.264-.264.396-.396.445-.548a.67.67 0 0 0 0-.412c-.05-.153-.181-.285-.445-.549L21.333 16l4.063-4.063c.419-.418.628-.627.663-.839a.67.67 0 0 0-.133-.52c-.131-.168-.415-.251-.983-.418z" }))); };
	Cursor.default = SvgCursor;
	
	return Cursor;
}

var Diamond = {};

var hasRequiredDiamond;

function requireDiamond () {
	if (hasRequiredDiamond) return Diamond;
	hasRequiredDiamond = 1;
	Object.defineProperty(Diamond, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgDiamond = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M3.333 12h25.333M13.333 4l-2.667 8 5.333 15.333L21.333 12l-2.667-8m-1.847 23.017 11.945-14.334c.202-.243.303-.365.342-.5a.67.67 0 0 0 0-.366c-.039-.136-.14-.257-.342-.5l-5.778-6.933c-.118-.141-.177-.212-.248-.263a.7.7 0 0 0-.211-.098C22.442 4 22.35 4 22.167 4H9.831c-.183 0-.275 0-.36.023a.7.7 0 0 0-.21.098c-.073.051-.132.122-.25.263l-5.777 6.933c-.202.243-.304.364-.342.5a.67.67 0 0 0 0 .366c.038.135.14.257.342.5L15.18 27.017c.281.337.422.506.59.568.148.054.31.054.458 0 .169-.062.31-.23.59-.568" }))); };
	Diamond.default = SvgDiamond;
	
	return Diamond;
}

var DirectionCircleDownLeft = {};

var hasRequiredDirectionCircleDownLeft;

function requireDirectionCircleDownLeft () {
	if (hasRequiredDirectionCircleDownLeft) return DirectionCircleDownLeft;
	hasRequiredDirectionCircleDownLeft = 1;
	Object.defineProperty(DirectionCircleDownLeft, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgDirectionCircleDownLeft = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M12 12v8m0 0h8m-8 0L25.333 6.667m3.548 5.88a13.33 13.33 0 0 1-3.453 12.881c-5.207 5.207-13.65 5.207-18.856 0s-5.207-13.649 0-18.856a13.33 13.33 0 0 1 12.88-3.453" }))); };
	DirectionCircleDownLeft.default = SvgDirectionCircleDownLeft;
	
	return DirectionCircleDownLeft;
}

var DirectionCircleDownRight = {};

var hasRequiredDirectionCircleDownRight;

function requireDirectionCircleDownRight () {
	if (hasRequiredDirectionCircleDownRight) return DirectionCircleDownRight;
	hasRequiredDirectionCircleDownRight = 1;
	Object.defineProperty(DirectionCircleDownRight, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgDirectionCircleDownRight = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M12.547 3.12a13.33 13.33 0 0 1 12.881 3.452c5.207 5.207 5.207 13.65 0 18.856s-13.649 5.207-18.856 0a13.33 13.33 0 0 1-3.453-12.88M20 12v8m0 0h-8m8 0L6.667 6.667" }))); };
	DirectionCircleDownRight.default = SvgDirectionCircleDownRight;
	
	return DirectionCircleDownRight;
}

var DirectionCircleDown = {};

var hasRequiredDirectionCircleDown;

function requireDirectionCircleDown () {
	if (hasRequiredDirectionCircleDown) return DirectionCircleDown;
	hasRequiredDirectionCircleDown = 1;
	Object.defineProperty(DirectionCircleDown, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgDirectionCircleDown = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M22.667 4.45A13.33 13.33 0 0 1 29.333 16c0 7.364-5.97 13.333-13.333 13.333S2.667 23.363 2.667 16c0-4.935 2.681-9.244 6.666-11.55M10.667 16 16 21.333m0 0L21.333 16M16 21.333V2.667" }))); };
	DirectionCircleDown.default = SvgDirectionCircleDown;
	
	return DirectionCircleDown;
}

var DirectionCircleLeft = {};

var hasRequiredDirectionCircleLeft;

function requireDirectionCircleLeft () {
	if (hasRequiredDirectionCircleLeft) return DirectionCircleLeft;
	hasRequiredDirectionCircleLeft = 1;
	Object.defineProperty(DirectionCircleLeft, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgDirectionCircleLeft = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M27.55 22.667A13.33 13.33 0 0 1 16 29.333c-7.364 0-13.333-5.97-13.333-13.333S8.637 2.667 16 2.667c4.935 0 9.244 2.681 11.55 6.666M16 10.667 10.667 16m0 0L16 21.333M10.667 16h18.666" }))); };
	DirectionCircleLeft.default = SvgDirectionCircleLeft;
	
	return DirectionCircleLeft;
}

var DirectionCircleRight = {};

var hasRequiredDirectionCircleRight;

function requireDirectionCircleRight () {
	if (hasRequiredDirectionCircleRight) return DirectionCircleRight;
	hasRequiredDirectionCircleRight = 1;
	Object.defineProperty(DirectionCircleRight, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgDirectionCircleRight = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M4.45 9.333A13.33 13.33 0 0 1 16 2.667c7.364 0 13.333 5.97 13.333 13.333S23.363 29.333 16 29.333a13.33 13.33 0 0 1-11.55-6.666M16 21.333 21.333 16m0 0L16 10.667M21.333 16H2.667" }))); };
	DirectionCircleRight.default = SvgDirectionCircleRight;
	
	return DirectionCircleRight;
}

var DirectionCircleUpLeft = {};

var hasRequiredDirectionCircleUpLeft;

function requireDirectionCircleUpLeft () {
	if (hasRequiredDirectionCircleUpLeft) return DirectionCircleUpLeft;
	hasRequiredDirectionCircleUpLeft = 1;
	Object.defineProperty(DirectionCircleUpLeft, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgDirectionCircleUpLeft = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M19.453 28.88a13.33 13.33 0 0 1-12.881-3.452c-5.207-5.207-5.207-13.65 0-18.856s13.649-5.207 18.856 0a13.33 13.33 0 0 1 3.453 12.88M12 20v-8m0 0h8m-8 0 13.332 13.333" }))); };
	DirectionCircleUpLeft.default = SvgDirectionCircleUpLeft;
	
	return DirectionCircleUpLeft;
}

var DirectionCircleUpRight = {};

var hasRequiredDirectionCircleUpRight;

function requireDirectionCircleUpRight () {
	if (hasRequiredDirectionCircleUpRight) return DirectionCircleUpRight;
	hasRequiredDirectionCircleUpRight = 1;
	Object.defineProperty(DirectionCircleUpRight, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgDirectionCircleUpRight = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M3.12 19.453A13.33 13.33 0 0 1 6.571 6.572c5.207-5.207 13.65-5.207 18.856 0s5.207 13.65 0 18.856a13.33 13.33 0 0 1-12.88 3.453M20 20v-8m0 0h-8m8 0L6.667 25.332" }))); };
	DirectionCircleUpRight.default = SvgDirectionCircleUpRight;
	
	return DirectionCircleUpRight;
}

var DirectionCircleUp = {};

var hasRequiredDirectionCircleUp;

function requireDirectionCircleUp () {
	if (hasRequiredDirectionCircleUp) return DirectionCircleUp;
	hasRequiredDirectionCircleUp = 1;
	Object.defineProperty(DirectionCircleUp, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgDirectionCircleUp = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M9.333 27.55A13.33 13.33 0 0 1 2.667 16C2.667 8.636 8.637 2.667 16 2.667S29.333 8.637 29.333 16c0 4.935-2.681 9.244-6.666 11.55M21.333 16 16 10.667m0 0L10.667 16M16 10.667v18.666" }))); };
	DirectionCircleUp.default = SvgDirectionCircleUp;
	
	return DirectionCircleUp;
}

var DirectionDiamondDownLeft = {};

var hasRequiredDirectionDiamondDownLeft;

function requireDirectionDiamondDownLeft () {
	if (hasRequiredDirectionDiamondDownLeft) return DirectionDiamondDownLeft;
	hasRequiredDirectionDiamondDownLeft = 1;
	Object.defineProperty(DirectionDiamondDownLeft, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgDirectionDiamondDownLeft = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m25.75 12.75 1.836 1.836a2 2 0 0 1 0 2.828L17.414 27.586a2 2 0 0 1-2.828 0L4.414 17.414a2 2 0 0 1 0-2.828L14.586 4.414a2 2 0 0 1 2.828 0L19.25 6.25" }),
	    React.createElement("path", { d: "M22 10v.963c0 2.31 0 2.465-.45 3.347a4.13 4.13 0 0 1-1.802 1.803c-.883.45-2.038.45-4.348.45H11m0 0 3.438-3.438M11 16.563 14.438 20" }))); };
	DirectionDiamondDownLeft.default = SvgDirectionDiamondDownLeft;
	
	return DirectionDiamondDownLeft;
}

var DirectionDiamondDownRight = {};

var hasRequiredDirectionDiamondDownRight;

function requireDirectionDiamondDownRight () {
	if (hasRequiredDirectionDiamondDownRight) return DirectionDiamondDownRight;
	hasRequiredDirectionDiamondDownRight = 1;
	Object.defineProperty(DirectionDiamondDownRight, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgDirectionDiamondDownRight = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m6.25 12.75-1.836 1.836a2 2 0 0 0 0 2.828l10.172 10.172a2 2 0 0 0 2.828 0l10.172-10.172a2 2 0 0 0 0-2.828L17.414 4.414a2 2 0 0 0-2.828 0L12.75 6.25" }),
	    React.createElement("path", { d: "M10 10v.963c0 2.31 0 2.465.45 3.347a4.13 4.13 0 0 0 1.802 1.803c.883.45 2.038.45 4.348.45H21m0 0-3.437-3.438M21 16.563 17.563 20" }))); };
	DirectionDiamondDownRight.default = SvgDirectionDiamondDownRight;
	
	return DirectionDiamondDownRight;
}

var DirectionDiamondDown = {};

var hasRequiredDirectionDiamondDown;

function requireDirectionDiamondDown () {
	if (hasRequiredDirectionDiamondDown) return DirectionDiamondDown;
	hasRequiredDirectionDiamondDown = 1;
	Object.defineProperty(DirectionDiamondDown, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgDirectionDiamondDown = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M4.414 14.586 14.586 4.414a2 2 0 0 1 2.828 0l10.172 10.172a2 2 0 0 1 0 2.828L17.414 27.586a2 2 0 0 1-2.828 0L4.414 17.414a2 2 0 0 1 0-2.828M16 9v13m0 0-4.5-4.5M16 22l4.5-4.5" }))); };
	DirectionDiamondDown.default = SvgDirectionDiamondDown;
	
	return DirectionDiamondDown;
}

var DirectionDiamondLeftDown = {};

var hasRequiredDirectionDiamondLeftDown;

function requireDirectionDiamondLeftDown () {
	if (hasRequiredDirectionDiamondLeftDown) return DirectionDiamondLeftDown;
	hasRequiredDirectionDiamondLeftDown = 1;
	Object.defineProperty(DirectionDiamondLeftDown, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgDirectionDiamondLeftDown = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m25.75 12.75 1.836 1.836a2 2 0 0 1 0 2.828L17.414 27.586a2 2 0 0 1-2.828 0L4.414 17.414a2 2 0 0 1 0-2.828L14.586 4.414a2 2 0 0 1 2.828 0L19.25 6.25" }),
	    React.createElement("path", { d: "M22.4 10.5h-.962c-2.31 0-2.466 0-3.348.45a4.13 4.13 0 0 0-1.803 1.802c-.45.883-.45 2.038-.45 4.348v4.4m0 0 3.438-3.437M15.838 21.5 12.4 18.063" }))); };
	DirectionDiamondLeftDown.default = SvgDirectionDiamondLeftDown;
	
	return DirectionDiamondLeftDown;
}

var DirectionDiamondLeftUp = {};

var hasRequiredDirectionDiamondLeftUp;

function requireDirectionDiamondLeftUp () {
	if (hasRequiredDirectionDiamondLeftUp) return DirectionDiamondLeftUp;
	hasRequiredDirectionDiamondLeftUp = 1;
	Object.defineProperty(DirectionDiamondLeftUp, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgDirectionDiamondLeftUp = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m25.75 19.25 1.836-1.836a2 2 0 0 0 0-2.828L17.414 4.414a2 2 0 0 0-2.828 0L4.414 14.586a2 2 0 0 0 0 2.828l10.172 10.172a2 2 0 0 0 2.828 0l1.836-1.836" }),
	    React.createElement("path", { d: "M22.4 21.5h-.962c-2.31 0-2.466 0-3.348-.45a4.13 4.13 0 0 1-1.803-1.802c-.45-.883-.45-2.038-.45-4.348v-4.4m0 0 3.438 3.438M15.838 10.5 12.4 13.938" }))); };
	DirectionDiamondLeftUp.default = SvgDirectionDiamondLeftUp;
	
	return DirectionDiamondLeftUp;
}

var DirectionDiamondLeft = {};

var hasRequiredDirectionDiamondLeft;

function requireDirectionDiamondLeft () {
	if (hasRequiredDirectionDiamondLeft) return DirectionDiamondLeft;
	hasRequiredDirectionDiamondLeft = 1;
	Object.defineProperty(DirectionDiamondLeft, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgDirectionDiamondLeft = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M4.414 14.586 14.586 4.414a2 2 0 0 1 2.828 0l10.172 10.172a2 2 0 0 1 0 2.828L17.414 27.586a2 2 0 0 1-2.828 0L4.414 17.414a2 2 0 0 1 0-2.828M23 16H10m0 0 4.5-4.5M10 16l4.5 4.5" }))); };
	DirectionDiamondLeft.default = SvgDirectionDiamondLeft;
	
	return DirectionDiamondLeft;
}

var DirectionDiamondRightDown = {};

var hasRequiredDirectionDiamondRightDown;

function requireDirectionDiamondRightDown () {
	if (hasRequiredDirectionDiamondRightDown) return DirectionDiamondRightDown;
	hasRequiredDirectionDiamondRightDown = 1;
	Object.defineProperty(DirectionDiamondRightDown, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgDirectionDiamondRightDown = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m6.25 12.75-1.836 1.836a2 2 0 0 0 0 2.828l10.172 10.172a2 2 0 0 0 2.828 0l10.172-10.172a2 2 0 0 0 0-2.828L17.414 4.414a2 2 0 0 0-2.828 0L12.75 6.25" }),
	    React.createElement("path", { d: "M9.6 10.5h.963c2.31 0 2.465 0 3.347.45a4.13 4.13 0 0 1 1.803 1.802c.45.883.45 2.038.45 4.348v4.4m0 0-3.438-3.437m3.438 3.437 3.437-3.437" }))); };
	DirectionDiamondRightDown.default = SvgDirectionDiamondRightDown;
	
	return DirectionDiamondRightDown;
}

var DirectionDiamondRightUp = {};

var hasRequiredDirectionDiamondRightUp;

function requireDirectionDiamondRightUp () {
	if (hasRequiredDirectionDiamondRightUp) return DirectionDiamondRightUp;
	hasRequiredDirectionDiamondRightUp = 1;
	Object.defineProperty(DirectionDiamondRightUp, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgDirectionDiamondRightUp = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m6.25 19.25-1.836-1.836a2 2 0 0 1 0-2.828L14.586 4.414a2 2 0 0 1 2.828 0l10.172 10.172a2 2 0 0 1 0 2.828L17.414 27.586a2 2 0 0 1-2.828 0L12.75 25.75" }),
	    React.createElement("path", { d: "M9.6 21.5h.963c2.31 0 2.465 0 3.347-.45a4.13 4.13 0 0 0 1.803-1.802c.45-.883.45-2.038.45-4.348v-4.4m0 0-3.438 3.438m3.438-3.438 3.437 3.438" }))); };
	DirectionDiamondRightUp.default = SvgDirectionDiamondRightUp;
	
	return DirectionDiamondRightUp;
}

var DirectionDiamondRight = {};

var hasRequiredDirectionDiamondRight;

function requireDirectionDiamondRight () {
	if (hasRequiredDirectionDiamondRight) return DirectionDiamondRight;
	hasRequiredDirectionDiamondRight = 1;
	Object.defineProperty(DirectionDiamondRight, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgDirectionDiamondRight = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M4.414 14.586 14.586 4.414a2 2 0 0 1 2.828 0l10.172 10.172a2 2 0 0 1 0 2.828L17.414 27.586a2 2 0 0 1-2.828 0L4.414 17.414a2 2 0 0 1 0-2.828M9 16h13m0 0-4.5-4.5M22 16l-4.5 4.5" }))); };
	DirectionDiamondRight.default = SvgDirectionDiamondRight;
	
	return DirectionDiamondRight;
}

var DirectionDiamondUpLeft = {};

var hasRequiredDirectionDiamondUpLeft;

function requireDirectionDiamondUpLeft () {
	if (hasRequiredDirectionDiamondUpLeft) return DirectionDiamondUpLeft;
	hasRequiredDirectionDiamondUpLeft = 1;
	Object.defineProperty(DirectionDiamondUpLeft, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgDirectionDiamondUpLeft = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m25.75 19.25 1.836-1.836a2 2 0 0 0 0-2.828L17.414 4.414a2 2 0 0 0-2.828 0L4.414 14.586a2 2 0 0 0 0 2.828l10.172 10.172a2 2 0 0 0 2.828 0l1.836-1.836" }),
	    React.createElement("path", { d: "M22 22v-.962c0-2.31 0-2.466-.45-3.348a4.13 4.13 0 0 0-1.802-1.803c-.883-.45-2.038-.45-4.348-.45H11m0 0 3.438 3.438M11 15.438 14.438 12" }))); };
	DirectionDiamondUpLeft.default = SvgDirectionDiamondUpLeft;
	
	return DirectionDiamondUpLeft;
}

var DirectionDiamondUpRight = {};

var hasRequiredDirectionDiamondUpRight;

function requireDirectionDiamondUpRight () {
	if (hasRequiredDirectionDiamondUpRight) return DirectionDiamondUpRight;
	hasRequiredDirectionDiamondUpRight = 1;
	Object.defineProperty(DirectionDiamondUpRight, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgDirectionDiamondUpRight = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m6.25 19.25-1.836-1.836a2 2 0 0 1 0-2.828L14.586 4.414a2 2 0 0 1 2.828 0l10.172 10.172a2 2 0 0 1 0 2.828L17.414 27.586a2 2 0 0 1-2.828 0L12.75 25.75" }),
	    React.createElement("path", { d: "M10 22v-.962c0-2.31 0-2.466.45-3.348a4.13 4.13 0 0 1 1.802-1.803c.883-.45 2.038-.45 4.348-.45H21m0 0-3.437 3.438M21 15.438 17.563 12" }))); };
	DirectionDiamondUpRight.default = SvgDirectionDiamondUpRight;
	
	return DirectionDiamondUpRight;
}

var DirectionDiamondUp = {};

var hasRequiredDirectionDiamondUp;

function requireDirectionDiamondUp () {
	if (hasRequiredDirectionDiamondUp) return DirectionDiamondUp;
	hasRequiredDirectionDiamondUp = 1;
	Object.defineProperty(DirectionDiamondUp, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgDirectionDiamondUp = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M4.414 14.586 14.586 4.414a2 2 0 0 1 2.828 0l10.172 10.172a2 2 0 0 1 0 2.828L17.414 27.586a2 2 0 0 1-2.828 0L4.414 17.414a2 2 0 0 1 0-2.828M16 23V10m0 0-4.5 4.5M16 10l4.5 4.5" }))); };
	DirectionDiamondUp.default = SvgDirectionDiamondUp;
	
	return DirectionDiamondUp;
}

var EspecDimension = {};

var hasRequiredEspecDimension;

function requireEspecDimension () {
	if (hasRequiredEspecDimension) return EspecDimension;
	hasRequiredEspecDimension = 1;
	Object.defineProperty(EspecDimension, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgEspecDimension = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M4.667 10.667h16.667m0 0v16.666m0-16.666 6-6M28 20.45V5.067c0-.374 0-.56-.073-.703a.67.67 0 0 0-.29-.291C27.493 4 27.306 4 26.932 4H11.55c-.326 0-.489 0-.642.037a1.3 1.3 0 0 0-.386.16c-.134.082-.25.197-.48.428l-5.417 5.417c-.23.23-.346.346-.428.48q-.11.181-.16.386C4 11.06 4 11.224 4 11.55v15.383c0 .374 0 .56.073.703a.67.67 0 0 0 .291.291c.143.073.33.073.703.073H20.45c.326 0 .489 0 .642-.037q.207-.05.386-.16c.134-.082.25-.197.48-.428l5.417-5.417c.23-.23.346-.346.429-.48q.11-.181.16-.386c.036-.153.036-.316.036-.642" }))); };
	EspecDimension.default = SvgEspecDimension;
	
	return EspecDimension;
}

var EspecMeasure = {};

var hasRequiredEspecMeasure;

function requireEspecMeasure () {
	if (hasRequiredEspecMeasure) return EspecMeasure;
	hasRequiredEspecMeasure = 1;
	Object.defineProperty(EspecMeasure, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgEspecMeasure = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m19.333 7.333 2 2m-6 2 2 2m-6 2 2 2m-6 2 2 2m-5.912 2.088 5.158 5.158c.264.264.396.396.548.446a.67.67 0 0 0 .412 0c.152-.05.285-.182.549-.446l18.491-18.491c.264-.264.396-.396.445-.549a.67.67 0 0 0 0-.412c-.049-.152-.181-.284-.445-.548l-5.158-5.158c-.264-.264-.396-.396-.548-.445a.67.67 0 0 0-.412 0c-.153.049-.285.181-.549.445L3.421 21.913c-.264.264-.396.395-.446.548a.67.67 0 0 0 0 .412c.05.152.182.284.446.548" }))); };
	EspecMeasure.default = SvgEspecMeasure;
	
	return EspecMeasure;
}

var EspecValue = {};

var hasRequiredEspecValue;

function requireEspecValue () {
	if (hasRequiredEspecValue) return EspecValue;
	hasRequiredEspecValue = 1;
	Object.defineProperty(EspecValue, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgEspecValue = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M23.334 8.667 8.667 23.333M11.334 14V8.667m-2.667 2.666H14m4 9.334h5.334M10.4 28h11.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C28 24.96 28 23.84 28 21.6V10.4c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C24.96 4 23.84 4 21.6 4H10.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C4 7.04 4 8.16 4 10.4v11.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C7.04 28 8.16 28 10.4 28" }))); };
	EspecValue.default = SvgEspecValue;
	
	return EspecValue;
}

var EspecVolumetry = {};

var hasRequiredEspecVolumetry;

function requireEspecVolumetry () {
	if (hasRequiredEspecVolumetry) return EspecVolumetry;
	hasRequiredEspecVolumetry = 1;
	Object.defineProperty(EspecVolumetry, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgEspecVolumetry = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M27.333 21.333H10.667m0 0V4.667m0 16.666-6 6m0-16.666h16.666m0 0v16.666m0-16.666 6-6M28 20.45V5.067c0-.374 0-.56-.073-.703a.67.67 0 0 0-.291-.291C27.493 4 27.306 4 26.933 4H11.55c-.326 0-.489 0-.642.037a1.3 1.3 0 0 0-.386.16c-.134.082-.25.197-.48.428l-5.417 5.417c-.23.23-.346.346-.429.48q-.11.181-.16.386C4 11.06 4 11.224 4 11.55v15.383c0 .374 0 .56.073.703a.67.67 0 0 0 .29.291c.143.073.33.073.704.073H20.45c.326 0 .489 0 .642-.037q.205-.05.386-.16c.134-.082.25-.197.48-.428l5.417-5.417c.23-.23.346-.346.428-.48q.11-.181.16-.386c.037-.153.037-.316.037-.642" }))); };
	EspecVolumetry.default = SvgEspecVolumetry;
	
	return EspecVolumetry;
}

var EspecWeight01 = {};

var hasRequiredEspecWeight01;

function requireEspecWeight01 () {
	if (hasRequiredEspecWeight01) return EspecWeight01;
	hasRequiredEspecWeight01 = 1;
	Object.defineProperty(EspecWeight01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgEspecWeight01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M2.667 22.667v-.2c0-.423 0-.634.032-.84q.043-.273.142-.533c.074-.195.179-.378.388-.745L8 12M2.667 22.667a5.333 5.333 0 0 0 10.666 0m-10.666 0V22.4c0-.373 0-.56.072-.703a.67.67 0 0 1 .292-.291c.142-.073.33-.073.702-.073h8.534c.373 0 .56 0 .702.073a.67.67 0 0 1 .292.291c.072.143.072.33.072.703v.267M8 12l4.771 8.35c.21.366.314.55.388.744q.1.259.142.534c.032.205.032.416.032.838v.2M8 12l16-2.667M18.667 20v-.2c0-.422 0-.633.032-.839q.043-.274.142-.534c.074-.194.178-.378.388-.744L24 9.333M18.667 20a5.333 5.333 0 0 0 10.666 0m-10.666 0v-.267c0-.373 0-.56.072-.702a.67.67 0 0 1 .292-.292c.142-.072.329-.072.702-.072h8.534c.373 0 .56 0 .702.072a.67.67 0 0 1 .292.292c.072.142.072.329.072.702V20M24 9.333l4.771 8.35c.21.366.314.55.388.744q.1.26.142.534c.032.206.032.417.032.839v.2M16 4v6.667" }))); };
	EspecWeight01.default = SvgEspecWeight01;
	
	return EspecWeight01;
}

var EspecWeight02 = {};

var hasRequiredEspecWeight02;

function requireEspecWeight02 () {
	if (hasRequiredEspecWeight02) return EspecWeight02;
	hasRequiredEspecWeight02 = 1;
	Object.defineProperty(EspecWeight02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgEspecWeight02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M3.334 17.333h8m9.333 0h8m-12.666-8V28m0-18.667A3.333 3.333 0 0 0 19.334 6m-3.333 3.333A3.333 3.333 0 0 1 12.667 6M5.334 28h21.333M5.334 6h7.333m0 0a3.333 3.333 0 0 1 6.667 0m0 0h7.333M11.841 19.115c-.534 2.046-2.35 3.552-4.507 3.552s-3.973-1.506-4.507-3.552c-.044-.167-.066-.25-.068-.584a3.8 3.8 0 0 1 .14-.871c.107-.317.223-.495.455-.852l3.98-6.141 3.98 6.14c.232.358.348.537.454.853.066.194.142.666.14.87-.001.334-.023.418-.067.585m17.334 0c-.535 2.046-2.35 3.552-4.508 3.552s-3.973-1.506-4.507-3.552c-.044-.167-.065-.25-.067-.584a3.8 3.8 0 0 1 .14-.871c.107-.317.223-.495.454-.852l3.98-6.141 3.98 6.14c.232.358.348.537.455.853.065.194.142.666.14.87-.002.334-.024.418-.067.585" }))); };
	EspecWeight02.default = SvgEspecWeight02;
	
	return EspecWeight02;
}

var EyeOff = {};

var hasRequiredEyeOff;

function requireEyeOff () {
	if (hasRequiredEyeOff) return EyeOff;
	hasRequiredEyeOff = 1;
	Object.defineProperty(EyeOff, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgEyeOff = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M14.324 6.79q.812-.122 1.676-.123c6.807 0 11.274 6.006 12.774 8.382.182.288.273.431.323.653.039.167.039.43 0 .596-.05.222-.142.367-.325.656-.4.633-1.01 1.522-1.817 2.487M8.965 8.953c-2.882 1.956-4.84 4.673-5.737 6.094-.182.289-.274.433-.324.655-.039.167-.039.43 0 .596.05.222.141.365.323.653 1.5 2.376 5.967 8.382 12.773 8.382 2.745 0 5.11-.976 7.052-2.297M4 4l24 24M13.171 13.172a4 4 0 1 0 5.657 5.657" }))); };
	EyeOff.default = SvgEyeOff;
	
	return EyeOff;
}

var Eye = {};

var hasRequiredEye;

function requireEye () {
	if (hasRequiredEye) return Eye;
	hasRequiredEye = 1;
	Object.defineProperty(Eye, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgEye = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M3.227 16.951c-.182-.288-.273-.431-.323-.653a1.6 1.6 0 0 1 0-.596c.05-.222.141-.365.323-.653C4.727 12.673 9.194 6.667 16 6.667c6.807 0 11.274 6.006 12.774 8.382.182.288.273.431.323.653.039.167.039.43 0 .596-.05.222-.141.366-.323.653-1.5 2.376-5.967 8.382-12.774 8.382S4.727 19.327 3.227 16.951" }),
	    React.createElement("path", { d: "M16 20a4 4 0 1 0 0-8 4 4 0 0 0 0 8" }))); };
	Eye.default = SvgEye;
	
	return Eye;
}

var FaceId01 = {};

var hasRequiredFaceId01;

function requireFaceId01 () {
	if (hasRequiredFaceId01) return FaceId01;
	hasRequiredFaceId01 = 1;
	Object.defineProperty(FaceId01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgFaceId01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M10 10.667v2m12-2v2M14.667 16.8c1.066 0 2-.933 2-2v-4.133m3.6 9.6a6.116 6.116 0 0 1-8.667 0M4 10.4v11.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C7.04 28 8.16 28 10.4 28h11.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C28 24.96 28 23.84 28 21.6V10.4c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C24.96 4 23.84 4 21.6 4H10.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C4 7.04 4 8.16 4 10.4" }))); };
	FaceId01.default = SvgFaceId01;
	
	return FaceId01;
}

var FaceId02 = {};

var hasRequiredFaceId02;

function requireFaceId02 () {
	if (hasRequiredFaceId02) return FaceId02;
	hasRequiredFaceId02 = 1;
	Object.defineProperty(FaceId02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgFaceId02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M10.667 4H10.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C4 7.04 4 8.16 4 10.4v.267M10.667 28H10.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C4 24.96 4 23.84 4 21.6v-.267m24-10.666V10.4c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C24.96 4 23.84 4 21.6 4h-.267M28 21.333v.267c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C24.96 28 23.84 28 21.6 28h-.267M10 10.667v2m12-2v2M14.667 16.8c1.066 0 2-.933 2-2v-4.133m3.6 9.6a6.116 6.116 0 0 1-8.667 0" }))); };
	FaceId02.default = SvgFaceId02;
	
	return FaceId02;
}

var FileLock01 = {};

var hasRequiredFileLock01;

function requireFileLock01 () {
	if (hasRequiredFileLock01) return FileLock01;
	hasRequiredFileLock01 = 1;
	Object.defineProperty(FileLock01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgFileLock01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M26.667 13.333V9.067c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748c-.856-.436-1.976-.436-4.216-.436h-8.534c-2.24 0-3.36 0-4.216.436A4 4 0 0 0 5.77 4.85c-.436.855-.436 1.976-.436 4.216v13.866c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748c.856.436 1.976.436 4.216.436H14m11.667-6.666v-2.334a2.333 2.333 0 1 0-4.667 0v2.334M20.8 28h5.067c.746 0 1.12 0 1.405-.145.25-.128.455-.332.583-.583.145-.285.145-.659.145-1.405V24.8c0-.747 0-1.12-.145-1.405a1.33 1.33 0 0 0-.583-.583c-.285-.145-.659-.145-1.405-.145H20.8c-.747 0-1.12 0-1.405.145-.251.128-.455.332-.583.583-.145.285-.145.658-.145 1.405v1.067c0 .746 0 1.12.145 1.405.128.251.332.455.583.583.285.145.658.145 1.405.145" }))); };
	FileLock01.default = SvgFileLock01;
	
	return FileLock01;
}

var FileLock02 = {};

var hasRequiredFileLock02;

function requireFileLock02 () {
	if (hasRequiredFileLock02) return FileLock02;
	hasRequiredFileLock02 = 1;
	Object.defineProperty(FileLock02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgFileLock02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M26.667 13.333V9.067c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748c-.856-.436-1.976-.436-4.216-.436h-8.534c-2.24 0-3.36 0-4.216.436A4 4 0 0 0 5.77 4.85c-.436.855-.436 1.976-.436 4.216v13.866c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748c.856.436 1.976.436 4.216.436H14m3.333-14.666h-6.666m4 5.333h-4M21.333 9.333H10.667m15 13.334v-2.334a2.333 2.333 0 1 0-4.667 0v2.334M20.8 28h5.067c.746 0 1.12 0 1.405-.145.25-.128.455-.332.583-.583.145-.285.145-.659.145-1.405V24.8c0-.747 0-1.12-.145-1.405a1.33 1.33 0 0 0-.583-.583c-.285-.145-.659-.145-1.405-.145H20.8c-.747 0-1.12 0-1.405.145-.251.128-.455.332-.583.583-.145.285-.145.658-.145 1.405v1.067c0 .746 0 1.12.145 1.405.128.251.332.455.583.583.285.145.658.145 1.405.145" }))); };
	FileLock02.default = SvgFileLock02;
	
	return FileLock02;
}

var FilePlus = {};

var hasRequiredFilePlus;

function requireFilePlus () {
	if (hasRequiredFilePlus) return FilePlus;
	hasRequiredFilePlus = 1;
	Object.defineProperty(FilePlus, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgFilePlus = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M18.667 3.026v5.508c0 .746 0 1.12.145 1.405.128.25.332.455.583.582.285.146.658.146 1.405.146h5.507M16 24v-8m-4 4h8M18.667 2.667h-6.934c-2.24 0-3.36 0-4.216.436A4 4 0 0 0 5.77 4.85c-.436.855-.436 1.976-.436 4.216v13.866c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748c.856.436 1.976.436 4.216.436h8.534c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748c.436-.855.436-1.975.436-4.216V10.667z" }))); };
	FilePlus.default = SvgFilePlus;
	
	return FilePlus;
}

var FileShield01 = {};

var hasRequiredFileShield01;

function requireFileShield01 () {
	if (hasRequiredFileShield01) return FileShield01;
	hasRequiredFileShield01 = 1;
	Object.defineProperty(FileShield01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgFileShield01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M26.667 13.333V9.067c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748c-.856-.436-1.976-.436-4.216-.436h-8.534c-2.24 0-3.36 0-4.216.436A4 4 0 0 0 5.77 4.85c-.436.855-.436 1.976-.436 4.216v13.866c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748c.856.436 1.976.436 4.216.436h4.934M24 28s4-1.907 4-4.766v-3.337l-2.917-1.042a3.2 3.2 0 0 0-2.168 0L20 19.897v3.337C20 26.094 24 28 24 28" }))); };
	FileShield01.default = SvgFileShield01;
	
	return FileShield01;
}

var FileShield02 = {};

var hasRequiredFileShield02;

function requireFileShield02 () {
	if (hasRequiredFileShield02) return FileShield02;
	hasRequiredFileShield02 = 1;
	Object.defineProperty(FileShield02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgFileShield02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M18.667 14.667h-8M13.333 20h-2.666M21.333 9.333H10.667m16 4V9.067c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748c-.856-.436-1.976-.436-4.216-.436h-8.534c-2.24 0-3.36 0-4.216.436A4 4 0 0 0 5.77 4.85c-.436.855-.436 1.976-.436 4.216v13.866c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748c.856.436 1.976.436 4.216.436h4.934M24 28s4-1.907 4-4.766v-3.337l-2.917-1.042a3.2 3.2 0 0 0-2.168 0L20 19.897v3.337C20 26.094 24 28 24 28" }))); };
	FileShield02.default = SvgFileShield02;
	
	return FileShield02;
}

var FileText01 = {};

var hasRequiredFileText01;

function requireFileText01 () {
	if (hasRequiredFileText01) return FileText01;
	hasRequiredFileText01 = 1;
	Object.defineProperty(FileText01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgFileText01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M18.667 3.026v5.508c0 .746 0 1.12.145 1.405.128.25.332.455.583.582.285.146.658.146 1.405.146h5.507m-7.64 12h-8m10.666-5.334H10.667m16-4.015v9.615c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748c-.856.436-1.976.436-4.216.436h-8.534c-2.24 0-3.36 0-4.216-.436A4 4 0 0 1 5.77 27.15c-.436-.855-.436-1.975-.436-4.216V9.067c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748c.856-.436 1.976-.436 4.216-.436h4.283c.978 0 1.467 0 1.928.11a4 4 0 0 1 1.156.48c.403.247.75.592 1.441 1.284l4.251 4.251c.692.692 1.038 1.038 1.285 1.442.22.357.381.748.48 1.156.11.46.11.95.11 1.928" }))); };
	FileText01.default = SvgFileText01;
	
	return FileText01;
}

var FileText02 = {};

var hasRequiredFileText02;

function requireFileText02 () {
	if (hasRequiredFileText02) return FileText02;
	hasRequiredFileText02 = 1;
	Object.defineProperty(FileText02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgFileText02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M18.667 3.026v5.508c0 .746 0 1.12.145 1.405.128.25.332.455.583.582.285.146.658.146 1.405.146h5.507m-4.974 6.666H10.667m10.666 5.334H10.667M13.333 12h-2.666m8-9.333h-6.934c-2.24 0-3.36 0-4.216.436A4 4 0 0 0 5.77 4.85c-.436.855-.436 1.976-.436 4.216v13.866c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748c.856.436 1.976.436 4.216.436h8.534c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748c.436-.855.436-1.975.436-4.216V10.667z" }))); };
	FileText02.default = SvgFileText02;
	
	return FileText02;
}

var FileText03 = {};

var hasRequiredFileText03;

function requireFileText03 () {
	if (hasRequiredFileText03) return FileText03;
	hasRequiredFileText03 = 1;
	Object.defineProperty(FileText03, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgFileText03 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M18.667 14.667h-8M13.333 20h-2.666M21.333 9.333H10.667m16-.266v13.866c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748c-.856.436-1.976.436-4.216.436h-8.534c-2.24 0-3.36 0-4.216-.436A4 4 0 0 1 5.77 27.15c-.436-.855-.436-1.975-.436-4.216V9.067c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748c.856-.436 1.976-.436 4.216-.436h8.534c2.24 0 3.36 0 4.216.436A4 4 0 0 1 26.23 4.85c.436.855.436 1.976.436 4.216" }))); };
	FileText03.default = SvgFileText03;
	
	return FileText03;
}

var FileTextAttach = {};

var hasRequiredFileTextAttach;

function requireFileTextAttach () {
	if (hasRequiredFileTextAttach) return FileTextAttach;
	hasRequiredFileTextAttach = 1;
	Object.defineProperty(FileTextAttach, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgFileTextAttach = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M26.667 9.333v-.266c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748c-.856-.436-1.976-.436-4.216-.436h-8.534c-2.24 0-3.36 0-4.216.436A4 4 0 0 0 5.77 4.85c-.436.855-.436 1.976-.436 4.216v13.866c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748c.856.436 1.976.436 4.216.436h4.934m0-14.666h-6M15.333 20h-4.666M21.333 9.333H10.667M24 24v-7.333a2 2 0 0 1 4 0V24a4 4 0 0 1-8 0v-5.333" }))); };
	FileTextAttach.default = SvgFileTextAttach;
	
	return FileTextAttach;
}

var FileTextCheck = {};

var hasRequiredFileTextCheck;

function requireFileTextCheck () {
	if (hasRequiredFileTextCheck) return FileTextCheck;
	hasRequiredFileTextCheck = 1;
	Object.defineProperty(FileTextCheck, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgFileTextCheck = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M26.667 16.667v-7.6c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748c-.856-.436-1.976-.436-4.216-.436h-8.534c-2.24 0-3.36 0-4.216.436A4 4 0 0 0 5.77 4.85c-.436.855-.436 1.976-.436 4.216v13.866c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748c.856.436 1.976.436 4.216.436H16m2.667-14.666h-8M13.333 20h-2.666M21.333 9.333H10.667m8.666 16L22 28l6-6" }))); };
	FileTextCheck.default = SvgFileTextCheck;
	
	return FileTextCheck;
}

var FileTextClose = {};

var hasRequiredFileTextClose;

function requireFileTextClose () {
	if (hasRequiredFileTextClose) return FileTextClose;
	hasRequiredFileTextClose = 1;
	Object.defineProperty(FileTextClose, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgFileTextClose = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M18.667 14.667h-8M13.333 20h-2.666M21.333 9.333H10.667m16 6.667V9.067c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748c-.856-.436-1.976-.436-4.216-.436h-8.534c-2.24 0-3.36 0-4.216.436A4 4 0 0 0 5.77 4.85c-.436.855-.436 1.976-.436 4.216v13.866c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748c.856.436 1.976.436 4.216.436H16m5.333-8L28 28m0-6.667L21.333 28" }))); };
	FileTextClose.default = SvgFileTextClose;
	
	return FileTextClose;
}

var FileTextDownload = {};

var hasRequiredFileTextDownload;

function requireFileTextDownload () {
	if (hasRequiredFileTextDownload) return FileTextDownload;
	hasRequiredFileTextDownload = 1;
	Object.defineProperty(FileTextDownload, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgFileTextDownload = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M26.667 16.667v-7.6c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748c-.856-.436-1.976-.436-4.216-.436h-8.534c-2.24 0-3.36 0-4.216.436A4 4 0 0 0 5.77 4.85c-.436.855-.436 1.976-.436 4.216v13.866c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748c.856.436 1.976.436 4.216.436h4.934m2-14.666h-8M13.333 20h-2.666M21.333 9.333H10.667m9.333 16 4 4m0 0 4-4m-4 4v-8" }))); };
	FileTextDownload.default = SvgFileTextDownload;
	
	return FileTextDownload;
}

var FileTextHeart = {};

var hasRequiredFileTextHeart;

function requireFileTextHeart () {
	if (hasRequiredFileTextHeart) return FileTextHeart;
	hasRequiredFileTextHeart = 1;
	Object.defineProperty(FileTextHeart, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgFileTextHeart = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M26.667 13.333V9.067c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748c-.856-.436-1.976-.436-4.216-.436h-8.534c-2.24 0-3.36 0-4.216.436A4 4 0 0 0 5.77 4.85c-.436.855-.436 1.976-.436 4.216v13.866c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748c.856.436 1.976.436 4.216.436H16m.667-14.666h-6M12 20h-1.333M21.333 9.333H10.667m11.996 10.441c-1.066-1.212-2.844-1.538-4.18-.428-1.337 1.11-1.525 2.965-.475 4.278S22.663 28 22.663 28s3.606-3.063 4.655-4.376.884-3.18-.475-4.278-3.114-.784-4.18.428" }))); };
	FileTextHeart.default = SvgFileTextHeart;
	
	return FileTextHeart;
}

var FileTextMinus = {};

var hasRequiredFileTextMinus;

function requireFileTextMinus () {
	if (hasRequiredFileTextMinus) return FileTextMinus;
	hasRequiredFileTextMinus = 1;
	Object.defineProperty(FileTextMinus, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgFileTextMinus = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M26.667 15.922V9.067c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748c-.856-.436-1.976-.436-4.216-.436h-8.534c-2.24 0-3.36 0-4.216.436A4 4 0 0 0 5.77 4.85c-.436.855-.436 1.976-.436 4.216v13.866c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748c.856.436 1.976.436 4.216.436h6.934m0-14.666h-8M13.333 20h-2.666M21.333 9.333H10.667M20 22.667h8" }))); };
	FileTextMinus.default = SvgFileTextMinus;
	
	return FileTextMinus;
}

var FileTextPlus = {};

var hasRequiredFileTextPlus;

function requireFileTextPlus () {
	if (hasRequiredFileTextPlus) return FileTextPlus;
	hasRequiredFileTextPlus = 1;
	Object.defineProperty(FileTextPlus, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgFileTextPlus = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M26.667 14V9.067c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748c-.856-.436-1.976-.436-4.216-.436h-8.534c-2.24 0-3.36 0-4.216.436A4 4 0 0 0 5.77 4.85c-.436.855-.436 1.976-.436 4.216v13.866c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748c.856.436 1.976.436 4.216.436H16m2.667-14.666h-8M13.333 20h-2.666M21.333 9.333H10.667M24 28v-8m-4 4h8" }))); };
	FileTextPlus.default = SvgFileTextPlus;
	
	return FileTextPlus;
}

var FileTextQuestion = {};

var hasRequiredFileTextQuestion;

function requireFileTextQuestion () {
	if (hasRequiredFileTextQuestion) return FileTextQuestion;
	hasRequiredFileTextQuestion = 1;
	Object.defineProperty(FileTextQuestion, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgFileTextQuestion = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M26.667 12.667v-3.6c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748c-.856-.436-1.976-.436-4.216-.436h-8.534c-2.24 0-3.36 0-4.216.436A4 4 0 0 0 5.77 4.85c-.436.855-.436 1.976-.436 4.216v13.866c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748c.856.436 1.976.436 4.216.436h6.934m0-14.666h-8M13.333 20h-2.666M21.333 9.333H10.667M22 20.003a2.997 2.997 0 0 1 5.826 1C27.826 23 24.828 24 24.828 24m.038 4h.014" }))); };
	FileTextQuestion.default = SvgFileTextQuestion;
	
	return FileTextQuestion;
}

var FileTextReport = {};

var hasRequiredFileTextReport;

function requireFileTextReport () {
	if (hasRequiredFileTextReport) return FileTextReport;
	hasRequiredFileTextReport = 1;
	Object.defineProperty(FileTextReport, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgFileTextReport = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M10.667 18.667V24m10.666-8v8M16 10.667V24M26.667 9.067v13.866c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748c-.856.436-1.976.436-4.216.436h-8.534c-2.24 0-3.36 0-4.216-.436A4 4 0 0 1 5.77 27.15c-.436-.855-.436-1.975-.436-4.216V9.067c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748c.856-.436 1.976-.436 4.216-.436h8.534c2.24 0 3.36 0 4.216.436A4 4 0 0 1 26.23 4.85c.436.855.436 1.976.436 4.216" }))); };
	FileTextReport.default = SvgFileTextReport;
	
	return FileTextReport;
}

var FileTextSearch = {};

var hasRequiredFileTextSearch;

function requireFileTextSearch () {
	if (hasRequiredFileTextSearch) return FileTextSearch;
	hasRequiredFileTextSearch = 1;
	Object.defineProperty(FileTextSearch, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgFileTextSearch = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M18.667 14.667h-8M13.333 20h-2.666M21.333 9.333H10.667m16 4.667V9.067c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748c-.856-.436-1.976-.436-4.216-.436h-8.534c-2.24 0-3.36 0-4.216.436A4 4 0 0 0 5.77 4.85c-.436.855-.436 1.976-.436 4.216v13.866c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748c.856.436 1.976.436 4.216.436h3.6m14 0-2-2M28.667 24a4.667 4.667 0 1 1-9.334 0 4.667 4.667 0 0 1 9.334 0" }))); };
	FileTextSearch.default = SvgFileTextSearch;
	
	return FileTextSearch;
}

var File = {};

var hasRequiredFile;

function requireFile () {
	if (hasRequiredFile) return File;
	hasRequiredFile = 1;
	Object.defineProperty(File, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgFile = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M18.667 3.026v5.507c0 .747 0 1.12.145 1.406.128.25.332.455.583.582.285.146.658.146 1.405.146h5.507m.36 2.65v9.616c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748c-.856.436-1.976.436-4.216.436h-8.534c-2.24 0-3.36 0-4.216-.436A4 4 0 0 1 5.77 27.15c-.436-.855-.436-1.975-.436-4.216V9.067c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748c.856-.436 1.976-.436 4.216-.436h4.283c.978 0 1.467 0 1.928.11a4 4 0 0 1 1.156.48c.403.247.75.592 1.441 1.284l4.251 4.251c.692.692 1.038 1.038 1.285 1.442.22.357.381.748.48 1.156.11.46.11.95.11 1.928" }))); };
	File.default = SvgFile;
	
	return File;
}

var FilterTuneHorizontal = {};

var hasRequiredFilterTuneHorizontal;

function requireFilterTuneHorizontal () {
	if (hasRequiredFilterTuneHorizontal) return FilterTuneHorizontal;
	hasRequiredFilterTuneHorizontal = 1;
	Object.defineProperty(FilterTuneHorizontal, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgFilterTuneHorizontal = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M4 10.667h16m0 0a4 4 0 1 0 8 0 4 4 0 0 0-8 0m-8 10.666h16m-16 0a4 4 0 1 1-8 0 4 4 0 0 1 8 0" }))); };
	FilterTuneHorizontal.default = SvgFilterTuneHorizontal;
	
	return FilterTuneHorizontal;
}

var FilterTuneVertical = {};

var hasRequiredFilterTuneVertical;

function requireFilterTuneVertical () {
	if (hasRequiredFilterTuneVertical) return FilterTuneVertical;
	hasRequiredFilterTuneVertical = 1;
	Object.defineProperty(FilterTuneVertical, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgFilterTuneVertical = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M6.667 28v-8m0 0a2.667 2.667 0 1 0 0-5.333 2.667 2.667 0 0 0 0 5.333m0-10.667V4M16 28v-8m0-10.667V4m0 5.333a2.667 2.667 0 1 0 0 5.334 2.667 2.667 0 0 0 0-5.334M25.333 28v-5.333m0 0a2.667 2.667 0 1 0 0-5.334 2.667 2.667 0 0 0 0 5.334m0-10.667V4" }))); };
	FilterTuneVertical.default = SvgFilterTuneVertical;
	
	return FilterTuneVertical;
}

var Filter = {};

var hasRequiredFilter;

function requireFilter () {
	if (hasRequiredFilter) return Filter;
	hasRequiredFilter = 1;
	Object.defineProperty(Filter, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgFilter = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M8 16h16M4 8h24M12 24h8" }))); };
	Filter.default = SvgFilter;
	
	return Filter;
}

var Fingerprint = {};

var hasRequiredFingerprint;

function requireFingerprint () {
	if (hasRequiredFingerprint) return Fingerprint;
	hasRequiredFingerprint = 1;
	Object.defineProperty(Fingerprint, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgFingerprint = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M10.8 28.295a16.2 16.2 0 0 1-2.943-9.337c0-4.499 3.645-8.145 8.141-8.145a8.144 8.144 0 0 1 8.142 8.145m.441 8.124c-.146.008-.29.022-.438.022A8.143 8.143 0 0 1 16 18.958m1.691 10.375a12.21 12.21 0 0 1-5.763-10.375 4.072 4.072 0 1 1 8.144 0 4.072 4.072 0 1 0 8.142 0c0-6.748-5.468-12.218-12.213-12.218S3.79 12.21 3.79 18.958c0 1.505.168 2.97.478 4.381m23.1-15.521C24.592 4.664 20.533 2.667 16 2.667c-4.531 0-8.59 1.997-11.367 5.15" }))); };
	Fingerprint.default = SvgFingerprint;
	
	return Fingerprint;
}

var Flag01 = {};

var hasRequiredFlag01;

function requireFlag01 () {
	if (hasRequiredFlag01) return Flag01;
	hasRequiredFlag01 = 1;
	Object.defineProperty(Flag01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgFlag01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M5.333 20s1.334-1.333 5.334-1.333 6.666 2.666 10.666 2.666S26.667 20 26.667 20V4s-1.334 1.333-5.334 1.333-6.666-2.666-10.666-2.666S5.333 4 5.333 4v25.333" }))); };
	Flag01.default = SvgFlag01;
	
	return Flag01;
}

var Flag02 = {};

var hasRequiredFlag02;

function requireFlag02 () {
	if (hasRequiredFlag02) return Flag02;
	hasRequiredFlag02 = 1;
	Object.defineProperty(Flag02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgFlag02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M5.333 17.333h20.783c.617 0 .925 0 1.101-.129a.67.67 0 0 0 .27-.476c.02-.217-.14-.481-.456-1.01l-2.702-4.502c-.12-.2-.18-.3-.203-.406a.7.7 0 0 1 0-.286c.024-.107.083-.207.203-.406l2.702-4.503c.317-.528.476-.793.455-1.01a.67.67 0 0 0-.269-.476C27.041 4 26.733 4 26.116 4H5.333v24" }))); };
	Flag02.default = SvgFlag02;
	
	return Flag02;
}

var Flag03 = {};

var hasRequiredFlag03;

function requireFlag03 () {
	if (hasRequiredFlag03) return Flag03;
	hasRequiredFlag03 = 1;
	Object.defineProperty(Flag03, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgFlag03 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M18 8.667h8.274c.572 0 .857 0 1.03.12.15.105.25.267.277.449.03.208-.097.463-.353.974l-1.67 3.34c-.082.165-.124.248-.141.335a.7.7 0 0 0-.006.234c.014.087.052.172.127.341l1.795 4.04c.223.5.334.75.297.952a.67.67 0 0 1-.281.433c-.17.115-.443.115-.99.115H16.133c-.746 0-1.12 0-1.405-.145a1.33 1.33 0 0 1-.583-.583C14 18.987 14 18.613 14 17.867v-3.2M4 28V4.667m0 10h11.867c.746 0 1.12 0 1.405-.146.25-.128.455-.332.583-.582.145-.286.145-.659.145-1.406V5.467c0-.747 0-1.12-.145-1.406a1.33 1.33 0 0 0-.583-.582c-.285-.146-.659-.146-1.405-.146H6.133c-.746 0-1.12 0-1.405.146-.25.127-.455.331-.583.582C4 4.347 4 4.72 4 5.467z" }))); };
	Flag03.default = SvgFlag03;
	
	return Flag03;
}

var FlashOff = {};

var hasRequiredFlashOff;

function requireFlashOff () {
	if (hasRequiredFlashOff) return FlashOff;
	hasRequiredFlashOff = 1;
	Object.defineProperty(FlashOff, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgFlashOff = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m10.667 10.667-5.21 6.25c-.464.558-.697.837-.7 1.073-.003.205.088.4.247.529.184.148.547.148 1.273.148H16l-1.333 10.666 6.666-8m-.466-8h4.856c.726 0 1.09 0 1.273.149.159.128.25.323.247.528-.003.236-.236.515-.7 1.073l-1.81 2.17M14.098 6.55l3.236-3.883-.8 6.397M28 28 4 4" }))); };
	FlashOff.default = SvgFlashOff;
	
	return FlashOff;
}

var Flash = {};

var hasRequiredFlash;

function requireFlash () {
	if (hasRequiredFlash) return Flash;
	hasRequiredFlash = 1;
	Object.defineProperty(Flash, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgFlash = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M17.333 2.667 5.458 16.917c-.465.558-.698.837-.701 1.073-.003.205.088.4.247.529.184.148.547.148 1.273.148H16l-1.333 10.666 11.875-14.25c.465-.558.698-.837.701-1.073a.67.67 0 0 0-.247-.528c-.184-.149-.547-.149-1.273-.149H16z" }))); };
	Flash.default = SvgFlash;
	
	return Flash;
}

var FlipBackward = {};

var hasRequiredFlipBackward;

function requireFlipBackward () {
	if (hasRequiredFlipBackward) return FlipBackward;
	hasRequiredFlipBackward = 1;
	Object.defineProperty(FlipBackward, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgFlipBackward = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M4 12h18a6 6 0 0 1 0 12h-6M4 12l5.333-5.333M4 12l5.333 5.333" }))); };
	FlipBackward.default = SvgFlipBackward;
	
	return FlipBackward;
}

var FlipForward = {};

var hasRequiredFlipForward;

function requireFlipForward () {
	if (hasRequiredFlipForward) return FlipForward;
	hasRequiredFlipForward = 1;
	Object.defineProperty(FlipForward, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgFlipForward = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M28 12H10a6 6 0 0 0 0 12h6m12-12-5.333-5.333M28 12l-5.333 5.333" }))); };
	FlipForward.default = SvgFlipForward;
	
	return FlipForward;
}

var FolderBlocked = {};

var hasRequiredFolderBlocked;

function requireFolderBlocked () {
	if (hasRequiredFolderBlocked) return FolderBlocked;
	hasRequiredFolderBlocked = 1;
	Object.defineProperty(FolderBlocked, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgFolderBlocked = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M17.333 9.333 15.846 6.36c-.428-.857-.642-1.285-.962-1.597a2.7 2.7 0 0 0-.996-.616C13.466 4 12.987 4 12.03 4H6.933c-1.493 0-2.24 0-2.81.29-.502.256-.91.664-1.166 1.166-.29.57-.29 1.317-.29 2.81v1.067m0 0h20.266c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748c.436.856.436 1.976.436 4.216V21.6c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748c-.855.436-1.975.436-4.216.436H9.067c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748c-.436-.856-.436-1.976-.436-4.216zm10 6L19.333 22m2-3.333a5.333 5.333 0 1 1-10.666 0 5.333 5.333 0 0 1 10.666 0" }))); };
	FolderBlocked.default = SvgFolderBlocked;
	
	return FolderBlocked;
}

var FolderCheck = {};

var hasRequiredFolderCheck;

function requireFolderCheck () {
	if (hasRequiredFolderCheck) return FolderCheck;
	hasRequiredFolderCheck = 1;
	Object.defineProperty(FolderCheck, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgFolderCheck = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M17.333 9.333 15.846 6.36c-.428-.857-.642-1.285-.961-1.597a2.7 2.7 0 0 0-.997-.616C13.466 4 12.987 4 12.03 4H6.933c-1.493 0-2.24 0-2.81.29-.502.256-.91.664-1.166 1.166-.29.57-.29 1.317-.29 2.81v1.067m0 0h20.266c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748c.436.856.436 1.976.436 4.216V21.6c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748c-.855.436-1.975.436-4.216.436H9.067c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748c-.436-.856-.436-1.976-.436-4.216zM12 18.667l2.667 2.666 6-6" }))); };
	FolderCheck.default = SvgFolderCheck;
	
	return FolderCheck;
}

var FolderClose = {};

var hasRequiredFolderClose;

function requireFolderClose () {
	if (hasRequiredFolderClose) return FolderClose;
	hasRequiredFolderClose = 1;
	Object.defineProperty(FolderClose, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgFolderClose = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M17.333 9.333 15.846 6.36c-.428-.857-.642-1.285-.962-1.597a2.7 2.7 0 0 0-.996-.616C13.466 4 12.987 4 12.03 4H6.933c-1.493 0-2.24 0-2.81.29-.502.256-.91.664-1.166 1.166-.29.57-.29 1.317-.29 2.81v1.067m0 0h20.266c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748c.436.856.436 1.976.436 4.216V21.6c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748c-.855.436-1.976.436-4.216.436H9.067c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748c-.436-.856-.436-1.976-.436-4.216zm10 6L19.333 22m0-6.667L12.667 22" }))); };
	FolderClose.default = SvgFolderClose;
	
	return FolderClose;
}

var FolderDownload = {};

var hasRequiredFolderDownload;

function requireFolderDownload () {
	if (hasRequiredFolderDownload) return FolderDownload;
	hasRequiredFolderDownload = 1;
	Object.defineProperty(FolderDownload, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgFolderDownload = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M17.333 9.333 15.846 6.36c-.428-.857-.642-1.285-.962-1.597a2.7 2.7 0 0 0-.996-.616C13.466 4 12.987 4 12.03 4H6.933c-1.493 0-2.24 0-2.81.29-.502.256-.91.664-1.166 1.166-.29.57-.29 1.317-.29 2.81v1.067m0 0h20.266c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748c.436.856.436 1.976.436 4.216V21.6c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748c-.855.436-1.976.436-4.216.436H9.067c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748c-.436-.856-.436-1.976-.436-4.216zM12 18.667l4 4m0 0 4-4m-4 4v-8" }))); };
	FolderDownload.default = SvgFolderDownload;
	
	return FolderDownload;
}

var FolderLocked = {};

var hasRequiredFolderLocked;

function requireFolderLocked () {
	if (hasRequiredFolderLocked) return FolderLocked;
	hasRequiredFolderLocked = 1;
	Object.defineProperty(FolderLocked, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgFolderLocked = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M17.333 9.333 15.846 6.36c-.428-.857-.642-1.285-.962-1.597a2.7 2.7 0 0 0-.996-.616C13.466 4 12.987 4 12.03 4H6.933c-1.493 0-2.24 0-2.81.29-.502.256-.91.664-1.166 1.166-.29.57-.29 1.317-.29 2.81v1.067m0 0h20.266c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748c.436.856.436 1.976.436 4.216V21.6c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748c-.855.436-1.976.436-4.216.436H9.067c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748c-.436-.856-.436-1.976-.436-4.216zm10.8 14h5.066c.747 0 1.12 0 1.406-.145.25-.128.454-.332.582-.583.146-.285.146-.658.146-1.405v-1.067c0-.746 0-1.12-.146-1.405a1.33 1.33 0 0 0-.582-.583C19.653 18 19.28 18 18.533 18h-5.066c-.747 0-1.12 0-1.406.145-.25.128-.455.332-.582.583-.146.285-.146.659-.146 1.405V21.2c0 .747 0 1.12.146 1.405.127.251.331.455.582.583.286.145.659.145 1.406.145M18.333 18v-2.333a2.333 2.333 0 1 0-4.666 0V18z" }))); };
	FolderLocked.default = SvgFolderLocked;
	
	return FolderLocked;
}

var FolderMinus = {};

var hasRequiredFolderMinus;

function requireFolderMinus () {
	if (hasRequiredFolderMinus) return FolderMinus;
	hasRequiredFolderMinus = 1;
	Object.defineProperty(FolderMinus, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgFolderMinus = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M17.333 9.333 15.846 6.36c-.428-.857-.642-1.285-.962-1.597a2.7 2.7 0 0 0-.996-.616C13.466 4 12.987 4 12.03 4H6.933c-1.493 0-2.24 0-2.81.29-.502.256-.91.664-1.166 1.166-.29.57-.29 1.317-.29 2.81v1.067m0 0h20.266c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748c.436.856.436 1.976.436 4.216V21.6c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748c-.855.436-1.975.436-4.216.436H9.067c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748c-.436-.856-.436-1.976-.436-4.216zM12 18.667h8" }))); };
	FolderMinus.default = SvgFolderMinus;
	
	return FolderMinus;
}

var FolderPlus = {};

var hasRequiredFolderPlus;

function requireFolderPlus () {
	if (hasRequiredFolderPlus) return FolderPlus;
	hasRequiredFolderPlus = 1;
	Object.defineProperty(FolderPlus, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgFolderPlus = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M17.333 9.333 15.846 6.36c-.428-.857-.642-1.285-.962-1.597a2.7 2.7 0 0 0-.996-.616C13.466 4 12.987 4 12.03 4H6.933c-1.493 0-2.24 0-2.81.29-.502.256-.91.664-1.166 1.166-.29.57-.29 1.317-.29 2.81v1.067m0 0h20.266c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748c.436.856.436 1.976.436 4.216V21.6c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748c-.855.436-1.975.436-4.216.436H9.067c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748c-.436-.856-.436-1.976-.436-4.216zM16 22.667v-8m-4 4h8" }))); };
	FolderPlus.default = SvgFolderPlus;
	
	return FolderPlus;
}

var FolderQuestion = {};

var hasRequiredFolderQuestion;

function requireFolderQuestion () {
	if (hasRequiredFolderQuestion) return FolderQuestion;
	hasRequiredFolderQuestion = 1;
	Object.defineProperty(FolderQuestion, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgFolderQuestion = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M17.333 9.333 15.846 6.36c-.428-.857-.642-1.285-.962-1.597a2.7 2.7 0 0 0-.996-.616C13.466 4 12.987 4 12.03 4H6.933c-1.493 0-2.24 0-2.81.29-.502.256-.91.664-1.166 1.166-.29.57-.29 1.317-.29 2.81v1.067m0 0h20.266c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748c.436.856.436 1.976.436 4.216V21.6c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748c-.855.436-1.976.436-4.216.436H9.067c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748c-.436-.856-.436-1.976-.436-4.216zm10.466 6.337a2.998 2.998 0 0 1 5.826.999c0 1.998-2.998 2.998-2.998 2.998m.039 4h.013" }))); };
	FolderQuestion.default = SvgFolderQuestion;
	
	return FolderQuestion;
}

var FolderSearch = {};

var hasRequiredFolderSearch;

function requireFolderSearch () {
	if (hasRequiredFolderSearch) return FolderSearch;
	hasRequiredFolderSearch = 1;
	Object.defineProperty(FolderSearch, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgFolderSearch = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M17.333 9.333 15.846 6.36c-.428-.857-.642-1.285-.962-1.597a2.7 2.7 0 0 0-.996-.616C13.466 4 12.987 4 12.03 4H6.933c-1.493 0-2.24 0-2.81.29-.502.256-.91.664-1.166 1.166-.29.57-.29 1.317-.29 2.81v1.067m0 0h20.266c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748c.436.856.436 1.976.436 4.216V21.6c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748c-.855.436-1.975.436-4.216.436H9.067c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748c-.436-.856-.436-1.976-.436-4.216zm18 14-2-2M20 18a4.667 4.667 0 1 1-9.333 0A4.667 4.667 0 0 1 20 18" }))); };
	FolderSearch.default = SvgFolderSearch;
	
	return FolderSearch;
}

var Fuel = {};

var hasRequiredFuel;

function requireFuel () {
	if (hasRequiredFuel) return Fuel;
	hasRequiredFuel = 1;
	Object.defineProperty(Fuel, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgFuel = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M8.2 9.267c0-.59.478-1.067 1.067-1.067h5.466c.59 0 1.067.478 1.067 1.067v5.267c0 .589-.478 1.066-1.067 1.066H9.267c-.59 0-1.067-.477-1.067-1.066z" }),
	    React.createElement("path", { d: "M20 27a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7.2A3.2 3.2 0 0 1 7.2 4h9.6A3.2 3.2 0 0 1 20 7.2zM24.8 6.667v4.45c0 .565.225 1.108.625 1.508L28 15.2" }),
	    React.createElement("path", { d: "M20 17.867h2.133c.59 0 1.067.477 1.067 1.067v7.293a.74.74 0 0 0 .069.331c.2.404.88 1.442 2.598 1.442C28 28 28 26.4 28 26.4V10.75c0-.565-.225-1.108-.625-1.508L23.2 5.067" }))); };
	Fuel.default = SvgFuel;
	
	return Fuel;
}

var Gift01 = {};

var hasRequiredGift01;

function requireGift01 () {
	if (hasRequiredGift01) return Gift01;
	hasRequiredGift01 = 1;
	Object.defineProperty(Gift01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgGift01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M16 8v21.333M16 8h-4.714c-.695 0-1.361-.281-1.852-.781a2.7 2.7 0 0 1-.767-1.886c0-.707.276-1.385.767-1.885a2.6 2.6 0 0 1 1.852-.781C14.952 2.667 16 8 16 8m0 0h4.714c.695 0 1.361-.281 1.852-.781s.767-1.178.767-1.886c0-.707-.276-1.385-.767-1.885a2.6 2.6 0 0 0-1.852-.781C17.048 2.667 16 8 16 8m10.667 6.667v10.4c0 1.493 0 2.24-.291 2.81-.256.502-.664.91-1.165 1.166-.57.29-1.317.29-2.811.29H9.6c-1.493 0-2.24 0-2.81-.29a2.67 2.67 0 0 1-1.166-1.166c-.29-.57-.29-1.317-.29-2.81v-10.4m-2.667-4.534v2.4c0 .747 0 1.12.145 1.406.128.25.332.454.583.582.285.146.658.146 1.405.146h22.4c.747 0 1.12 0 1.405-.146.251-.128.455-.332.583-.582.145-.286.145-.659.145-1.406v-2.4c0-.746 0-1.12-.145-1.405a1.33 1.33 0 0 0-.583-.583C28.32 8 27.947 8 27.2 8H4.8c-.747 0-1.12 0-1.405.145-.251.128-.455.332-.583.583-.145.285-.145.659-.145 1.405" }))); };
	Gift01.default = SvgGift01;
	
	return Gift01;
}

var Gift02 = {};

var hasRequiredGift02;

function requireGift02 () {
	if (hasRequiredGift02) return Gift02;
	hasRequiredGift02 = 1;
	Object.defineProperty(Gift02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgGift02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M16 9.333h-6a3.333 3.333 0 1 1 0-6.666c4.667 0 6 6.666 6 6.666m0 0h6a3.333 3.333 0 0 0 0-6.666c-4.667 0-6 6.666-6 6.666m0 0v20M2.667 18.667h26.666M2.667 13.6v11.467c0 1.493 0 2.24.29 2.81.256.502.664.91 1.166 1.166.57.29 1.317.29 2.81.29h18.134c1.493 0 2.24 0 2.81-.29.502-.256.91-.664 1.166-1.166.29-.57.29-1.317.29-2.81V13.6c0-1.493 0-2.24-.29-2.81a2.67 2.67 0 0 0-1.166-1.166c-.57-.29-1.317-.29-2.81-.29H6.933c-1.493 0-2.24 0-2.81.29-.502.256-.91.664-1.166 1.165-.29.57-.29 1.318-.29 2.811" }))); };
	Gift02.default = SvgGift02;
	
	return Gift02;
}

var GlobeNavigator = {};

var hasRequiredGlobeNavigator;

function requireGlobeNavigator () {
	if (hasRequiredGlobeNavigator) return GlobeNavigator;
	hasRequiredGlobeNavigator = 1;
	Object.defineProperty(GlobeNavigator, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgGlobeNavigator = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m3.582 20.86 2.545-1.469c.137-.08.3-.107.455-.078l5.007.937a.667.667 0 0 0 .789-.658l-.02-4.386q0-.182.091-.34l2.527-4.324a.67.67 0 0 0-.03-.72l-4.254-6.054m14.642 2.71C18 10 22 14.668 23.334 15.334c2.502 1.251 5.983 1.334 5.983 1.334q.016-.332.016-.667c0-7.364-5.97-13.333-13.333-13.333S2.667 8.637 2.667 16 8.637 29.333 16 29.333q.336 0 .667-.016m5.677-.064L18.12 18.121l11.132 4.223-4.936 1.973z" }))); };
	GlobeNavigator.default = SvgGlobeNavigator;
	
	return GlobeNavigator;
}

var GlobePin = {};

var hasRequiredGlobePin;

function requireGlobePin () {
	if (hasRequiredGlobePin) return GlobePin;
	hasRequiredGlobePin = 1;
	Object.defineProperty(GlobePin, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgGlobePin = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M20 3.277a13.3 13.3 0 0 0-4-.61C8.636 2.667 2.667 8.637 2.667 16S8.637 29.333 16 29.333 29.333 23.363 29.333 16c0-2.287-.575-4.44-1.59-6.32m-5.076-2.013h.006M14 29.184v-2.937c0-.16.057-.314.16-.434l3.315-3.867a.667.667 0 0 0-.175-1.013l-3.809-2.176a.67.67 0 0 1-.248-.248l-2.482-4.35a.67.67 0 0 0-.638-.335l-7.37.657M28 8c0 2.945-2.667 5.333-5.333 8-2.667-2.667-5.334-5.055-5.334-8A5.333 5.333 0 1 1 28 8m-5-.333a.333.333 0 1 1-.667 0 .333.333 0 0 1 .667 0" }))); };
	GlobePin.default = SvgGlobePin;
	
	return GlobePin;
}

var Globe = {};

var hasRequiredGlobe;

function requireGlobe () {
	if (hasRequiredGlobe) return Globe;
	hasRequiredGlobe = 1;
	Object.defineProperty(Globe, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgGlobe = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m4.101 9.977 5.718 4.084c.297.212.446.319.602.343.137.022.277 0 .401-.062.141-.07.25-.217.47-.51l1.208-1.61c.062-.083.093-.124.13-.16a.7.7 0 0 1 .106-.084c.043-.028.09-.049.184-.09l5.158-2.293c.214-.095.321-.143.402-.217a.7.7 0 0 0 .164-.236c.042-.1.05-.218.066-.451l.377-5.665M18 18l3.488 1.495c.405.173.607.26.714.404.094.126.14.282.13.44-.01.178-.132.362-.377.728l-1.638 2.458c-.116.174-.174.26-.25.323a.7.7 0 0 1-.23.123c-.095.029-.2.029-.408.029h-2.66c-.277 0-.415 0-.532-.046a.67.67 0 0 1-.268-.193c-.081-.097-.125-.228-.212-.49l-.95-2.852a1.4 1.4 0 0 1-.085-.31.7.7 0 0 1 .015-.209c.018-.076.054-.15.127-.295l.722-1.444c.147-.294.22-.44.333-.531.1-.08.22-.13.348-.144.144-.016.3.036.61.14zm11.333-2c0 7.364-5.97 13.333-13.333 13.333S2.667 23.363 2.667 16 8.637 2.667 16 2.667 29.333 8.637 29.333 16" }))); };
	Globe.default = SvgGlobe;
	
	return Globe;
}

var Graduate = {};

var hasRequiredGraduate;

function requireGraduate () {
	if (hasRequiredGraduate) return Graduate;
	hasRequiredGraduate = 1;
	Object.defineProperty(Graduate, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgGraduate = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M22.667 19.333v-4.007c0-.24 0-.359-.037-.465a.7.7 0 0 0-.154-.249c-.078-.08-.185-.133-.399-.24L16 11.333M5.333 12.667v9.075c0 .496 0 .744.078.961.068.192.18.366.326.508.165.16.39.264.84.47l8.534 3.912c.327.15.49.224.66.254q.23.039.457 0c.17-.03.334-.105.66-.254l8.534-3.911c.451-.207.676-.31.841-.471.146-.142.258-.316.326-.508.078-.217.078-.465.078-.96v-9.076m-24-1.334 12.856-6.428c.175-.087.262-.131.354-.148a.7.7 0 0 1 .246 0c.092.017.18.06.354.148l12.856 6.428-12.856 6.429c-.175.087-.262.13-.354.148a.7.7 0 0 1-.246 0c-.092-.017-.18-.061-.354-.148z" }))); };
	Graduate.default = SvgGraduate;
	
	return Graduate;
}

var Grid01 = {};

var hasRequiredGrid01;

function requireGrid01 () {
	if (hasRequiredGrid01) return Grid01;
	hasRequiredGrid01 = 1;
	Object.defineProperty(Grid01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgGrid01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M4 16h24M16 4v24M10.4 4h11.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C28 7.04 28 8.16 28 10.4v11.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C24.96 28 23.84 28 21.6 28H10.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C4 24.96 4 23.84 4 21.6V10.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C7.04 4 8.16 4 10.4 4" }))); };
	Grid01.default = SvgGrid01;
	
	return Grid01;
}

var Grid02 = {};

var hasRequiredGrid02;

function requireGrid02 () {
	if (hasRequiredGrid02) return Grid02;
	hasRequiredGrid02 = 1;
	Object.defineProperty(Grid02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgGrid02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M4 12h24M4 20h24M16 4v24M10.4 4h11.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C28 7.04 28 8.16 28 10.4v11.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C24.96 28 23.84 28 21.6 28H10.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C4 24.96 4 23.84 4 21.6V10.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C7.04 4 8.16 4 10.4 4" }))); };
	Grid02.default = SvgGrid02;
	
	return Grid02;
}

var Headphone = {};

var hasRequiredHeadphone;

function requireHeadphone () {
	if (hasRequiredHeadphone) return Headphone;
	hasRequiredHeadphone = 1;
	Object.defineProperty(Headphone, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgHeadphone = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M28 24v-8c0-6.627-5.373-12-12-12S4 9.373 4 16v8m3.333 4A3.333 3.333 0 0 1 4 24.667V22a3.333 3.333 0 1 1 6.667 0v2.667A3.333 3.333 0 0 1 7.333 28m17.334 0a3.333 3.333 0 0 1-3.334-3.333V22A3.333 3.333 0 1 1 28 22v2.667A3.333 3.333 0 0 1 24.667 28" }))); };
	Headphone.default = SvgHeadphone;
	
	return Headphone;
}

var Home01 = {};

var hasRequiredHome01;

function requireHome01 () {
	if (hasRequiredHome01) return Home01;
	hasRequiredHome01 = 1;
	Object.defineProperty(Home01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgHome01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M4 14.087c0-.766 0-1.149.099-1.501.087-.313.23-.607.424-.867.217-.295.52-.53 1.124-1l9.043-7.034c.469-.364.703-.546.962-.616.228-.062.468-.062.697 0 .258.07.492.252.96.616l9.044 7.034c.604.47.907.705 1.124 1 .193.26.337.554.424.867.099.352.099.735.099 1.5v9.647c0 1.494 0 2.24-.29 2.811-.256.502-.664.91-1.166 1.165-.57.291-1.317.291-2.81.291H8.266c-1.494 0-2.24 0-2.811-.29a2.67 2.67 0 0 1-1.165-1.166C4 25.974 4 25.227 4 23.734z" }))); };
	Home01.default = SvgHome01;
	
	return Home01;
}

var Home02 = {};

var hasRequiredHome02;

function requireHome02 () {
	if (hasRequiredHome02) return Home02;
	hasRequiredHome02 = 1;
	Object.defineProperty(Home02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgHome02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M10.835 18.667a5.336 5.336 0 0 0 10.33 0M14.69 3.685 5.647 10.72c-.604.47-.907.705-1.124 1-.193.26-.337.554-.424.867C4 12.938 4 13.32 4 14.086v9.647c0 1.494 0 2.24.29 2.811.256.502.664.91 1.166 1.165.57.291 1.317.291 2.81.291h15.467c1.494 0 2.24 0 2.811-.29.502-.256.91-.664 1.165-1.166.291-.57.291-1.317.291-2.81v-9.647c0-.766 0-1.149-.099-1.501a2.7 2.7 0 0 0-.424-.867c-.217-.295-.52-.53-1.124-1L17.31 3.685c-.469-.364-.703-.546-.961-.616a1.33 1.33 0 0 0-.697 0c-.26.07-.493.252-.962.616" }))); };
	Home02.default = SvgHome02;
	
	return Home02;
}

var Home03 = {};

var hasRequiredHome03;

function requireHome03 () {
	if (hasRequiredHome03) return Home03;
	hasRequiredHome03 = 1;
	Object.defineProperty(Home03, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgHome03 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M17.31 3.685c-.469-.364-.703-.546-.961-.616a1.33 1.33 0 0 0-.697 0c-.26.07-.493.252-.962.616L5.647 10.72c-.604.47-.907.705-1.124 1-.193.26-.337.554-.424.867C4 12.938 4 13.32 4 14.086v9.647c0 1.494 0 2.24.29 2.811.256.502.664.91 1.166 1.165.57.291 1.317.291 2.81.291h2.667c.374 0 .56 0 .703-.073a.67.67 0 0 0 .291-.291c.073-.143.073-.33.073-.703v-8.8c0-.746 0-1.12.145-1.405.128-.25.332-.455.583-.583.285-.145.659-.145 1.405-.145h3.734c.746 0 1.12 0 1.405.145.25.128.455.332.583.583.145.285.145.659.145 1.405v8.8c0 .374 0 .56.073.703a.67.67 0 0 0 .291.291c.143.073.33.073.703.073h2.666c1.494 0 2.24 0 2.811-.29.502-.256.91-.664 1.165-1.166.291-.57.291-1.317.291-2.81v-9.647c0-.766 0-1.149-.099-1.501a2.7 2.7 0 0 0-.424-.867c-.217-.295-.52-.53-1.124-1z" }))); };
	Home03.default = SvgHome03;
	
	return Home03;
}

var ImageCheck = {};

var hasRequiredImageCheck;

function requireImageCheck () {
	if (hasRequiredImageCheck) return ImageCheck;
	hasRequiredImageCheck = 1;
	Object.defineProperty(ImageCheck, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgImageCheck = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M21.333 6.667 24 9.333 29.333 4M16.667 4H10.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C4 7.04 4 8.16 4 10.4v11.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C7.04 28 8.16 28 10.4 28h12.267c1.24 0 1.86 0 2.368-.136a4 4 0 0 0 2.829-2.829c.136-.508.136-1.128.136-2.368M14 11.333a2.667 2.667 0 1 1-5.333 0 2.667 2.667 0 0 1 5.333 0m5.987 4.558L8.708 26.144c-.634.577-.951.865-.98 1.115a.67.67 0 0 0 .223.575C8.14 28 8.568 28 9.426 28H21.94c1.92 0 2.879 0 3.632-.322a4 4 0 0 0 2.105-2.105C28 24.82 28 23.86 28 21.941c0-.645 0-.968-.07-1.269a2.7 2.7 0 0 0-.499-1.037c-.19-.243-.443-.444-.947-.848l-3.73-2.983c-.504-.404-.756-.606-1.034-.677a1.33 1.33 0 0 0-.743.023c-.273.089-.512.306-.99.74" }))); };
	ImageCheck.default = SvgImageCheck;
	
	return ImageCheck;
}

var ImageClose = {};

var hasRequiredImageClose;

function requireImageClose () {
	if (hasRequiredImageClose) return ImageClose;
	hasRequiredImageClose = 1;
	Object.defineProperty(ImageClose, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgImageClose = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M22 3.333 28.667 10m0-6.667L22 10m-5.333-6H10.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C4 7.04 4 8.16 4 10.4v11.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C7.04 28 8.16 28 10.4 28h12.267c1.24 0 1.86 0 2.368-.136a4 4 0 0 0 2.829-2.829c.136-.508.136-1.128.136-2.368M14 11.333a2.667 2.667 0 1 1-5.333 0 2.667 2.667 0 0 1 5.333 0m5.987 4.558L8.708 26.144c-.634.577-.951.865-.98 1.115a.67.67 0 0 0 .223.575C8.14 28 8.568 28 9.426 28H21.94c1.92 0 2.879 0 3.632-.322a4 4 0 0 0 2.105-2.105C28 24.82 28 23.86 28 21.941c0-.645 0-.968-.07-1.269a2.7 2.7 0 0 0-.499-1.037c-.19-.243-.443-.444-.947-.848l-3.73-2.983c-.504-.404-.756-.606-1.034-.677a1.33 1.33 0 0 0-.743.023c-.273.089-.512.306-.99.74" }))); };
	ImageClose.default = SvgImageClose;
	
	return ImageClose;
}

var ImageDownload = {};

var hasRequiredImageDownload;

function requireImageDownload () {
	if (hasRequiredImageDownload) return ImageDownload;
	hasRequiredImageDownload = 1;
	Object.defineProperty(ImageDownload, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgImageDownload = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m21.333 6.667 4 4m0 0 4-4m-4 4v-8M16.667 4H10.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C4 7.04 4 8.16 4 10.4v11.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C7.04 28 8.16 28 10.4 28h12.267c1.24 0 1.86 0 2.368-.136a4 4 0 0 0 2.829-2.829c.136-.508.136-1.128.136-2.368M14 11.333a2.667 2.667 0 1 1-5.333 0 2.667 2.667 0 0 1 5.333 0m5.987 4.558L8.708 26.144c-.634.577-.951.865-.98 1.115a.67.67 0 0 0 .223.575C8.14 28 8.568 28 9.426 28H21.94c1.92 0 2.879 0 3.632-.322a4 4 0 0 0 2.105-2.105C28 24.82 28 23.86 28 21.941c0-.645 0-.968-.07-1.269a2.7 2.7 0 0 0-.499-1.037c-.19-.243-.443-.444-.947-.848l-3.73-2.983c-.504-.404-.756-.606-1.034-.677a1.33 1.33 0 0 0-.743.023c-.273.089-.512.306-.99.74" }))); };
	ImageDownload.default = SvgImageDownload;
	
	return ImageDownload;
}

var ImageLandscape = {};

var hasRequiredImageLandscape;

function requireImageLandscape () {
	if (hasRequiredImageLandscape) return ImageLandscape;
	hasRequiredImageLandscape = 1;
	Object.defineProperty(ImageLandscape, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgImageLandscape = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m5.696 27.637 8.796-8.795c.527-.528.791-.792 1.096-.891.268-.087.556-.087.824 0 .304.099.568.363 1.097.89l8.736 8.738M18.667 20l3.824-3.825c.529-.528.793-.792 1.097-.89.268-.088.556-.088.824 0 .304.098.568.362 1.097.89L29.333 20m-16-8A2.667 2.667 0 1 1 8 12a2.667 2.667 0 0 1 5.333 0M9.067 28h13.866c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748c.436-.856.436-1.976.436-4.216V10.4c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C26.294 4 25.173 4 22.933 4H9.067c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748c-.436.856-.436 1.976-.436 4.216v11.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C5.706 28 6.826 28 9.067 28" }))); };
	ImageLandscape.default = SvgImageLandscape;
	
	return ImageLandscape;
}

var ImageNext = {};

var hasRequiredImageNext;

function requireImageNext () {
	if (hasRequiredImageNext) return ImageNext;
	hasRequiredImageNext = 1;
	Object.defineProperty(ImageNext, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgImageNext = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m25.333 10.667 4-4m0 0-4-4m4 4h-8M16.667 4H10.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C4 7.04 4 8.16 4 10.4v11.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C7.04 28 8.16 28 10.4 28h12.267c1.24 0 1.86 0 2.368-.136a4 4 0 0 0 2.829-2.829c.136-.508.136-1.128.136-2.368M14 11.333a2.667 2.667 0 1 1-5.333 0 2.667 2.667 0 0 1 5.333 0m5.987 4.558L8.708 26.144c-.634.577-.951.865-.98 1.115a.67.67 0 0 0 .223.575C8.14 28 8.568 28 9.426 28H21.94c1.92 0 2.879 0 3.632-.322a4 4 0 0 0 2.105-2.105C28 24.82 28 23.86 28 21.941c0-.645 0-.968-.07-1.269a2.7 2.7 0 0 0-.499-1.037c-.19-.243-.443-.444-.947-.848l-3.73-2.983c-.504-.404-.756-.606-1.034-.677a1.33 1.33 0 0 0-.743.023c-.273.089-.512.306-.99.74" }))); };
	ImageNext.default = SvgImageNext;
	
	return ImageNext;
}

var ImagePlus = {};

var hasRequiredImagePlus;

function requireImagePlus () {
	if (hasRequiredImagePlus) return ImagePlus;
	hasRequiredImagePlus = 1;
	Object.defineProperty(ImagePlus, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgImagePlus = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M16.667 4H10.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C4 7.04 4 8.16 4 10.4v11.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C7.04 28 8.16 28 10.4 28h12.267c1.24 0 1.86 0 2.368-.136a4 4 0 0 0 2.829-2.829c.136-.508.136-1.128.136-2.368m-2.667-12v-8m-4 4h8M14 11.333a2.667 2.667 0 1 1-5.333 0 2.667 2.667 0 0 1 5.333 0m5.987 4.558L8.708 26.144c-.634.577-.951.865-.98 1.115a.67.67 0 0 0 .223.575C8.14 28 8.568 28 9.426 28H21.94c1.92 0 2.879 0 3.632-.322a4 4 0 0 0 2.105-2.105C28 24.82 28 23.86 28 21.941c0-.645 0-.968-.07-1.269a2.7 2.7 0 0 0-.499-1.037c-.19-.243-.443-.444-.947-.848l-3.73-2.983c-.504-.404-.756-.606-1.034-.677a1.33 1.33 0 0 0-.743.023c-.273.089-.512.306-.99.74" }))); };
	ImagePlus.default = SvgImagePlus;
	
	return ImagePlus;
}

var ImagePortrait = {};

var hasRequiredImagePortrait;

function requireImagePortrait () {
	if (hasRequiredImagePortrait) return ImagePortrait;
	hasRequiredImagePortrait = 1;
	Object.defineProperty(ImagePortrait, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgImagePortrait = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M21.6 28H9.242c-.808 0-1.212 0-1.399-.16a.67.67 0 0 1-.231-.559c.019-.245.304-.53.876-1.102l11.337-11.337c.528-.528.792-.792 1.096-.891.268-.087.557-.087.824 0 .305.099.569.363 1.097.89L28 20v1.6M21.6 28c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C28 24.96 28 23.84 28 21.6M21.6 28H10.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C4 24.96 4 23.84 4 21.6V10.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C7.04 4 8.16 4 10.4 4h11.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C28 7.04 28 8.16 28 10.4v11.2M14 11.333a2.667 2.667 0 1 1-5.333 0 2.667 2.667 0 0 1 5.333 0" }))); };
	ImagePortrait.default = SvgImagePortrait;
	
	return ImagePortrait;
}

var ImagePrevious = {};

var hasRequiredImagePrevious;

function requireImagePrevious () {
	if (hasRequiredImagePrevious) return ImagePrevious;
	hasRequiredImagePrevious = 1;
	Object.defineProperty(ImagePrevious, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgImagePrevious = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m25.333 10.667-4-4m0 0 4-4m-4 4h8M16.667 4H10.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C4 7.04 4 8.16 4 10.4v11.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C7.04 28 8.16 28 10.4 28h12.267c1.24 0 1.86 0 2.368-.136a4 4 0 0 0 2.829-2.829c.136-.508.136-1.128.136-2.368M14 11.333a2.667 2.667 0 1 1-5.333 0 2.667 2.667 0 0 1 5.333 0m5.987 4.558L8.708 26.144c-.634.577-.951.865-.98 1.115a.67.67 0 0 0 .223.575C8.14 28 8.568 28 9.426 28H21.94c1.92 0 2.879 0 3.632-.322a4 4 0 0 0 2.105-2.105C28 24.82 28 23.86 28 21.941c0-.645 0-.968-.07-1.269a2.7 2.7 0 0 0-.499-1.037c-.19-.243-.443-.444-.947-.848l-3.73-2.983c-.504-.404-.756-.606-1.034-.677a1.33 1.33 0 0 0-.743.023c-.273.089-.512.306-.99.74" }))); };
	ImagePrevious.default = SvgImagePrevious;
	
	return ImagePrevious;
}

var ImageThumb = {};

var hasRequiredImageThumb;

function requireImageThumb () {
	if (hasRequiredImageThumb) return ImageThumb;
	hasRequiredImageThumb = 1;
	Object.defineProperty(ImageThumb, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgImageThumb = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M25.333 28h1.348c1.294 0 1.942 0 2.299-.27.31-.235.503-.595.526-.984.027-.447-.332-.985-1.05-2.063l-4.014-6.02c-.594-.89-.89-1.336-1.265-1.49a1.33 1.33 0 0 0-1.021 0c-.374.154-.67.6-1.264 1.49l-.993 1.488M25.333 28 15.087 13.2c-.589-.85-.883-1.276-1.251-1.426a1.33 1.33 0 0 0-1.005 0c-.368.15-.662.575-1.252 1.426L3.651 24.652c-.75 1.085-1.126 1.627-1.105 2.078.019.392.21.757.522.996C3.427 28 4.086 28 5.405 28zM28 8a4 4 0 1 1-8 0 4 4 0 0 1 8 0" }))); };
	ImageThumb.default = SvgImageThumb;
	
	return ImageThumb;
}

var ImageUpload = {};

var hasRequiredImageUpload;

function requireImageUpload () {
	if (hasRequiredImageUpload) return ImageUpload;
	hasRequiredImageUpload = 1;
	Object.defineProperty(ImageUpload, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgImageUpload = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m21.333 6.667 4-4m0 0 4 4m-4-4v8M16.667 4H10.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C4 7.04 4 8.16 4 10.4v11.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C7.04 28 8.16 28 10.4 28h12.267c1.24 0 1.86 0 2.368-.136a4 4 0 0 0 2.829-2.829c.136-.508.136-1.128.136-2.368M14 11.333a2.667 2.667 0 1 1-5.333 0 2.667 2.667 0 0 1 5.333 0m5.987 4.558L8.708 26.144c-.634.577-.951.865-.98 1.115a.67.67 0 0 0 .223.575C8.14 28 8.568 28 9.426 28H21.94c1.92 0 2.879 0 3.632-.322a4 4 0 0 0 2.105-2.105C28 24.82 28 23.86 28 21.941c0-.645 0-.968-.07-1.269a2.7 2.7 0 0 0-.499-1.037c-.19-.243-.443-.444-.947-.848l-3.73-2.983c-.504-.404-.756-.606-1.034-.677a1.33 1.33 0 0 0-.743.023c-.273.089-.512.306-.99.74" }))); };
	ImageUpload.default = SvgImageUpload;
	
	return ImageUpload;
}

var Insight01 = {};

var hasRequiredInsight01;

function requireInsight01 () {
	if (hasRequiredInsight01) return Insight01;
	hasRequiredInsight01 = 1;
	Object.defineProperty(Insight01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgInsight01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M19 2.667h-7.675c-.239 0-.359 0-.464.036a.7.7 0 0 0-.25.154c-.08.078-.133.185-.24.4l-5.6 11.2c-.255.51-.383.766-.352.974a.67.67 0 0 0 .277.449c.172.12.458.12 1.03.12H14l-4 13.333 16.257-16.86c.548-.568.823-.852.839-1.096a.67.67 0 0 0-.235-.553c-.187-.157-.582-.157-1.372-.157H16z" }))); };
	Insight01.default = SvgInsight01;
	
	return Insight01;
}

var Insight02 = {};

var hasRequiredInsight02;

function requireInsight02 () {
	if (hasRequiredInsight02) return Insight02;
	hasRequiredInsight02 = 1;
	Object.defineProperty(Insight02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgInsight02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m8.667 17.333 1.046 2.092c.354.708.53 1.062.767 1.369q.317.41.726.726c.307.236.66.413 1.369.768l2.092 1.045-2.092 1.046c-.708.354-1.062.531-1.369.768q-.41.317-.726.726c-.236.307-.413.66-.767 1.368l-1.046 2.092-1.046-2.091c-.354-.708-.531-1.062-.768-1.37a4 4 0 0 0-.726-.725c-.306-.237-.66-.414-1.368-.768l-2.092-1.046 2.092-1.045c.708-.355 1.062-.532 1.368-.768q.411-.317.726-.726c.237-.307.414-.66.768-1.369zM20 2.667l1.572 4.086c.376.977.564 1.466.856 1.877a4 4 0 0 0 .942.942c.411.293.9.48 1.877.857L29.334 12l-4.085 1.572c-.978.376-1.467.564-1.878.856a4 4 0 0 0-.942.942c-.292.411-.48.9-.856 1.877L20 21.334l-1.571-4.085c-.376-.978-.564-1.467-.857-1.878a4 4 0 0 0-.942-.942c-.41-.292-.9-.48-1.877-.856L10.667 12l4.086-1.571c.977-.376 1.466-.564 1.877-.857a4 4 0 0 0 .942-.942c.293-.41.48-.9.857-1.877z" }))); };
	Insight02.default = SvgInsight02;
	
	return Insight02;
}

var Insight03 = {};

var hasRequiredInsight03;

function requireInsight03 () {
	if (hasRequiredInsight03) return Insight03;
	hasRequiredInsight03 = 1;
	Object.defineProperty(Insight03, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgInsight03 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M6 29.333v-6.666M6 9.333V2.667M2.667 6h6.666M2.667 26h6.666m8-22-2.312 6.012c-.376.977-.564 1.466-.856 1.877-.26.365-.578.683-.942.943-.411.292-.9.48-1.878.856L5.333 16l6.012 2.312c.978.376 1.467.564 1.878.857a4 4 0 0 1 .942.942c.292.41.48.9.856 1.877L17.333 28l2.313-6.012c.375-.977.564-1.466.856-1.877a4 4 0 0 1 .942-.942c.411-.293.9-.48 1.878-.857L29.333 16l-6.011-2.312c-.978-.376-1.467-.564-1.878-.857a4 4 0 0 1-.942-.941c-.292-.412-.48-.9-.857-1.878z" }))); };
	Insight03.default = SvgInsight03;
	
	return Insight03;
}

var Keyboard = {};

var hasRequiredKeyboard;

function requireKeyboard () {
	if (hasRequiredKeyboard) return Keyboard;
	hasRequiredKeyboard = 1;
	Object.defineProperty(Keyboard, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgKeyboard = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M8 13.333h.013m2.654 5.334h.013m2.653-5.334h.014M16 18.667h.013m2.654-5.334h.013m2.653 5.334h.014M24 13.333h.013M6.933 24h18.134c1.493 0 2.24 0 2.81-.29.502-.256.91-.664 1.166-1.166.29-.57.29-1.317.29-2.81v-7.467c0-1.494 0-2.24-.29-2.81a2.67 2.67 0 0 0-1.166-1.166C27.307 8 26.56 8 25.067 8H6.933c-1.493 0-2.24 0-2.81.29-.502.255-.91.663-1.166 1.165-.29.57-.29 1.317-.29 2.81v7.467c0 1.494 0 2.24.29 2.811.256.502.664.91 1.166 1.165.57.291 1.317.291 2.81.291" }))); };
	Keyboard.default = SvgKeyboard;
	
	return Keyboard;
}

var KpiDownLeft = {};

var hasRequiredKpiDownLeft;

function requireKpiDownLeft () {
	if (hasRequiredKpiDownLeft) return KpiDownLeft;
	hasRequiredKpiDownLeft = 1;
	Object.defineProperty(KpiDownLeft, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgKpiDownLeft = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M12 12v8m0 0h8m-8 0 8-8m-9.6 16h11.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C28 24.96 28 23.84 28 21.6V10.4c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C24.96 4 23.84 4 21.6 4H10.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C4 7.04 4 8.16 4 10.4v11.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C7.04 28 8.16 28 10.4 28" }))); };
	KpiDownLeft.default = SvgKpiDownLeft;
	
	return KpiDownLeft;
}

var KpiDownRight = {};

var hasRequiredKpiDownRight;

function requireKpiDownRight () {
	if (hasRequiredKpiDownRight) return KpiDownRight;
	hasRequiredKpiDownRight = 1;
	Object.defineProperty(KpiDownRight, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgKpiDownRight = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M20 12v8m0 0h-8m8 0-8-8m-1.6 16h11.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C28 24.96 28 23.84 28 21.6V10.4c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C24.96 4 23.84 4 21.6 4H10.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C4 7.04 4 8.16 4 10.4v11.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C7.04 28 8.16 28 10.4 28" }))); };
	KpiDownRight.default = SvgKpiDownRight;
	
	return KpiDownRight;
}

var KpiDown = {};

var hasRequiredKpiDown;

function requireKpiDown () {
	if (hasRequiredKpiDown) return KpiDown;
	hasRequiredKpiDown = 1;
	Object.defineProperty(KpiDown, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgKpiDown = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M10.667 16 16 21.334m0 0L21.333 16M16 21.334V10.667M10.4 28h11.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C28 24.96 28 23.84 28 21.6V10.4c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C24.96 4 23.84 4 21.6 4H10.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C4 7.04 4 8.16 4 10.4v11.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C7.04 28 8.16 28 10.4 28" }))); };
	KpiDown.default = SvgKpiDown;
	
	return KpiDown;
}

var KpiLeft = {};

var hasRequiredKpiLeft;

function requireKpiLeft () {
	if (hasRequiredKpiLeft) return KpiLeft;
	hasRequiredKpiLeft = 1;
	Object.defineProperty(KpiLeft, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgKpiLeft = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M16 10.667 10.667 16m0 0L16 21.334M10.667 16h10.666M10.4 28h11.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C28 24.96 28 23.84 28 21.6V10.4c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C24.96 4 23.84 4 21.6 4H10.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C4 7.04 4 8.16 4 10.4v11.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C7.04 28 8.16 28 10.4 28" }))); };
	KpiLeft.default = SvgKpiLeft;
	
	return KpiLeft;
}

var KpiRight = {};

var hasRequiredKpiRight;

function requireKpiRight () {
	if (hasRequiredKpiRight) return KpiRight;
	hasRequiredKpiRight = 1;
	Object.defineProperty(KpiRight, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgKpiRight = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M16 21.334 21.333 16m0 0L16 10.667M21.333 16H10.667M10.4 28h11.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C28 24.96 28 23.84 28 21.6V10.4c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C24.96 4 23.84 4 21.6 4H10.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C4 7.04 4 8.16 4 10.4v11.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C7.04 28 8.16 28 10.4 28" }))); };
	KpiRight.default = SvgKpiRight;
	
	return KpiRight;
}

var KpiUpLeft = {};

var hasRequiredKpiUpLeft;

function requireKpiUpLeft () {
	if (hasRequiredKpiUpLeft) return KpiUpLeft;
	hasRequiredKpiUpLeft = 1;
	Object.defineProperty(KpiUpLeft, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgKpiUpLeft = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M12 20v-8m0 0h8m-8 0 8 8m-9.6 8h11.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C28 24.96 28 23.84 28 21.6V10.4c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C24.96 4 23.84 4 21.6 4H10.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C4 7.04 4 8.16 4 10.4v11.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C7.04 28 8.16 28 10.4 28" }))); };
	KpiUpLeft.default = SvgKpiUpLeft;
	
	return KpiUpLeft;
}

var KpiUpRight = {};

var hasRequiredKpiUpRight;

function requireKpiUpRight () {
	if (hasRequiredKpiUpRight) return KpiUpRight;
	hasRequiredKpiUpRight = 1;
	Object.defineProperty(KpiUpRight, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgKpiUpRight = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M20 20v-8m0 0h-8m8 0-8 8m-1.6 8h11.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C28 24.96 28 23.84 28 21.6V10.4c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C24.96 4 23.84 4 21.6 4H10.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C4 7.04 4 8.16 4 10.4v11.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C7.04 28 8.16 28 10.4 28" }))); };
	KpiUpRight.default = SvgKpiUpRight;
	
	return KpiUpRight;
}

var KpiUp = {};

var hasRequiredKpiUp;

function requireKpiUp () {
	if (hasRequiredKpiUp) return KpiUp;
	hasRequiredKpiUp = 1;
	Object.defineProperty(KpiUp, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgKpiUp = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M21.333 16 16 10.667m0 0L10.667 16M16 10.667v10.667M10.4 28h11.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C28 24.96 28 23.84 28 21.6V10.4c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C24.96 4 23.84 4 21.6 4H10.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C4 7.04 4 8.16 4 10.4v11.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C7.04 28 8.16 28 10.4 28" }))); };
	KpiUp.default = SvgKpiUp;
	
	return KpiUp;
}

var Layers01 = {};

var hasRequiredLayers01;

function requireLayers01 () {
	if (hasRequiredLayers01) return Layers01;
	hasRequiredLayers01 = 1;
	Object.defineProperty(Layers01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgLayers01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m2.667 19.333 12.856 6.428c.175.088.262.132.354.149a.7.7 0 0 0 .246 0c.092-.017.18-.061.354-.149l12.856-6.428M2.667 12.667l12.856-6.429c.175-.087.262-.13.354-.148a.7.7 0 0 1 .246 0c.092.017.18.061.354.148l12.856 6.429-12.856 6.428c-.175.087-.262.13-.354.148a.7.7 0 0 1-.246 0c-.092-.017-.18-.06-.354-.148z" }))); };
	Layers01.default = SvgLayers01;
	
	return Layers01;
}

var Layers02 = {};

var hasRequiredLayers02;

function requireLayers02 () {
	if (hasRequiredLayers02) return Layers02;
	hasRequiredLayers02 = 1;
	Object.defineProperty(Layers02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgLayers02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m2.667 16 12.856 6.428c.175.087.262.131.354.148a.7.7 0 0 0 .246 0c.092-.017.18-.06.354-.148L29.333 16M2.667 22.666l12.856 6.429c.175.087.262.13.354.148a.7.7 0 0 0 .246 0c.092-.017.18-.06.354-.148l12.856-6.428M2.667 9.333l12.856-6.428c.175-.087.262-.131.354-.148a.7.7 0 0 1 .246 0c.092.017.18.06.354.148l12.856 6.428-12.856 6.428c-.175.088-.262.132-.354.149a.7.7 0 0 1-.246 0c-.092-.017-.18-.061-.354-.149z" }))); };
	Layers02.default = SvgLayers02;
	
	return Layers02;
}

var LayoutAlt01 = {};

var hasRequiredLayoutAlt01;

function requireLayoutAlt01 () {
	if (hasRequiredLayoutAlt01) return LayoutAlt01;
	hasRequiredLayoutAlt01 = 1;
	Object.defineProperty(LayoutAlt01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgLayoutAlt01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M4 12h24m-16 0v16M10.4 4h11.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C28 7.04 28 8.16 28 10.4v11.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C24.96 28 23.84 28 21.6 28H10.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C4 24.96 4 23.84 4 21.6V10.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C7.04 4 8.16 4 10.4 4" }))); };
	LayoutAlt01.default = SvgLayoutAlt01;
	
	return LayoutAlt01;
}

var LayoutAlt02 = {};

var hasRequiredLayoutAlt02;

function requireLayoutAlt02 () {
	if (hasRequiredLayoutAlt02) return LayoutAlt02;
	hasRequiredLayoutAlt02 = 1;
	Object.defineProperty(LayoutAlt02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgLayoutAlt02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M23.333 14.667h-6.666M23.333 20h-6.666m6.666-10.667h-6.666M12 4v24M10.4 4h11.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C28 7.04 28 8.16 28 10.4v11.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C24.96 28 23.84 28 21.6 28H10.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C4 24.96 4 23.84 4 21.6V10.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C7.04 4 8.16 4 10.4 4" }))); };
	LayoutAlt02.default = SvgLayoutAlt02;
	
	return LayoutAlt02;
}

var LayoutAlt03 = {};

var hasRequiredLayoutAlt03;

function requireLayoutAlt03 () {
	if (hasRequiredLayoutAlt03) return LayoutAlt03;
	hasRequiredLayoutAlt03 = 1;
	Object.defineProperty(LayoutAlt03, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgLayoutAlt03 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M23.333 22.667H8.667m14.666-5.334H8.667M4 12h24M10.4 4h11.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C28 7.04 28 8.16 28 10.4v11.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C24.96 28 23.84 28 21.6 28H10.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C4 24.96 4 23.84 4 21.6V10.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C7.04 4 8.16 4 10.4 4" }))); };
	LayoutAlt03.default = SvgLayoutAlt03;
	
	return LayoutAlt03;
}

var LayoutAlt04 = {};

var hasRequiredLayoutAlt04;

function requireLayoutAlt04 () {
	if (hasRequiredLayoutAlt04) return LayoutAlt04;
	hasRequiredLayoutAlt04 = 1;
	Object.defineProperty(LayoutAlt04, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgLayoutAlt04 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M16 16h12M16 4v24M10.4 4h11.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C28 7.04 28 8.16 28 10.4v11.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C24.96 28 23.84 28 21.6 28H10.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C4 24.96 4 23.84 4 21.6V10.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C7.04 4 8.16 4 10.4 4" }))); };
	LayoutAlt04.default = SvgLayoutAlt04;
	
	return LayoutAlt04;
}

var LayoutBottom = {};

var hasRequiredLayoutBottom;

function requireLayoutBottom () {
	if (hasRequiredLayoutBottom) return LayoutBottom;
	hasRequiredLayoutBottom = 1;
	Object.defineProperty(LayoutBottom, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgLayoutBottom = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M4 20h24M10.4 4h11.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C28 7.04 28 8.16 28 10.4v11.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C24.96 28 23.84 28 21.6 28H10.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C4 24.96 4 23.84 4 21.6V10.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C7.04 4 8.16 4 10.4 4" }))); };
	LayoutBottom.default = SvgLayoutBottom;
	
	return LayoutBottom;
}

var LayoutLeft = {};

var hasRequiredLayoutLeft;

function requireLayoutLeft () {
	if (hasRequiredLayoutLeft) return LayoutLeft;
	hasRequiredLayoutLeft = 1;
	Object.defineProperty(LayoutLeft, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgLayoutLeft = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M12 4v24M10.4 4h11.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C28 7.04 28 8.16 28 10.4v11.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C24.96 28 23.84 28 21.6 28H10.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C4 24.96 4 23.84 4 21.6V10.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C7.04 4 8.16 4 10.4 4" }))); };
	LayoutLeft.default = SvgLayoutLeft;
	
	return LayoutLeft;
}

var LayoutRight = {};

var hasRequiredLayoutRight;

function requireLayoutRight () {
	if (hasRequiredLayoutRight) return LayoutRight;
	hasRequiredLayoutRight = 1;
	Object.defineProperty(LayoutRight, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgLayoutRight = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M20 4v24M10.4 4h11.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C28 7.04 28 8.16 28 10.4v11.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C24.96 28 23.84 28 21.6 28H10.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C4 24.96 4 23.84 4 21.6V10.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C7.04 4 8.16 4 10.4 4" }))); };
	LayoutRight.default = SvgLayoutRight;
	
	return LayoutRight;
}

var LayoutTop = {};

var hasRequiredLayoutTop;

function requireLayoutTop () {
	if (hasRequiredLayoutTop) return LayoutTop;
	hasRequiredLayoutTop = 1;
	Object.defineProperty(LayoutTop, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgLayoutTop = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M4 12h24M10.4 4h11.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C28 7.04 28 8.16 28 10.4v11.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C24.96 28 23.84 28 21.6 28H10.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C4 24.96 4 23.84 4 21.6V10.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C7.04 4 8.16 4 10.4 4" }))); };
	LayoutTop.default = SvgLayoutTop;
	
	return LayoutTop;
}

var Legal = {};

var hasRequiredLegal;

function requireLegal () {
	if (hasRequiredLegal) return Legal;
	hasRequiredLegal = 1;
	Object.defineProperty(Legal, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgLegal = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M4 28h24M8 24V13.333M13.333 24V13.333M18.667 24V13.333M24 24V13.333m2.667-4L16.565 3.02c-.205-.128-.307-.192-.417-.217a.7.7 0 0 0-.296 0c-.11.025-.212.089-.417.217L5.333 9.333z" }))); };
	Legal.default = SvgLegal;
	
	return Legal;
}

var LightbulbOn = {};

var hasRequiredLightbulbOn;

function requireLightbulbOn () {
	if (hasRequiredLightbulbOn) return LightbulbOn;
	hasRequiredLightbulbOn = 1;
	Object.defineProperty(LightbulbOn, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgLightbulbOn = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M16 2.667V4M4 16H2.667m4.666-8.667-.8-.8m18.134.8.8-.8M29.333 16H28m-14.667 2h5.334M16 18v6.667m4.667-2.168a8 8 0 1 0-9.333 0v2.568c0 1.493 0 2.24.29 2.81.256.502.664.91 1.165 1.166.57.29 1.318.29 2.811.29h.8c1.494 0 2.24 0 2.81-.29.502-.256.91-.664 1.166-1.166.29-.57.29-1.317.29-2.81z" }))); };
	LightbulbOn.default = SvgLightbulbOn;
	
	return LightbulbOn;
}

var Lightbulb = {};

var hasRequiredLightbulb;

function requireLightbulb () {
	if (hasRequiredLightbulb) return Lightbulb;
	hasRequiredLightbulb = 1;
	Object.defineProperty(Lightbulb, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgLightbulb = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M12.667 29.333h6.666m-6-16h5.333m-2.666 0v8m4-.898a9.333 9.333 0 1 0-8 0v.898c0 1.243 0 1.864.203 2.354.27.654.79 1.173 1.443 1.443.49.203 1.111.203 2.354.203 1.242 0 1.864 0 2.354-.203a2.67 2.67 0 0 0 1.443-1.443c.203-.49.203-1.111.203-2.354z" }))); };
	Lightbulb.default = SvgLightbulb;
	
	return Lightbulb;
}

var LinkOff = {};

var hasRequiredLinkOff;

function requireLinkOff () {
	if (hasRequiredLinkOff) return LinkOff;
	hasRequiredLinkOff = 1;
	Object.defineProperty(LinkOff, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgLinkOff = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M12 5.333V2.667m8 24v2.666M5.333 12H2.667m24 8h2.666M6.553 6.552 4.666 4.667m20.78 20.78 1.886 1.886M16 23.543l-2.828 2.828a5.333 5.333 0 1 1-7.543-7.542L8.458 16m15.085 0 2.828-2.828a5.333 5.333 0 0 0-7.543-7.543L16 8.458" }))); };
	LinkOff.default = SvgLinkOff;
	
	return LinkOff;
}

var LinkOn = {};

var hasRequiredLinkOn;

function requireLinkOn () {
	if (hasRequiredLinkOn) return LinkOn;
	hasRequiredLinkOn = 1;
	Object.defineProperty(LinkOn, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgLinkOn = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m11.333 20.667 9.334-9.334m-8.667-6V2.667m8 24v2.666M5.333 12H2.667m24 8h2.666M6.553 6.552 4.666 4.667m20.78 20.78 1.886 1.886M16 23.543l-2.828 2.828a5.333 5.333 0 0 1-7.543-7.543L8.458 16m15.085 0 2.828-2.828a5.333 5.333 0 1 0-7.543-7.543L16 8.457" }))); };
	LinkOn.default = SvgLinkOn;
	
	return LinkOn;
}

var Link = {};

var hasRequiredLink;

function requireLink () {
	if (hasRequiredLink) return Link;
	hasRequiredLink = 1;
	Object.defineProperty(Link, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgLink = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m16.944 24.485-1.886 1.886a6.667 6.667 0 1 1-9.428-9.428l1.885-1.886m16.97 1.886 1.887-1.886a6.667 6.667 0 1 0-9.428-9.428l-1.886 1.886m-3.724 13.152 9.333-9.334" }))); };
	Link.default = SvgLink;
	
	return Link;
}

var LockLocked01 = {};

var hasRequiredLockLocked01;

function requireLockLocked01 () {
	if (hasRequiredLockLocked01) return LockLocked01;
	hasRequiredLockLocked01 = 1;
	Object.defineProperty(LockLocked01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgLockLocked01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M22.667 13.333v-2.666a6.667 6.667 0 1 0-13.334 0v2.666m6.667 6V22m-4.267 6h8.534c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748c.436-.856.436-1.976.436-4.216v-1.867c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748c-.856-.436-1.976-.436-4.216-.436h-8.534c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748c-.436.856-.436 1.976-.436 4.216V21.6c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C8.373 28 9.493 28 11.733 28" }))); };
	LockLocked01.default = SvgLockLocked01;
	
	return LockLocked01;
}

var LockLocked02 = {};

var hasRequiredLockLocked02;

function requireLockLocked02 () {
	if (hasRequiredLockLocked02) return LockLocked02;
	hasRequiredLockLocked02 = 1;
	Object.defineProperty(LockLocked02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgLockLocked02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M22.667 14.667v-4a6.667 6.667 0 1 0-13.334 0v4M11.733 28h8.534c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748c.436-.856.436-1.976.436-4.216v-.533c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748c-.856-.436-1.976-.436-4.216-.436h-8.534c-2.24 0-3.36 0-4.216.436A4 4 0 0 0 5.77 16.85c-.436.855-.436 1.976-.436 4.216v.533c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C8.373 28 9.493 28 11.733 28" }))); };
	LockLocked02.default = SvgLockLocked02;
	
	return LockLocked02;
}

var LockUnlocked01 = {};

var hasRequiredLockUnlocked01;

function requireLockUnlocked01 () {
	if (hasRequiredLockUnlocked01) return LockUnlocked01;
	hasRequiredLockUnlocked01 = 1;
	Object.defineProperty(LockUnlocked01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgLockUnlocked01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M9.333 13.333v-2.666A6.667 6.667 0 0 1 22.112 8M16 19.333V22m-4.267 6h8.534c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748c.436-.856.436-1.976.436-4.216v-1.867c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748c-.856-.436-1.976-.436-4.216-.436h-8.534c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748c-.436.856-.436 1.976-.436 4.216V21.6c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C8.373 28 9.493 28 11.733 28" }))); };
	LockUnlocked01.default = SvgLockUnlocked01;
	
	return LockUnlocked01;
}

var LockUnlocked02 = {};

var hasRequiredLockUnlocked02;

function requireLockUnlocked02 () {
	if (hasRequiredLockUnlocked02) return LockUnlocked02;
	hasRequiredLockUnlocked02 = 1;
	Object.defineProperty(LockUnlocked02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgLockUnlocked02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M9.333 14.667v-4a6.667 6.667 0 0 1 13.2-1.334M11.733 28h8.534c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748c.436-.856.436-1.976.436-4.216v-.533c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748c-.856-.436-1.976-.436-4.216-.436h-8.534c-2.24 0-3.36 0-4.216.436A4 4 0 0 0 5.77 16.85c-.436.855-.436 1.976-.436 4.216v.533c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C8.373 28 9.493 28 11.733 28" }))); };
	LockUnlocked02.default = SvgLockUnlocked02;
	
	return LockUnlocked02;
}

var Login = {};

var hasRequiredLogin;

function requireLogin () {
	if (hasRequiredLogin) return Login;
	hasRequiredLogin = 1;
	Object.defineProperty(Login, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgLogin = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M20 4h1.6c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C28 7.04 28 8.16 28 10.4v11.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C24.96 28 23.84 28 21.6 28H20M13.333 9.333 20 16m0 0-6.667 6.667M20 16H4" }))); };
	Login.default = SvgLogin;
	
	return Login;
}

var Logout = {};

var hasRequiredLogout;

function requireLogout () {
	if (hasRequiredLogout) return Logout;
	hasRequiredLogout = 1;
	Object.defineProperty(Logout, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgLogout = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M21.333 22.667 28 16m0 0-6.667-6.667M28 16H12m0-12h-1.6c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C4 7.04 4 8.16 4 10.4v11.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C7.04 28 8.16 28 10.4 28H12" }))); };
	Logout.default = SvgLogout;
	
	return Logout;
}

var MailClosed01 = {};

var hasRequiredMailClosed01;

function requireMailClosed01 () {
	if (hasRequiredMailClosed01) return MailClosed01;
	hasRequiredMailClosed01 = 1;
	Object.defineProperty(MailClosed01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgMailClosed01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m2.667 9.333 10.886 7.62c.882.618 1.322.927 1.802 1.046.423.106.866.106 1.29 0 .48-.12.92-.428 1.802-1.045l10.886-7.62M9.067 26.666h13.866c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748c.436-.856.436-1.976.436-4.216v-8.534c0-2.24 0-3.36-.436-4.216A4 4 0 0 0 27.15 5.77c-.855-.436-1.976-.436-4.216-.436H9.067c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748c-.436.856-.436 1.976-.436 4.216v8.534c0 2.24 0 3.36.436 4.216A4 4 0 0 0 4.85 26.23c.855.436 1.975.436 4.216.436" }))); };
	MailClosed01.default = SvgMailClosed01;
	
	return MailClosed01;
}

var MailClosed02 = {};

var hasRequiredMailClosed02;

function requireMailClosed02 () {
	if (hasRequiredMailClosed02) return MailClosed02;
	hasRequiredMailClosed02 = 1;
	Object.defineProperty(MailClosed02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgMailClosed02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m28.667 24-8.858-8m-7.619 0-8.857 8M2.667 9.333l10.886 7.62c.882.618 1.322.927 1.802 1.046.423.106.866.106 1.29 0 .48-.12.92-.428 1.802-1.045l10.886-7.62M9.067 26.666h13.866c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748c.436-.856.436-1.976.436-4.216v-8.534c0-2.24 0-3.36-.436-4.216A4 4 0 0 0 27.15 5.77c-.855-.436-1.976-.436-4.216-.436H9.067c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748c-.436.856-.436 1.976-.436 4.216v8.534c0 2.24 0 3.36.436 4.216A4 4 0 0 0 4.85 26.23c.855.436 1.975.436 4.216.436" }))); };
	MailClosed02.default = SvgMailClosed02;
	
	return MailClosed02;
}

var MailInbox01 = {};

var hasRequiredMailInbox01;

function requireMailInbox01 () {
	if (hasRequiredMailInbox01) return MailInbox01;
	hasRequiredMailInbox01 = 1;
	Object.defineProperty(MailInbox01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgMailInbox01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M3.333 16h4.51c.913 0 1.748.516 2.157 1.333a2.41 2.41 0 0 0 2.157 1.334h7.686c.913 0 1.748-.517 2.157-1.334A2.41 2.41 0 0 1 24.157 16h4.51M11.955 5.333h8.09c1.435 0 2.153 0 2.787.219a4 4 0 0 1 1.495.924c.479.469.8 1.11 1.442 2.395l2.889 5.778c.252.504.378.756.466 1.02q.12.353.17.72c.04.277.04.558.04 1.122v2.756c0 2.24 0 3.36-.437 4.216a4 4 0 0 1-1.748 1.748c-.855.436-1.975.436-4.216.436H9.067c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748c-.436-.856-.436-1.976-.436-4.216V17.51c0-.564 0-.845.038-1.121q.053-.369.17-.721c.09-.264.215-.516.467-1.02l2.89-5.778c.641-1.284.962-1.926 1.441-2.395a4 4 0 0 1 1.495-.924c.634-.219 1.352-.219 2.787-.219" }))); };
	MailInbox01.default = SvgMailInbox01;
	
	return MailInbox01;
}

var MailInbox02 = {};

var hasRequiredMailInbox02;

function requireMailInbox02 () {
	if (hasRequiredMailInbox02) return MailInbox02;
	hasRequiredMailInbox02 = 1;
	Object.defineProperty(MailInbox02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgMailInbox02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M2.667 16h5.176c.913 0 1.748.516 2.157 1.333a2.41 2.41 0 0 0 2.157 1.334h7.686c.913 0 1.748-.517 2.157-1.334A2.41 2.41 0 0 1 24.157 16h5.176M2.667 16v-4.267c0-2.24 0-3.36.436-4.216A4 4 0 0 1 4.85 5.77c.855-.436 1.975-.436 4.216-.436h13.866c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748c.436.856.436 1.976.436 4.216V16M2.667 16v4.267c0 2.24 0 3.36.436 4.216A4 4 0 0 0 4.85 26.23c.855.436 1.975.436 4.216.436h13.866c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748c.436-.856.436-1.976.436-4.216V16" }))); };
	MailInbox02.default = SvgMailInbox02;
	
	return MailInbox02;
}

var MailOpened01 = {};

var hasRequiredMailOpened01;

function requireMailOpened01 () {
	if (hasRequiredMailOpened01) return MailOpened01;
	hasRequiredMailOpened01 = 1;
	Object.defineProperty(MailOpened01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgMailOpened01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m18.325 3.511 10.038 6.525c.354.23.532.346.66.5.114.135.2.293.252.462.058.192.058.403.058.826V21.6c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748c-.855.436-1.975.436-4.216.436H9.067c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748c-.436-.856-.436-1.976-.436-4.216v-9.776c0-.423 0-.634.059-.826.052-.17.137-.327.251-.463.128-.153.306-.269.66-.5l10.038-6.524m4.65 0c-.841-.547-1.262-.82-1.716-.927a2.7 2.7 0 0 0-1.218 0c-.454.107-.874.38-1.716.927m4.65 0 9.633 6.261c.458.298.687.447.767.636.07.166.07.352 0 .517-.08.189-.309.338-.768.636l-9.632 6.26c-.841.548-1.262.821-1.716.928-.4.094-.818.094-1.218 0-.454-.107-.874-.38-1.716-.927L4.043 11.56c-.459-.298-.688-.447-.768-.636a.67.67 0 0 1 0-.517c.08-.189.31-.338.768-.636l9.632-6.26" }))); };
	MailOpened01.default = SvgMailOpened01;
	
	return MailOpened01;
}

var MailOpened02 = {};

var hasRequiredMailOpened02;

function requireMailOpened02 () {
	if (hasRequiredMailOpened02) return MailOpened02;
	hasRequiredMailOpened02 = 1;
	Object.defineProperty(MailOpened02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgMailOpened02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m18.325 3.511 10.038 6.525c.354.23.532.346.66.5.114.135.2.293.251.462.06.192.06.403.06.826V21.6c0 2.24 0 3.36-.437 4.216a4 4 0 0 1-1.748 1.748c-.855.436-1.976.436-4.216.436H9.067c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748c-.436-.856-.436-1.976-.436-4.216v-9.776c0-.423 0-.634.059-.826.052-.17.137-.327.25-.463.13-.153.307-.269.661-.5l10.038-6.524m4.65 0c-.841-.547-1.262-.82-1.716-.927a2.7 2.7 0 0 0-1.218 0c-.454.107-.875.38-1.716.927m4.65 0 8.256 5.367c.918.596 1.376.894 1.535 1.272.139.33.139.703 0 1.033-.159.378-.617.676-1.535 1.272l-8.256 5.367c-.841.547-1.262.82-1.716.927-.4.094-.818.094-1.218 0-.454-.107-.875-.38-1.716-.927l-8.257-5.367c-.917-.596-1.375-.894-1.534-1.272a1.33 1.33 0 0 1 0-1.033c.159-.378.617-.676 1.534-1.272l8.257-5.367m14.992 21.822-8.858-8m-7.619 0-8.857 8" }))); };
	MailOpened02.default = SvgMailOpened02;
	
	return MailOpened02;
}

var Map01 = {};

var hasRequiredMap01;

function requireMap01 () {
	if (hasRequiredMap01) return Map01;
	hasRequiredMap01 = 1;
	Object.defineProperty(Map01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgMap01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m12 24-9.333 5.333V8L12 2.667M12 24l9.333 5.333M12 24V2.667m9.333 26.666 8-5.333V2.667l-8 5.333m0 21.333V8m0 0L12 2.667" }))); };
	Map01.default = SvgMap01;
	
	return Map01;
}

var Map02 = {};

var hasRequiredMap02;

function requireMap02 () {
	if (hasRequiredMap02) return Map02;
	hasRequiredMap02 = 1;
	Object.defineProperty(Map02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgMap02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m10.667 4 10.666 24M4 22.667 16 16m-5.6 12h11.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C28 24.96 28 23.84 28 21.6V10.4c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C24.96 4 23.84 4 21.6 4H10.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C4 7.04 4 8.16 4 10.4v11.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C7.04 28 8.16 28 10.4 28" }))); };
	Map02.default = SvgMap02;
	
	return Map02;
}

var MarkCheck = {};

var hasRequiredMarkCheck;

function requireMarkCheck () {
	if (hasRequiredMarkCheck) return MarkCheck;
	hasRequiredMarkCheck = 1;
	Object.defineProperty(MarkCheck, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgMarkCheck = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m12 14 2.667 2.667 6-6M25.333 28V10.4c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C22.294 4 21.173 4 18.933 4h-5.866c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748c-.436.856-.436 1.976-.436 4.216V28L16 22.667z" }))); };
	MarkCheck.default = SvgMarkCheck;
	
	return MarkCheck;
}

var MarkClose = {};

var hasRequiredMarkClose;

function requireMarkClose () {
	if (hasRequiredMarkClose) return MarkClose;
	hasRequiredMarkClose = 1;
	Object.defineProperty(MarkClose, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgMarkClose = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m12.667 10 6.666 6.667m0-6.667-6.666 6.667M25.333 28V10.4c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C22.294 4 21.173 4 18.933 4h-5.866c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748c-.436.856-.436 1.976-.436 4.216V28L16 22.667z" }))); };
	MarkClose.default = SvgMarkClose;
	
	return MarkClose;
}

var MarkMinus = {};

var hasRequiredMarkMinus;

function requireMarkMinus () {
	if (hasRequiredMarkMinus) return MarkMinus;
	hasRequiredMarkMinus = 1;
	Object.defineProperty(MarkMinus, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgMarkMinus = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M12 13.333h8M25.333 28V10.4c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C22.294 4 21.173 4 18.933 4h-5.866c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748c-.436.856-.436 1.976-.436 4.216V28L16 22.667z" }))); };
	MarkMinus.default = SvgMarkMinus;
	
	return MarkMinus;
}

var MarkPlus = {};

var hasRequiredMarkPlus;

function requireMarkPlus () {
	if (hasRequiredMarkPlus) return MarkPlus;
	hasRequiredMarkPlus = 1;
	Object.defineProperty(MarkPlus, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgMarkPlus = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M16 17.333v-8m-4 4h8M25.333 28V10.4c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C22.294 4 21.174 4 18.933 4h-5.866c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748c-.436.856-.436 1.976-.436 4.216V28L16 22.667z" }))); };
	MarkPlus.default = SvgMarkPlus;
	
	return MarkPlus;
}

var Mark = {};

var hasRequiredMark;

function requireMark () {
	if (hasRequiredMark) return Mark;
	hasRequiredMark = 1;
	Object.defineProperty(Mark, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgMark = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M6.667 10.4c0-2.24 0-3.36.436-4.216A4 4 0 0 1 8.85 4.436C9.706 4 10.826 4 13.067 4h5.866c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748c.436.856.436 1.976.436 4.216V28L16 22.667 6.667 28z" }))); };
	Mark.default = SvgMark;
	
	return Mark;
}

var MarkerPin01 = {};

var hasRequiredMarkerPin01;

function requireMarkerPin01 () {
	if (hasRequiredMarkerPin01) return MarkerPin01;
	hasRequiredMarkerPin01 = 1;
	Object.defineProperty(MarkerPin01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgMarkerPin01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M16 17.333a4 4 0 1 0 0-8 4 4 0 0 0 0 8" }),
	    React.createElement("path", { d: "M16 29.333c5.333-5.333 10.667-10.109 10.667-16 0-5.89-4.776-10.666-10.667-10.666S5.333 7.442 5.333 13.333 10.667 24 16 29.333" }))); };
	MarkerPin01.default = SvgMarkerPin01;
	
	return MarkerPin01;
}

var MarkerPin02 = {};

var hasRequiredMarkerPin02;

function requireMarkerPin02 () {
	if (hasRequiredMarkerPin02) return MarkerPin02;
	hasRequiredMarkerPin02 = 1;
	Object.defineProperty(MarkerPin02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgMarkerPin02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M16 16.667a4 4 0 1 0 0-8 4 4 0 0 0 0 8" }),
	    React.createElement("path", { d: "M16 29.333c2.667-5.333 10.667-8.775 10.667-16 0-5.89-4.776-10.666-10.667-10.666-5.89 0-10.666 4.775-10.666 10.666 0 7.225 8 10.667 10.666 16" }))); };
	MarkerPin02.default = SvgMarkerPin02;
	
	return MarkerPin02;
}

var MarkerPin03 = {};

var hasRequiredMarkerPin03;

function requireMarkerPin03 () {
	if (hasRequiredMarkerPin03) return MarkerPin03;
	hasRequiredMarkerPin03 = 1;
	Object.defineProperty(MarkerPin03, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgMarkerPin03 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M6.667 19.048c-2.469 1.09-4 2.607-4 4.285 0 3.314 5.969 6 13.333 6s13.333-2.686 13.333-6c0-1.678-1.531-3.196-4-4.285M24 10.667c0 5.418-6 8-8 12-2-4-8-6.582-8-12a8 8 0 0 1 16 0m-6.667 0a1.333 1.333 0 1 1-2.667 0 1.333 1.333 0 0 1 2.667 0" }))); };
	MarkerPin03.default = SvgMarkerPin03;
	
	return MarkerPin03;
}

var MarkerPin04 = {};

var hasRequiredMarkerPin04;

function requireMarkerPin04 () {
	if (hasRequiredMarkerPin04) return MarkerPin04;
	hasRequiredMarkerPin04 = 1;
	Object.defineProperty(MarkerPin04, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgMarkerPin04 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M21.333 17.833c4.71.926 8 3.04 8 5.5 0 3.314-5.97 6-13.333 6s-13.333-2.686-13.333-6c0-2.46 3.29-4.574 8-5.5M16 22.667V12m0 0a4 4 0 1 0 0-8 4 4 0 0 0 0 8" }))); };
	MarkerPin04.default = SvgMarkerPin04;
	
	return MarkerPin04;
}

var MarkerPin05 = {};

var hasRequiredMarkerPin05;

function requireMarkerPin05 () {
	if (hasRequiredMarkerPin05) return MarkerPin05;
	hasRequiredMarkerPin05 = 1;
	Object.defineProperty(MarkerPin05, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgMarkerPin05 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M21.333 17.833c4.71.926 8 3.04 8 5.5 0 3.314-5.97 6-13.333 6s-13.333-2.686-13.333-6c0-2.46 3.29-4.574 8-5.5M16 22.667V4l7.09 4.363c.518.319.776.478.859.678a.67.67 0 0 1-.016.543c-.094.195-.361.339-.896.627L16 14" }))); };
	MarkerPin05.default = SvgMarkerPin05;
	
	return MarkerPin05;
}

var Medal01 = {};

var hasRequiredMedal01;

function requireMedal01 () {
	if (hasRequiredMedal01) return Medal01;
	hasRequiredMedal01 = 1;
	Object.defineProperty(Medal01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgMedal01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m10.492 20.613-1.159 8.72 6.118-3.67c.2-.12.3-.18.406-.203a.7.7 0 0 1 .286 0c.107.023.206.083.406.203l6.118 3.67-1.158-8.723m.392-14.945c.206.498.601.894 1.1 1.1l1.744.724a2.033 2.033 0 0 1 1.1 2.656l-.722 1.744a2.03 2.03 0 0 0 0 1.556l.722 1.743a2.033 2.033 0 0 1-1.1 2.657L23 18.568a2.03 2.03 0 0 0-1.1 1.098l-.723 1.746a2.033 2.033 0 0 1-2.656 1.1l-1.744-.723a2.03 2.03 0 0 0-1.555.002l-1.745.721a2.03 2.03 0 0 1-2.654-1.099l-.723-1.746a2.03 2.03 0 0 0-1.1-1.1l-1.744-.723a2.033 2.033 0 0 1-1.1-2.655l.721-1.744a2.03 2.03 0 0 0 0-1.555l-.722-1.747a2.03 2.03 0 0 1 1.1-2.656L9 6.764c.498-.205.893-.6 1.1-1.097l.723-1.745a2.033 2.033 0 0 1 2.656-1.1l1.744.722a2.03 2.03 0 0 0 1.555-.001l1.746-.72a2.033 2.033 0 0 1 2.655 1.1l.723 1.745z" }))); };
	Medal01.default = SvgMedal01;
	
	return Medal01;
}

var Medal02 = {};

var hasRequiredMedal02;

function requireMedal02 () {
	if (hasRequiredMedal02) return Medal02;
	hasRequiredMedal02 = 1;
	Object.defineProperty(Medal02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgMedal02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m11.835 17.46-5.567-6.958c-.346-.433-.52-.65-.643-.89a2.7 2.7 0 0 1-.237-.678c-.055-.265-.055-.543-.055-1.097v-.904c0-1.493 0-2.24.291-2.81.256-.502.664-.91 1.165-1.166.57-.29 1.318-.29 2.811-.29h12.8c1.494 0 2.24 0 2.81.29.502.256.91.664 1.166 1.166.29.57.29 1.317.29 2.81v.904c0 .554 0 .832-.054 1.097a2.7 2.7 0 0 1-.237.677c-.123.241-.297.458-.643.891l-5.567 6.958M6.667 4 16 16l9.333-12m-4.619 13.953a6.667 6.667 0 1 1-9.428 9.428 6.667 6.667 0 0 1 9.428-9.428" }))); };
	Medal02.default = SvgMedal02;
	
	return Medal02;
}

var Menu01 = {};

var hasRequiredMenu01;

function requireMenu01 () {
	if (hasRequiredMenu01) return Menu01;
	hasRequiredMenu01 = 1;
	Object.defineProperty(Menu01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgMenu01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M4 16h24M4 8h24M4 24h24" }))); };
	Menu01.default = SvgMenu01;
	
	return Menu01;
}

var Menu02 = {};

var hasRequiredMenu02;

function requireMenu02 () {
	if (hasRequiredMenu02) return Menu02;
	hasRequiredMenu02 = 1;
	Object.defineProperty(Menu02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgMenu02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M4 16h16M4 8h24M4 24h24" }))); };
	Menu02.default = SvgMenu02;
	
	return Menu02;
}

var Menu03 = {};

var hasRequiredMenu03;

function requireMenu03 () {
	if (hasRequiredMenu03) return Menu03;
	hasRequiredMenu03 = 1;
	Object.defineProperty(Menu03, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgMenu03 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M4 16h24M4 8h24M4 24h16" }))); };
	Menu03.default = SvgMenu03;
	
	return Menu03;
}

var Menu04 = {};

var hasRequiredMenu04;

function requireMenu04 () {
	if (hasRequiredMenu04) return Menu04;
	hasRequiredMenu04 = 1;
	Object.defineProperty(Menu04, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgMenu04 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M28 16H12m16-8H12m16 16H12m-5.333-8A1.333 1.333 0 1 1 4 16a1.333 1.333 0 0 1 2.667 0m0-8A1.333 1.333 0 1 1 4 8a1.333 1.333 0 0 1 2.667 0m0 16A1.333 1.333 0 1 1 4 24a1.333 1.333 0 0 1 2.667 0" }))); };
	Menu04.default = SvgMenu04;
	
	return Menu04;
}

var MessageAlert = {};

var hasRequiredMessageAlert;

function requireMessageAlert () {
	if (hasRequiredMessageAlert) return MessageAlert;
	hasRequiredMessageAlert = 1;
	Object.defineProperty(MessageAlert, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgMessageAlert = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M16 14V9.333m0 9.334h.013M9.333 24v3.114c0 .71 0 1.066.146 1.248.127.159.319.251.522.25.233 0 .51-.221 1.065-.665l3.18-2.545c.65-.52.975-.78 1.337-.964a4 4 0 0 1 1.016-.356c.398-.082.814-.082 1.646-.082H21.6c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C28 20.96 28 19.84 28 17.6v-7.2c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C24.96 4 23.84 4 21.6 4H10.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C4 7.04 4 8.16 4 10.4v8.267c0 1.24 0 1.86.136 2.368a4 4 0 0 0 2.829 2.829C7.473 24 8.093 24 9.333 24" }))); };
	MessageAlert.default = SvgMessageAlert;
	
	return MessageAlert;
}

var MessageChat = {};

var hasRequiredMessageChat;

function requireMessageChat () {
	if (hasRequiredMessageChat) return MessageChat;
	hasRequiredMessageChat = 1;
	Object.defineProperty(MessageChat, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgMessageChat = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m13.333 20-4.1 4.152c-.572.579-.858.868-1.104.889a.67.67 0 0 1-.561-.23c-.16-.188-.16-.595-.16-1.409v-2.08c0-.73-.598-1.258-1.321-1.364a4 4 0 0 1-3.378-3.378c-.042-.289-.042-.633-.042-1.32V9.066c0-2.24 0-3.36.436-4.216A4 4 0 0 1 4.85 3.103c.855-.436 1.976-.436 4.216-.436h9.866c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748c.436.855.436 1.975.436 4.216v5.6m0 14.666-2.901-2.017c-.408-.284-.612-.426-.834-.526a2.7 2.7 0 0 0-.617-.194c-.24-.044-.488-.044-.985-.044H17.6c-1.493 0-2.24 0-2.81-.29a2.67 2.67 0 0 1-1.166-1.166c-.29-.57-.29-1.317-.29-2.81v-3.353c0-1.493 0-2.24.29-2.81.256-.502.664-.91 1.165-1.166.57-.29 1.318-.29 2.811-.29h7.467c1.493 0 2.24 0 2.81.29.502.256.91.664 1.166 1.166.29.57.29 1.317.29 2.81v3.62c0 1.242 0 1.863-.203 2.353a2.67 2.67 0 0 1-1.443 1.443c-.49.203-1.111.203-2.354.203z" }))); };
	MessageChat.default = SvgMessageChat;
	
	return MessageChat;
}

var MessageCheck = {};

var hasRequiredMessageCheck;

function requireMessageCheck () {
	if (hasRequiredMessageCheck) return MessageCheck;
	hasRequiredMessageCheck = 1;
	Object.defineProperty(MessageCheck, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgMessageCheck = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m12 14 2.667 2.667 6-6M9.333 24v3.114c0 .71 0 1.066.146 1.248.127.159.319.251.522.25.233 0 .51-.221 1.066-.665l3.18-2.545c.65-.52.975-.78 1.336-.964a4 4 0 0 1 1.016-.356c.398-.082.814-.082 1.646-.082H21.6c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C28 20.96 28 19.84 28 17.6v-7.2c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C24.96 4 23.84 4 21.6 4H10.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C4 7.04 4 8.16 4 10.4v8.267c0 1.24 0 1.86.136 2.368a4 4 0 0 0 2.829 2.829C7.474 24 8.093 24 9.333 24" }))); };
	MessageCheck.default = SvgMessageCheck;
	
	return MessageCheck;
}

var MessageClose = {};

var hasRequiredMessageClose;

function requireMessageClose () {
	if (hasRequiredMessageClose) return MessageClose;
	hasRequiredMessageClose = 1;
	Object.defineProperty(MessageClose, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgMessageClose = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m12.667 10.667 6.666 6.666m0-6.666-6.666 6.666M9.333 24v3.114c0 .71 0 1.066.146 1.248.127.159.319.251.522.25.233 0 .51-.221 1.065-.665l3.18-2.545c.65-.52.975-.78 1.337-.964a4 4 0 0 1 1.016-.356c.398-.082.814-.082 1.646-.082H21.6c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C28 20.96 28 19.84 28 17.6v-7.2c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C24.96 4 23.84 4 21.6 4H10.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C4 7.04 4 8.16 4 10.4v8.267c0 1.24 0 1.86.136 2.368a4 4 0 0 0 2.829 2.829C7.473 24 8.093 24 9.333 24" }))); };
	MessageClose.default = SvgMessageClose;
	
	return MessageClose;
}

var MessageDots = {};

var hasRequiredMessageDots;

function requireMessageDots () {
	if (hasRequiredMessageDots) return MessageDots;
	hasRequiredMessageDots = 1;
	Object.defineProperty(MessageDots, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgMessageDots = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M10 14h.013M16 14h.013M22 14h.013M9.333 24v3.114c0 .71 0 1.066.146 1.248.127.159.319.251.522.25.233 0 .51-.221 1.065-.665l3.181-2.545c.65-.52.975-.78 1.336-.964a4 4 0 0 1 1.016-.356c.398-.082.814-.082 1.646-.082H21.6c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C28 20.96 28 19.84 28 17.6v-7.2c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C24.96 4 23.84 4 21.6 4H10.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C4 7.04 4 8.16 4 10.4v8.267c0 1.24 0 1.86.136 2.368a4 4 0 0 0 2.829 2.829C7.473 24 8.093 24 9.333 24m1.334-10a.667.667 0 1 1-1.334 0 .667.667 0 0 1 1.334 0m6 0a.667.667 0 1 1-1.334 0 .667.667 0 0 1 1.334 0m6 0a.667.667 0 1 1-1.334 0 .667.667 0 0 1 1.334 0" }))); };
	MessageDots.default = SvgMessageDots;
	
	return MessageDots;
}

var MessageHeart = {};

var hasRequiredMessageHeart;

function requireMessageHeart () {
	if (hasRequiredMessageHeart) return MessageHeart;
	hasRequiredMessageHeart = 1;
	Object.defineProperty(MessageHeart, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgMessageHeart = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M4 10.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C7.04 4 8.16 4 10.4 4h11.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C28 7.04 28 8.16 28 10.4v7.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C24.96 24 23.84 24 21.6 24h-3.355c-.832 0-1.248 0-1.646.082a4 4 0 0 0-1.016.356c-.361.185-.686.445-1.336.964l-3.18 2.545c-.555.444-.833.666-1.066.666a.67.67 0 0 1-.522-.25c-.146-.183-.146-.538-.146-1.249V24c-1.24 0-1.86 0-2.368-.136a4 4 0 0 1-2.829-2.829C4 20.527 4 19.907 4 18.667z" }),
	    React.createElement("path", { d: "M15.996 10.266c-1.2-1.385-3.2-1.758-4.703-.49s-1.715 3.39-.534 4.89c.73.929 2.566 2.626 3.857 3.783.474.425.711.638.996.723.244.074.524.074.768 0 .285-.085.522-.298.996-.723 1.29-1.157 3.126-2.854 3.857-3.784 1.18-1.5.995-3.634-.534-4.889s-3.504-.895-4.703.49", clipRule: "evenodd" }))); };
	MessageHeart.default = SvgMessageHeart;
	
	return MessageHeart;
}

var MessageNotification = {};

var hasRequiredMessageNotification;

function requireMessageNotification () {
	if (hasRequiredMessageNotification) return MessageNotification;
	hasRequiredMessageNotification = 1;
	Object.defineProperty(MessageNotification, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgMessageNotification = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M14.667 5.333H10.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C4 8.373 4 9.493 4 11.733v6.934c0 1.24 0 1.86.136 2.368a4 4 0 0 0 2.829 2.829C7.473 24 8.093 24 9.333 24v3.114c0 .71 0 1.066.146 1.248.127.159.319.251.522.25.233 0 .51-.221 1.065-.665l3.181-2.545c.65-.52.975-.78 1.336-.964a4 4 0 0 1 1.016-.356c.398-.082.814-.082 1.646-.082h2.022c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748c.436-.856.436-1.976.436-4.216v-.267m.161-12.161a4 4 0 1 1-5.656 5.656 4 4 0 0 1 5.656-5.656" }))); };
	MessageNotification.default = SvgMessageNotification;
	
	return MessageNotification;
}

var MessagePlus = {};

var hasRequiredMessagePlus;

function requireMessagePlus () {
	if (hasRequiredMessagePlus) return MessagePlus;
	hasRequiredMessagePlus = 1;
	Object.defineProperty(MessagePlus, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgMessagePlus = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M16 18v-8m-4 4h8M9.333 24v3.114c0 .71 0 1.066.146 1.248.127.159.319.251.522.25.233 0 .51-.221 1.065-.665l3.181-2.545c.65-.52.975-.78 1.336-.964a4 4 0 0 1 1.016-.356c.398-.082.814-.082 1.646-.082H21.6c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C28 20.96 28 19.84 28 17.6v-7.2c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C24.96 4 23.84 4 21.6 4H10.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C4 7.04 4 8.16 4 10.4v8.267c0 1.24 0 1.86.136 2.368a4 4 0 0 0 2.829 2.829C7.473 24 8.093 24 9.333 24" }))); };
	MessagePlus.default = SvgMessagePlus;
	
	return MessagePlus;
}

var MessageQuestion = {};

var hasRequiredMessageQuestion;

function requireMessageQuestion () {
	if (hasRequiredMessageQuestion) return MessageQuestion;
	hasRequiredMessageQuestion = 1;
	Object.defineProperty(MessageQuestion, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgMessageQuestion = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M13.333 10.67a2.998 2.998 0 0 1 5.826.999c0 1.998-2.998 2.998-2.998 2.998m.039 4h.013M9.333 24v3.114c0 .71 0 1.066.146 1.248.127.159.319.251.522.25.233 0 .51-.221 1.065-.665l3.181-2.545c.65-.52.975-.78 1.336-.964a4 4 0 0 1 1.016-.356c.398-.082.814-.082 1.646-.082H21.6c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C28 20.96 28 19.84 28 17.6v-7.2c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C24.96 4 23.84 4 21.6 4H10.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C4 7.04 4 8.16 4 10.4v8.267c0 1.24 0 1.86.136 2.368a4 4 0 0 0 2.829 2.829C7.473 24 8.093 24 9.333 24" }))); };
	MessageQuestion.default = SvgMessageQuestion;
	
	return MessageQuestion;
}

var MessageSmile = {};

var hasRequiredMessageSmile;

function requireMessageSmile () {
	if (hasRequiredMessageSmile) return MessageSmile;
	hasRequiredMessageSmile = 1;
	Object.defineProperty(MessageSmile, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgMessageSmile = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M11.334 16.667s1.75 2 4.666 2 4.667-2 4.667-2m-1-6.667h.013m-7.346 0h.013M9.333 24v3.114c0 .71 0 1.066.146 1.248.127.159.319.251.522.25.233 0 .51-.221 1.066-.665l3.18-2.545c.65-.52.975-.78 1.336-.964a4 4 0 0 1 1.016-.356c.398-.082.814-.082 1.646-.082H21.6c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C28 20.96 28 19.84 28 17.6v-7.2c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C24.96 4 23.84 4 21.6 4H10.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C4 7.04 4 8.16 4 10.4v8.267c0 1.24 0 1.86.136 2.368a4 4 0 0 0 2.829 2.829C7.474 24 8.093 24 9.333 24m11-14A.667.667 0 1 1 19 10a.667.667 0 0 1 1.334 0M13 10a.667.667 0 1 1-1.333 0A.667.667 0 0 1 13 10" }))); };
	MessageSmile.default = SvgMessageSmile;
	
	return MessageSmile;
}

var MessageText = {};

var hasRequiredMessageText;

function requireMessageText () {
	if (hasRequiredMessageText) return MessageText;
	hasRequiredMessageText = 1;
	Object.defineProperty(MessageText, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgMessageText = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M9.333 11.333H16M9.333 16H20M9.333 24v3.114c0 .71 0 1.066.146 1.248.127.159.319.251.522.25.233 0 .51-.221 1.065-.665l3.181-2.545c.65-.52.975-.78 1.336-.964a4 4 0 0 1 1.016-.356c.398-.082.814-.082 1.646-.082H21.6c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C28 20.96 28 19.84 28 17.6v-7.2c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C24.96 4 23.84 4 21.6 4H10.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C4 7.04 4 8.16 4 10.4v8.267c0 1.24 0 1.86.136 2.368a4 4 0 0 0 2.829 2.829C7.473 24 8.093 24 9.333 24" }))); };
	MessageText.default = SvgMessageText;
	
	return MessageText;
}

var Message = {};

var hasRequiredMessage;

function requireMessage () {
	if (hasRequiredMessage) return Message;
	hasRequiredMessage = 1;
	Object.defineProperty(Message, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgMessage = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M4 10.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C7.04 4 8.16 4 10.4 4h11.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C28 7.04 28 8.16 28 10.4v7.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C24.96 24 23.84 24 21.6 24h-3.355c-.832 0-1.248 0-1.646.082a4 4 0 0 0-1.016.356c-.361.185-.686.445-1.336.964l-3.18 2.545c-.555.444-.833.666-1.066.666a.67.67 0 0 1-.522-.25c-.146-.183-.146-.538-.146-1.249V24c-1.24 0-1.86 0-2.368-.136a4 4 0 0 1-2.829-2.829C4 20.527 4 19.907 4 18.667z" }))); };
	Message.default = SvgMessage;
	
	return Message;
}

var MicrophoneOff = {};

var hasRequiredMicrophoneOff;

function requireMicrophoneOff () {
	if (hasRequiredMicrophoneOff) return MicrophoneOff;
	hasRequiredMicrophoneOff = 1;
	Object.defineProperty(MicrophoneOff, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgMicrophoneOff = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M20 12.533V6.667a4 4 0 0 0-7.584-1.779M16 25.333v4m0-4A9.333 9.333 0 0 1 6.667 16v-2.667m9.333 12A9.333 9.333 0 0 0 25.333 16v-2.667m-14.666 16h10.666M2.667 2.667l26.666 26.666M16 20a4 4 0 0 1-4-4v-4l6.83 6.827A3.99 3.99 0 0 1 16 20" }))); };
	MicrophoneOff.default = SvgMicrophoneOff;
	
	return MicrophoneOff;
}

var Microphone = {};

var hasRequiredMicrophone;

function requireMicrophone () {
	if (hasRequiredMicrophone) return Microphone;
	hasRequiredMicrophone = 1;
	Object.defineProperty(Microphone, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgMicrophone = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M25.333 13.333V16A9.333 9.333 0 0 1 16 25.333m-9.333-12V16A9.333 9.333 0 0 0 16 25.333m0 0v4m-5.333 0h10.666M16 20a4 4 0 0 1-4-4V6.667a4 4 0 0 1 8 0V16a4 4 0 0 1-4 4" }))); };
	Microphone.default = SvgMicrophone;
	
	return Microphone;
}

var Monitor = {};

var hasRequiredMonitor;

function requireMonitor () {
	if (hasRequiredMonitor) return Monitor;
	hasRequiredMonitor = 1;
	Object.defineProperty(Monitor, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgMonitor = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M20 22.667V28h-8v-5.333m-5.067 0h18.134c1.493 0 2.24 0 2.81-.29.502-.257.91-.665 1.166-1.166.29-.57.29-1.317.29-2.81V8.266c0-1.494 0-2.24-.29-2.81a2.67 2.67 0 0 0-1.166-1.166C27.307 4 26.56 4 25.067 4H6.933c-1.493 0-2.24 0-2.81.29-.502.255-.91.663-1.166 1.165-.29.57-.29 1.317-.29 2.81V18.4c0 1.494 0 2.24.29 2.81.256.502.664.91 1.166 1.166.57.29 1.317.29 2.81.29" }))); };
	Monitor.default = SvgMonitor;
	
	return Monitor;
}

var MoodContent = {};

var hasRequiredMoodContent;

function requireMoodContent () {
	if (hasRequiredMoodContent) return MoodContent;
	hasRequiredMoodContent = 1;
	Object.defineProperty(MoodContent, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgMoodContent = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M10.667 18.667s2 2.666 5.333 2.666 5.333-2.666 5.333-2.666m1.334-6.347c-.527.647-1.247 1.013-2 1.013-.754 0-1.454-.366-2-1.013m-5.334 0c-.526.647-1.246 1.013-2 1.013-.753 0-1.453-.366-2-1.013m20 3.68c0 7.364-5.97 13.333-13.333 13.333S2.667 23.363 2.667 16 8.637 2.667 16 2.667 29.333 8.637 29.333 16" }))); };
	MoodContent.default = SvgMoodContent;
	
	return MoodContent;
}

var MoodFrown = {};

var hasRequiredMoodFrown;

function requireMoodFrown () {
	if (hasRequiredMoodFrown) return MoodFrown;
	hasRequiredMoodFrown = 1;
	Object.defineProperty(MoodFrown, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgMoodFrown = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M21.333 21.333s-2-2.666-5.333-2.666-5.333 2.666-5.333 2.666M20 12h.013M12 12h.013m17.32 4c0 7.364-5.97 13.333-13.333 13.333S2.667 23.363 2.667 16 8.637 2.667 16 2.667 29.333 8.637 29.333 16m-8.666-4a.667.667 0 1 1-1.333 0 .667.667 0 0 1 1.333 0m-8 0a.667.667 0 1 1-1.333 0 .667.667 0 0 1 1.333 0" }))); };
	MoodFrown.default = SvgMoodFrown;
	
	return MoodFrown;
}

var MoodHappy = {};

var hasRequiredMoodHappy;

function requireMoodHappy () {
	if (hasRequiredMoodHappy) return MoodHappy;
	hasRequiredMoodHappy = 1;
	Object.defineProperty(MoodHappy, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgMoodHappy = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M20 12h.013M12 12h.013m17.32 4c0 7.364-5.97 13.333-13.333 13.333S2.667 23.363 2.667 16 8.636 2.667 16 2.667 29.333 8.637 29.333 16m-8.666-4a.667.667 0 1 1-1.334 0 .667.667 0 0 1 1.334 0m-8 0a.667.667 0 1 1-1.334 0 .667.667 0 0 1 1.333 0M16 23.333c3.334 0 6-2.444 6-4.666H10c0 2.222 2.666 4.666 6 4.666" }))); };
	MoodHappy.default = SvgMoodHappy;
	
	return MoodHappy;
}

var MoodNeutral = {};

var hasRequiredMoodNeutral;

function requireMoodNeutral () {
	if (hasRequiredMoodNeutral) return MoodNeutral;
	hasRequiredMoodNeutral = 1;
	Object.defineProperty(MoodNeutral, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgMoodNeutral = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M10.667 20h10.666M20 12h.013M12 12h.013m17.32 4c0 7.364-5.97 13.333-13.333 13.333S2.667 23.363 2.667 16 8.637 2.667 16 2.667 29.333 8.637 29.333 16m-8.666-4a.667.667 0 1 1-1.334 0 .667.667 0 0 1 1.334 0m-8 0a.667.667 0 1 1-1.334 0 .667.667 0 0 1 1.334 0" }))); };
	MoodNeutral.default = SvgMoodNeutral;
	
	return MoodNeutral;
}

var MoodSad = {};

var hasRequiredMoodSad;

function requireMoodSad () {
	if (hasRequiredMoodSad) return MoodSad;
	hasRequiredMoodSad = 1;
	Object.defineProperty(MoodSad, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgMoodSad = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M21.333 21.333s-2-2.666-5.333-2.666-5.333 2.666-5.333 2.666m12-9.013c-.527.647-1.247 1.013-2 1.013-.754 0-1.454-.366-2-1.013m-5.334 0c-.526.647-1.246 1.013-2 1.013-.753 0-1.453-.366-2-1.013m20 3.68c0 7.364-5.97 13.333-13.333 13.333S2.667 23.363 2.667 16 8.637 2.667 16 2.667 29.333 8.637 29.333 16" }))); };
	MoodSad.default = SvgMoodSad;
	
	return MoodSad;
}

var MoodSmile = {};

var hasRequiredMoodSmile;

function requireMoodSmile () {
	if (hasRequiredMoodSmile) return MoodSmile;
	hasRequiredMoodSmile = 1;
	Object.defineProperty(MoodSmile, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgMoodSmile = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M10.667 18.667s2 2.666 5.333 2.666 5.333-2.666 5.333-2.666M20 12h.013M12 12h.013m17.32 4c0 7.364-5.97 13.333-13.333 13.333S2.667 23.363 2.667 16 8.637 2.667 16 2.667 29.333 8.637 29.333 16m-8.666-4a.667.667 0 1 1-1.333 0 .667.667 0 0 1 1.333 0m-8 0a.667.667 0 1 1-1.333 0 .667.667 0 0 1 1.333 0" }))); };
	MoodSmile.default = SvgMoodSmile;
	
	return MoodSmile;
}

var MoodWink = {};

var hasRequiredMoodWink;

function requireMoodWink () {
	if (hasRequiredMoodWink) return MoodWink;
	hasRequiredMoodWink = 1;
	Object.defineProperty(MoodWink, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgMoodWink = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M10.667 18.667s2 2.666 5.333 2.666 5.333-2.666 5.333-2.666M20 12h.013m-9.346 0h2.666m16 4c0 7.364-5.97 13.333-13.333 13.333S2.667 23.363 2.667 16 8.637 2.667 16 2.667 29.333 8.637 29.333 16m-8.666-4a.667.667 0 1 1-1.334 0 .667.667 0 0 1 1.334 0" }))); };
	MoodWink.default = SvgMoodWink;
	
	return MoodWink;
}

var MoreHandler = {};

var hasRequiredMoreHandler;

function requireMoreHandler () {
	if (hasRequiredMoreHandler) return MoreHandler;
	hasRequiredMoreHandler = 1;
	Object.defineProperty(MoreHandler, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgMoreHandler = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M20.667 8a1.333 1.333 0 1 0 0-2.667 1.333 1.333 0 0 0 0 2.667M20.667 17.334a1.333 1.333 0 1 0 0-2.667 1.333 1.333 0 0 0 0 2.667M20.667 26.667a1.333 1.333 0 1 0 0-2.667 1.333 1.333 0 0 0 0 2.667M11.333 8a1.333 1.333 0 1 0 0-2.666 1.333 1.333 0 0 0 0 2.666M11.333 17.334a1.333 1.333 0 1 0 0-2.667 1.333 1.333 0 0 0 0 2.667M11.333 26.667a1.333 1.333 0 1 0 0-2.667 1.333 1.333 0 0 0 0 2.667" }))); };
	MoreHandler.default = SvgMoreHandler;
	
	return MoreHandler;
}

var MoreHorizontal = {};

var hasRequiredMoreHorizontal;

function requireMoreHorizontal () {
	if (hasRequiredMoreHorizontal) return MoreHorizontal;
	hasRequiredMoreHorizontal = 1;
	Object.defineProperty(MoreHorizontal, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgMoreHorizontal = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M16 17.333a1.333 1.333 0 1 0 0-2.666 1.333 1.333 0 0 0 0 2.666M25.333 17.333a1.333 1.333 0 1 0 0-2.666 1.333 1.333 0 0 0 0 2.666M6.667 17.333a1.333 1.333 0 1 0 0-2.666 1.333 1.333 0 0 0 0 2.666" }))); };
	MoreHorizontal.default = SvgMoreHorizontal;
	
	return MoreHorizontal;
}

var MoreVertical = {};

var hasRequiredMoreVertical;

function requireMoreVertical () {
	if (hasRequiredMoreVertical) return MoreVertical;
	hasRequiredMoreVertical = 1;
	Object.defineProperty(MoreVertical, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgMoreVertical = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M16 17.334a1.333 1.333 0 1 0 0-2.667 1.333 1.333 0 0 0 0 2.667M16 8a1.333 1.333 0 1 0 0-2.666A1.333 1.333 0 0 0 16 8M16 26.667A1.333 1.333 0 1 0 16 24a1.333 1.333 0 0 0 0 2.667" }))); };
	MoreVertical.default = SvgMoreVertical;
	
	return MoreVertical;
}

var More = {};

var hasRequiredMore;

function requireMore () {
	if (hasRequiredMore) return More;
	hasRequiredMore = 1;
	Object.defineProperty(More, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgMore = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M16 8a1.333 1.333 0 1 0 0-2.666A1.333 1.333 0 0 0 16 8M16 17.334a1.333 1.333 0 1 0 0-2.667 1.333 1.333 0 0 0 0 2.667M16 26.667A1.333 1.333 0 1 0 16 24a1.333 1.333 0 0 0 0 2.667M25.333 8a1.333 1.333 0 1 0 0-2.666 1.333 1.333 0 0 0 0 2.666M25.333 17.334a1.333 1.333 0 1 0 0-2.667 1.333 1.333 0 0 0 0 2.667M25.333 26.667a1.333 1.333 0 1 0 0-2.667 1.333 1.333 0 0 0 0 2.667M6.667 8a1.333 1.333 0 1 0 0-2.666 1.333 1.333 0 0 0 0 2.666M6.667 17.334a1.333 1.333 0 1 0 0-2.667 1.333 1.333 0 0 0 0 2.667M6.667 26.667a1.333 1.333 0 1 0 0-2.667 1.333 1.333 0 0 0 0 2.667" }))); };
	More.default = SvgMore;
	
	return More;
}

var MotorcycleBag = {};

var hasRequiredMotorcycleBag;

function requireMotorcycleBag () {
	if (hasRequiredMotorcycleBag) return MotorcycleBag;
	hasRequiredMotorcycleBag = 1;
	Object.defineProperty(MotorcycleBag, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgMotorcycleBag = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M20.492 14.296h-6.388a.5.5 0 0 0-.186.036l-4.69 1.865a.444.444 0 0 0-.177.698l4.165 4.996c.097.116.24.183.39.183h2.663a.51.51 0 0 0 .441-.257l4.322-6.808M15.12 9.111h1.192c.158 0 .308.075.404.202l4.317 5.696m2.12 2.697-2.12-2.697M19.51 13h3.273M2.667 9.667v3.889c0 1.227.995 2.222 2.222 2.222h3.333a2.22 2.22 0 0 0 2.223-2.222v-3.334A2.22 2.22 0 0 0 8.221 8H4.333c-.92 0-1.666.746-1.666 1.667m0 0h2.778m4.884 11.11c0 2.149-1.715 3.89-3.83 3.89-2.117 0-3.832-1.741-3.832-3.89 0-2.147 1.715-3.888 3.831-3.888s3.831 1.741 3.831 3.889m19.004 0c0 2.149-1.715 3.89-3.831 3.89s-3.831-1.741-3.831-3.89c0-2.147 1.715-3.888 3.831-3.888s3.831 1.741 3.831 3.889" }))); };
	MotorcycleBag.default = SvgMotorcycleBag;
	
	return MotorcycleBag;
}

var MotorcycleHelmetLeft = {};

var hasRequiredMotorcycleHelmetLeft;

function requireMotorcycleHelmetLeft () {
	if (hasRequiredMotorcycleHelmetLeft) return MotorcycleHelmetLeft;
	hasRequiredMotorcycleHelmetLeft = 1;
	Object.defineProperty(MotorcycleHelmetLeft, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgMotorcycleHelmetLeft = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M8.669 8.369c2.306-2.202 6.264-4.658 12.528-2.588s7.408 7.207 7.71 9.316C29.87 21.825 23.125 27 19.752 27H6.46C4.654 27 3.03 25.649 3 23.708a19.2 19.2 0 0 1 .368-3.953m5.3-11.386c-2.523 2.409-4.503 7.263-5.3 11.386m5.3-11.386 6.757 3.456c1.704.871 2.186 3.234.978 4.791l-1.279 1.649c-.732.944-1.817 1.49-2.961 1.49H3.369" }))); };
	MotorcycleHelmetLeft.default = SvgMotorcycleHelmetLeft;
	
	return MotorcycleHelmetLeft;
}

var MotorcycleHelmetRight = {};

var hasRequiredMotorcycleHelmetRight;

function requireMotorcycleHelmetRight () {
	if (hasRequiredMotorcycleHelmetRight) return MotorcycleHelmetRight;
	hasRequiredMotorcycleHelmetRight = 1;
	Object.defineProperty(MotorcycleHelmetRight, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgMotorcycleHelmetRight = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M23.331 8.369C21.025 6.167 17.067 3.71 10.803 5.78s-7.408 7.207-7.71 9.316C2.13 21.825 8.875 27 12.248 27H25.54c1.807 0 3.43-1.351 3.46-3.292a19.2 19.2 0 0 0-.368-3.953m-5.3-11.386c2.523 2.409 4.503 7.263 5.3 11.386m-5.3-11.386-6.757 3.456c-1.704.871-2.186 3.234-.978 4.791l1.279 1.649c.732.944 1.817 1.49 2.961 1.49h8.795" }))); };
	MotorcycleHelmetRight.default = SvgMotorcycleHelmetRight;
	
	return MotorcycleHelmetRight;
}

var Motorcycle = {};

var hasRequiredMotorcycle;

function requireMotorcycle () {
	if (hasRequiredMotorcycle) return Motorcycle;
	hasRequiredMotorcycle = 1;
	Object.defineProperty(Motorcycle, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgMotorcycle = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M3.152 12.667h2.956c.15 0 .293.069.39.188l2.16 2.666m11.834-2.188h-6.388a.5.5 0 0 0-.186.037l-5.26 2.151m0 0 4.558 5.624c.097.12.24.188.39.188h2.663c.181 0 .35-.1.441-.264l4.322-7.002M14.008 8h2.303c.158 0 .308.077.404.208l4.317 5.859m2.12 2.774-2.12-2.774M19.51 12h3.273M10.33 20c0 2.21-1.716 4-3.832 4s-3.831-1.79-3.831-4 1.715-4 3.831-4 3.831 1.79 3.831 4m19.003 0c0 2.21-1.715 4-3.831 4s-3.831-1.79-3.831-4 1.715-4 3.831-4 3.831 1.79 3.831 4" }))); };
	Motorcycle.default = SvgMotorcycle;
	
	return Motorcycle;
}

var Mouse = {};

var hasRequiredMouse;

function requireMouse () {
	if (hasRequiredMouse) return Mouse;
	hasRequiredMouse = 1;
	Object.defineProperty(Mouse, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgMouse = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M16 12V8m0 21.333A9.333 9.333 0 0 1 6.667 20v-8a9.333 9.333 0 1 1 18.666 0v8A9.333 9.333 0 0 1 16 29.333" }))); };
	Mouse.default = SvgMouse;
	
	return Mouse;
}

var MusicalNote01 = {};

var hasRequiredMusicalNote01;

function requireMusicalNote01 () {
	if (hasRequiredMusicalNote01) return MusicalNote01;
	hasRequiredMusicalNote01 = 1;
	Object.defineProperty(MusicalNote01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgMusicalNote01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M12 24V8.474c0-.642 0-.963.117-1.224.103-.23.269-.425.478-.564.238-.158.554-.21 1.188-.316l11.733-1.956c.855-.142 1.282-.214 1.615-.09.292.109.537.316.692.587.177.308.177.74.177 1.607v14.815M12 24a4 4 0 1 1-8 0 4 4 0 0 1 8 0m16-2.667a4 4 0 1 1-8 0 4 4 0 0 1 8 0" }))); };
	MusicalNote01.default = SvgMusicalNote01;
	
	return MusicalNote01;
}

var MusicalNote02 = {};

var hasRequiredMusicalNote02;

function requireMusicalNote02 () {
	if (hasRequiredMusicalNote02) return MusicalNote02;
	hasRequiredMusicalNote02 = 1;
	Object.defineProperty(MusicalNote02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgMusicalNote02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M16 24V7.452c0-1.143 0-1.714.24-2.059.21-.3.536-.5.899-.554.415-.062.926.194 1.948.705L24 8m-8 16a4 4 0 1 1-8 0 4 4 0 0 1 8 0" }))); };
	MusicalNote02.default = SvgMusicalNote02;
	
	return MusicalNote02;
}

var Navigator01Off = {};

var hasRequiredNavigator01Off;

function requireNavigator01Off () {
	if (hasRequiredNavigator01Off) return Navigator01Off;
	hasRequiredNavigator01Off = 1;
	Object.defineProperty(Navigator01Off, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgNavigator01Off = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M15.116 8.215 27.067 3.55c.716-.28 1.075-.42 1.303-.343a.67.67 0 0 1 .421.421c.077.23-.063.587-.342 1.303l-4.68 11.99m-1.921 4.926-2.186 5.602c-.31.793-.465 1.19-.687 1.305-.193.1-.423.1-.616 0-.222-.116-.377-.513-.685-1.307l-3.504-9.01c-.063-.162-.095-.242-.143-.31a.7.7 0 0 0-.155-.155c-.068-.049-.149-.08-.31-.143l-9.01-3.504c-.794-.309-1.191-.463-1.307-.686a.67.67 0 0 1 0-.615c.115-.222.512-.377 1.305-.687l5.607-2.188M27.999 28 4 4" }))); };
	Navigator01Off.default = SvgNavigator01Off;
	
	return Navigator01Off;
}

var Navigator01On = {};

var hasRequiredNavigator01On;

function requireNavigator01On () {
	if (hasRequiredNavigator01On) return Navigator01On;
	hasRequiredNavigator01On = 1;
	Object.defineProperty(Navigator01On, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgNavigator01On = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M4.551 14.326c-.794-.309-1.19-.463-1.306-.686a.67.67 0 0 1 0-.615c.115-.222.512-.377 1.305-.687l22.517-8.787c.716-.28 1.074-.42 1.303-.343a.67.67 0 0 1 .421.421c.077.23-.063.587-.343 1.303L19.661 27.45c-.31.793-.464 1.19-.687 1.305-.192.1-.422.1-.615 0-.222-.116-.377-.513-.686-1.307l-3.504-9.01c-.062-.162-.094-.242-.142-.31a.7.7 0 0 0-.156-.155c-.067-.049-.148-.08-.31-.143z" }))); };
	Navigator01On.default = SvgNavigator01On;
	
	return Navigator01On;
}

var Navigator02Off = {};

var hasRequiredNavigator02Off;

function requireNavigator02Off () {
	if (hasRequiredNavigator02Off) return Navigator02Off;
	hasRequiredNavigator02Off = 1;
	Object.defineProperty(Navigator02Off, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgNavigator02Off = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m13.962 7.301 1.055-2.407c.31-.704.464-1.056.68-1.164a.67.67 0 0 1 .595 0c.216.108.37.46.68 1.164l4.229 9.644m-9.272-2.603L5.309 27.03c-.342.78-.513 1.17-.438 1.41.066.207.228.369.436.434.239.076.629-.096 1.408-.439l8.85-3.894c.158-.07.237-.104.319-.118a.7.7 0 0 1 .22 0c.082.014.161.049.32.118l8.849 3.894c.78.343 1.17.515 1.409.44a.67.67 0 0 0 .435-.436c.075-.239-.096-.629-.438-1.409l-.272-.62m2.926 2.924L2.667 2.667" }))); };
	Navigator02Off.default = SvgNavigator02Off;
	
	return Navigator02Off;
}

var Navigator02On = {};

var hasRequiredNavigator02On;

function requireNavigator02On () {
	if (hasRequiredNavigator02On) return Navigator02On;
	hasRequiredNavigator02On = 1;
	Object.defineProperty(Navigator02On, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgNavigator02On = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M6.716 28.434c-.78.343-1.17.514-1.409.439a.67.67 0 0 1-.435-.435c-.076-.24.095-.63.437-1.41l9.709-22.134c.309-.705.463-1.057.679-1.164a.67.67 0 0 1 .595 0c.216.107.37.46.68 1.164l9.708 22.135c.342.78.513 1.17.438 1.409a.67.67 0 0 1-.436.435c-.24.075-.629-.096-1.408-.44l-8.85-3.893c-.158-.07-.237-.104-.32-.118a.7.7 0 0 0-.22 0c-.082.014-.16.048-.319.118z" }))); };
	Navigator02On.default = SvgNavigator02On;
	
	return Navigator02On;
}

var Notebook = {};

var hasRequiredNotebook;

function requireNotebook () {
	if (hasRequiredNotebook) return Notebook;
	hasRequiredNotebook = 1;
	Object.defineProperty(Notebook, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgNotebook = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M4 21.333V9.6c0-1.493 0-2.24.29-2.81.256-.502.664-.91 1.166-1.166.57-.29 1.317-.29 2.81-.29h15.467c1.494 0 2.24 0 2.811.29.502.256.91.664 1.165 1.165C28 7.36 28 8.107 28 9.6v11.733h-7.116c-.326 0-.49 0-.643.037a1.3 1.3 0 0 0-.385.16c-.135.082-.25.198-.48.428l-.084.084c-.231.23-.346.346-.48.428q-.181.11-.386.16c-.154.037-.317.037-.643.037h-3.566c-.326 0-.49 0-.643-.037a1.3 1.3 0 0 1-.385-.16c-.134-.082-.25-.197-.48-.428l-.084-.084c-.23-.23-.346-.346-.48-.428a1.3 1.3 0 0 0-.386-.16c-.153-.037-.316-.037-.643-.037zm0 0c-.736 0-1.333.597-1.333 1.334v.444c0 .827 0 1.24.09 1.58.247.92.966 1.638 1.886 1.885.34.09.753.09 1.58.09h19.555c.827 0 1.24 0 1.579-.09a2.67 2.67 0 0 0 1.886-1.886c.09-.339.09-.752.09-1.579 0-.413 0-.62-.045-.79a1.33 1.33 0 0 0-.943-.942c-.17-.046-.376-.046-.79-.046h-.888" }))); };
	Notebook.default = SvgNotebook;
	
	return Notebook;
}

var NotificationBellOff = {};

var hasRequiredNotificationBellOff;

function requireNotificationBellOff () {
	if (hasRequiredNotificationBellOff) return NotificationBellOff;
	hasRequiredNotificationBellOff = 1;
	Object.defineProperty(NotificationBellOff, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgNotificationBellOff = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M18.667 28h-5.334M11.511 4.045A8 8 0 0 1 24 10.667c0 2.8.36 5.001.864 6.71M8.345 8.343A8 8 0 0 0 8 10.667c0 4.12-1.04 6.941-2.2 8.807-.98 1.574-1.47 2.36-1.452 2.58.02.244.072.336.268.482.177.13.974.13 2.57.13h15.48M28 28 4 4" }))); };
	NotificationBellOff.default = SvgNotificationBellOff;
	
	return NotificationBellOff;
}

var NotificationBellOn = {};

var hasRequiredNotificationBellOn;

function requireNotificationBellOn () {
	if (hasRequiredNotificationBellOn) return NotificationBellOn;
	hasRequiredNotificationBellOn = 1;
	Object.defineProperty(NotificationBellOn, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgNotificationBellOn = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M18.667 28h-5.333M3.059 7.76a5.34 5.34 0 0 1 2.71-4.693M28.937 7.76a5.34 5.34 0 0 0-2.71-4.693M24 10.667a8 8 0 0 0-16 0c0 4.12-1.039 6.941-2.2 8.807-.98 1.574-1.47 2.36-1.451 2.58.02.244.071.336.267.482.177.13.975.13 2.57.13h17.63c1.594 0 2.392 0 2.569-.13.196-.146.247-.239.267-.482.018-.22-.472-1.006-1.451-2.58-1.161-1.866-2.2-4.687-2.2-8.807" }))); };
	NotificationBellOn.default = SvgNotificationBellOn;
	
	return NotificationBellOn;
}

var NotificationBell = {};

var hasRequiredNotificationBell;

function requireNotificationBell () {
	if (hasRequiredNotificationBell) return NotificationBell;
	hasRequiredNotificationBell = 1;
	Object.defineProperty(NotificationBell, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgNotificationBell = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M18.667 28h-5.334M24 10.667a8 8 0 1 0-16 0c0 4.12-1.04 6.941-2.2 8.807-.98 1.574-1.47 2.36-1.452 2.58.02.244.072.336.268.482.177.13.974.13 2.57.13h17.629c1.595 0 2.392 0 2.57-.13.195-.146.247-.239.266-.482.018-.22-.471-1.006-1.45-2.58C25.038 17.608 24 14.787 24 10.667" }))); };
	NotificationBell.default = SvgNotificationBell;
	
	return NotificationBell;
}

var NotificationBox = {};

var hasRequiredNotificationBox;

function requireNotificationBox () {
	if (hasRequiredNotificationBox) return NotificationBox;
	hasRequiredNotificationBox = 1;
	Object.defineProperty(NotificationBox, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgNotificationBox = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M14.667 5.333H10.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C4 8.373 4 9.493 4 11.733V21.6c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C7.04 28 8.16 28 10.4 28h9.867c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748c.436-.856.436-1.976.436-4.216v-4.267m.161-12.161a4 4 0 1 1-5.656 5.656 4 4 0 0 1 5.656-5.656" }))); };
	NotificationBox.default = SvgNotificationBox;
	
	return NotificationBox;
}

var NotificationMessage = {};

var hasRequiredNotificationMessage;

function requireNotificationMessage () {
	if (hasRequiredNotificationMessage) return NotificationMessage;
	hasRequiredNotificationMessage = 1;
	Object.defineProperty(NotificationMessage, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgNotificationMessage = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M14.667 5.333H10.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C4 8.373 4 9.493 4 11.733v6.934c0 1.24 0 1.86.136 2.368a4 4 0 0 0 2.829 2.829C7.473 24 8.093 24 9.333 24v3.114c0 .71 0 1.066.146 1.248.127.159.319.251.522.25.233 0 .51-.221 1.065-.665l3.181-2.545c.65-.52.975-.78 1.336-.964a4 4 0 0 1 1.016-.356c.398-.082.814-.082 1.646-.082h2.022c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748c.436-.856.436-1.976.436-4.216v-.267m.161-12.161a4 4 0 1 1-5.656 5.656 4 4 0 0 1 5.656-5.656" }))); };
	NotificationMessage.default = SvgNotificationMessage;
	
	return NotificationMessage;
}

var Number0 = {};

var hasRequiredNumber0;

function requireNumber0 () {
	if (hasRequiredNumber0) return Number0;
	hasRequiredNumber0 = 1;
	Object.defineProperty(Number0, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgNumber0 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M28 24V8a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4" }),
	    React.createElement("path", { d: "M18 10h-4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V11a1 1 0 0 0-1-1" }))); };
	Number0.default = SvgNumber0;
	
	return Number0;
}

var Number1 = {};

var hasRequiredNumber1;

function requireNumber1 () {
	if (hasRequiredNumber1) return Number1;
	hasRequiredNumber1 = 1;
	Object.defineProperty(Number1, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgNumber1 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M28 24V8a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4" }),
	    React.createElement("path", { d: "M14 10h2a1 1 0 0 1 1 1v11" }))); };
	Number1.default = SvgNumber1;
	
	return Number1;
}

var Number2 = {};

var hasRequiredNumber2;

function requireNumber2 () {
	if (hasRequiredNumber2) return Number2;
	hasRequiredNumber2 = 1;
	Object.defineProperty(Number2, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgNumber2 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M28 24V8a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4" }),
	    React.createElement("path", { d: "M13 10.5h4.625c.76 0 1.375.616 1.375 1.375v2.75c0 .76-.616 1.375-1.375 1.375h-3.25c-.76 0-1.375.616-1.375 1.375V21.5h6" }))); };
	Number2.default = SvgNumber2;
	
	return Number2;
}

var Number3 = {};

var hasRequiredNumber3;

function requireNumber3 () {
	if (hasRequiredNumber3) return Number3;
	hasRequiredNumber3 = 1;
	Object.defineProperty(Number3, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgNumber3 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M28 24V8a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4" }),
	    React.createElement("path", { d: "M13.5 10H17a1.5 1.5 0 0 1 1.5 1.5v2.379a1.5 1.5 0 0 1-.44 1.06l-.62.622a1.5 1.5 0 0 1-1.061.439m0 0H15.5m.879 0a1.5 1.5 0 0 1 1.06.44l.622.62a1.5 1.5 0 0 1 .439 1.061V20.5A1.5 1.5 0 0 1 17 22h-3.5" }))); };
	Number3.default = SvgNumber3;
	
	return Number3;
}

var Number4 = {};

var hasRequiredNumber4;

function requireNumber4 () {
	if (hasRequiredNumber4) return Number4;
	hasRequiredNumber4 = 1;
	Object.defineProperty(Number4, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgNumber4 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M28 24V8a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4" }),
	    React.createElement("path", { d: "M13.25 10v5a1 1 0 0 0 1 1h4.5m0 0v6m0-6v-6" }))); };
	Number4.default = SvgNumber4;
	
	return Number4;
}

var Number5 = {};

var hasRequiredNumber5;

function requireNumber5 () {
	if (hasRequiredNumber5) return Number5;
	hasRequiredNumber5 = 1;
	Object.defineProperty(Number5, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgNumber5 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M28 24V8a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4" }),
	    React.createElement("path", { d: "m13.203 21.132.007.002q1.217.391 2.475.392c.942 0 1.84-.183 2.57-.682.791-.54 1.212-1.353 1.212-2.308 0-.574-.153-1.124-.478-1.61-.397-.594-1.019-.922-1.63-1.109-.63-.197-1.42-.27-2.305-.27H12.84l.49-5.347h6.122v.156H15.82a2.2 2.2 0 0 0-2.191 2.005l-.055.615a2.2 2.2 0 0 0 2.191 2.395h.039c1.273 0 2.179.18 2.791.461l.021.01c.664.29 1.055.645 1.281 1.026.262.44.404.953.404 1.57 0 .6-.147 1.142-.444 1.65-.269.448-.709.86-1.398 1.21-.622.31-1.499.502-2.695.502q-1.275 0-2.543-.332a8 8 0 0 1-1.127-.41l.156-.301.006.002q.455.213.948.373" }))); };
	Number5.default = SvgNumber5;
	
	return Number5;
}

var Number6 = {};

var hasRequiredNumber6;

function requireNumber6 () {
	if (hasRequiredNumber6) return Number6;
	hasRequiredNumber6 = 1;
	Object.defineProperty(Number6, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgNumber6 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M28 24V8a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4" }),
	    React.createElement("path", { d: "M17.5 10H14a1 1 0 0 0-1 1v5m0 0v5a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1z" }))); };
	Number6.default = SvgNumber6;
	
	return Number6;
}

var Number7 = {};

var hasRequiredNumber7;

function requireNumber7 () {
	if (hasRequiredNumber7) return Number7;
	hasRequiredNumber7 = 1;
	Object.defineProperty(Number7, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgNumber7 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M28 24V8a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4" }),
	    React.createElement("path", { d: "M13 10h6l-3 12" }))); };
	Number7.default = SvgNumber7;
	
	return Number7;
}

var Number8 = {};

var hasRequiredNumber8;

function requireNumber8 () {
	if (hasRequiredNumber8) return Number8;
	hasRequiredNumber8 = 1;
	Object.defineProperty(Number8, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgNumber8 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M28 24V8a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4" }),
	    React.createElement("path", { d: "M16 16a3 3 0 0 1-3-3v-1.5a1.5 1.5 0 0 1 1.5-1.5h3a1.5 1.5 0 0 1 1.5 1.5V13a3 3 0 0 1-3 3m0 0a3 3 0 0 1 3 3v1.5a1.5 1.5 0 0 1-1.5 1.5h-3a1.5 1.5 0 0 1-1.5-1.5V19a3 3 0 0 1 3-3" }))); };
	Number8.default = SvgNumber8;
	
	return Number8;
}

var Number9 = {};

var hasRequiredNumber9;

function requireNumber9 () {
	if (hasRequiredNumber9) return Number9;
	hasRequiredNumber9 = 1;
	Object.defineProperty(Number9, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgNumber9 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M28 24V8a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4" }),
	    React.createElement("path", { d: "M14.5 22H18a1 1 0 0 0 1-1v-5m0 0v-5a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1z" }))); };
	Number9.default = SvgNumber9;
	
	return Number9;
}

var OpenNew = {};

var hasRequiredOpenNew;

function requireOpenNew () {
	if (hasRequiredOpenNew) return OpenNew;
	hasRequiredOpenNew = 1;
	Object.defineProperty(OpenNew, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgOpenNew = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M28 12V4m0 0h-8m8 0L16 16M13.333 4H10.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C4 7.04 4 8.16 4 10.4v11.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C7.04 28 8.16 28 10.4 28h11.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C28 24.96 28 23.84 28 21.6v-2.933" }))); };
	OpenNew.default = SvgOpenNew;
	
	return OpenNew;
}

var Package01 = {};

var hasRequiredPackage01;

function requirePackage01 () {
	if (hasRequiredPackage01) return Package01;
	hasRequiredPackage01 = 1;
	Object.defineProperty(Package01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgPackage01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M27.333 9.704 16 16m0 0L4.667 9.704M16 16v12.667m12-7.256V10.59c0-.457 0-.686-.067-.89a1.3 1.3 0 0 0-.286-.485c-.145-.157-.345-.268-.744-.49l-9.867-5.482c-.378-.21-.567-.315-.767-.356a1.3 1.3 0 0 0-.538 0c-.2.041-.389.146-.767.356L5.097 8.724c-.4.222-.599.333-.744.49-.129.14-.226.305-.286.486C4 9.903 4 10.132 4 10.589V21.41c0 .457 0 .686.067.89.06.18.157.345.286.485.145.157.345.268.744.49l9.867 5.482c.378.21.567.315.767.356.178.037.36.037.538 0 .2-.041.389-.146.767-.356l9.867-5.482c.4-.222.599-.332.744-.49.129-.14.226-.305.286-.486.067-.203.067-.432.067-.889" }))); };
	Package01.default = SvgPackage01;
	
	return Package01;
}

var Package02 = {};

var hasRequiredPackage02;

function requirePackage02 () {
	if (hasRequiredPackage02) return Package02;
	hasRequiredPackage02 = 1;
	Object.defineProperty(Package02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgPackage02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M27.333 9.704 22 12.667M16 16 4.667 9.704M16 16v12.667M16 16l6-3.333M10.03 5.983l-4.933 2.74c-.4.223-.599.334-.744.491-.129.14-.226.305-.286.486C4 9.903 4 10.132 4 10.589V21.41c0 .457 0 .686.067.89.06.18.157.345.286.485.145.157.345.268.744.49l9.867 5.482c.378.21.567.315.767.356.178.037.36.037.538 0 .2-.041.389-.146.767-.356l9.867-5.482c.4-.222.599-.332.744-.49.129-.14.226-.305.286-.486.067-.203.067-.432.067-.889V10.59c0-.457 0-.686-.067-.89a1.3 1.3 0 0 0-.286-.485c-.145-.157-.345-.268-.744-.49l-9.867-5.482c-.378-.21-.567-.315-.767-.356a1.3 1.3 0 0 0-.538 0c-.2.041-.389.146-.767.356zm0 0L22 12.667" }))); };
	Package02.default = SvgPackage02;
	
	return Package02;
}

var PackageCheck = {};

var hasRequiredPackageCheck;

function requirePackageCheck () {
	if (hasRequiredPackageCheck) return PackageCheck;
	hasRequiredPackageCheck = 1;
	Object.defineProperty(PackageCheck, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgPackageCheck = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M27.333 9.704 16 16m0 0L4.667 9.704M16 16v12.667m2.666-.815-1.63.906c-.378.21-.567.315-.768.356-.177.037-.36.037-.537 0-.2-.041-.389-.146-.767-.356l-9.867-5.482c-.4-.222-.599-.332-.744-.49a1.3 1.3 0 0 1-.286-.486C4 22.098 4 21.869 4 21.412V10.59c0-.457 0-.686.067-.89.06-.18.157-.345.286-.485.145-.157.345-.268.744-.49l9.867-5.482c.378-.21.567-.315.767-.356.178-.036.36-.036.537 0 .2.041.39.146.768.356l9.867 5.482c.399.222.599.333.744.49.129.14.226.305.286.486.067.203.067.432.067.889v6.078M10 6l12 6.667M21.333 24 24 26.667l5.333-5.334" }))); };
	PackageCheck.default = SvgPackageCheck;
	
	return PackageCheck;
}

var PackageClose = {};

var hasRequiredPackageClose;

function requirePackageClose () {
	if (hasRequiredPackageClose) return PackageClose;
	hasRequiredPackageClose = 1;
	Object.defineProperty(PackageClose, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgPackageClose = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M27.333 9.704 16 16m0 0L4.667 9.704M16 16v12.667m12-12v-6.078c0-.457 0-.686-.067-.89a1.3 1.3 0 0 0-.286-.485c-.145-.157-.345-.268-.744-.49l-9.867-5.482c-.378-.21-.567-.315-.767-.356a1.3 1.3 0 0 0-.538 0c-.2.041-.389.146-.767.356L5.097 8.724c-.4.222-.599.333-.744.49-.129.14-.226.305-.286.486C4 9.903 4 10.132 4 10.589V21.41c0 .457 0 .686.067.89.06.18.157.345.286.485.145.157.345.268.744.49l9.867 5.482c.378.21.567.315.767.356.178.037.36.037.538 0 .2-.041.389-.146.767-.356l.297-.165M10 6l12 6.667m0 8.666L28.667 28m0-6.667L22 28" }))); };
	PackageClose.default = SvgPackageClose;
	
	return PackageClose;
}

var PackageCustom01 = {};

var hasRequiredPackageCustom01;

function requirePackageCustom01 () {
	if (hasRequiredPackageCustom01) return PackageCustom01;
	hasRequiredPackageCustom01 = 1;
	Object.defineProperty(PackageCustom01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgPackageCustom01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M9.333 22.667h5.334M8 28h16a4 4 0 0 0 4-4V8a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4m2.667-24v10.667L16 12l5.333 2.667V4z" }))); };
	PackageCustom01.default = SvgPackageCustom01;
	
	return PackageCustom01;
}

var PackageCustom02 = {};

var hasRequiredPackageCustom02;

function requirePackageCustom02 () {
	if (hasRequiredPackageCustom02) return PackageCustom02;
	hasRequiredPackageCustom02 = 1;
	Object.defineProperty(PackageCustom02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgPackageCustom02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M4 9.333V24a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4V9.333m-24 0L6.8 5.6A4 4 0 0 1 10 4h12a4 4 0 0 1 3.2 1.6L28 9.333m-24 0h24M9.333 22.667h5.334" }))); };
	PackageCustom02.default = SvgPackageCustom02;
	
	return PackageCustom02;
}

var PackageCustom03 = {};

var hasRequiredPackageCustom03;

function requirePackageCustom03 () {
	if (hasRequiredPackageCustom03) return PackageCustom03;
	hasRequiredPackageCustom03 = 1;
	Object.defineProperty(PackageCustom03, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgPackageCustom03 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M4 9.333V24a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4V9.333m-24 0L6.8 5.6A4 4 0 0 1 10 4h3.333M4 9.333h24m0 0L25.2 5.6A4 4 0 0 0 22 4h-3.333m-8 5.333v8L16 14.667l5.333 2.666v-8m-10.666 0h10.666m-10.666 0L13.333 4m8 5.333L18.667 4M9.333 22.667h5.334M13.333 4h5.334" }))); };
	PackageCustom03.default = SvgPackageCustom03;
	
	return PackageCustom03;
}

var PackageMinus = {};

var hasRequiredPackageMinus;

function requirePackageMinus () {
	if (hasRequiredPackageMinus) return PackageMinus;
	hasRequiredPackageMinus = 1;
	Object.defineProperty(PackageMinus, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgPackageMinus = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M27.333 9.704 16 16m0 0L4.667 9.704M16 16v12.667m2.667-.815-1.631.906c-.378.21-.567.315-.767.356q-.269.055-.538 0c-.2-.041-.389-.146-.767-.356l-9.867-5.482c-.4-.222-.599-.332-.744-.49a1.3 1.3 0 0 1-.286-.486C4 22.098 4 21.869 4 21.412V10.59c0-.457 0-.686.067-.89.06-.18.157-.345.286-.485.145-.157.345-.268.744-.49l9.867-5.482c.378-.21.567-.315.767-.356.178-.036.36-.036.538 0 .2.041.389.146.767.356l9.867 5.482c.4.222.599.333.744.49.129.14.226.305.286.486.067.203.067.432.067.889v6.744M10 6l12 6.667M21.333 24h8" }))); };
	PackageMinus.default = SvgPackageMinus;
	
	return PackageMinus;
}

var PackagePlus = {};

var hasRequiredPackagePlus;

function requirePackagePlus () {
	if (hasRequiredPackagePlus) return PackagePlus;
	hasRequiredPackagePlus = 1;
	Object.defineProperty(PackagePlus, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgPackagePlus = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M27.333 9.704 16 16m0 0L4.667 9.704M16 16v12.667m2.667-.815-1.631.906c-.378.21-.567.315-.767.356q-.269.055-.538 0c-.2-.041-.389-.146-.767-.356l-9.867-5.482c-.4-.222-.599-.332-.744-.49a1.3 1.3 0 0 1-.286-.486C4 22.098 4 21.869 4 21.412V10.59c0-.457 0-.686.067-.89.06-.18.157-.345.286-.485.145-.157.345-.268.744-.49l9.867-5.482c.378-.21.567-.315.767-.356.178-.036.36-.036.538 0 .2.041.389.146.767.356l9.867 5.482c.4.222.599.333.744.49.129.14.226.305.286.486.067.203.067.432.067.889v6.078M10 6l12 6.667M25.333 28v-8m-4 4h8" }))); };
	PackagePlus.default = SvgPackagePlus;
	
	return PackagePlus;
}

var PackageSearch = {};

var hasRequiredPackageSearch;

function requirePackageSearch () {
	if (hasRequiredPackageSearch) return PackageSearch;
	hasRequiredPackageSearch = 1;
	Object.defineProperty(PackageSearch, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgPackageSearch = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M27.333 9.704 16 16m0 0L4.667 9.704M16 16v12.667M28 16v-5.411c0-.457 0-.686-.067-.89a1.3 1.3 0 0 0-.286-.485c-.145-.157-.345-.268-.744-.49l-9.867-5.482c-.378-.21-.567-.315-.767-.356a1.3 1.3 0 0 0-.538 0c-.2.041-.389.146-.767.356L5.097 8.724c-.4.222-.599.333-.744.49-.129.14-.226.305-.286.486C4 9.903 4 10.132 4 10.589V21.41c0 .457 0 .686.067.89.06.18.157.345.286.485.145.157.345.268.744.49l9.867 5.482c.378.21.567.315.767.356.178.037.36.037.538 0 .2-.041.389-.146.767-.356l.297-.165M10 6l12 6.667m7.333 16L28 27.333M29.333 24a4 4 0 1 1-8 0 4 4 0 0 1 8 0" }))); };
	PackageSearch.default = SvgPackageSearch;
	
	return PackageSearch;
}

var PasscodeLock = {};

var hasRequiredPasscodeLock;

function requirePasscodeLock () {
	if (hasRequiredPasscodeLock) return PasscodeLock;
	hasRequiredPasscodeLock = 1;
	Object.defineProperty(PasscodeLock, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgPasscodeLock = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M29.333 14.667v-3.734c0-1.493 0-2.24-.29-2.81a2.67 2.67 0 0 0-1.166-1.166c-.57-.29-1.317-.29-2.81-.29H6.933c-1.493 0-2.24 0-2.81.29-.502.256-.91.664-1.166 1.166-.29.57-.29 1.317-.29 2.81v4.8c0 1.494 0 2.24.29 2.811.256.502.664.91 1.166 1.165.57.291 1.317.291 2.81.291h7.734M16 13.333h.007m6.66 0h.006m-13.34 0h.007m16.327 9.334v-2.334a2.333 2.333 0 0 0-4.667 0v2.334m-4.667-9.334a.333.333 0 1 1-.666 0 .333.333 0 0 1 .666 0m6.667 0a.333.333 0 1 1-.667 0 .333.333 0 0 1 .667 0m-13.333 0a.333.333 0 1 1-.667 0 .333.333 0 0 1 .667 0M20.8 28h5.067c.746 0 1.12 0 1.405-.145.25-.128.455-.332.583-.583.145-.285.145-.659.145-1.405V24.8c0-.747 0-1.12-.145-1.405a1.33 1.33 0 0 0-.583-.583c-.285-.145-.659-.145-1.405-.145H20.8c-.747 0-1.12 0-1.405.145-.251.128-.455.332-.583.583-.145.285-.145.658-.145 1.405v1.067c0 .746 0 1.12.145 1.405.128.251.332.455.583.583.285.145.658.145 1.405.145" }))); };
	PasscodeLock.default = SvgPasscodeLock;
	
	return PasscodeLock;
}

var Passcode = {};

var hasRequiredPasscode;

function requirePasscode () {
	if (hasRequiredPasscode) return Passcode;
	hasRequiredPasscode = 1;
	Object.defineProperty(Passcode, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgPasscode = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M16 16h.007m6.66 0h.006m-13.34 0h.007M6.933 9.333h18.134c1.493 0 2.24 0 2.81.291.502.256.91.664 1.166 1.165.29.57.29 1.318.29 2.811v4.8c0 1.494 0 2.24-.29 2.81-.256.502-.664.91-1.166 1.166-.57.29-1.317.29-2.81.29H6.933c-1.493 0-2.24 0-2.81-.29a2.67 2.67 0 0 1-1.166-1.165c-.29-.57-.29-1.317-.29-2.81v-4.8c0-1.494 0-2.241.29-2.812.256-.501.664-.91 1.166-1.165.57-.29 1.317-.29 2.81-.29m9.4 6.667a.333.333 0 1 1-.666 0 .333.333 0 0 1 .666 0M23 16a.333.333 0 1 1-.667 0A.333.333 0 0 1 23 16M9.667 16A.333.333 0 1 1 9 16a.333.333 0 0 1 .667 0" }))); };
	Passcode.default = SvgPasscode;
	
	return Passcode;
}

var Pickup01 = {};

var hasRequiredPickup01;

function requirePickup01 () {
	if (hasRequiredPickup01) return Pickup01;
	hasRequiredPickup01 = 1;
	Object.defineProperty(Pickup01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgPickup01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M12 20a2.667 2.667 0 0 1-5.333 0M12 20a2.667 2.667 0 1 0-5.333 0M12 20h9.333M6.667 20H5.105a2.67 2.67 0 0 1-1.886-.781l-.162-.162c-.25-.25-.39-.589-.39-.943v-4.78H8.24c.636 0 1.183-.45 1.308-1.073l.904-4.523a1.33 1.33 0 0 1 1.308-1.071h6.4c.326 0 .642.12.886.336l5.393 4.795c.15.133.328.23.52.286l3.407.973c.573.163.967.687.967 1.282v3.504c0 .505-.285.966-.737 1.192l-1.93.965m0 0a2.667 2.667 0 0 1-5.333 0m5.334 0a2.667 2.667 0 1 0-5.334 0M14.667 6.667v6.666m-6.667 0h20.876" }))); };
	Pickup01.default = SvgPickup01;
	
	return Pickup01;
}

var Pickup02 = {};

var hasRequiredPickup02;

function requirePickup02 () {
	if (hasRequiredPickup02) return Pickup02;
	hasRequiredPickup02 = 1;
	Object.defineProperty(Pickup02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgPickup02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M11.22 22.646a2.677 2.677 0 0 1-2.668 2.687 2.677 2.677 0 0 1-2.666-2.687m5.333 0a2.677 2.677 0 0 0-2.667-2.688 2.677 2.677 0 0 0-2.666 2.688m5.333 0h10.115m-15.448 0h-.781a2.66 2.66 0 0 1-1.886-.787l-.162-.163a1.35 1.35 0 0 1-.39-.95V8c0-.736.597-1.333 1.333-1.333h7.786a2.88 2.88 0 0 1 2.88 2.88m12 13.099A2.677 2.677 0 0 1 24 25.333a2.677 2.677 0 0 1-2.666-2.687m5.333 0A2.677 2.677 0 0 0 24 19.958a2.677 2.677 0 0 0-2.666 2.688m5.333 0 1.93-.973c.451-.227.736-.692.736-1.201V16.94c0-.6-.394-1.128-.967-1.292l-3.407-.982a1.3 1.3 0 0 1-.52-.287l-5.014-4.492a1.33 1.33 0 0 0-.89-.34h-3.868m14.209 6.379H16a1.333 1.333 0 0 1-1.333-1.333V9.548" }))); };
	Pickup02.default = SvgPickup02;
	
	return Pickup02;
}

var PiggyBank = {};

var hasRequiredPiggyBank;

function requirePiggyBank () {
	if (hasRequiredPiggyBank) return PiggyBank;
	hasRequiredPiggyBank = 1;
	Object.defineProperty(PiggyBank, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgPiggyBank = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M6.667 17.333c0 2.198.886 4.189 2.32 5.635.139.14.208.21.249.276.039.064.062.12.079.192.018.076.018.163.018.337v3.16c0 .374 0 .56.073.703a.67.67 0 0 0 .291.291c.143.073.33.073.703.073h2.533c.374 0 .56 0 .703-.073a.67.67 0 0 0 .291-.291c.073-.143.073-.33.073-.703V26.4c0-.373 0-.56.073-.703a.67.67 0 0 1 .29-.291c.144-.073.33-.073.704-.073h1.866c.374 0 .56 0 .703.073a.67.67 0 0 1 .291.291c.073.143.073.33.073.703v.533c0 .374 0 .56.073.703a.67.67 0 0 0 .29.291c.143.073.33.073.704.073H21.6c.373 0 .56 0 .703-.073a.67.67 0 0 0 .291-.291c.073-.143.073-.33.073-.703v-1.3c0-.27 0-.405.038-.513a.6.6 0 0 1 .162-.253c.082-.08.22-.145.498-.274a8.03 8.03 0 0 0 3.237-2.74c.142-.207.213-.31.289-.372a.6.6 0 0 1 .227-.12c.094-.028.205-.028.427-.028h.722c.373 0 .56 0 .702-.072a.67.67 0 0 0 .292-.292c.072-.142.072-.329.072-.702v-4.553c0-.355 0-.533-.066-.67a.67.67 0 0 0-.311-.311c-.137-.066-.315-.066-.67-.066-.258 0-.386 0-.49-.035a.6.6 0 0 1-.271-.174c-.075-.08-.136-.212-.26-.477a8 8 0 0 0-1.586-2.282c-.138-.14-.207-.21-.248-.277a.6.6 0 0 1-.08-.191c-.018-.077-.018-.164-.018-.338V9.415c0-.48 0-.72-.1-.881a.67.67 0 0 0-.384-.29c-.183-.052-.414.014-.875.145l-3.164.904a.666.666 0 0 1-.181.039c-.028.002-.056.002-.112.002h-.572m-13.278 8a8 8 0 0 1 4.272-7.08m-4.272 7.08H5.333A2.667 2.667 0 0 1 4 12.357m16-3.69a4.667 4.667 0 1 1-9.333 0 4.667 4.667 0 0 1 9.333 0" }))); };
	PiggyBank.default = SvgPiggyBank;
	
	return PiggyBank;
}

var Pin01 = {};

var hasRequiredPin01;

function requirePin01 () {
	if (hasRequiredPin01) return Pin01;
	hasRequiredPin01 = 1;
	Object.defineProperty(Pin01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgPin01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M16 20v9.333M10.668 9.744v2.841c0 .277 0 .416-.027.549a1.3 1.3 0 0 1-.119.338c-.061.12-.148.23-.321.446l-2.093 2.616c-.888 1.11-1.332 1.664-1.332 2.131 0 .406.184.79.501 1.044C7.641 20 8.352 20 9.773 20h12.456c1.42 0 2.131 0 2.496-.291.317-.253.502-.638.501-1.044 0-.467-.444-1.021-1.331-2.13L21.8 13.917c-.173-.217-.26-.325-.321-.446a1.3 1.3 0 0 1-.119-.338c-.027-.133-.027-.272-.027-.549v-2.84c0-.154 0-.231.009-.307q.01-.1.038-.199c.02-.073.049-.145.105-.287l1.344-3.36c.392-.98.588-1.47.507-1.863a1.33 1.33 0 0 0-.57-.84c-.334-.222-.862-.222-1.917-.222h-9.698c-1.056 0-1.584 0-1.919.222a1.33 1.33 0 0 0-.568.84c-.082.393.114.883.506 1.863l1.344 3.36c.057.142.085.214.105.287q.026.099.039.2c.008.075.008.152.008.305" }))); };
	Pin01.default = SvgPin01;
	
	return Pin01;
}

var Pin02 = {};

var hasRequiredPin02;

function requirePin02 () {
	if (hasRequiredPin02) return Pin02;
	hasRequiredPin02 = 1;
	Object.defineProperty(Pin02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgPin02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m11.169 20.822-7.543 7.542M15.593 8.856l-2.082 2.081c-.17.17-.254.255-.351.322a1.3 1.3 0 0 1-.276.148c-.11.043-.227.066-.463.114l-4.886.977c-1.27.254-1.904.38-2.201.715a1.33 1.33 0 0 0-.324 1.068c.062.444.52.901 1.435 1.817l9.448 9.448c.915.915 1.373 1.373 1.816 1.435.387.053.777-.065 1.069-.324.334-.297.461-.932.715-2.201l.977-4.886c.047-.236.071-.353.114-.463q.057-.147.148-.276c.067-.097.152-.182.322-.351l2.081-2.082c.108-.108.163-.162.223-.21q.079-.063.167-.113c.067-.038.137-.069.278-.129l3.326-1.425c.97-.416 1.455-.624 1.676-.96.192-.294.261-.652.192-.996-.08-.394-.453-.767-1.2-1.514L20.94 4.194c-.747-.747-1.12-1.12-1.514-1.2-.344-.07-.702 0-.996.192-.336.22-.544.706-.96 1.676l-1.425 3.326c-.06.14-.09.211-.129.278a1.3 1.3 0 0 1-.113.167c-.048.06-.102.114-.21.223" }))); };
	Pin02.default = SvgPin02;
	
	return Pin02;
}

var Plane = {};

var hasRequiredPlane;

function requirePlane () {
	if (hasRequiredPlane) return Plane;
	hasRequiredPlane = 1;
	Object.defineProperty(Plane, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgPlane = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M23.66 3.75a3.31 3.31 0 0 1 4.772 4.59l-3.704 3.88c-.29.303-.436.455-.526.634-.079.157-.126.329-.138.505-.014.199.033.404.128.813l2.303 9.984c.098.42.146.63.13.834-.013.18-.064.355-.147.515-.095.181-.248.334-.553.639l-.494.494c-.808.808-1.212 1.213-1.626 1.286a1.33 1.33 0 0 1-1.027-.243c-.337-.25-.518-.792-.88-1.877l-2.68-8.039-4.46 4.46c-.266.267-.399.4-.488.557q-.119.21-.157.448c-.029.179-.008.366.034.74l.245 2.204c.041.375.062.562.034.74q-.04.239-.158.448c-.089.157-.222.29-.488.557l-.263.263c-.631.63-.947.946-1.297 1.037-.307.08-.633.048-.919-.09-.326-.159-.573-.53-1.068-1.272L8.142 24.72a3 3 0 0 0-.184-.259 1.3 1.3 0 0 0-.149-.149c-.06-.051-.126-.095-.259-.184l-3.136-2.09c-.743-.495-1.114-.743-1.272-1.069a1.33 1.33 0 0 1-.091-.919c.091-.35.407-.666 1.037-1.296l.264-.264c.266-.266.4-.399.556-.488q.21-.119.448-.157c.179-.029.366-.008.74.034l2.204.245c.375.041.562.062.74.034.158-.026.31-.079.448-.158.157-.089.29-.222.556-.488l4.46-4.46-8.038-2.68c-1.084-.362-1.627-.542-1.877-.88a1.33 1.33 0 0 1-.242-1.027c.073-.413.477-.817 1.285-1.626l.494-.494c.306-.305.458-.458.639-.552.16-.084.335-.134.515-.148.204-.016.414.033.835.13L18.06 8.07c.413.095.62.143.82.129.192-.014.38-.07.549-.163.175-.096.322-.248.617-.553z" }))); };
	Plane.default = SvgPlane;
	
	return Plane;
}

var Print = {};

var hasRequiredPrint;

function requirePrint () {
	if (hasRequiredPrint) return Print;
	hasRequiredPrint = 1;
	Object.defineProperty(Print, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgPrint = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M24 9.333v-2.4c0-1.493 0-2.24-.29-2.81a2.67 2.67 0 0 0-1.166-1.166c-.57-.29-1.317-.29-2.81-.29h-7.468c-1.493 0-2.24 0-2.81.29-.502.256-.91.664-1.166 1.166C8 4.693 8 5.44 8 6.933v2.4M8 24c-1.24 0-1.86 0-2.369-.136a4 4 0 0 1-2.828-2.829c-.136-.508-.136-1.128-.136-2.368v-2.934c0-2.24 0-3.36.435-4.216A4 4 0 0 1 4.851 9.77c.855-.436 1.975-.436 4.216-.436h13.866c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.749c.436.855.436 1.975.436 4.215v2.934c0 1.24 0 1.86-.136 2.368a4 4 0 0 1-2.829 2.829C25.86 24 25.24 24 24 24m-4-10h4M12.267 29.333h7.466c1.494 0 2.24 0 2.81-.29.503-.256.91-.664 1.166-1.166.29-.57.29-1.317.29-2.81v-2.134c0-1.493 0-2.24-.29-2.81a2.67 2.67 0 0 0-1.165-1.166c-.57-.29-1.317-.29-2.81-.29h-7.468c-1.493 0-2.24 0-2.81.29-.502.256-.91.664-1.166 1.166-.29.57-.29 1.317-.29 2.81v2.134c0 1.493 0 2.24.29 2.81.256.502.664.91 1.166 1.166.57.29 1.317.29 2.81.29" }))); };
	Print.default = SvgPrint;
	
	return Print;
}

var Puzzle = {};

var hasRequiredPuzzle;

function requirePuzzle () {
	if (hasRequiredPuzzle) return Puzzle;
	hasRequiredPuzzle = 1;
	Object.defineProperty(Puzzle, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgPuzzle = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M10 6a3.333 3.333 0 0 1 6.667 0v2H18c1.864 0 2.796 0 3.53.304a4 4 0 0 1 2.165 2.165C24 11.204 24 12.136 24 14h2a3.333 3.333 0 1 1 0 6.667h-2v2.266c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748c-.856.436-1.976.436-4.216.436h-.933V27a3 3 0 1 0-6 0v2.333h-1.6c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748c-.436-.855-.436-1.976-.436-4.216v-2.266h2a3.333 3.333 0 0 0 0-6.667h-2c0-1.864 0-2.796.304-3.53a4 4 0 0 1 2.165-2.166C5.87 8 6.803 8 8.666 8H10z" }))); };
	Puzzle.default = SvgPuzzle;
	
	return Puzzle;
}

var QrCode01 = {};

var hasRequiredQrCode01;

function requireQrCode01 () {
	if (hasRequiredQrCode01) return QrCode01;
	hasRequiredQrCode01 = 1;
	Object.defineProperty(QrCode01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgQrCode01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M8.667 8.667h.013m14.653 0h.014M8.667 23.333h.013m8.653-6h.014m5.986 6h.014M22.667 28H28v-5.333M18.667 22v6M28 18.667h-6m-1.2-5.334h5.067c.746 0 1.12 0 1.405-.145.25-.128.455-.332.583-.583C28 12.32 28 11.947 28 11.2V6.133c0-.746 0-1.12-.145-1.405a1.33 1.33 0 0 0-.583-.583C26.987 4 26.613 4 25.867 4H20.8c-.747 0-1.12 0-1.405.145-.251.128-.455.332-.583.583-.145.285-.145.659-.145 1.405V11.2c0 .747 0 1.12.145 1.405.128.251.332.455.583.583.285.145.658.145 1.405.145m-14.667 0H11.2c.747 0 1.12 0 1.405-.145.251-.128.455-.332.583-.583.145-.285.145-.658.145-1.405V6.133c0-.746 0-1.12-.145-1.405a1.33 1.33 0 0 0-.583-.583C12.32 4 11.947 4 11.2 4H6.133c-.746 0-1.12 0-1.405.145-.25.128-.455.332-.583.583C4 5.013 4 5.387 4 6.133V11.2c0 .747 0 1.12.145 1.405.128.251.332.455.583.583.285.145.659.145 1.405.145m0 14.667H11.2c.747 0 1.12 0 1.405-.145.251-.128.455-.332.583-.583.145-.285.145-.659.145-1.405V20.8c0-.747 0-1.12-.145-1.405a1.33 1.33 0 0 0-.583-.583c-.285-.145-.658-.145-1.405-.145H6.133c-.746 0-1.12 0-1.405.145-.25.128-.455.332-.583.583C4 19.68 4 20.053 4 20.8v5.067c0 .746 0 1.12.145 1.405.128.25.332.455.583.583.285.145.659.145 1.405.145" }))); };
	QrCode01.default = SvgQrCode01;
	
	return QrCode01;
}

var QrCode02 = {};

var hasRequiredQrCode02;

function requireQrCode02 () {
	if (hasRequiredQrCode02) return QrCode02;
	hasRequiredQrCode02 = 1;
	Object.defineProperty(QrCode02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgQrCode02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M9.333 16H16v6.667M4.013 16H4m6.68 6.667h-.014M16.014 28H16m12.013-12H28M4 22.667h2M20.667 16h2.666M4 28h6.666M16 2.667v8M23.467 28h2.4c.746 0 1.12 0 1.405-.145.25-.128.455-.332.583-.583.145-.285.145-.659.145-1.405v-2.4c0-.747 0-1.12-.145-1.406a1.33 1.33 0 0 0-.583-.582c-.285-.146-.659-.146-1.405-.146h-2.4c-.747 0-1.12 0-1.406.146-.25.128-.455.332-.582.582-.146.286-.146.659-.146 1.406v2.4c0 .746 0 1.12.146 1.405.127.251.331.455.582.583.285.145.659.145 1.406.145m0-17.333h2.4c.746 0 1.12 0 1.405-.146.25-.127.455-.331.583-.582C28 9.654 28 9.28 28 8.533v-2.4c0-.746 0-1.12-.145-1.405a1.33 1.33 0 0 0-.583-.583C26.987 4 26.613 4 25.867 4h-2.4c-.747 0-1.12 0-1.406.145-.25.128-.455.332-.582.583-.146.285-.146.659-.146 1.405v2.4c0 .747 0 1.12.146 1.406.127.25.331.455.582.582.285.146.659.146 1.406.146m-17.334 0h2.4c.747 0 1.12 0 1.406-.146.25-.127.454-.331.582-.582.145-.285.145-.659.145-1.406v-2.4c0-.746 0-1.12-.145-1.405a1.33 1.33 0 0 0-.582-.583C9.653 4 9.279 4 8.533 4h-2.4c-.747 0-1.12 0-1.405.145-.251.128-.455.332-.583.583C4 5.013 4 5.387 4 6.133v2.4c0 .747 0 1.12.145 1.406.128.25.332.455.583.582.285.146.658.146 1.405.146" }))); };
	QrCode02.default = SvgQrCode02;
	
	return QrCode02;
}

var ReceiptCheck = {};

var hasRequiredReceiptCheck;

function requireReceiptCheck () {
	if (hasRequiredReceiptCheck) return ReceiptCheck;
	hasRequiredReceiptCheck = 1;
	Object.defineProperty(ReceiptCheck, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgReceiptCheck = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m12 14 2.667 2.667 6-6m6 17.333V10.4c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C23.627 4 22.507 4 20.267 4h-8.534c-2.24 0-3.36 0-4.216.436A4 4 0 0 0 5.77 6.184c-.436.856-.436 1.976-.436 4.216V28L9 25.333 12.333 28 16 25.333 19.667 28 23 25.333z" }))); };
	ReceiptCheck.default = SvgReceiptCheck;
	
	return ReceiptCheck;
}

var Receipt = {};

var hasRequiredReceipt;

function requireReceipt () {
	if (hasRequiredReceipt) return Receipt;
	hasRequiredReceipt = 1;
	Object.defineProperty(Receipt, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgReceipt = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M5.333 10.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C8.373 4 9.493 4 11.733 4h8.534c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748c.436.856.436 1.976.436 4.216V28L23 25.333 19.667 28 16 25.333 12.333 28 9 25.333 5.333 28z" }))); };
	Receipt.default = SvgReceipt;
	
	return Receipt;
}

var RefreshBackward = {};

var hasRequiredRefreshBackward;

function requireRefreshBackward () {
	if (hasRequiredRefreshBackward) return RefreshBackward;
	hasRequiredRefreshBackward = 1;
	Object.defineProperty(RefreshBackward, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgRefreshBackward = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M22.667 25.166A11.32 11.32 0 0 0 27.333 16C27.333 9.74 22.26 4.667 16 4.667h-.667M16 27.333C9.74 27.333 4.667 22.26 4.667 16c0-3.767 1.838-7.105 4.666-9.166m5.334 23.033 2.666-2.667-2.666-2.667m2.666-17.066L14.667 4.8l2.666-2.667" }))); };
	RefreshBackward.default = SvgRefreshBackward;
	
	return RefreshBackward;
}

var RefreshForward = {};

var hasRequiredRefreshForward;

function requireRefreshForward () {
	if (hasRequiredRefreshForward) return RefreshForward;
	hasRequiredRefreshForward = 1;
	Object.defineProperty(RefreshForward, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgRefreshForward = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M22.667 6.834A11.32 11.32 0 0 1 27.333 16c0 6.26-5.074 11.333-11.333 11.333h-.667m-6-2.167A11.32 11.32 0 0 1 4.667 16C4.667 9.74 9.74 4.667 16 4.667h.667m.666 25.2L14.667 27.2l2.666-2.667M14.667 7.467 17.333 4.8l-2.666-2.667" }))); };
	RefreshForward.default = SvgRefreshForward;
	
	return RefreshForward;
}

var ReloadBackward = {};

var hasRequiredReloadBackward;

function requireReloadBackward () {
	if (hasRequiredReloadBackward) return ReloadBackward;
	hasRequiredReloadBackward = 1;
	Object.defineProperty(ReloadBackward, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgReloadBackward = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M2.667 13.333S5.34 9.691 7.512 7.518A11.96 11.96 0 0 1 16 4c6.627 0 12 5.373 12 12s-5.373 12-12 12c-5.47 0-10.087-3.661-11.531-8.667m-1.802-6v-8m0 8h8" }))); };
	ReloadBackward.default = SvgReloadBackward;
	
	return ReloadBackward;
}

var ReloadForward = {};

var hasRequiredReloadForward;

function requireReloadForward () {
	if (hasRequiredReloadForward) return ReloadForward;
	hasRequiredReloadForward = 1;
	Object.defineProperty(ReloadForward, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgReloadForward = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M28 13.333s-2.673-3.642-4.845-5.815A11.96 11.96 0 0 0 14.667 4c-6.628 0-12 5.373-12 12s5.372 12 12 12c5.47 0 10.086-3.661 11.53-8.667m1.803-6v-8m0 8h-8" }))); };
	ReloadForward.default = SvgReloadForward;
	
	return ReloadForward;
}

var Residence01 = {};

var hasRequiredResidence01;

function requireResidence01 () {
	if (hasRequiredResidence01) return Residence01;
	hasRequiredResidence01 = 1;
	Object.defineProperty(Residence01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgResidence01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M12 28v-9.867c0-.746 0-1.12.145-1.405.128-.25.332-.455.583-.583.285-.145.659-.145 1.405-.145h3.734c.746 0 1.12 0 1.405.145.251.128.455.332.583.583.145.285.145.659.145 1.405V28M2.667 12.667l12.053-9.04c.46-.345.689-.517.94-.583.223-.059.457-.059.68 0 .252.066.481.238.94.583l12.053 9.04m-24-2v13.066c0 1.494 0 2.24.291 2.811.256.502.664.91 1.165 1.165C7.36 28 8.107 28 9.6 28h12.8c1.494 0 2.24 0 2.81-.29.502-.256.91-.664 1.166-1.166.29-.57.29-1.317.29-2.81V10.666l-8.106-6.08c-.918-.689-1.377-1.033-1.881-1.166a2.67 2.67 0 0 0-1.358 0c-.504.133-.963.477-1.88 1.166z" }))); };
	Residence01.default = SvgResidence01;
	
	return Residence01;
}

var Residence02 = {};

var hasRequiredResidence02;

function requireResidence02 () {
	if (hasRequiredResidence02) return Residence02;
	hasRequiredResidence02 = 1;
	Object.defineProperty(Residence02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgResidence02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M20 28v-7.2c0-.747 0-1.12-.145-1.405a1.33 1.33 0 0 0-.583-.583c-.285-.145-.659-.145-1.405-.145h-3.734c-.746 0-1.12 0-1.405.145-.25.128-.455.332-.583.583C12 19.68 12 20.053 12 20.8V28m13.333 0V8.267c0-1.494 0-2.24-.29-2.811a2.67 2.67 0 0 0-1.166-1.165C23.307 4 22.56 4 21.067 4H10.933c-1.493 0-2.24 0-2.81.29-.502.256-.91.664-1.166 1.166-.29.57-.29 1.317-.29 2.81V28M28 28H4m8.667-17.333h.013m6.653 0h.014m-6.014 0a.667.667 0 1 1-1.333 0 .667.667 0 0 1 1.333 0m6.667 0a.667.667 0 1 1-1.333 0 .667.667 0 0 1 1.333 0" }))); };
	Residence02.default = SvgResidence02;
	
	return Residence02;
}

var Rocket01 = {};

var hasRequiredRocket01;

function requireRocket01 () {
	if (hasRequiredRocket01) return Rocket01;
	hasRequiredRocket01 = 1;
	Object.defineProperty(Rocket01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgRocket01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M17.333 14.667 4.666 27.333M18.691 4.718a30 30 0 0 1 4.643 3.807 30 30 0 0 1 3.835 4.685m-14.83-2.682L8.506 9.25a1.33 1.33 0 0 0-1.283.247l-3.81 3.224c-.779.66-.557 1.916.401 2.269l3.61 1.33m8.15 8.15 1.33 3.61a1.333 1.333 0 0 0 2.27.4l3.223-3.81c.3-.355.394-.841.247-1.283l-1.278-3.833m4.432-16.526-6.542 1.09a3.26 3.26 0 0 0-1.844.988L8.595 14.53a6.203 6.203 0 0 0 8.768 8.768l9.425-8.817c.523-.49.87-1.137.988-1.844l1.09-6.542a2.667 2.667 0 0 0-3.068-3.068" }))); };
	Rocket01.default = SvgRocket01;
	
	return Rocket01;
}

var Rocket02 = {};

var hasRequiredRocket02;

function requireRocket02 () {
	if (hasRequiredRocket02) return Rocket02;
	hasRequiredRocket02 = 1;
	Object.defineProperty(Rocket02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgRocket02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m16 20-4-4m4 4a29.8 29.8 0 0 0 5.333-2.667M16 20v6.667s4.04-.734 5.333-2.667c1.44-2.16 0-6.667 0-6.667M12 16a29.3 29.3 0 0 1 2.667-5.267 17.17 17.17 0 0 1 14.666-8.066c0 3.626-1.04 10-8 14.666M12 16H5.333S6.067 11.96 8 10.667c2.16-1.44 6.667 0 6.667 0M6 22c-2 1.68-2.667 6.667-2.667 6.667S8.32 28 10 26c.947-1.12.933-2.84-.12-3.88A2.907 2.907 0 0 0 6 22" }))); };
	Rocket02.default = SvgRocket02;
	
	return Rocket02;
}

var Route01 = {};

var hasRequiredRoute01;

function requireRoute01 () {
	if (hasRequiredRoute01) return Route01;
	hasRequiredRoute01 = 1;
	Object.defineProperty(Route01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgRoute01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M21.333 16a5.333 5.333 0 0 1-10.666 0m10.666 0a5.333 5.333 0 1 0-10.666 0m10.666 0h8m-18.666 0h-8" }))); };
	Route01.default = SvgRoute01;
	
	return Route01;
}

var Route02 = {};

var hasRequiredRoute02;

function requireRoute02 () {
	if (hasRequiredRoute02) return Route02;
	hasRequiredRoute02 = 1;
	Object.defineProperty(Route02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgRoute02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M4 4v13.6c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C7.04 24 8.16 24 10.4 24H20m0 0a4 4 0 1 0 8 0 4 4 0 0 0-8 0M4 10.667h16m0 0a4 4 0 1 0 8 0 4 4 0 0 0-8 0" }))); };
	Route02.default = SvgRoute02;
	
	return Route02;
}

var Route03 = {};

var hasRequiredRoute03;

function requireRoute03 () {
	if (hasRequiredRoute03) return Route03;
	hasRequiredRoute03 = 1;
	Object.defineProperty(Route03, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgRoute03 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M8 4v16m0 0a4 4 0 1 0 4 4m-4-4a4 4 0 0 1 4 4m12-12a4 4 0 1 0 0-8 4 4 0 0 0 0 8m0 0a12 12 0 0 1-12 12" }))); };
	Route03.default = SvgRoute03;
	
	return Route03;
}

var Route04 = {};

var hasRequiredRoute04;

function requireRoute04 () {
	if (hasRequiredRoute04) return Route04;
	hasRequiredRoute04 = 1;
	Object.defineProperty(Route04, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgRoute04 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M20 24a4 4 0 1 0 8 0 4 4 0 0 0-8 0m0 0A12 12 0 0 1 8 12m0 0a4 4 0 1 0 0-8 4 4 0 0 0 0 8m0 0v16" }))); };
	Route04.default = SvgRoute04;
	
	return Route04;
}

var Route05 = {};

var hasRequiredRoute05;

function requireRoute05 () {
	if (hasRequiredRoute05) return Route05;
	hasRequiredRoute05 = 1;
	Object.defineProperty(Route05, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgRoute05 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M24 20a4 4 0 1 0 0 8 4 4 0 0 0 0-8m0 0v-9.333A2.667 2.667 0 0 0 21.333 8h-4M8 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8m0 0v16" }))); };
	Route05.default = SvgRoute05;
	
	return Route05;
}

var Route06 = {};

var hasRequiredRoute06;

function requireRoute06 () {
	if (hasRequiredRoute06) return Route06;
	hasRequiredRoute06 = 1;
	Object.defineProperty(Route06, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgRoute06 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M22.667 26.667H22.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C16 23.627 16 22.507 16 20.267v-8.534c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748c.856-.436 1.976-.436 4.216-.436h.267m0 21.334a2.667 2.667 0 1 0 5.333 0 2.667 2.667 0 0 0-5.333 0m0-21.334a2.667 2.667 0 1 0 5.333 0 2.667 2.667 0 0 0-5.333 0M9.333 16h13.334M9.333 16A2.667 2.667 0 1 1 4 16a2.667 2.667 0 0 1 5.333 0m13.334 0A2.667 2.667 0 1 0 28 16a2.667 2.667 0 0 0-5.333 0" }))); };
	Route06.default = SvgRoute06;
	
	return Route06;
}

var Route07 = {};

var hasRequiredRoute07;

function requireRoute07 () {
	if (hasRequiredRoute07) return Route07;
	hasRequiredRoute07 = 1;
	Object.defineProperty(Route07, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgRoute07 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M15.333 6.667h.58c4.063 0 6.094 0 6.865.73.667.63.962 1.56.782 2.46-.208 1.04-1.867 2.213-5.184 4.56l-5.42 3.833c-3.316 2.346-4.975 3.52-5.183 4.56-.18.9.116 1.83.782 2.46.771.73 2.803.73 6.866.73h1.246m-6-19.333a4 4 0 1 1-8 0 4 4 0 0 1 8 0m18.666 18.666a4 4 0 1 1-8 0 4 4 0 0 1 8 0" }))); };
	Route07.default = SvgRoute07;
	
	return Route07;
}

var Rows02 = {};

var hasRequiredRows02;

function requireRows02 () {
	if (hasRequiredRows02) return Rows02;
	hasRequiredRows02 = 1;
	Object.defineProperty(Rows02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgRows02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M4 16h24M10.4 4h11.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C28 7.04 28 8.16 28 10.4v11.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C24.96 28 23.84 28 21.6 28H10.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C4 24.96 4 23.84 4 21.6V10.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C7.04 4 8.16 4 10.4 4" }))); };
	Rows02.default = SvgRows02;
	
	return Rows02;
}

var Rows03 = {};

var hasRequiredRows03;

function requireRows03 () {
	if (hasRequiredRows03) return Rows03;
	hasRequiredRows03 = 1;
	Object.defineProperty(Rows03, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgRows03 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M4 12h24M4 20h24M10.4 4h11.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C28 7.04 28 8.16 28 10.4v11.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C24.96 28 23.84 28 21.6 28H10.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C4 24.96 4 23.84 4 21.6V10.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C7.04 4 8.16 4 10.4 4" }))); };
	Rows03.default = SvgRows03;
	
	return Rows03;
}

var Sale01 = {};

var hasRequiredSale01;

function requireSale01 () {
	if (hasRequiredSale01) return Sale01;
	hasRequiredSale01 = 1;
	Object.defineProperty(Sale01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgSale01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M12 12h.013M20 20h.013m1.32-9.333L10.667 21.333M9.778 5.092a5.1 5.1 0 0 0 2.908-1.205 5.11 5.11 0 0 1 6.628 0 5.1 5.1 0 0 0 2.908 1.205 5.11 5.11 0 0 1 4.686 4.686 5.1 5.1 0 0 0 1.205 2.908 5.11 5.11 0 0 1 0 6.628 5.1 5.1 0 0 0-1.204 2.908 5.11 5.11 0 0 1-4.687 4.686 5.1 5.1 0 0 0-2.908 1.205 5.11 5.11 0 0 1-6.628 0 5.1 5.1 0 0 0-2.908-1.205 5.11 5.11 0 0 1-4.686-4.686 5.1 5.1 0 0 0-1.205-2.908 5.11 5.11 0 0 1 0-6.628 5.1 5.1 0 0 0 1.205-2.908 5.11 5.11 0 0 1 4.686-4.686M12.667 12a.667.667 0 1 1-1.334 0 .667.667 0 0 1 1.334 0m8 8a.667.667 0 1 1-1.334 0 .667.667 0 0 1 1.334 0" }))); };
	Sale01.default = SvgSale01;
	
	return Sale01;
}

var Sale02 = {};

var hasRequiredSale02;

function requireSale02 () {
	if (hasRequiredSale02) return Sale02;
	hasRequiredSale02 = 1;
	Object.defineProperty(Sale02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgSale02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M12 12h.013M20 20h.013m1.32-9.333L10.667 21.333m1.602 6.135c.437-.058.879.06 1.227.329l1.604 1.23c.53.408 1.268.408 1.797 0l1.665-1.278a1.47 1.47 0 0 1 1.092-.292l2.083.274c.662.088 1.3-.281 1.557-.899l.801-1.937c.15-.363.437-.65.8-.8l1.938-.802c.617-.255.986-.895.899-1.557l-.264-2.007c-.058-.437.06-.879.329-1.227l1.23-1.604a1.474 1.474 0 0 0 0-1.797l-1.277-1.665a1.47 1.47 0 0 1-.292-1.092l.274-2.083a1.48 1.48 0 0 0-.9-1.557l-1.937-.802a1.47 1.47 0 0 1-.8-.8l-.801-1.937a1.476 1.476 0 0 0-1.557-.9l-2.083.275a1.47 1.47 0 0 1-1.09-.29l-1.666-1.278a1.474 1.474 0 0 0-1.796 0l-1.665 1.279a1.49 1.49 0 0 1-1.092.292l-2.083-.275a1.48 1.48 0 0 0-1.557.9l-.8 1.937a1.5 1.5 0 0 1-.8.8l-1.937.8a1.48 1.48 0 0 0-.9 1.557l.275 2.083c.05.388-.055.781-.292 1.09l-1.279 1.666a1.474 1.474 0 0 0 0 1.797l1.279 1.665c.238.311.343.704.292 1.092l-.275 2.083c-.087.662.282 1.3.9 1.557l1.937.801c.363.15.65.437.8.8l.802 1.938c.254.617.894.986 1.556.899zM12.667 12a.667.667 0 1 1-1.334 0 .667.667 0 0 1 1.334 0m8 8a.667.667 0 1 1-1.334 0 .667.667 0 0 1 1.334 0" }))); };
	Sale02.default = SvgSale02;
	
	return Sale02;
}

var SaveGroup = {};

var hasRequiredSaveGroup;

function requireSaveGroup () {
	if (hasRequiredSaveGroup) return SaveGroup;
	hasRequiredSaveGroup = 1;
	Object.defineProperty(SaveGroup, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgSaveGroup = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M9.333 4h10.233c.652 0 .978 0 1.285.074.272.065.533.173.771.319.27.165.5.395.961.857l4.167 4.167c.462.461.692.692.857.96q.22.362.32.772c.073.307.073.633.073 1.285v10.233m-11.333-9.334h-5.2c-.747 0-1.12 0-1.406-.145a1.33 1.33 0 0 1-.582-.583c-.146-.285-.146-.658-.146-1.405V8.667M18 28v-5.867c0-.746 0-1.12-.145-1.405a1.33 1.33 0 0 0-.583-.583C16.987 20 16.613 20 15.867 20h-4.4c-.747 0-1.12 0-1.406.145-.25.128-.455.332-.582.583-.146.285-.146.659-.146 1.405V28m14-14.45v10.183c0 1.494 0 2.24-.29 2.811-.256.502-.664.91-1.166 1.165-.57.291-1.317.291-2.81.291h-10.8c-1.494 0-2.24 0-2.811-.29a2.67 2.67 0 0 1-1.165-1.166C4 25.974 4 25.227 4 23.734v-10.8c0-1.494 0-2.24.29-2.811.256-.502.664-.91 1.166-1.166.57-.29 1.317-.29 2.81-.29H18.45c.326 0 .489 0 .642.037q.205.049.386.16c.134.082.25.197.48.428l2.75 2.75c.231.23.346.346.429.48q.11.181.16.386c.036.153.036.316.036.642" }))); };
	SaveGroup.default = SvgSaveGroup;
	
	return SaveGroup;
}

var Save = {};

var hasRequiredSave;

function requireSave () {
	if (hasRequiredSave) return Save;
	hasRequiredSave = 1;
	Object.defineProperty(Save, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgSave = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M20 10.667h-8.533c-.747 0-1.12 0-1.406-.146a1.33 1.33 0 0 1-.582-.582c-.146-.286-.146-.659-.146-1.406V4m13.334 24v-8.533c0-.747 0-1.12-.146-1.406a1.33 1.33 0 0 0-.582-.582c-.286-.146-.659-.146-1.406-.146h-9.066c-.747 0-1.12 0-1.406.146-.25.128-.455.332-.582.582-.146.286-.146.659-.146 1.406V28M28 12.434V21.6c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C24.96 28 23.84 28 21.6 28H10.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C4 24.96 4 23.84 4 21.6V10.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C7.04 4 8.16 4 10.4 4h9.166c.652 0 .978 0 1.285.074.272.065.533.173.771.319.27.165.5.395.961.857l4.167 4.167c.462.461.692.692.857.96q.22.362.32.772c.073.307.073.633.073 1.285" }))); };
	Save.default = SvgSave;
	
	return Save;
}

var Scan = {};

var hasRequiredScan;

function requireScan () {
	if (hasRequiredScan) return Scan;
	hasRequiredScan = 1;
	Object.defineProperty(Scan, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgScan = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M10.667 4H10.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C4 7.04 4 8.16 4 10.4v.267M10.667 28H10.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C4 24.96 4 23.84 4 21.6v-.267m24-10.666V10.4c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C24.96 4 23.84 4 21.6 4h-.267M28 21.333v.267c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C24.96 28 23.84 28 21.6 28h-.267M4 16h.013M10 16h.013M22 16h.013M16 16h.013M28 16h.013" }))); };
	Scan.default = SvgScan;
	
	return Scan;
}

var ScreenExpand = {};

var hasRequiredScreenExpand;

function requireScreenExpand () {
	if (hasRequiredScreenExpand) return ScreenExpand;
	hasRequiredScreenExpand = 1;
	Object.defineProperty(ScreenExpand, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgScreenExpand = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M21.333 10.667 28 4m0 0h-6.667M28 4v6.667m-17.333 0L4 4m0 0v6.667M4 4h6.667m0 17.333L4 28m0 0h6.667M4 28v-6.667m17.333 0L28 28m0 0v-6.667M28 28h-6.667" }))); };
	ScreenExpand.default = SvgScreenExpand;
	
	return ScreenExpand;
}

var ScreenMaximize = {};

var hasRequiredScreenMaximize;

function requireScreenMaximize () {
	if (hasRequiredScreenMaximize) return ScreenMaximize;
	hasRequiredScreenMaximize = 1;
	Object.defineProperty(ScreenMaximize, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgScreenMaximize = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M18.667 13.333 28 4m0 0h-8m8 0v8m-14.667 6.667L4 28m0 0h8m-8 0v-8" }))); };
	ScreenMaximize.default = SvgScreenMaximize;
	
	return ScreenMaximize;
}

var ScreenMinimize = {};

var hasRequiredScreenMinimize;

function requireScreenMinimize () {
	if (hasRequiredScreenMinimize) return ScreenMinimize;
	hasRequiredScreenMinimize = 1;
	Object.defineProperty(ScreenMinimize, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgScreenMinimize = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M5.333 18.667h8m0 0v8m0-8L4 28m22.667-14.667h-8m0 0v-8m0 8L28 4" }))); };
	ScreenMinimize.default = SvgScreenMinimize;
	
	return ScreenMinimize;
}

var SearchLarge = {};

var hasRequiredSearchLarge;

function requireSearchLarge () {
	if (hasRequiredSearchLarge) return SearchLarge;
	hasRequiredSearchLarge = 1;
	Object.defineProperty(SearchLarge, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgSearchLarge = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m28 28-4.666-4.667m3.333-8c0 6.26-5.074 11.334-11.334 11.334S4 21.593 4 15.333 9.074 4 15.333 4s11.334 5.074 11.334 11.333" }))); };
	SearchLarge.default = SvgSearchLarge;
	
	return SearchLarge;
}

var SearchMedium = {};

var hasRequiredSearchMedium;

function requireSearchMedium () {
	if (hasRequiredSearchMedium) return SearchMedium;
	hasRequiredSearchMedium = 1;
	Object.defineProperty(SearchMedium, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgSearchMedium = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m28 28-5.8-5.8m3.133-7.533c0 5.89-4.775 10.666-10.666 10.666S4 20.558 4 14.667 8.776 4 14.667 4c5.89 0 10.666 4.776 10.666 10.667" }))); };
	SearchMedium.default = SvgSearchMedium;
	
	return SearchMedium;
}

var Send01 = {};

var hasRequiredSend01;

function requireSend01 () {
	if (hasRequiredSend01) return Send01;
	hasRequiredSend01 = 1;
	Object.defineProperty(Send01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgSend01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M14 18 28 4M14.17 18.437l3.504 9.011c.308.794.463 1.19.685 1.307.193.1.422.1.615 0 .223-.116.378-.512.687-1.306l8.787-22.517c.28-.716.42-1.074.343-1.303a.67.67 0 0 0-.42-.421c-.23-.076-.588.063-1.304.343L4.55 12.338c-.793.31-1.19.464-1.306.687-.1.193-.1.422 0 .615.117.223.513.377 1.307.686l9.01 3.504c.162.063.243.094.31.142q.09.065.156.156c.049.068.08.148.143.31" }))); };
	Send01.default = SvgSend01;
	
	return Send01;
}

var Send02 = {};

var hasRequiredSend02;

function requireSend02 () {
	if (hasRequiredSend02) return Send02;
	hasRequiredSend02 = 1;
	Object.defineProperty(Send02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgSend02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M16 25.333V16m.39 9.446 9.304 3.115c.73.244 1.094.366 1.319.279a.67.67 0 0 0 .4-.442c.065-.232-.093-.583-.407-1.285L17.021 4.83c-.307-.686-.46-1.03-.675-1.136a.67.67 0 0 0-.591 0c-.215.105-.37.447-.679 1.133L5.003 27.115c-.317.701-.475 1.052-.41 1.284a.67.67 0 0 0 .398.443c.225.088.59-.033 1.32-.276l9.404-3.12c.125-.042.188-.063.252-.071a.7.7 0 0 1 .17 0c.065.008.127.03.252.071" }))); };
	Send02.default = SvgSend02;
	
	return Send02;
}

var Send03 = {};

var hasRequiredSend03;

function requireSend03 () {
	if (hasRequiredSend03) return Send03;
	hasRequiredSend03 = 1;
	Object.defineProperty(Send03, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgSend03 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M14 16H6.668m-.113.389-3.113 9.3c-.244.73-.367 1.095-.279 1.32.076.195.24.343.442.4.232.065.584-.093 1.286-.41l22.282-10.026c.686-.309 1.029-.463 1.135-.678a.67.67 0 0 0 0-.59c-.106-.215-.449-.37-1.135-.678L4.882 4.997c-.7-.315-1.05-.473-1.282-.408a.67.67 0 0 0-.442.399c-.088.224.033.589.275 1.318l3.122 9.408c.042.125.063.188.07.252a.7.7 0 0 1 0 .171c-.008.064-.029.127-.07.252" }))); };
	Send03.default = SvgSend03;
	
	return Send03;
}

var Settings01 = {};

var hasRequiredSettings01;

function requireSettings01 () {
	if (hasRequiredSettings01) return Settings01;
	hasRequiredSettings01 = 1;
	Object.defineProperty(Settings01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgSettings01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m12.527 25.828.779 1.753a2.95 2.95 0 0 0 5.393 0l.779-1.753a3.23 3.23 0 0 1 3.293-1.898l1.907.203a2.95 2.95 0 0 0 2.696-4.67l-1.129-1.55A3.24 3.24 0 0 1 25.632 16c0-.684.217-1.351.62-1.905l1.128-1.551a2.948 2.948 0 0 0-1.047-4.365 2.95 2.95 0 0 0-1.65-.305l-1.906.203a3.24 3.24 0 0 1-1.96-.416 3.23 3.23 0 0 1-1.333-1.49l-.785-1.752a2.95 2.95 0 0 0-5.393 0l-.78 1.753a3.23 3.23 0 0 1-1.333 1.489 3.25 3.25 0 0 1-1.96.416l-1.912-.203a2.95 2.95 0 0 0-2.697 4.67l1.13 1.55a3.24 3.24 0 0 1 0 3.811l-1.13 1.551a2.948 2.948 0 0 0 1.048 4.365 2.95 2.95 0 0 0 1.649.305l1.906-.203a3.234 3.234 0 0 1 3.3 1.905" }),
	    React.createElement("path", { d: "M16 20a4 4 0 1 0 0-8 4 4 0 0 0 0 8" }))); };
	Settings01.default = SvgSettings01;
	
	return Settings01;
}

var Settings02 = {};

var hasRequiredSettings02;

function requireSettings02 () {
	if (hasRequiredSettings02) return Settings02;
	hasRequiredSettings02 = 1;
	Object.defineProperty(Settings02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgSettings02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M20.842 10.175c-.528-.528-.792-.792-.891-1.096a1.33 1.33 0 0 1 0-.824c.099-.305.363-.569.89-1.097l3.785-3.784a8 8 0 0 0-11.066 9.193c.16.652.239.978.225 1.184a1.1 1.1 0 0 1-.147.523c-.095.183-.277.365-.641.729l-8.33 8.33a2.828 2.828 0 1 0 4 4l8.33-8.33c.364-.364.546-.546.73-.641.191-.1.306-.132.522-.146.206-.015.532.065 1.184.224a8 8 0 0 0 9.193-11.066l-3.784 3.784c-.528.528-.792.792-1.097.891a1.33 1.33 0 0 1-.824 0c-.304-.099-.568-.363-1.096-.89z" }))); };
	Settings02.default = SvgSettings02;
	
	return Settings02;
}

var Settings03 = {};

var hasRequiredSettings03;

function requireSettings03 () {
	if (hasRequiredSettings03) return Settings03;
	hasRequiredSettings03 = 1;
	Object.defineProperty(Settings03, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgSettings03 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m8 8 6 6M8 8H4L2.667 4 4 2.667 8 4zm17.679-4.345-3.504 3.503c-.528.528-.792.792-.89 1.097a1.33 1.33 0 0 0 0 .824c.098.304.362.568.89 1.096l.316.317c.529.528.793.792 1.097.89.268.088.556.088.824 0 .305-.098.569-.362 1.097-.89l3.277-3.278c.353.86.547 1.8.547 2.786a7.333 7.333 0 0 1-8.76 7.195c-.648-.128-.972-.192-1.169-.172-.209.02-.312.052-.497.15-.174.094-.348.268-.698.618l-9.542 9.542a2.828 2.828 0 1 1-4-4l9.542-9.542c.35-.35.524-.524.617-.698.1-.185.13-.288.152-.497.02-.197-.045-.52-.173-1.169a7.333 7.333 0 0 1 10.873-7.772M16 20l7.333 7.333a2.829 2.829 0 0 0 4-4L21.3 17.301a7.3 7.3 0 0 1-1.246-.228c-.518-.143-1.087-.04-1.468.34z" }))); };
	Settings03.default = SvgSettings03;
	
	return Settings03;
}

var Share01 = {};

var hasRequiredShare01;

function requireShare01 () {
	if (hasRequiredShare01) return Share01;
	hasRequiredShare01 = 1;
	Object.defineProperty(Share01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgShare01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M28 8h-4.267c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748c-.436.856-.436 1.976-.436 4.216V16M28 8l-4-4m4 4-4 4M13.333 4H10.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C4 7.04 4 8.16 4 10.4v11.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C7.04 28 8.16 28 10.4 28h11.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C28 24.96 28 23.84 28 21.6v-2.933" }))); };
	Share01.default = SvgShare01;
	
	return Share01;
}

var Share02 = {};

var hasRequiredShare02;

function requireShare02 () {
	if (hasRequiredShare02) return Share02;
	hasRequiredShare02 = 1;
	Object.defineProperty(Share02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgShare02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m11.454 18.013 9.106 5.307m-.013-14.64-9.093 5.307M28 6.667a4 4 0 1 1-8 0 4 4 0 0 1 8 0M12 16a4 4 0 1 1-8 0 4 4 0 0 1 8 0m16 9.333a4 4 0 1 1-8 0 4 4 0 0 1 8 0" }))); };
	Share02.default = SvgShare02;
	
	return Share02;
}

var ShieldCheck = {};

var hasRequiredShieldCheck;

function requireShieldCheck () {
	if (hasRequiredShieldCheck) return ShieldCheck;
	hasRequiredShieldCheck = 1;
	Object.defineProperty(ShieldCheck, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgShieldCheck = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M12 15.333 14.667 18l6-6m6 4c0 6.545-7.139 11.305-9.736 12.82-.296.172-.443.258-.651.303a1.5 1.5 0 0 1-.56 0c-.208-.045-.355-.13-.65-.303-2.598-1.515-9.737-6.275-9.737-12.82V9.624c0-1.067 0-1.6.175-2.058.154-.404.404-.766.729-1.052.368-.324.867-.511 1.865-.885l7.149-2.681c.277-.104.416-.156.558-.177q.191-.027.382 0c.142.02.28.073.558.177l7.15 2.68c.997.375 1.496.562 1.864.886.325.286.575.648.73 1.052.174.458.174.991.174 2.058z" }))); };
	ShieldCheck.default = SvgShieldCheck;
	
	return ShieldCheck;
}

var ShieldCurrency = {};

var hasRequiredShieldCurrency;

function requireShieldCurrency () {
	if (hasRequiredShieldCurrency) return ShieldCurrency;
	hasRequiredShieldCurrency = 1;
	Object.defineProperty(ShieldCurrency, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgShieldCurrency = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M12.284 19.333a2.49 2.49 0 0 0 2.205 1.334h2.844a2.667 2.667 0 0 0 0-5.334h-2.666a2.667 2.667 0 1 1 0-5.333h2.844c.958 0 1.789.54 2.205 1.333M16 8v2m0 10.667v2M26.667 16c0 6.545-7.139 11.305-9.736 12.82-.296.172-.443.258-.651.303a1.5 1.5 0 0 1-.56 0c-.208-.045-.355-.13-.65-.303-2.598-1.515-9.737-6.275-9.737-12.82V9.624c0-1.067 0-1.6.175-2.058.154-.404.404-.766.729-1.052.368-.324.867-.511 1.865-.885l7.149-2.681c.277-.104.416-.156.558-.177q.191-.027.382 0c.142.02.28.073.558.177l7.15 2.68c.997.375 1.496.562 1.864.886.325.286.575.648.73 1.052.174.458.174.991.174 2.058z" }))); };
	ShieldCurrency.default = SvgShieldCurrency;
	
	return ShieldCurrency;
}

var ShieldOff = {};

var hasRequiredShieldOff;

function requireShieldOff () {
	if (hasRequiredShieldOff) return ShieldOff;
	hasRequiredShieldOff = 1;
	Object.defineProperty(ShieldOff, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgShieldOff = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m11.745 4.262 3.506-1.314c.277-.104.416-.156.558-.177q.191-.027.382 0c.142.02.281.073.558.177l7.15 2.68c.997.375 1.496.562 1.864.886.325.286.575.648.73 1.052.174.458.174.991.174 2.058V16c0 .96-.154 1.882-.425 2.761m-2.746 4.74c-2.248 2.614-5.112 4.47-6.563 5.318-.297.173-.445.26-.653.304a1.5 1.5 0 0 1-.56 0c-.208-.045-.355-.13-.65-.303-2.598-1.515-9.737-6.275-9.737-12.82V7.702c0-.623.387-1.18.97-1.399M4 4l24 24" }))); };
	ShieldOff.default = SvgShieldOff;
	
	return ShieldOff;
}

var ShieldPlus = {};

var hasRequiredShieldPlus;

function requireShieldPlus () {
	if (hasRequiredShieldPlus) return ShieldPlus;
	hasRequiredShieldPlus = 1;
	Object.defineProperty(ShieldPlus, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgShieldPlus = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M16 19.333v-8m-4 4h8m6.667.667c0 6.545-7.139 11.305-9.736 12.82-.296.172-.443.258-.652.303a1.5 1.5 0 0 1-.559 0c-.208-.045-.356-.13-.65-.303-2.598-1.515-9.737-6.275-9.737-12.82V9.624c0-1.067 0-1.6.175-2.058.154-.404.404-.766.729-1.052.368-.324.867-.511 1.865-.885l7.149-2.681c.277-.104.416-.156.558-.177q.191-.027.382 0c.142.02.28.073.558.177l7.149 2.68c.998.375 1.497.562 1.865.886.325.286.575.648.73 1.052.174.458.174.991.174 2.058z" }))); };
	ShieldPlus.default = SvgShieldPlus;
	
	return ShieldPlus;
}

var ShieldZap = {};

var hasRequiredShieldZap;

function requireShieldZap () {
	if (hasRequiredShieldZap) return ShieldZap;
	hasRequiredShieldZap = 1;
	Object.defineProperty(ShieldZap, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgShieldZap = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m17.333 10-4 4 5.334 2.667-4 4m12-4.667c0 6.545-7.139 11.305-9.736 12.82-.296.172-.443.258-.651.303a1.5 1.5 0 0 1-.56 0c-.208-.045-.355-.13-.65-.303-2.598-1.515-9.737-6.275-9.737-12.82V9.624c0-1.067 0-1.6.175-2.058.154-.404.404-.766.729-1.052.368-.324.867-.511 1.865-.885l7.149-2.681c.277-.104.416-.156.558-.177q.191-.027.382 0c.142.02.28.073.558.177l7.15 2.68c.997.375 1.496.562 1.864.886.325.286.575.648.73 1.052.174.458.174.991.174 2.058z" }))); };
	ShieldZap.default = SvgShieldZap;
	
	return ShieldZap;
}

var Shield = {};

var hasRequiredShield;

function requireShield () {
	if (hasRequiredShield) return Shield;
	hasRequiredShield = 1;
	Object.defineProperty(Shield, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgShield = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M15.07 28.82c.295.172.442.258.65.303.162.034.398.034.56 0 .208-.045.355-.13.65-.303 2.598-1.515 9.737-6.275 9.737-12.82V9.624c0-1.067 0-1.6-.175-2.058a2.7 2.7 0 0 0-.729-1.052c-.368-.324-.867-.511-1.865-.885L16.75 2.948c-.277-.104-.416-.156-.558-.177a1.3 1.3 0 0 0-.382 0c-.142.02-.28.073-.558.177l-7.15 2.68c-.997.375-1.496.562-1.864.886a2.7 2.7 0 0 0-.73 1.052c-.174.458-.174.991-.174 2.058V16c0 6.545 7.139 11.305 9.736 12.82" }))); };
	Shield.default = SvgShield;
	
	return Shield;
}

var ShoppingBag01 = {};

var hasRequiredShoppingBag01;

function requireShoppingBag01 () {
	if (hasRequiredShoppingBag01) return ShoppingBag01;
	hasRequiredShoppingBag01 = 1;
	Object.defineProperty(ShoppingBag01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgShoppingBag01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M7.36 3.52 5.28 6.293c-.412.55-.618.824-.613 1.054.004.2.098.388.255.511C5.103 8 5.447 8 6.133 8h19.734c.686 0 1.03 0 1.21-.142a.67.67 0 0 0 .256-.51c.005-.23-.201-.505-.613-1.055L24.64 3.52m-17.28 0c.235-.313.352-.47.5-.582.132-.1.282-.175.44-.22.18-.051.376-.051.767-.051h13.866c.392 0 .587 0 .767.05q.24.07.44.22c.148.114.265.27.5.583m-17.28 0L4.853 6.862c-.316.422-.475.633-.587.866q-.15.31-.216.65C4 8.63 4 8.893 4 9.421v15.645c0 1.493 0 2.24.29 2.81.256.502.664.91 1.166 1.166.57.29 1.317.29 2.81.29h15.467c1.494 0 2.24 0 2.811-.29.502-.256.91-.664 1.165-1.166.291-.57.291-1.317.291-2.81V9.422c0-.528 0-.791-.05-1.045a2.7 2.7 0 0 0-.216-.65c-.112-.232-.27-.443-.587-.865L24.64 3.52m-3.307 9.813a5.333 5.333 0 1 1-10.666 0" }))); };
	ShoppingBag01.default = SvgShoppingBag01;
	
	return ShoppingBag01;
}

var ShoppingBag02 = {};

var hasRequiredShoppingBag02;

function requireShoppingBag02 () {
	if (hasRequiredShoppingBag02) return ShoppingBag02;
	hasRequiredShoppingBag02 = 1;
	Object.defineProperty(ShoppingBag02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgShoppingBag02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M21.333 10.667a5.333 5.333 0 1 1-10.667 0m-5.822-.799-.934 11.2c-.2 2.406-.3 3.61.106 4.537a4 4 0 0 0 1.76 1.913c.89.482 2.098.482 4.512.482h11.423c2.414 0 3.621 0 4.512-.482a4 4 0 0 0 1.76-1.913c.406-.928.306-2.13.105-4.536l-.933-11.2c-.172-2.07-.259-3.106-.717-3.89a4 4 0 0 0-1.726-1.587C23.893 4 22.855 4 20.777 4h-9.555c-2.078 0-3.116 0-3.935.392A4 4 0 0 0 5.56 5.98c-.459.783-.545 1.818-.717 3.888" }))); };
	ShoppingBag02.default = SvgShoppingBag02;
	
	return ShoppingBag02;
}

var ShoppingCart01 = {};

var hasRequiredShoppingCart01;

function requireShoppingCart01 () {
	if (hasRequiredShoppingCart01) return ShoppingCart01;
	hasRequiredShoppingCart01 = 1;
	Object.defineProperty(ShoppingCart01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgShoppingCart01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M2.667 2.667h1.741c.328 0 .492 0 .624.06a.67.67 0 0 1 .284.246c.079.122.102.285.148.61L6.095 8m0 0 1.403 10.308c.178 1.309.267 1.963.58 2.455.275.434.67.779 1.137.993.53.244 1.19.244 2.51.244h11.411c1.257 0 1.885 0 2.399-.226.452-.2.84-.52 1.121-.928.319-.463.436-1.08.671-2.314l1.765-9.266c.083-.434.124-.652.064-.821a.67.67 0 0 0-.293-.354C28.708 8 28.487 8 28.044 8zm7.238 20a1.333 1.333 0 1 1-2.666 0 1.333 1.333 0 0 1 2.666 0M24 28a1.333 1.333 0 1 1-2.667 0A1.333 1.333 0 0 1 24 28" }))); };
	ShoppingCart01.default = SvgShoppingCart01;
	
	return ShoppingCart01;
}

var ShoppingCart02 = {};

var hasRequiredShoppingCart02;

function requireShoppingCart02 () {
	if (hasRequiredShoppingCart02) return ShoppingCart02;
	hasRequiredShoppingCart02 = 1;
	Object.defineProperty(ShoppingCart02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgShoppingCart02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M6.667 18.667H24.18c1.35 0 2.026 0 2.563-.252a2.67 2.67 0 0 0 1.144-1.024c.31-.507.385-1.178.534-2.52l.78-7.02c.045-.41.068-.615.002-.773a.67.67 0 0 0-.293-.328c-.15-.083-.357-.083-.77-.083H6.002m-3.334-4H4.33c.353 0 .53 0 .668.067.121.059.222.153.288.271.076.134.087.31.109.662L6.604 23c.022.352.033.528.109.662a.67.67 0 0 0 .289.27c.138.068.314.068.667.068h17.664M10 28.667h.013m11.987 0h.013m-11.346 0a.667.667 0 1 1-1.334 0 .667.667 0 0 1 1.334 0m12 0a.667.667 0 1 1-1.334 0 .667.667 0 0 1 1.334 0" }))); };
	ShoppingCart02.default = SvgShoppingCart02;
	
	return ShoppingCart02;
}

var Smartphone = {};

var hasRequiredSmartphone;

function requireSmartphone () {
	if (hasRequiredSmartphone) return Smartphone;
	hasRequiredSmartphone = 1;
	Object.defineProperty(Smartphone, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgSmartphone = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M16 23.333h.013m-5.08 6h10.134c1.493 0 2.24 0 2.81-.29.502-.256.91-.664 1.166-1.166.29-.57.29-1.317.29-2.81V6.933c0-1.493 0-2.24-.29-2.81a2.67 2.67 0 0 0-1.166-1.166c-.57-.29-1.317-.29-2.81-.29H10.933c-1.493 0-2.24 0-2.81.29-.502.256-.91.664-1.166 1.166-.29.57-.29 1.317-.29 2.81v18.134c0 1.493 0 2.24.29 2.81.256.502.664.91 1.166 1.166.57.29 1.317.29 2.81.29m5.733-6a.667.667 0 1 1-1.333 0 .667.667 0 0 1 1.333 0" }))); };
	Smartphone.default = SvgSmartphone;
	
	return Smartphone;
}

var SortHorizontal = {};

var hasRequiredSortHorizontal;

function requireSortHorizontal () {
	if (hasRequiredSortHorizontal) return SortHorizontal;
	hasRequiredSortHorizontal = 1;
	Object.defineProperty(SortHorizontal, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgSortHorizontal = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M12 9.334 5.333 16 12 22.667m8-13.333L26.667 16 20 22.667" }))); };
	SortHorizontal.default = SvgSortHorizontal;
	
	return SortHorizontal;
}

var SortList = {};

var hasRequiredSortList;

function requireSortList () {
	if (hasRequiredSortList) return SortList;
	hasRequiredSortList = 1;
	Object.defineProperty(SortList, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgSortList = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M28 13.334H17.334M28 8H17.334M28 18.667H17.334M28 24H17.334M8 26.667V5.334m0 21.333-4-4m4 4 4-4M8 5.334l-4 4m4-4 4 4" }))); };
	SortList.default = SvgSortList;
	
	return SortList;
}

var SortVertical = {};

var hasRequiredSortVertical;

function requireSortVertical () {
	if (hasRequiredSortVertical) return SortVertical;
	hasRequiredSortVertical = 1;
	Object.defineProperty(SortVertical, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgSortVertical = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M9.333 20 16 26.667 22.667 20M9.333 12 16 5.334 22.667 12" }))); };
	SortVertical.default = SvgSortVertical;
	
	return SortVertical;
}

var Squares01 = {};

var hasRequiredSquares01;

function requireSquares01 () {
	if (hasRequiredSquares01) return Squares01;
	hasRequiredSquares01 = 1;
	Object.defineProperty(Squares01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgSquares01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M2.667 6.933c0-1.493 0-2.24.29-2.81.256-.502.664-.91 1.166-1.166.57-.29 1.317-.29 2.81-.29h10.134c1.493 0 2.24 0 2.81.29.502.256.91.664 1.166 1.166.29.57.29 1.317.29 2.81v10.134c0 1.493 0 2.24-.29 2.81-.256.502-.664.91-1.166 1.166-.57.29-1.317.29-2.81.29H6.933c-1.493 0-2.24 0-2.81-.29a2.67 2.67 0 0 1-1.166-1.166c-.29-.57-.29-1.317-.29-2.81z" }),
	    React.createElement("path", { d: "M10.667 14.933c0-1.493 0-2.24.29-2.81.256-.502.664-.91 1.166-1.166.57-.29 1.317-.29 2.81-.29h10.134c1.493 0 2.24 0 2.81.29.502.256.91.664 1.166 1.166.29.57.29 1.317.29 2.81v10.134c0 1.493 0 2.24-.29 2.81-.256.502-.664.91-1.166 1.166-.57.29-1.317.29-2.81.29H14.933c-1.493 0-2.24 0-2.81-.29a2.67 2.67 0 0 1-1.166-1.166c-.29-.57-.29-1.317-.29-2.81z" }))); };
	Squares01.default = SvgSquares01;
	
	return Squares01;
}

var Squares02 = {};

var hasRequiredSquares02;

function requireSquares02 () {
	if (hasRequiredSquares02) return Squares02;
	hasRequiredSquares02 = 1;
	Object.defineProperty(Squares02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgSquares02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M11.2 4H6.133c-.746 0-1.12 0-1.405.145-.25.128-.455.332-.583.583C4 5.013 4 5.387 4 6.133V11.2c0 .747 0 1.12.145 1.405.128.251.332.455.583.583.285.145.659.145 1.405.145H11.2c.747 0 1.12 0 1.405-.145.251-.128.455-.332.583-.583.145-.285.145-.658.145-1.405V6.133c0-.746 0-1.12-.145-1.405a1.33 1.33 0 0 0-.583-.583C12.32 4 11.947 4 11.2 4M25.867 4H20.8c-.747 0-1.12 0-1.405.145-.251.128-.455.332-.583.583-.145.285-.145.659-.145 1.405V11.2c0 .747 0 1.12.145 1.405.128.251.332.455.583.583.285.145.658.145 1.405.145h5.067c.746 0 1.12 0 1.405-.145.25-.128.455-.332.583-.583C28 12.32 28 11.947 28 11.2V6.133c0-.746 0-1.12-.145-1.405a1.33 1.33 0 0 0-.583-.583C26.987 4 26.613 4 25.867 4M25.867 18.667H20.8c-.747 0-1.12 0-1.405.145-.251.128-.455.332-.583.583-.145.285-.145.658-.145 1.405v5.067c0 .746 0 1.12.145 1.405.128.25.332.455.583.583.285.145.658.145 1.405.145h5.067c.746 0 1.12 0 1.405-.145.25-.128.455-.332.583-.583.145-.285.145-.659.145-1.405V20.8c0-.747 0-1.12-.145-1.405a1.33 1.33 0 0 0-.583-.583c-.285-.145-.659-.145-1.405-.145M11.2 18.667H6.133c-.746 0-1.12 0-1.405.145-.25.128-.455.332-.583.583C4 19.68 4 20.053 4 20.8v5.067c0 .746 0 1.12.145 1.405.128.25.332.455.583.583.285.145.659.145 1.405.145H11.2c.747 0 1.12 0 1.405-.145.251-.128.455-.332.583-.583.145-.285.145-.659.145-1.405V20.8c0-.747 0-1.12-.145-1.405a1.33 1.33 0 0 0-.583-.583c-.285-.145-.658-.145-1.405-.145" }))); };
	Squares02.default = SvgSquares02;
	
	return Squares02;
}

var Store = {};

var hasRequiredStore;

function requireStore () {
	if (hasRequiredStore) return Store;
	hasRequiredStore = 1;
	Object.defineProperty(Store, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgStore = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M20 28v-7.2c0-.747 0-1.12-.145-1.405a1.33 1.33 0 0 0-.583-.583c-.285-.145-.659-.145-1.405-.145h-3.734c-.746 0-1.12 0-1.405.145-.251.128-.455.332-.583.583C12 19.68 12 20.053 12 20.8V28M4 9.333a4 4 0 1 0 8 0 4 4 0 1 0 8 0 4 4 0 1 0 8 0M8.267 28h15.466c1.494 0 2.24 0 2.81-.29.503-.256.91-.664 1.166-1.166.29-.57.29-1.317.29-2.81V8.266c0-1.494 0-2.24-.29-2.811a2.67 2.67 0 0 0-1.165-1.165C25.974 4 25.227 4 23.734 4H8.266c-1.494 0-2.24 0-2.811.29-.502.256-.91.664-1.165 1.166C4 6.026 4 6.773 4 8.266v15.467c0 1.494 0 2.24.29 2.811.256.502.664.91 1.166 1.165.57.291 1.317.291 2.81.291" }))); };
	Store.default = SvgStore;
	
	return Store;
}

var SwitchHorizontal01 = {};

var hasRequiredSwitchHorizontal01;

function requireSwitchHorizontal01 () {
	if (hasRequiredSwitchHorizontal01) return SwitchHorizontal01;
	hasRequiredSwitchHorizontal01 = 1;
	Object.defineProperty(SwitchHorizontal01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgSwitchHorizontal01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M5.333 22.667h21.334m0 0-5.334-5.334m5.334 5.334L21.333 28m5.334-18.667H5.333m0 0L10.667 4M5.333 9.333l5.334 5.334" }))); };
	SwitchHorizontal01.default = SvgSwitchHorizontal01;
	
	return SwitchHorizontal01;
}

var SwitchHorizontal02 = {};

var hasRequiredSwitchHorizontal02;

function requireSwitchHorizontal02 () {
	if (hasRequiredSwitchHorizontal02) return SwitchHorizontal02;
	hasRequiredSwitchHorizontal02 = 1;
	Object.defineProperty(SwitchHorizontal02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgSwitchHorizontal02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M26.667 22.667H5.333m0 0 5.334-5.334m-5.334 5.334L10.667 28M5.333 9.333h21.334m0 0L21.333 4m5.334 5.333-5.334 5.334" }))); };
	SwitchHorizontal02.default = SvgSwitchHorizontal02;
	
	return SwitchHorizontal02;
}

var SwitchVertical01 = {};

var hasRequiredSwitchVertical01;

function requireSwitchVertical01 () {
	if (hasRequiredSwitchVertical01) return SwitchVertical01;
	hasRequiredSwitchVertical01 = 1;
	Object.defineProperty(SwitchVertical01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgSwitchVertical01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M22.667 5.334v21.333m0 0-5.334-5.334m5.334 5.334L28 21.333M9.333 26.668V5.334m0 0L4 10.667m5.333-5.333 5.334 5.333" }))); };
	SwitchVertical01.default = SvgSwitchVertical01;
	
	return SwitchVertical01;
}

var SwitchVertical02 = {};

var hasRequiredSwitchVertical02;

function requireSwitchVertical02 () {
	if (hasRequiredSwitchVertical02) return SwitchVertical02;
	hasRequiredSwitchVertical02 = 1;
	Object.defineProperty(SwitchVertical02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgSwitchVertical02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M9.333 5.334v21.333m0 0L4 21.333m5.333 5.334 5.334-5.334m8 5.334V5.334m0 0-5.334 5.333m5.334-5.333L28 10.667" }))); };
	SwitchVertical02.default = SvgSwitchVertical02;
	
	return SwitchVertical02;
}

var Sync01 = {};

var hasRequiredSync01;

function requireSync01 () {
	if (hasRequiredSync01) return Sync01;
	hasRequiredSync01 = 1;
	Object.defineProperty(Sync01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgSync01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M11.396 26.357a11.32 11.32 0 0 0 10.27-.542c5.421-3.13 7.279-10.06 4.15-15.482l-.334-.577M6.185 21.666c-3.13-5.42-1.273-12.351 4.148-15.48a11.32 11.32 0 0 1 10.271-.542M3.324 21.779l3.643.976.976-3.643m16.114-6.224.976-3.643 3.643.976" }))); };
	Sync01.default = SvgSync01;
	
	return Sync01;
}

var Sync02 = {};

var hasRequiredSync02;

function requireSync02 () {
	if (hasRequiredSync02) return Sync02;
	hasRequiredSync02 = 1;
	Object.defineProperty(Sync02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgSync02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M27.27 17.19a11.32 11.32 0 0 1-5.604 8.625c-5.42 3.13-12.352 1.273-15.482-4.148l-.333-.577m-1.123-6.28c.37-3.48 2.342-6.741 5.605-8.625 5.42-3.13 12.352-1.273 15.482 4.148l.333.578M4.658 24.088l.976-3.643 3.642.976M22.723 10.58l3.643.976.976-3.643" }))); };
	Sync02.default = SvgSync02;
	
	return Sync02;
}

var Table = {};

var hasRequiredTable;

function requireTable () {
	if (hasRequiredTable) return Table;
	hasRequiredTable = 1;
	Object.defineProperty(Table, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgTable = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M4 12h24M12 4v24M10.4 4h11.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C28 7.04 28 8.16 28 10.4v11.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C24.96 28 23.84 28 21.6 28H10.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C4 24.96 4 23.84 4 21.6V10.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C7.04 4 8.16 4 10.4 4" }))); };
	Table.default = SvgTable;
	
	return Table;
}

var Tablet = {};

var hasRequiredTablet;

function requireTablet () {
	if (hasRequiredTablet) return Tablet;
	hasRequiredTablet = 1;
	Object.defineProperty(Tablet, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgTablet = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M20 2.667v1.866c0 .747 0 1.12-.145 1.406-.128.25-.332.455-.583.582-.285.146-.659.146-1.405.146h-3.734c-.746 0-1.12 0-1.405-.146a1.33 1.33 0 0 1-.583-.582C12 5.654 12 5.28 12 4.533V2.667M9.6 29.333h12.8c1.493 0 2.24 0 2.81-.29.502-.256.91-.664 1.166-1.166.29-.57.29-1.317.29-2.81V6.933c0-1.493 0-2.24-.29-2.81a2.67 2.67 0 0 0-1.165-1.166c-.57-.29-1.318-.29-2.811-.29H9.6c-1.494 0-2.24 0-2.81.29-.502.256-.91.664-1.166 1.166-.29.57-.29 1.317-.29 2.81v18.134c0 1.493 0 2.24.29 2.81.256.502.664.91 1.165 1.166.57.29 1.317.29 2.81.29" }))); };
	Tablet.default = SvgTablet;
	
	return Tablet;
}

var TagGroup = {};

var hasRequiredTagGroup;

function requireTagGroup () {
	if (hasRequiredTagGroup) return TagGroup;
	hasRequiredTagGroup = 1;
	Object.defineProperty(TagGroup, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgTagGroup = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M28 14.667 17.875 4.54c-.692-.692-1.038-1.038-1.442-1.285a4 4 0 0 0-1.156-.479c-.46-.11-.95-.11-1.928-.11H8M4 11.6v2.633c0 .652 0 .978.074 1.285.065.272.173.532.319.77.165.27.395.5.857.962l10.4 10.4c1.056 1.056 1.584 1.584 2.193 1.782a2.67 2.67 0 0 0 1.648 0c.609-.198 1.137-.726 2.193-1.782l3.299-3.3c1.056-1.056 1.584-1.584 1.782-2.193a2.67 2.67 0 0 0 0-1.648c-.198-.609-.726-1.137-1.782-2.193L15.25 8.583c-.461-.461-.692-.692-.961-.857a2.7 2.7 0 0 0-.771-.319c-.307-.074-.633-.074-1.285-.074H8.267c-1.494 0-2.24 0-2.811.29-.502.257-.91.665-1.165 1.166C4 9.36 4 10.107 4 11.6" }))); };
	TagGroup.default = SvgTagGroup;
	
	return TagGroup;
}

var Tag$1 = {};

var hasRequiredTag;

function requireTag () {
	if (hasRequiredTag) return Tag$1;
	hasRequiredTag = 1;
	Object.defineProperty(Tag$1, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgTag = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M10.667 10.667h.013M2.667 6.933V12.9c0 .653 0 .979.073 1.286.066.272.173.532.32.77.165.27.395.5.856.961l10.225 10.225c1.584 1.584 2.376 2.376 3.29 2.673a4 4 0 0 0 2.472 0c.913-.297 1.705-1.089 3.29-2.673l2.948-2.949c1.584-1.584 2.376-2.376 2.673-3.29a4 4 0 0 0 0-2.471c-.297-.914-1.089-1.706-2.673-3.29L15.916 3.916c-.46-.46-.691-.691-.96-.856a2.7 2.7 0 0 0-.771-.32c-.307-.073-.633-.073-1.286-.073H6.933c-1.493 0-2.24 0-2.81.29-.502.256-.91.664-1.166 1.166-.29.57-.29 1.317-.29 2.81m8.666 3.734a.667.667 0 1 1-1.333 0 .667.667 0 0 1 1.333 0" }))); };
	Tag$1.default = SvgTag;
	
	return Tag$1;
}

var Target01 = {};

var hasRequiredTarget01;

function requireTarget01 () {
	if (hasRequiredTarget01) return Target01;
	hasRequiredTarget01 = 1;
	Object.defineProperty(Target01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgTarget01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M29.333 16H24M8 16H2.667M16 8V2.667m0 26.666V24m10.667-8c0 5.891-4.776 10.667-10.667 10.667S5.333 21.89 5.333 16 10.11 5.333 16 5.333 26.667 10.11 26.667 16" }))); };
	Target01.default = SvgTarget01;
	
	return Target01;
}

var Target02 = {};

var hasRequiredTarget02;

function requireTarget02 () {
	if (hasRequiredTarget02) return Target02;
	hasRequiredTarget02 = 1;
	Object.defineProperty(Target02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgTarget02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M29.333 16H24M8 16H2.667M16 8V2.667m0 26.666V24m10.667-8c0 5.891-4.776 10.667-10.667 10.667S5.333 21.89 5.333 16 10.11 5.333 16 5.333 26.667 10.11 26.667 16M20 16a4 4 0 1 1-8 0 4 4 0 0 1 8 0" }))); };
	Target02.default = SvgTarget02;
	
	return Target02;
}

var Target = {};

var hasRequiredTarget;

function requireTarget () {
	if (hasRequiredTarget) return Target;
	hasRequiredTarget = 1;
	Object.defineProperty(Target, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgTarget = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M21.333 10.667v-4l4-4 1.334 2.666 2.666 1.334-4 4zm0 0L16 16m13.333 0c0 7.364-5.97 13.333-13.333 13.333S2.667 23.363 2.667 16 8.637 2.667 16 2.667M22.667 16A6.667 6.667 0 1 1 16 9.333" }))); };
	Target.default = SvgTarget;
	
	return Target;
}

var ThumbsDown = {};

var hasRequiredThumbsDown;

function requireThumbsDown () {
	if (hasRequiredThumbsDown) return ThumbsDown;
	hasRequiredThumbsDown = 1;
	Object.defineProperty(ThumbsDown, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgThumbsDown = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M22.667 2.667v14.666m6.666-4.266V6.933c0-1.493 0-2.24-.29-2.81a2.67 2.67 0 0 0-1.165-1.166c-.571-.29-1.318-.29-2.811-.29H10.824c-1.948 0-2.923 0-3.71.356a4 4 0 0 0-1.699 1.458c-.472.724-.62 1.687-.916 3.613L3.8 12.627c-.39 2.54-.586 3.81-.21 4.799a4 4 0 0 0 1.761 2.051c.92.523 2.205.523 4.775.523H11.2c.747 0 1.12 0 1.406.145.25.128.454.332.582.583.146.285.146.659.146 1.405v3.913a3.29 3.29 0 0 0 3.287 3.287c.433 0 .826-.255 1.002-.65l4.48-10.083c.205-.458.306-.687.467-.856.143-.148.318-.262.511-.332.22-.079.47-.079.972-.079h1.014c1.493 0 2.24 0 2.81-.29.502-.256.91-.664 1.166-1.166.29-.57.29-1.317.29-2.81" }))); };
	ThumbsDown.default = SvgThumbsDown;
	
	return ThumbsDown;
}

var ThumbsUp = {};

var hasRequiredThumbsUp;

function requireThumbsUp () {
	if (hasRequiredThumbsUp) return ThumbsUp;
	hasRequiredThumbsUp = 1;
	Object.defineProperty(ThumbsUp, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgThumbsUp = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M9.333 29.333V14.667m-6.666 2.666v9.334a2.667 2.667 0 0 0 2.666 2.666h17.902a4 4 0 0 0 3.954-3.391l1.436-9.334A4 4 0 0 0 24.67 12h-4.67a1.333 1.333 0 0 1-1.334-1.333V5.955a3.29 3.29 0 0 0-3.288-3.288c-.433 0-.826.255-1.001.65L9.685 13.876a1.33 1.33 0 0 1-1.218.792H5.333a2.667 2.667 0 0 0-2.666 2.666" }))); };
	ThumbsUp.default = SvgThumbsUp;
	
	return ThumbsUp;
}

var Ticket01 = {};

var hasRequiredTicket01;

function requireTicket01 () {
	if (hasRequiredTicket01) return Ticket01;
	hasRequiredTicket01 = 1;
	Object.defineProperty(Ticket01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgTicket01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M13.333 10.667V9.333m0 7.334v-1.334m0 7.334v-1.334m-6.4-16h18.134c1.493 0 2.24 0 2.81.29.502.257.91.665 1.166 1.166.29.57.29 1.317.29 2.811v1.733a4.667 4.667 0 1 0 0 9.334V22.4c0 1.493 0 2.24-.29 2.81-.256.502-.664.91-1.166 1.166-.57.29-1.317.29-2.81.29H6.933c-1.493 0-2.24 0-2.81-.29a2.67 2.67 0 0 1-1.166-1.165c-.29-.57-.29-1.318-.29-2.811v-1.733a4.667 4.667 0 1 0 0-9.334V9.6c0-1.494 0-2.24.29-2.81.256-.502.664-.91 1.166-1.166.57-.29 1.317-.29 2.81-.29" }))); };
	Ticket01.default = SvgTicket01;
	
	return Ticket01;
}

var Ticket02 = {};

var hasRequiredTicket02;

function requireTicket02 () {
	if (hasRequiredTicket02) return Ticket02;
	hasRequiredTicket02 = 1;
	Object.defineProperty(Ticket02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgTicket02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M10.667 10.667V9.333m0 7.334v-1.334m0 7.334v-1.334m-1.6 5.334h13.866c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748c.436-.856.436-1.976.436-4.216v-8.534c0-2.24 0-3.36-.436-4.216A4 4 0 0 0 27.15 5.77c-.855-.436-1.975-.436-4.216-.436H9.067c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748c-.436.856-.436 1.976-.436 4.216v8.534c0 2.24 0 3.36.436 4.216A4 4 0 0 0 4.85 26.23c.855.436 1.975.436 4.216.436" }))); };
	Ticket02.default = SvgTicket02;
	
	return Ticket02;
}

var TimeBackward = {};

var hasRequiredTimeBackward;

function requireTimeBackward () {
	if (hasRequiredTimeBackward) return TimeBackward;
	hasRequiredTimeBackward = 1;
	Object.defineProperty(TimeBackward, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgTimeBackward = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M30.267 18 27.6 15.333 24.933 18M28 16c0 6.627-5.372 12-12 12-6.627 0-12-5.373-12-12S9.373 4 16 4c4.403 0 8.252 2.37 10.34 5.905M16 9.333V16l4 2.667" }))); };
	TimeBackward.default = SvgTimeBackward;
	
	return TimeBackward;
}

var TimeCheck = {};

var hasRequiredTimeCheck;

function requireTimeCheck () {
	if (hasRequiredTimeCheck) return TimeCheck;
	hasRequiredTimeCheck = 1;
	Object.defineProperty(TimeCheck, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgTimeCheck = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M19.333 25.333 22 28l6-6m1.314-5.267q.02-.364.02-.733c0-7.364-5.97-13.333-13.334-13.333S2.667 8.637 2.667 16c0 7.247 5.782 13.144 12.984 13.329M16.001 8v8l4.984 2.492" }))); };
	TimeCheck.default = SvgTimeCheck;
	
	return TimeCheck;
}

var TimeForward = {};

var hasRequiredTimeForward;

function requireTimeForward () {
	if (hasRequiredTimeForward) return TimeForward;
	hasRequiredTimeForward = 1;
	Object.defineProperty(TimeForward, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgTimeForward = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M30.267 15.333 27.6 18l-2.668-2.667m2.994 2q.072-.656.073-1.333c0-6.627-5.373-12-12-12S4 9.373 4 16s5.373 12 12 12c3.77 0 7.133-1.738 9.333-4.457M16 9.333V16l4 2.667" }))); };
	TimeForward.default = SvgTimeForward;
	
	return TimeForward;
}

var TimePlus = {};

var hasRequiredTimePlus;

function requireTimePlus () {
	if (hasRequiredTimePlus) return TimePlus;
	hasRequiredTimePlus = 1;
	Object.defineProperty(TimePlus, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgTimePlus = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M29.228 17.687q.105-.83.105-1.687c0-7.364-5.97-13.333-13.333-13.333S2.667 8.637 2.667 16 8.637 29.333 16 29.333q.87 0 1.713-.109M16 8v8l4.985 2.492m4.348 10.841v-8m-4 4h8" }))); };
	TimePlus.default = SvgTimePlus;
	
	return TimePlus;
}

var TimeRefresh = {};

var hasRequiredTimeRefresh;

function requireTimeRefresh () {
	if (hasRequiredTimeRefresh) return TimeRefresh;
	hasRequiredTimeRefresh = 1;
	Object.defineProperty(TimeRefresh, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgTimeRefresh = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M27.27 17.19a11.32 11.32 0 0 1-5.604 8.625c-5.42 3.13-12.352 1.272-15.481-4.148l-.334-.578m-1.123-6.28c.37-3.48 2.342-6.74 5.605-8.624 5.42-3.13 12.352-1.272 15.481 4.148l.334.578M4.658 24.088l.976-3.643 3.642.976M22.723 10.58l3.643.976.976-3.643M16 10v6l3.333 2" }))); };
	TimeRefresh.default = SvgTimeRefresh;
	
	return TimeRefresh;
}

var TimeSleep = {};

var hasRequiredTimeSleep;

function requireTimeSleep () {
	if (hasRequiredTimeSleep) return TimeSleep;
	hasRequiredTimeSleep = 1;
	Object.defineProperty(TimeSleep, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgTimeSleep = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M22 22.667h6.667L22 29.333h6.667m.6-12q.066-.657.066-1.333c0-7.364-5.97-13.333-13.333-13.333S2.667 8.637 2.667 16 8.637 29.333 16 29.333a14 14 0 0 0 1.333-.066M16 8v8l4.985 2.492" }))); };
	TimeSleep.default = SvgTimeSleep;
	
	return TimeSleep;
}

var Time = {};

var hasRequiredTime;

function requireTime () {
	if (hasRequiredTime) return Time;
	hasRequiredTime = 1;
	Object.defineProperty(Time, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgTime = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M16 8v8l5.333 2.667m8-2.667c0 7.364-5.97 13.333-13.333 13.333S2.667 23.363 2.667 16 8.636 2.667 16 2.667 29.333 8.637 29.333 16" }))); };
	Time.default = SvgTime;
	
	return Time;
}

var Trophy = {};

var hasRequiredTrophy;

function requireTrophy () {
	if (hasRequiredTrophy) return Trophy;
	hasRequiredTrophy = 1;
	Object.defineProperty(Trophy, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgTrophy = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M16 20a8 8 0 0 1-8-8V4.593c0-.552 0-.828.08-1.049.135-.37.427-.662.797-.797.221-.08.497-.08 1.049-.08h12.148c.552 0 .828 0 1.049.08.37.135.662.427.796.797.081.221.081.497.081 1.049V12a8 8 0 0 1-8 8m0 0v4m8-18.667h3.333c.622 0 .932 0 1.177.102.327.135.586.395.722.722.101.245.101.555.101 1.176V8c0 1.24 0 1.86-.136 2.369a4 4 0 0 1-2.828 2.828c-.51.136-1.13.136-2.369.136m-16-8H4.667c-.622 0-.932 0-1.177.102a1.33 1.33 0 0 0-.722.722c-.101.245-.101.555-.101 1.176V8c0 1.24 0 1.86.136 2.369a4 4 0 0 0 2.828 2.828c.509.136 1.129.136 2.369.136m1.926 16h12.148a.593.593 0 0 0 .593-.592A4.74 4.74 0 0 0 17.926 24h-3.852a4.74 4.74 0 0 0-4.74 4.74c0 .327.265.592.592.592" }))); };
	Trophy.default = SvgTrophy;
	
	return Trophy;
}

var Truck = {};

var hasRequiredTruck;

function requireTruck () {
	if (hasRequiredTruck) return Truck;
	hasRequiredTruck = 1;
	Object.defineProperty(Truck, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgTruck = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M12.376 21.667A3.33 3.33 0 0 1 9.051 25a3.33 3.33 0 0 1-3.325-3.333m6.65 0a3.33 3.33 0 0 0-3.325-3.334 3.33 3.33 0 0 0-3.325 3.334m6.65 0h7.914c.367 0 .665-.966.665-1.334v-4.666m-15.229 6H3.665A.666.666 0 0 1 3 21l.066-13.333c0-.369.298-.667.665-.667h16.56c.366 0 .664.298.664.667V11m0 0h4.416c.194 0 .378.085.505.233l3.79 4.434M20.957 11v4.667m8.71 0v4.666a.666.666 0 0 1-.664.667H26.65m3.016-5.333h-8.712m5.985 6.666A2.663 2.663 0 0 1 24.28 25a2.663 2.663 0 0 1-2.66-2.667 2.663 2.663 0 0 1 2.66-2.666c1.47 0 2.66 1.194 2.66 2.666" }))); };
	Truck.default = SvgTruck;
	
	return Truck;
}

var UserCheck = {};

var hasRequiredUserCheck;

function requireUserCheck () {
	if (hasRequiredUserCheck) return UserCheck;
	hasRequiredUserCheck = 1;
	Object.defineProperty(UserCheck, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgUserCheck = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M16 20.667h-6c-1.86 0-2.791 0-3.548.23a5.33 5.33 0 0 0-3.556 3.555c-.23.757-.23 1.687-.23 3.548m18.667-4L24 26.667l5.333-5.334M19.333 10a6 6 0 1 1-12 0 6 6 0 0 1 12 0" }))); };
	UserCheck.default = SvgUserCheck;
	
	return UserCheck;
}

var UserDown = {};

var hasRequiredUserDown;

function requireUserDown () {
	if (hasRequiredUserDown) return UserDown;
	hasRequiredUserDown = 1;
	Object.defineProperty(UserDown, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgUserDown = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M16 20.667h-6c-1.86 0-2.791 0-3.548.23a5.33 5.33 0 0 0-3.556 3.555c-.23.757-.23 1.687-.23 3.548m18.667-4 4 4m0 0 4-4m-4 4v-8m-6-10a6 6 0 1 1-12 0 6 6 0 0 1 12 0" }))); };
	UserDown.default = SvgUserDown;
	
	return UserDown;
}

var UserEdit = {};

var hasRequiredUserEdit;

function requireUserEdit () {
	if (hasRequiredUserEdit) return UserEdit;
	hasRequiredUserEdit = 1;
	Object.defineProperty(UserEdit, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgUserEdit = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M12 20.667h-2c-1.86 0-2.791 0-3.548.23a5.33 5.33 0 0 0-3.556 3.555c-.23.757-.23 1.687-.23 3.548m16.667-18a6 6 0 1 1-12 0 6 6 0 0 1 12 0m-4.666 18 4.135-1.181c.198-.057.297-.085.389-.128q.123-.056.233-.137c.082-.06.154-.133.3-.278l8.61-8.61A2.357 2.357 0 0 0 25 14.334l-8.61 8.61c-.145.145-.218.218-.278.3q-.08.109-.137.233c-.042.092-.07.19-.127.389z" }))); };
	UserEdit.default = SvgUserEdit;
	
	return UserEdit;
}

var UserGroupCheck = {};

var hasRequiredUserGroupCheck;

function requireUserGroupCheck () {
	if (hasRequiredUserGroupCheck) return UserGroupCheck;
	hasRequiredUserGroupCheck = 1;
	Object.defineProperty(UserGroupCheck, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgUserGroupCheck = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M21.333 24 24 26.667l5.333-5.334M16 20h-5.333c-2.485 0-3.728 0-4.708.406a5.33 5.33 0 0 0-2.886 2.886c-.406.98-.406 2.223-.406 4.708m18-23.612a5.335 5.335 0 0 1 0 9.891M18 9.333a5.333 5.333 0 1 1-10.667 0 5.333 5.333 0 0 1 10.667 0" }))); };
	UserGroupCheck.default = SvgUserGroupCheck;
	
	return UserGroupCheck;
}

var UserGroupDown = {};

var hasRequiredUserGroupDown;

function requireUserGroupDown () {
	if (hasRequiredUserGroupDown) return UserGroupDown;
	hasRequiredUserGroupDown = 1;
	Object.defineProperty(UserGroupDown, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgUserGroupDown = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m21.333 24 4 4m0 0 4-4m-4 4v-8M20.667 4.388a5.335 5.335 0 0 1 0 9.891M16 20h-5.333c-2.485 0-3.728 0-4.708.406a5.33 5.33 0 0 0-2.886 2.886c-.406.98-.406 2.223-.406 4.708M18 9.333a5.333 5.333 0 1 1-10.667 0 5.333 5.333 0 0 1 10.667 0" }))); };
	UserGroupDown.default = SvgUserGroupDown;
	
	return UserGroupDown;
}

var UserGroupEdit = {};

var hasRequiredUserGroupEdit;

function requireUserGroupEdit () {
	if (hasRequiredUserGroupEdit) return UserGroupEdit;
	hasRequiredUserGroupEdit = 1;
	Object.defineProperty(UserGroupEdit, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgUserGroupEdit = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M14.667 20h-4c-2.485 0-3.728 0-4.708.406a5.33 5.33 0 0 0-2.886 2.886c-.406.98-.406 2.223-.406 4.708m18-23.612A5.335 5.335 0 0 1 24 9.333m-8 19.334 2.7-.54c.235-.047.353-.071.463-.114q.146-.058.276-.148a3 3 0 0 0 .351-.322l8.877-8.876A1.886 1.886 0 1 0 26 16l-8.877 8.877c-.17.17-.254.254-.322.351q-.09.129-.147.276c-.043.11-.067.227-.114.463zm2-19.334a5.333 5.333 0 1 1-10.667 0 5.333 5.333 0 0 1 10.667 0" }))); };
	UserGroupEdit.default = SvgUserGroupEdit;
	
	return UserGroupEdit;
}

var UserGroupLeft = {};

var hasRequiredUserGroupLeft;

function requireUserGroupLeft () {
	if (hasRequiredUserGroupLeft) return UserGroupLeft;
	hasRequiredUserGroupLeft = 1;
	Object.defineProperty(UserGroupLeft, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgUserGroupLeft = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m25.333 28-4-4m0 0 4-4m-4 4h8M20.667 4.388a5.335 5.335 0 0 1 0 9.891M16 20h-5.333c-2.485 0-3.728 0-4.708.406a5.33 5.33 0 0 0-2.886 2.886c-.406.98-.406 2.223-.406 4.708M18 9.333a5.333 5.333 0 1 1-10.667 0 5.333 5.333 0 0 1 10.667 0" }))); };
	UserGroupLeft.default = SvgUserGroupLeft;
	
	return UserGroupLeft;
}

var UserGroupMinus = {};

var hasRequiredUserGroupMinus;

function requireUserGroupMinus () {
	if (hasRequiredUserGroupMinus) return UserGroupMinus;
	hasRequiredUserGroupMinus = 1;
	Object.defineProperty(UserGroupMinus, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgUserGroupMinus = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M21.333 24h8M20.667 4.388a5.335 5.335 0 0 1 0 9.891M16 20h-5.333c-2.485 0-3.728 0-4.708.406a5.33 5.33 0 0 0-2.886 2.886c-.406.98-.406 2.223-.406 4.708M18 9.333a5.333 5.333 0 1 1-10.667 0 5.333 5.333 0 0 1 10.667 0" }))); };
	UserGroupMinus.default = SvgUserGroupMinus;
	
	return UserGroupMinus;
}

var UserGroupPlus = {};

var hasRequiredUserGroupPlus;

function requireUserGroupPlus () {
	if (hasRequiredUserGroupPlus) return UserGroupPlus;
	hasRequiredUserGroupPlus = 1;
	Object.defineProperty(UserGroupPlus, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgUserGroupPlus = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M25.333 28v-8m-4 4h8M16 20h-5.333c-2.485 0-3.728 0-4.708.406a5.33 5.33 0 0 0-2.886 2.886c-.406.98-.406 2.223-.406 4.708m18-23.612a5.335 5.335 0 0 1 0 9.891M18 9.333a5.333 5.333 0 1 1-10.667 0 5.333 5.333 0 0 1 10.667 0" }))); };
	UserGroupPlus.default = SvgUserGroupPlus;
	
	return UserGroupPlus;
}

var UserGroupRemove = {};

var hasRequiredUserGroupRemove;

function requireUserGroupRemove () {
	if (hasRequiredUserGroupRemove) return UserGroupRemove;
	hasRequiredUserGroupRemove = 1;
	Object.defineProperty(UserGroupRemove, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgUserGroupRemove = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M22 21.333 28.667 28m0-6.667L22 28M20.667 4.388a5.335 5.335 0 0 1 0 9.891M16 20h-5.333c-2.485 0-3.728 0-4.708.406a5.33 5.33 0 0 0-2.886 2.886c-.406.98-.406 2.223-.406 4.708M18 9.333a5.333 5.333 0 1 1-10.667 0 5.333 5.333 0 0 1 10.667 0" }))); };
	UserGroupRemove.default = SvgUserGroupRemove;
	
	return UserGroupRemove;
}

var UserGroupRight = {};

var hasRequiredUserGroupRight;

function requireUserGroupRight () {
	if (hasRequiredUserGroupRight) return UserGroupRight;
	hasRequiredUserGroupRight = 1;
	Object.defineProperty(UserGroupRight, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgUserGroupRight = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m25.333 28 4-4m0 0-4-4m4 4h-8m-.666-19.612a5.335 5.335 0 0 1 0 9.891M16 20h-5.333c-2.485 0-3.728 0-4.708.406a5.33 5.33 0 0 0-2.886 2.886c-.406.98-.406 2.223-.406 4.708M18 9.333a5.333 5.333 0 1 1-10.667 0 5.333 5.333 0 0 1 10.667 0" }))); };
	UserGroupRight.default = SvgUserGroupRight;
	
	return UserGroupRight;
}

var UserGroupUp = {};

var hasRequiredUserGroupUp;

function requireUserGroupUp () {
	if (hasRequiredUserGroupUp) return UserGroupUp;
	hasRequiredUserGroupUp = 1;
	Object.defineProperty(UserGroupUp, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgUserGroupUp = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m21.333 24 4-4m0 0 4 4m-4-4v8M20.667 4.388a5.335 5.335 0 0 1 0 9.891M16 20h-5.333c-2.485 0-3.728 0-4.708.406a5.33 5.33 0 0 0-2.886 2.886c-.406.98-.406 2.223-.406 4.708M18 9.333a5.333 5.333 0 1 1-10.667 0 5.333 5.333 0 0 1 10.667 0" }))); };
	UserGroupUp.default = SvgUserGroupUp;
	
	return UserGroupUp;
}

var UserGroup = {};

var hasRequiredUserGroup;

function requireUserGroup () {
	if (hasRequiredUserGroup) return UserGroup;
	hasRequiredUserGroup = 1;
	Object.defineProperty(UserGroup, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgUserGroup = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M29.333 28v-2.667c0-2.485-1.7-4.573-4-5.165m-4.666-15.78a5.335 5.335 0 0 1 0 9.891m2 13.721c0-2.485 0-3.727-.406-4.708a5.33 5.33 0 0 0-2.887-2.886C18.394 20 17.152 20 14.667 20h-4c-2.485 0-3.728 0-4.708.406a5.33 5.33 0 0 0-2.886 2.886c-.406.98-.406 2.223-.406 4.708M18 9.333a5.333 5.333 0 1 1-10.667 0 5.333 5.333 0 0 1 10.667 0" }))); };
	UserGroup.default = SvgUserGroup;
	
	return UserGroup;
}

var UserLeft = {};

var hasRequiredUserLeft;

function requireUserLeft () {
	if (hasRequiredUserLeft) return UserLeft;
	hasRequiredUserLeft = 1;
	Object.defineProperty(UserLeft, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgUserLeft = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m25.333 28-4-4m0 0 4-4m-4 4h8M16 20.667h-6c-1.86 0-2.791 0-3.548.23a5.33 5.33 0 0 0-3.556 3.555c-.23.757-.23 1.687-.23 3.548m16.667-18a6 6 0 1 1-12 0 6 6 0 0 1 12 0" }))); };
	UserLeft.default = SvgUserLeft;
	
	return UserLeft;
}

var UserMinus = {};

var hasRequiredUserMinus;

function requireUserMinus () {
	if (hasRequiredUserMinus) return UserMinus;
	hasRequiredUserMinus = 1;
	Object.defineProperty(UserMinus, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgUserMinus = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M21.333 24h8M16 20.667h-6c-1.86 0-2.791 0-3.548.23a5.33 5.33 0 0 0-3.556 3.555c-.23.757-.23 1.687-.23 3.548m16.667-18a6 6 0 1 1-12 0 6 6 0 0 1 12 0" }))); };
	UserMinus.default = SvgUserMinus;
	
	return UserMinus;
}

var UserPlus = {};

var hasRequiredUserPlus;

function requireUserPlus () {
	if (hasRequiredUserPlus) return UserPlus;
	hasRequiredUserPlus = 1;
	Object.defineProperty(UserPlus, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgUserPlus = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M16 20.667h-6c-1.86 0-2.791 0-3.548.23a5.33 5.33 0 0 0-3.556 3.555c-.23.757-.23 1.687-.23 3.548m22.667 0v-8m-4 4h8m-10-14a6 6 0 1 1-12 0 6 6 0 0 1 12 0" }))); };
	UserPlus.default = SvgUserPlus;
	
	return UserPlus;
}

var UserRemove = {};

var hasRequiredUserRemove;

function requireUserRemove () {
	if (hasRequiredUserRemove) return UserRemove;
	hasRequiredUserRemove = 1;
	Object.defineProperty(UserRemove, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgUserRemove = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M22 21.333 28.667 28m0-6.667L22 28m-6-7.333h-6c-1.86 0-2.791 0-3.548.23a5.33 5.33 0 0 0-3.556 3.555c-.23.757-.23 1.687-.23 3.548m16.667-18a6 6 0 1 1-12 0 6 6 0 0 1 12 0" }))); };
	UserRemove.default = SvgUserRemove;
	
	return UserRemove;
}

var UserRight = {};

var hasRequiredUserRight;

function requireUserRight () {
	if (hasRequiredUserRight) return UserRight;
	hasRequiredUserRight = 1;
	Object.defineProperty(UserRight, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgUserRight = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m25.333 28 4-4m0 0-4-4m4 4h-8M16 20.667h-6c-1.86 0-2.791 0-3.548.23a5.33 5.33 0 0 0-3.556 3.555c-.23.757-.23 1.687-.23 3.548m16.667-18a6 6 0 1 1-12 0 6 6 0 0 1 12 0" }))); };
	UserRight.default = SvgUserRight;
	
	return UserRight;
}

var UserUp = {};

var hasRequiredUserUp;

function requireUserUp () {
	if (hasRequiredUserUp) return UserUp;
	hasRequiredUserUp = 1;
	Object.defineProperty(UserUp, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgUserUp = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m21.333 24 4-4m0 0 4 4m-4-4v8M16 20.667h-6c-1.86 0-2.791 0-3.548.23a5.33 5.33 0 0 0-3.556 3.555c-.23.757-.23 1.687-.23 3.548m16.667-18a6 6 0 1 1-12 0 6 6 0 0 1 12 0" }))); };
	UserUp.default = SvgUserUp;
	
	return UserUp;
}

var User = {};

var hasRequiredUser;

function requireUser () {
	if (hasRequiredUser) return User;
	hasRequiredUser = 1;
	Object.defineProperty(User, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgUser = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M26.667 28c0-1.86 0-2.791-.23-3.548a5.33 5.33 0 0 0-3.555-3.556c-.757-.23-1.688-.23-3.549-.23h-6.666c-1.86 0-2.791 0-3.548.23a5.33 5.33 0 0 0-3.556 3.556c-.23.757-.23 1.687-.23 3.548M22 10a6 6 0 1 1-12 0 6 6 0 0 1 12 0" }))); };
	User.default = SvgUser;
	
	return User;
}

var Vacations = {};

var hasRequiredVacations;

function requireVacations () {
	if (hasRequiredVacations) return Vacations;
	hasRequiredVacations = 1;
	Object.defineProperty(Vacations, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgVacations = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M8.333 29.279 16 15.999m6.667-11.546C16.916 1.133 9.719 2.583 5.66 7.577c-.396.488-.594.731-.651 1.08-.046.278.022.646.164.89.178.305.494.488 1.126.853l19.4 11.2c.632.365.948.548 1.302.55.282 0 .634-.125.852-.303.274-.225.386-.518.61-1.105 2.295-6.011-.046-12.969-5.797-16.29m0 0c-2.551-1.473-7.604 2.503-11.286 8.88m11.286-8.88c2.55 1.473 1.634 7.836-2.048 14.214m8.714 10.666H2.667" }))); };
	Vacations.default = SvgVacations;
	
	return Vacations;
}

var Van = {};

var hasRequiredVan;

function requireVan () {
	if (hasRequiredVan) return Van;
	hasRequiredVan = 1;
	Object.defineProperty(Van, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgVan = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M10.667 21.333a2.667 2.667 0 1 1-5.334 0m5.334 0a2.667 2.667 0 0 0-5.334 0m5.334 0h10.666m-16 0h-2a.667.667 0 0 1-.666-.666v-12c0-.369.298-.667.666-.667h14.6m8.734 13.333a2.667 2.667 0 1 1-5.334 0m5.334 0a2.667 2.667 0 0 0-5.334 0m5.334 0h2a.667.667 0 0 0 .666-.666v-6m0 0-7.142-6.494A.67.67 0 0 0 21.742 8h-3.809m11.4 6.667h-11.4m0-6.667v6.667m0 0v6.666" }))); };
	Van.default = SvgVan;
	
	return Van;
}

var VideoRecorderOff = {};

var hasRequiredVideoRecorderOff;

function requireVideoRecorderOff () {
	if (hasRequiredVideoRecorderOff) return VideoRecorderOff;
	hasRequiredVideoRecorderOff = 1;
	Object.defineProperty(VideoRecorderOff, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgVideoRecorderOff = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M6.667 6.667a4 4 0 0 0-4 4v10.666a4 4 0 0 0 4 4h12a4 4 0 0 0 3.827-2.834M22.667 16l4.845-4.846c.572-.57.857-.856 1.102-.876.213-.017.421.07.56.232.16.187.16.59.16 1.399v8.183c0 .807 0 1.211-.16 1.398a.67.67 0 0 1-.56.232c-.245-.02-.53-.305-1.102-.876zm0 0v-2.933c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748c-.856-.436-1.976-.436-4.216-.436h-3.6m-10-4 26.666 26.666" }))); };
	VideoRecorderOff.default = SvgVideoRecorderOff;
	
	return VideoRecorderOff;
}

var VideoRecorder = {};

var hasRequiredVideoRecorder;

function requireVideoRecorder () {
	if (hasRequiredVideoRecorder) return VideoRecorder;
	hasRequiredVideoRecorder = 1;
	Object.defineProperty(VideoRecorder, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgVideoRecorder = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M29.333 11.909c0-.808 0-1.212-.16-1.4a.67.67 0 0 0-.559-.23c-.245.019-.53.304-1.102.875L22.667 16l4.845 4.846c.572.571.857.857 1.102.876.213.017.421-.07.56-.232.16-.187.16-.59.16-1.398zM2.667 13.067c0-2.24 0-3.36.436-4.216A4 4 0 0 1 4.85 7.103c.855-.436 1.975-.436 4.216-.436h7.2c2.24 0 3.36 0 4.216.436A4 4 0 0 1 22.23 8.85c.436.855.436 1.975.436 4.216v5.866c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748c-.856.436-1.976.436-4.216.436h-7.2c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748c-.436-.855-.436-1.975-.436-4.216z" }))); };
	VideoRecorder.default = SvgVideoRecorder;
	
	return VideoRecorder;
}

var WalletClosed = {};

var hasRequiredWalletClosed;

function requireWalletClosed () {
	if (hasRequiredWalletClosed) return WalletClosed;
	hasRequiredWalletClosed = 1;
	Object.defineProperty(WalletClosed, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgWalletClosed = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M22 18.667h.013M4 6.667v18.666A2.667 2.667 0 0 0 6.667 28h18.666A2.667 2.667 0 0 0 28 25.333V12a2.667 2.667 0 0 0-2.667-2.667H6.667A2.667 2.667 0 0 1 4 6.667m0 0A2.667 2.667 0 0 1 6.667 4h16m0 14.667a.667.667 0 1 1-1.334 0 .667.667 0 0 1 1.334 0" }))); };
	WalletClosed.default = SvgWalletClosed;
	
	return WalletClosed;
}

var WalletOpened = {};

var hasRequiredWalletOpened;

function requireWalletOpened () {
	if (hasRequiredWalletOpened) return WalletOpened;
	hasRequiredWalletOpened = 1;
	Object.defineProperty(WalletOpened, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgWalletOpened = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M21.333 10.667V6c0-1.11 0-1.664-.233-2.004-.204-.298-.52-.5-.876-.56-.408-.07-.911.162-1.918.627L6.479 9.523c-.898.414-1.347.621-1.676.943-.29.284-.513.63-.649 1.014C4 11.913 4 12.408 4 13.397V20m18-.667h.013M4 14.933v8.8c0 1.494 0 2.24.29 2.811.256.502.664.91 1.166 1.165.57.291 1.317.291 2.81.291h15.467c1.494 0 2.24 0 2.811-.29.502-.256.91-.664 1.165-1.166.291-.57.291-1.317.291-2.81v-8.8c0-1.494 0-2.24-.29-2.811a2.67 2.67 0 0 0-1.166-1.166c-.57-.29-1.317-.29-2.81-.29H8.266c-1.494 0-2.24 0-2.811.29-.502.256-.91.664-1.165 1.166C4 12.693 4 13.44 4 14.933m18.667 4.4a.667.667 0 1 1-1.334 0 .667.667 0 0 1 1.334 0" }))); };
	WalletOpened.default = SvgWalletOpened;
	
	return WalletOpened;
}

var WeatherDay = {};

var hasRequiredWeatherDay;

function requireWeatherDay () {
	if (hasRequiredWeatherDay) return WeatherDay;
	hasRequiredWeatherDay = 1;
	Object.defineProperty(WeatherDay, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgWeatherDay = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M16 2.667v2.666m0 21.334v2.666M5.333 16H2.667m5.752-7.581L6.533 6.533M23.581 8.42l1.886-1.886M8.419 23.587l-1.886 1.885m17.048-1.885 1.886 1.885M29.333 16h-2.666m-4 0a6.667 6.667 0 1 1-13.334 0 6.667 6.667 0 0 1 13.334 0" }))); };
	WeatherDay.default = SvgWeatherDay;
	
	return WeatherDay;
}

var WeatherNight = {};

var hasRequiredWeatherNight;

function requireWeatherNight () {
	if (hasRequiredWeatherNight) return WeatherNight;
	hasRequiredWeatherNight = 1;
	Object.defineProperty(WeatherNight, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgWeatherNight = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M29.333 21.126a13.9 13.9 0 0 1-5.742 1.232c-7.704 0-13.95-6.245-13.95-13.95 0-2.046.441-3.99 1.233-5.741-4.84 2.188-8.207 7.06-8.207 12.717 0 7.704 6.245 13.95 13.95 13.95 5.657 0 10.528-3.368 12.716-8.208" }))); };
	WeatherNight.default = SvgWeatherNight;
	
	return WeatherNight;
}

var WeatherRain01 = {};

var hasRequiredWeatherRain01;

function requireWeatherRain01 () {
	if (hasRequiredWeatherRain01) return WeatherRain01;
	hasRequiredWeatherRain01 = 1;
	Object.defineProperty(WeatherRain01, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgWeatherRain01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M21.333 24.667 20 28m-9.333-3.333L9.333 28M16 24.667 14.667 28m-5.334-8a6.667 6.667 0 1 1 .133-13.332 7.336 7.336 0 0 1 13.593 1.338Q23.195 8 23.333 8a6 6 0 0 1 0 12z" }))); };
	WeatherRain01.default = SvgWeatherRain01;
	
	return WeatherRain01;
}

var WeatherRain02 = {};

var hasRequiredWeatherRain02;

function requireWeatherRain02 () {
	if (hasRequiredWeatherRain02) return WeatherRain02;
	hasRequiredWeatherRain02 = 1;
	Object.defineProperty(WeatherRain02, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgWeatherRain02 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M26.667 20.323a6 6 0 0 0-2.773-10.964 8.002 8.002 0 0 0-15.788 0 6 6 0 0 0-2.773 10.964m11-.323L12.6 29.333m10.133-12L19 26.667m-6.933-9.334-3.734 9.334" }))); };
	WeatherRain02.default = SvgWeatherRain02;
	
	return WeatherRain02;
}

var WeatherRain03 = {};

var hasRequiredWeatherRain03;

function requireWeatherRain03 () {
	if (hasRequiredWeatherRain03) return WeatherRain03;
	hasRequiredWeatherRain03 = 1;
	Object.defineProperty(WeatherRain03, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgWeatherRain03 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M25.333 20.992a6.003 6.003 0 0 0-1.44-11.633 8.002 8.002 0 0 0-15.787 0 6 6 0 0 0-1.44 11.633m10.667-7.659-5.333 8h8l-5.333 8" }))); };
	WeatherRain03.default = SvgWeatherRain03;
	
	return WeatherRain03;
}

var WeatherRain04 = {};

var hasRequiredWeatherRain04;

function requireWeatherRain04 () {
	if (hasRequiredWeatherRain04) return WeatherRain04;
	hasRequiredWeatherRain04 = 1;
	Object.defineProperty(WeatherRain04, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgWeatherRain04 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M22.667 25.867c0 1.914-1.493 3.466-3.334 3.466S16 27.781 16 25.867V16M2.835 13.875C3.853 7.521 9.36 2.667 16 2.667S28.147 7.52 29.165 13.875c.1.62.149.93.024 1.261-.099.264-.342.549-.586.689C28.295 16 27.93 16 27.2 16H4.8c-.73 0-1.095 0-1.403-.175a1.46 1.46 0 0 1-.586-.689c-.125-.33-.075-.64.024-1.261" }))); };
	WeatherRain04.default = SvgWeatherRain04;
	
	return WeatherRain04;
}

var WeatherRain05 = {};

var hasRequiredWeatherRain05;

function requireWeatherRain05 () {
	if (hasRequiredWeatherRain05) return WeatherRain05;
	hasRequiredWeatherRain05 = 1;
	Object.defineProperty(WeatherRain05, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgWeatherRain05 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M29.333 21.333a8 8 0 0 1-16 0c0-5.751 8-18.666 8-18.666s8 12.915 8 18.666M10.667 12a4 4 0 0 1-8 0c0-2.876 4-9.333 4-9.333s4 6.457 4 9.333" }))); };
	WeatherRain05.default = SvgWeatherRain05;
	
	return WeatherRain05;
}

var WeatherTemperature = {};

var hasRequiredWeatherTemperature;

function requireWeatherTemperature () {
	if (hasRequiredWeatherTemperature) return WeatherTemperature;
	hasRequiredWeatherTemperature = 1;
	Object.defineProperty(WeatherTemperature, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgWeatherTemperature = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M28 4h-8m8 5.333h-8m8 5.334h-8M7.333 18.344V6A3.333 3.333 0 1 1 14 6v12.344a6 6 0 1 1-6.667 0M12 23.334a1.333 1.333 0 1 1-2.667 0 1.333 1.333 0 0 1 2.667 0" }))); };
	WeatherTemperature.default = SvgWeatherTemperature;
	
	return WeatherTemperature;
}

var WifiOff = {};

var hasRequiredWifiOff;

function requireWifiOff () {
	if (hasRequiredWifiOff) return WifiOff;
	hasRequiredWifiOff = 1;
	Object.defineProperty(WifiOff, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgWifiOff = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M20.416 13.333a14.7 14.7 0 0 1 5.024 2.734m4.667-4.734a21.33 21.33 0 0 0-16.51-5.194m-2.224 14.674a8 8 0 0 1 9.267 0M16 26h.013M1.591 11.601a21.4 21.4 0 0 1 6.087-3.917m-1.369 8.64a14.6 14.6 0 0 1 6.668-3.345m7.954 8.055a7.97 7.97 0 0 0-4.931-1.7 7.97 7.97 0 0 0-4.993 1.748M4 4l24 24" }))); };
	WifiOff.default = SvgWifiOff;
	
	return WifiOff;
}

var Wifi = {};

var hasRequiredWifi;

function requireWifi () {
	if (hasRequiredWifi) return Wifi;
	hasRequiredWifi = 1;
	Object.defineProperty(Wifi, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgWifi = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "M16 26h.013M30.41 11.601a21.26 21.26 0 0 0-14.41-5.6 21.26 21.26 0 0 0-14.408 5.6m4.718 4.723A14.6 14.6 0 0 1 16 12.667c3.715 0 7.107 1.38 9.69 3.657m-4.759 4.71a7.97 7.97 0 0 0-4.931-1.7 7.97 7.97 0 0 0-4.993 1.748" }))); };
	Wifi.default = SvgWifi;
	
	return Wifi;
}

var ZoomIn = {};

var hasRequiredZoomIn;

function requireZoomIn () {
	if (hasRequiredZoomIn) return ZoomIn;
	hasRequiredZoomIn = 1;
	Object.defineProperty(ZoomIn, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgZoomIn = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m28 28-5.8-5.8m-7.533-11.533v8m-4-4h8m6.666 0c0 5.89-4.775 10.666-10.666 10.666S4 20.558 4 14.667 8.776 4 14.667 4c5.89 0 10.666 4.776 10.666 10.667" }))); };
	ZoomIn.default = SvgZoomIn;
	
	return ZoomIn;
}

var ZoomOut = {};

var hasRequiredZoomOut;

function requireZoomOut () {
	if (hasRequiredZoomOut) return ZoomOut;
	hasRequiredZoomOut = 1;
	Object.defineProperty(ZoomOut, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var React = tslib_1.__importStar(require$$1);
	var SvgZoomOut = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
	    React.createElement("path", { d: "m28 28-5.8-5.8m-11.533-7.533h8m6.666 0c0 5.89-4.775 10.666-10.666 10.666S4 20.558 4 14.667 8.776 4 14.667 4c5.89 0 10.666 4.776 10.666 10.667" }))); };
	ZoomOut.default = SvgZoomOut;
	
	return ZoomOut;
}

var hasRequiredWeb;

function requireWeb () {
	if (hasRequiredWeb) return web;
	hasRequiredWeb = 1;
	(function (exports) {
		var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
		    return (mod && mod.__esModule) ? mod : { "default": mod };
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.Base02 = exports.Base01 = exports.Bank = exports.Attention = exports.AtSign = exports.ArrowUpload = exports.ArrowUp = exports.ArrowRight = exports.ArrowLeft = exports.ArrowGoingUp = exports.ArrowGoingDown = exports.ArrowDownload = exports.ArrowDown = exports.Announcement = exports.Alarm = exports.AlarmOff = exports.ActionsVolumeX = exports.ActionsVolumePlus = exports.ActionsVolumeMinus = exports.ActionsVolumeMin = exports.ActionsVolumeMax = exports.ActionsStop = exports.ActionsSkipForward = exports.ActionsSkipBack = exports.ActionsPower = exports.ActionsPlay = exports.ActionsForward = exports.ActionsBackward = exports.ActionTrash02 = exports.ActionTrash01 = exports.ActionPlus = exports.ActionPaste = exports.ActionMinus = exports.ActionFavorite02 = exports.ActionFavorite01 = exports.ActionEdit03 = exports.ActionEdit02 = exports.ActionEdit01 = exports.ActionCut02 = exports.ActionCut01 = exports.ActionCopy = exports.ActionClose = exports.ActionClear02 = exports.ActionClear01 = exports.ActionCheck = exports.ActionBlock = exports.ActionAttach02 = exports.ActionAttach01 = exports.ActionArchive02 = exports.ActionArchive01 = void 0;
		exports.CircleAlert = exports.CircleAdd = exports.ChevronUp = exports.ChevronRight = exports.ChevronLeft = exports.ChevronDown = exports.CheckVerified02 = exports.CheckVerified01 = exports.Chart = exports.ChartUp = exports.ChartPlus = exports.ChartPie03 = exports.ChartPie02 = exports.ChartPie01 = exports.ChartMinus = exports.ChartLine02 = exports.ChartLine01 = exports.ChartGoingUp = exports.ChartGoingDown = exports.ChartDown = exports.ChartArrowOutlier = exports.ChartArrowGoingUp = exports.ChartArrowGoingDown = exports.Car02 = exports.Car01 = exports.Camera = exports.CameraOff = exports.Call = exports.CallOff = exports.Calendar = exports.CalendarPlus = exports.CalendarMinus = exports.CalendarHeart = exports.CalendarCheck = exports.Book = exports.Bluetooth = exports.BluetoothSignal = exports.BluetoothOff = exports.Bike = exports.Battery05 = exports.Battery04 = exports.Battery03 = exports.Battery02 = exports.Battery01 = exports.BaseArrowUp = exports.BaseArrowDown = exports.Base06 = exports.Base05 = exports.Base04 = exports.Base03 = void 0;
		exports.DirectionCircleUpRight = exports.DirectionCircleUpLeft = exports.DirectionCircleRight = exports.DirectionCircleLeft = exports.DirectionCircleDown = exports.DirectionCircleDownRight = exports.DirectionCircleDownLeft = exports.Diamond = exports.Cursor = exports.CursorPointer = exports.Currency = exports.CurrencyNote = exports.CurrencyCircle = exports.CreditCardUpload = exports.CreditCardUp = exports.CreditCardShield = exports.CreditCardSearch = exports.CreditCardRefresh = exports.CreditCardPlus = exports.CreditCardMinus = exports.CreditCardLock = exports.CreditCardEdit = exports.CreditCardDownload = exports.CreditCardDown = exports.CreditCardClose = exports.CreditCardCheck = exports.CreditCard02 = exports.CreditCard01 = exports.Condominium03 = exports.Condominium02 = exports.Condominium01 = exports.Compass = exports.Columns03 = exports.Columns02 = exports.Coins02 = exports.Coins01 = exports.Cloud = exports.CloudUpload = exports.CloudOff = exports.CloudDownload = exports.Circles02 = exports.Circles01 = exports.CircleUser = exports.CircleSuccess = exports.CircleRemove = exports.CircleQuestion = exports.CircleInfo = exports.CircleHelp = exports.CircleHeart = exports.CircleError = void 0;
		exports.FlashOff = exports.Flag03 = exports.Flag02 = exports.Flag01 = exports.Fingerprint = exports.Filter = exports.FilterTuneVertical = exports.FilterTuneHorizontal = exports.File = exports.FileTextSearch = exports.FileTextReport = exports.FileTextQuestion = exports.FileTextPlus = exports.FileTextMinus = exports.FileTextHeart = exports.FileTextDownload = exports.FileTextClose = exports.FileTextCheck = exports.FileTextAttach = exports.FileText03 = exports.FileText02 = exports.FileText01 = exports.FileShield02 = exports.FileShield01 = exports.FilePlus = exports.FileLock02 = exports.FileLock01 = exports.FaceId02 = exports.FaceId01 = exports.Eye = exports.EyeOff = exports.EspecWeight02 = exports.EspecWeight01 = exports.EspecVolumetry = exports.EspecValue = exports.EspecMeasure = exports.EspecDimension = exports.DirectionDiamondUp = exports.DirectionDiamondUpRight = exports.DirectionDiamondUpLeft = exports.DirectionDiamondRight = exports.DirectionDiamondRightUp = exports.DirectionDiamondRightDown = exports.DirectionDiamondLeft = exports.DirectionDiamondLeftUp = exports.DirectionDiamondLeftDown = exports.DirectionDiamondDown = exports.DirectionDiamondDownRight = exports.DirectionDiamondDownLeft = exports.DirectionCircleUp = void 0;
		exports.LayoutAlt01 = exports.Layers02 = exports.Layers01 = exports.KpiUp = exports.KpiUpRight = exports.KpiUpLeft = exports.KpiRight = exports.KpiLeft = exports.KpiDown = exports.KpiDownRight = exports.KpiDownLeft = exports.Keyboard = exports.Insight03 = exports.Insight02 = exports.Insight01 = exports.ImageUpload = exports.ImageThumb = exports.ImagePrevious = exports.ImagePortrait = exports.ImagePlus = exports.ImageNext = exports.ImageLandscape = exports.ImageDownload = exports.ImageClose = exports.ImageCheck = exports.Home03 = exports.Home02 = exports.Home01 = exports.Headphone = exports.Grid02 = exports.Grid01 = exports.Graduate = exports.Globe = exports.GlobePin = exports.GlobeNavigator = exports.Gift02 = exports.Gift01 = exports.Fuel = exports.FolderSearch = exports.FolderQuestion = exports.FolderPlus = exports.FolderMinus = exports.FolderLocked = exports.FolderDownload = exports.FolderClose = exports.FolderCheck = exports.FolderBlocked = exports.FlipForward = exports.FlipBackward = exports.Flash = void 0;
		exports.MessageNotification = exports.MessageHeart = exports.MessageDots = exports.MessageClose = exports.MessageCheck = exports.MessageChat = exports.MessageAlert = exports.Menu04 = exports.Menu03 = exports.Menu02 = exports.Menu01 = exports.Medal02 = exports.Medal01 = exports.MarkerPin05 = exports.MarkerPin04 = exports.MarkerPin03 = exports.MarkerPin02 = exports.MarkerPin01 = exports.Mark = exports.MarkPlus = exports.MarkMinus = exports.MarkClose = exports.MarkCheck = exports.Map02 = exports.Map01 = exports.MailOpened02 = exports.MailOpened01 = exports.MailInbox02 = exports.MailInbox01 = exports.MailClosed02 = exports.MailClosed01 = exports.Logout = exports.Login = exports.LockUnlocked02 = exports.LockUnlocked01 = exports.LockLocked02 = exports.LockLocked01 = exports.Link = exports.LinkOn = exports.LinkOff = exports.Lightbulb = exports.LightbulbOn = exports.Legal = exports.LayoutTop = exports.LayoutRight = exports.LayoutLeft = exports.LayoutBottom = exports.LayoutAlt04 = exports.LayoutAlt03 = exports.LayoutAlt02 = void 0;
		exports.PackageCheck = exports.Package02 = exports.Package01 = exports.OpenNew = exports.Number9 = exports.Number8 = exports.Number7 = exports.Number6 = exports.Number5 = exports.Number4 = exports.Number3 = exports.Number2 = exports.Number1 = exports.Number0 = exports.NotificationMessage = exports.NotificationBox = exports.NotificationBell = exports.NotificationBellOn = exports.NotificationBellOff = exports.Notebook = exports.Navigator02On = exports.Navigator02Off = exports.Navigator01On = exports.Navigator01Off = exports.MusicalNote02 = exports.MusicalNote01 = exports.Mouse = exports.Motorcycle = exports.MotorcycleHelmetRight = exports.MotorcycleHelmetLeft = exports.MotorcycleBag = exports.More = exports.MoreVertical = exports.MoreHorizontal = exports.MoreHandler = exports.MoodWink = exports.MoodSmile = exports.MoodSad = exports.MoodNeutral = exports.MoodHappy = exports.MoodFrown = exports.MoodContent = exports.Monitor = exports.Microphone = exports.MicrophoneOff = exports.Message = exports.MessageText = exports.MessageSmile = exports.MessageQuestion = exports.MessagePlus = void 0;
		exports.Send02 = exports.Send01 = exports.SearchMedium = exports.SearchLarge = exports.ScreenMinimize = exports.ScreenMaximize = exports.ScreenExpand = exports.Scan = exports.Save = exports.SaveGroup = exports.Sale02 = exports.Sale01 = exports.Rows03 = exports.Rows02 = exports.Route07 = exports.Route06 = exports.Route05 = exports.Route04 = exports.Route03 = exports.Route02 = exports.Route01 = exports.Rocket02 = exports.Rocket01 = exports.Residence02 = exports.Residence01 = exports.ReloadForward = exports.ReloadBackward = exports.RefreshForward = exports.RefreshBackward = exports.Receipt = exports.ReceiptCheck = exports.QrCode02 = exports.QrCode01 = exports.Puzzle = exports.Print = exports.Plane = exports.Pin02 = exports.Pin01 = exports.PiggyBank = exports.Pickup02 = exports.Pickup01 = exports.Passcode = exports.PasscodeLock = exports.PackageSearch = exports.PackagePlus = exports.PackageMinus = exports.PackageCustom03 = exports.PackageCustom02 = exports.PackageCustom01 = exports.PackageClose = void 0;
		exports.UserCheck = exports.Truck = exports.Trophy = exports.Time = exports.TimeSleep = exports.TimeRefresh = exports.TimePlus = exports.TimeForward = exports.TimeCheck = exports.TimeBackward = exports.Ticket02 = exports.Ticket01 = exports.ThumbsUp = exports.ThumbsDown = exports.Target = exports.Target02 = exports.Target01 = exports.Tag = exports.TagGroup = exports.Tablet = exports.Table = exports.Sync02 = exports.Sync01 = exports.SwitchVertical02 = exports.SwitchVertical01 = exports.SwitchHorizontal02 = exports.SwitchHorizontal01 = exports.Store = exports.Squares02 = exports.Squares01 = exports.SortVertical = exports.SortList = exports.SortHorizontal = exports.Smartphone = exports.ShoppingCart02 = exports.ShoppingCart01 = exports.ShoppingBag02 = exports.ShoppingBag01 = exports.Shield = exports.ShieldZap = exports.ShieldPlus = exports.ShieldOff = exports.ShieldCurrency = exports.ShieldCheck = exports.Share02 = exports.Share01 = exports.Settings03 = exports.Settings02 = exports.Settings01 = exports.Send03 = void 0;
		exports.ZoomOut = exports.ZoomIn = exports.Wifi = exports.WifiOff = exports.WeatherTemperature = exports.WeatherRain05 = exports.WeatherRain04 = exports.WeatherRain03 = exports.WeatherRain02 = exports.WeatherRain01 = exports.WeatherNight = exports.WeatherDay = exports.WalletOpened = exports.WalletClosed = exports.VideoRecorder = exports.VideoRecorderOff = exports.Van = exports.Vacations = exports.User = exports.UserUp = exports.UserRight = exports.UserRemove = exports.UserPlus = exports.UserMinus = exports.UserLeft = exports.UserGroup = exports.UserGroupUp = exports.UserGroupRight = exports.UserGroupRemove = exports.UserGroupPlus = exports.UserGroupMinus = exports.UserGroupLeft = exports.UserGroupEdit = exports.UserGroupDown = exports.UserGroupCheck = exports.UserEdit = exports.UserDown = void 0;
		var ActionArchive01_1 = requireActionArchive01();
		Object.defineProperty(exports, "ActionArchive01", { enumerable: true, get: function () { return __importDefault(ActionArchive01_1).default; } });
		var ActionArchive02_1 = requireActionArchive02();
		Object.defineProperty(exports, "ActionArchive02", { enumerable: true, get: function () { return __importDefault(ActionArchive02_1).default; } });
		var ActionAttach01_1 = requireActionAttach01();
		Object.defineProperty(exports, "ActionAttach01", { enumerable: true, get: function () { return __importDefault(ActionAttach01_1).default; } });
		var ActionAttach02_1 = requireActionAttach02();
		Object.defineProperty(exports, "ActionAttach02", { enumerable: true, get: function () { return __importDefault(ActionAttach02_1).default; } });
		var ActionBlock_1 = requireActionBlock();
		Object.defineProperty(exports, "ActionBlock", { enumerable: true, get: function () { return __importDefault(ActionBlock_1).default; } });
		var ActionCheck_1 = requireActionCheck();
		Object.defineProperty(exports, "ActionCheck", { enumerable: true, get: function () { return __importDefault(ActionCheck_1).default; } });
		var ActionClear01_1 = requireActionClear01();
		Object.defineProperty(exports, "ActionClear01", { enumerable: true, get: function () { return __importDefault(ActionClear01_1).default; } });
		var ActionClear02_1 = requireActionClear02();
		Object.defineProperty(exports, "ActionClear02", { enumerable: true, get: function () { return __importDefault(ActionClear02_1).default; } });
		var ActionClose_1 = requireActionClose();
		Object.defineProperty(exports, "ActionClose", { enumerable: true, get: function () { return __importDefault(ActionClose_1).default; } });
		var ActionCopy_1 = requireActionCopy();
		Object.defineProperty(exports, "ActionCopy", { enumerable: true, get: function () { return __importDefault(ActionCopy_1).default; } });
		var ActionCut01_1 = requireActionCut01();
		Object.defineProperty(exports, "ActionCut01", { enumerable: true, get: function () { return __importDefault(ActionCut01_1).default; } });
		var ActionCut02_1 = requireActionCut02();
		Object.defineProperty(exports, "ActionCut02", { enumerable: true, get: function () { return __importDefault(ActionCut02_1).default; } });
		var ActionEdit01_1 = requireActionEdit01();
		Object.defineProperty(exports, "ActionEdit01", { enumerable: true, get: function () { return __importDefault(ActionEdit01_1).default; } });
		var ActionEdit02_1 = requireActionEdit02();
		Object.defineProperty(exports, "ActionEdit02", { enumerable: true, get: function () { return __importDefault(ActionEdit02_1).default; } });
		var ActionEdit03_1 = requireActionEdit03();
		Object.defineProperty(exports, "ActionEdit03", { enumerable: true, get: function () { return __importDefault(ActionEdit03_1).default; } });
		var ActionFavorite01_1 = requireActionFavorite01();
		Object.defineProperty(exports, "ActionFavorite01", { enumerable: true, get: function () { return __importDefault(ActionFavorite01_1).default; } });
		var ActionFavorite02_1 = requireActionFavorite02();
		Object.defineProperty(exports, "ActionFavorite02", { enumerable: true, get: function () { return __importDefault(ActionFavorite02_1).default; } });
		var ActionMinus_1 = requireActionMinus();
		Object.defineProperty(exports, "ActionMinus", { enumerable: true, get: function () { return __importDefault(ActionMinus_1).default; } });
		var ActionPaste_1 = requireActionPaste();
		Object.defineProperty(exports, "ActionPaste", { enumerable: true, get: function () { return __importDefault(ActionPaste_1).default; } });
		var ActionPlus_1 = requireActionPlus();
		Object.defineProperty(exports, "ActionPlus", { enumerable: true, get: function () { return __importDefault(ActionPlus_1).default; } });
		var ActionTrash01_1 = requireActionTrash01();
		Object.defineProperty(exports, "ActionTrash01", { enumerable: true, get: function () { return __importDefault(ActionTrash01_1).default; } });
		var ActionTrash02_1 = requireActionTrash02();
		Object.defineProperty(exports, "ActionTrash02", { enumerable: true, get: function () { return __importDefault(ActionTrash02_1).default; } });
		var ActionsBackward_1 = requireActionsBackward();
		Object.defineProperty(exports, "ActionsBackward", { enumerable: true, get: function () { return __importDefault(ActionsBackward_1).default; } });
		var ActionsForward_1 = requireActionsForward();
		Object.defineProperty(exports, "ActionsForward", { enumerable: true, get: function () { return __importDefault(ActionsForward_1).default; } });
		var ActionsPlay_1 = requireActionsPlay();
		Object.defineProperty(exports, "ActionsPlay", { enumerable: true, get: function () { return __importDefault(ActionsPlay_1).default; } });
		var ActionsPower_1 = requireActionsPower();
		Object.defineProperty(exports, "ActionsPower", { enumerable: true, get: function () { return __importDefault(ActionsPower_1).default; } });
		var ActionsSkipBack_1 = requireActionsSkipBack();
		Object.defineProperty(exports, "ActionsSkipBack", { enumerable: true, get: function () { return __importDefault(ActionsSkipBack_1).default; } });
		var ActionsSkipForward_1 = requireActionsSkipForward();
		Object.defineProperty(exports, "ActionsSkipForward", { enumerable: true, get: function () { return __importDefault(ActionsSkipForward_1).default; } });
		var ActionsStop_1 = requireActionsStop();
		Object.defineProperty(exports, "ActionsStop", { enumerable: true, get: function () { return __importDefault(ActionsStop_1).default; } });
		var ActionsVolumeMax_1 = requireActionsVolumeMax();
		Object.defineProperty(exports, "ActionsVolumeMax", { enumerable: true, get: function () { return __importDefault(ActionsVolumeMax_1).default; } });
		var ActionsVolumeMin_1 = requireActionsVolumeMin();
		Object.defineProperty(exports, "ActionsVolumeMin", { enumerable: true, get: function () { return __importDefault(ActionsVolumeMin_1).default; } });
		var ActionsVolumeMinus_1 = requireActionsVolumeMinus();
		Object.defineProperty(exports, "ActionsVolumeMinus", { enumerable: true, get: function () { return __importDefault(ActionsVolumeMinus_1).default; } });
		var ActionsVolumePlus_1 = requireActionsVolumePlus();
		Object.defineProperty(exports, "ActionsVolumePlus", { enumerable: true, get: function () { return __importDefault(ActionsVolumePlus_1).default; } });
		var ActionsVolumeX_1 = requireActionsVolumeX();
		Object.defineProperty(exports, "ActionsVolumeX", { enumerable: true, get: function () { return __importDefault(ActionsVolumeX_1).default; } });
		var AlarmOff_1 = requireAlarmOff();
		Object.defineProperty(exports, "AlarmOff", { enumerable: true, get: function () { return __importDefault(AlarmOff_1).default; } });
		var Alarm_1 = requireAlarm();
		Object.defineProperty(exports, "Alarm", { enumerable: true, get: function () { return __importDefault(Alarm_1).default; } });
		var Announcement_1 = requireAnnouncement();
		Object.defineProperty(exports, "Announcement", { enumerable: true, get: function () { return __importDefault(Announcement_1).default; } });
		var ArrowDown_1 = requireArrowDown();
		Object.defineProperty(exports, "ArrowDown", { enumerable: true, get: function () { return __importDefault(ArrowDown_1).default; } });
		var ArrowDownload_1 = requireArrowDownload();
		Object.defineProperty(exports, "ArrowDownload", { enumerable: true, get: function () { return __importDefault(ArrowDownload_1).default; } });
		var ArrowGoingDown_1 = requireArrowGoingDown();
		Object.defineProperty(exports, "ArrowGoingDown", { enumerable: true, get: function () { return __importDefault(ArrowGoingDown_1).default; } });
		var ArrowGoingUp_1 = requireArrowGoingUp();
		Object.defineProperty(exports, "ArrowGoingUp", { enumerable: true, get: function () { return __importDefault(ArrowGoingUp_1).default; } });
		var ArrowLeft_1 = requireArrowLeft();
		Object.defineProperty(exports, "ArrowLeft", { enumerable: true, get: function () { return __importDefault(ArrowLeft_1).default; } });
		var ArrowRight_1 = requireArrowRight();
		Object.defineProperty(exports, "ArrowRight", { enumerable: true, get: function () { return __importDefault(ArrowRight_1).default; } });
		var ArrowUp_1 = requireArrowUp();
		Object.defineProperty(exports, "ArrowUp", { enumerable: true, get: function () { return __importDefault(ArrowUp_1).default; } });
		var ArrowUpload_1 = requireArrowUpload();
		Object.defineProperty(exports, "ArrowUpload", { enumerable: true, get: function () { return __importDefault(ArrowUpload_1).default; } });
		var AtSign_1 = requireAtSign();
		Object.defineProperty(exports, "AtSign", { enumerable: true, get: function () { return __importDefault(AtSign_1).default; } });
		var Attention_1 = requireAttention();
		Object.defineProperty(exports, "Attention", { enumerable: true, get: function () { return __importDefault(Attention_1).default; } });
		var Bank_1 = requireBank();
		Object.defineProperty(exports, "Bank", { enumerable: true, get: function () { return __importDefault(Bank_1).default; } });
		var Base01_1 = requireBase01();
		Object.defineProperty(exports, "Base01", { enumerable: true, get: function () { return __importDefault(Base01_1).default; } });
		var Base02_1 = requireBase02();
		Object.defineProperty(exports, "Base02", { enumerable: true, get: function () { return __importDefault(Base02_1).default; } });
		var Base03_1 = requireBase03();
		Object.defineProperty(exports, "Base03", { enumerable: true, get: function () { return __importDefault(Base03_1).default; } });
		var Base04_1 = requireBase04();
		Object.defineProperty(exports, "Base04", { enumerable: true, get: function () { return __importDefault(Base04_1).default; } });
		var Base05_1 = requireBase05();
		Object.defineProperty(exports, "Base05", { enumerable: true, get: function () { return __importDefault(Base05_1).default; } });
		var Base06_1 = requireBase06();
		Object.defineProperty(exports, "Base06", { enumerable: true, get: function () { return __importDefault(Base06_1).default; } });
		var BaseArrowDown_1 = requireBaseArrowDown();
		Object.defineProperty(exports, "BaseArrowDown", { enumerable: true, get: function () { return __importDefault(BaseArrowDown_1).default; } });
		var BaseArrowUp_1 = requireBaseArrowUp();
		Object.defineProperty(exports, "BaseArrowUp", { enumerable: true, get: function () { return __importDefault(BaseArrowUp_1).default; } });
		var Battery01_1 = requireBattery01();
		Object.defineProperty(exports, "Battery01", { enumerable: true, get: function () { return __importDefault(Battery01_1).default; } });
		var Battery02_1 = requireBattery02();
		Object.defineProperty(exports, "Battery02", { enumerable: true, get: function () { return __importDefault(Battery02_1).default; } });
		var Battery03_1 = requireBattery03();
		Object.defineProperty(exports, "Battery03", { enumerable: true, get: function () { return __importDefault(Battery03_1).default; } });
		var Battery04_1 = requireBattery04();
		Object.defineProperty(exports, "Battery04", { enumerable: true, get: function () { return __importDefault(Battery04_1).default; } });
		var Battery05_1 = requireBattery05();
		Object.defineProperty(exports, "Battery05", { enumerable: true, get: function () { return __importDefault(Battery05_1).default; } });
		var Bike_1 = requireBike();
		Object.defineProperty(exports, "Bike", { enumerable: true, get: function () { return __importDefault(Bike_1).default; } });
		var BluetoothOff_1 = requireBluetoothOff();
		Object.defineProperty(exports, "BluetoothOff", { enumerable: true, get: function () { return __importDefault(BluetoothOff_1).default; } });
		var BluetoothSignal_1 = requireBluetoothSignal();
		Object.defineProperty(exports, "BluetoothSignal", { enumerable: true, get: function () { return __importDefault(BluetoothSignal_1).default; } });
		var Bluetooth_1 = requireBluetooth();
		Object.defineProperty(exports, "Bluetooth", { enumerable: true, get: function () { return __importDefault(Bluetooth_1).default; } });
		var Book_1 = requireBook();
		Object.defineProperty(exports, "Book", { enumerable: true, get: function () { return __importDefault(Book_1).default; } });
		var CalendarCheck_1 = requireCalendarCheck();
		Object.defineProperty(exports, "CalendarCheck", { enumerable: true, get: function () { return __importDefault(CalendarCheck_1).default; } });
		var CalendarHeart_1 = requireCalendarHeart();
		Object.defineProperty(exports, "CalendarHeart", { enumerable: true, get: function () { return __importDefault(CalendarHeart_1).default; } });
		var CalendarMinus_1 = requireCalendarMinus();
		Object.defineProperty(exports, "CalendarMinus", { enumerable: true, get: function () { return __importDefault(CalendarMinus_1).default; } });
		var CalendarPlus_1 = requireCalendarPlus();
		Object.defineProperty(exports, "CalendarPlus", { enumerable: true, get: function () { return __importDefault(CalendarPlus_1).default; } });
		var Calendar_1 = requireCalendar();
		Object.defineProperty(exports, "Calendar", { enumerable: true, get: function () { return __importDefault(Calendar_1).default; } });
		var CallOff_1 = requireCallOff();
		Object.defineProperty(exports, "CallOff", { enumerable: true, get: function () { return __importDefault(CallOff_1).default; } });
		var Call_1 = requireCall();
		Object.defineProperty(exports, "Call", { enumerable: true, get: function () { return __importDefault(Call_1).default; } });
		var CameraOff_1 = requireCameraOff();
		Object.defineProperty(exports, "CameraOff", { enumerable: true, get: function () { return __importDefault(CameraOff_1).default; } });
		var Camera_1 = requireCamera();
		Object.defineProperty(exports, "Camera", { enumerable: true, get: function () { return __importDefault(Camera_1).default; } });
		var Car01_1 = requireCar01();
		Object.defineProperty(exports, "Car01", { enumerable: true, get: function () { return __importDefault(Car01_1).default; } });
		var Car02_1 = requireCar02();
		Object.defineProperty(exports, "Car02", { enumerable: true, get: function () { return __importDefault(Car02_1).default; } });
		var ChartArrowGoingDown_1 = requireChartArrowGoingDown();
		Object.defineProperty(exports, "ChartArrowGoingDown", { enumerable: true, get: function () { return __importDefault(ChartArrowGoingDown_1).default; } });
		var ChartArrowGoingUp_1 = requireChartArrowGoingUp();
		Object.defineProperty(exports, "ChartArrowGoingUp", { enumerable: true, get: function () { return __importDefault(ChartArrowGoingUp_1).default; } });
		var ChartArrowOutlier_1 = requireChartArrowOutlier();
		Object.defineProperty(exports, "ChartArrowOutlier", { enumerable: true, get: function () { return __importDefault(ChartArrowOutlier_1).default; } });
		var ChartDown_1 = requireChartDown();
		Object.defineProperty(exports, "ChartDown", { enumerable: true, get: function () { return __importDefault(ChartDown_1).default; } });
		var ChartGoingDown_1 = requireChartGoingDown();
		Object.defineProperty(exports, "ChartGoingDown", { enumerable: true, get: function () { return __importDefault(ChartGoingDown_1).default; } });
		var ChartGoingUp_1 = requireChartGoingUp();
		Object.defineProperty(exports, "ChartGoingUp", { enumerable: true, get: function () { return __importDefault(ChartGoingUp_1).default; } });
		var ChartLine01_1 = requireChartLine01();
		Object.defineProperty(exports, "ChartLine01", { enumerable: true, get: function () { return __importDefault(ChartLine01_1).default; } });
		var ChartLine02_1 = requireChartLine02();
		Object.defineProperty(exports, "ChartLine02", { enumerable: true, get: function () { return __importDefault(ChartLine02_1).default; } });
		var ChartMinus_1 = requireChartMinus();
		Object.defineProperty(exports, "ChartMinus", { enumerable: true, get: function () { return __importDefault(ChartMinus_1).default; } });
		var ChartPie01_1 = requireChartPie01();
		Object.defineProperty(exports, "ChartPie01", { enumerable: true, get: function () { return __importDefault(ChartPie01_1).default; } });
		var ChartPie02_1 = requireChartPie02();
		Object.defineProperty(exports, "ChartPie02", { enumerable: true, get: function () { return __importDefault(ChartPie02_1).default; } });
		var ChartPie03_1 = requireChartPie03();
		Object.defineProperty(exports, "ChartPie03", { enumerable: true, get: function () { return __importDefault(ChartPie03_1).default; } });
		var ChartPlus_1 = requireChartPlus();
		Object.defineProperty(exports, "ChartPlus", { enumerable: true, get: function () { return __importDefault(ChartPlus_1).default; } });
		var ChartUp_1 = requireChartUp();
		Object.defineProperty(exports, "ChartUp", { enumerable: true, get: function () { return __importDefault(ChartUp_1).default; } });
		var Chart_1 = requireChart();
		Object.defineProperty(exports, "Chart", { enumerable: true, get: function () { return __importDefault(Chart_1).default; } });
		var CheckVerified01_1 = requireCheckVerified01();
		Object.defineProperty(exports, "CheckVerified01", { enumerable: true, get: function () { return __importDefault(CheckVerified01_1).default; } });
		var CheckVerified02_1 = requireCheckVerified02();
		Object.defineProperty(exports, "CheckVerified02", { enumerable: true, get: function () { return __importDefault(CheckVerified02_1).default; } });
		var ChevronDown_1 = requireChevronDown();
		Object.defineProperty(exports, "ChevronDown", { enumerable: true, get: function () { return __importDefault(ChevronDown_1).default; } });
		var ChevronLeft_1 = requireChevronLeft();
		Object.defineProperty(exports, "ChevronLeft", { enumerable: true, get: function () { return __importDefault(ChevronLeft_1).default; } });
		var ChevronRight_1 = requireChevronRight();
		Object.defineProperty(exports, "ChevronRight", { enumerable: true, get: function () { return __importDefault(ChevronRight_1).default; } });
		var ChevronUp_1 = requireChevronUp();
		Object.defineProperty(exports, "ChevronUp", { enumerable: true, get: function () { return __importDefault(ChevronUp_1).default; } });
		var CircleAdd_1 = requireCircleAdd();
		Object.defineProperty(exports, "CircleAdd", { enumerable: true, get: function () { return __importDefault(CircleAdd_1).default; } });
		var CircleAlert_1 = requireCircleAlert();
		Object.defineProperty(exports, "CircleAlert", { enumerable: true, get: function () { return __importDefault(CircleAlert_1).default; } });
		var CircleError_1 = requireCircleError();
		Object.defineProperty(exports, "CircleError", { enumerable: true, get: function () { return __importDefault(CircleError_1).default; } });
		var CircleHeart_1 = requireCircleHeart();
		Object.defineProperty(exports, "CircleHeart", { enumerable: true, get: function () { return __importDefault(CircleHeart_1).default; } });
		var CircleHelp_1 = requireCircleHelp();
		Object.defineProperty(exports, "CircleHelp", { enumerable: true, get: function () { return __importDefault(CircleHelp_1).default; } });
		var CircleInfo_1 = requireCircleInfo();
		Object.defineProperty(exports, "CircleInfo", { enumerable: true, get: function () { return __importDefault(CircleInfo_1).default; } });
		var CircleQuestion_1 = requireCircleQuestion();
		Object.defineProperty(exports, "CircleQuestion", { enumerable: true, get: function () { return __importDefault(CircleQuestion_1).default; } });
		var CircleRemove_1 = requireCircleRemove();
		Object.defineProperty(exports, "CircleRemove", { enumerable: true, get: function () { return __importDefault(CircleRemove_1).default; } });
		var CircleSuccess_1 = requireCircleSuccess();
		Object.defineProperty(exports, "CircleSuccess", { enumerable: true, get: function () { return __importDefault(CircleSuccess_1).default; } });
		var CircleUser_1 = requireCircleUser();
		Object.defineProperty(exports, "CircleUser", { enumerable: true, get: function () { return __importDefault(CircleUser_1).default; } });
		var Circles01_1 = requireCircles01();
		Object.defineProperty(exports, "Circles01", { enumerable: true, get: function () { return __importDefault(Circles01_1).default; } });
		var Circles02_1 = requireCircles02();
		Object.defineProperty(exports, "Circles02", { enumerable: true, get: function () { return __importDefault(Circles02_1).default; } });
		var CloudDownload_1 = requireCloudDownload();
		Object.defineProperty(exports, "CloudDownload", { enumerable: true, get: function () { return __importDefault(CloudDownload_1).default; } });
		var CloudOff_1 = requireCloudOff();
		Object.defineProperty(exports, "CloudOff", { enumerable: true, get: function () { return __importDefault(CloudOff_1).default; } });
		var CloudUpload_1 = requireCloudUpload();
		Object.defineProperty(exports, "CloudUpload", { enumerable: true, get: function () { return __importDefault(CloudUpload_1).default; } });
		var Cloud_1 = requireCloud();
		Object.defineProperty(exports, "Cloud", { enumerable: true, get: function () { return __importDefault(Cloud_1).default; } });
		var Coins01_1 = requireCoins01();
		Object.defineProperty(exports, "Coins01", { enumerable: true, get: function () { return __importDefault(Coins01_1).default; } });
		var Coins02_1 = requireCoins02();
		Object.defineProperty(exports, "Coins02", { enumerable: true, get: function () { return __importDefault(Coins02_1).default; } });
		var Columns02_1 = requireColumns02();
		Object.defineProperty(exports, "Columns02", { enumerable: true, get: function () { return __importDefault(Columns02_1).default; } });
		var Columns03_1 = requireColumns03();
		Object.defineProperty(exports, "Columns03", { enumerable: true, get: function () { return __importDefault(Columns03_1).default; } });
		var Compass_1 = requireCompass();
		Object.defineProperty(exports, "Compass", { enumerable: true, get: function () { return __importDefault(Compass_1).default; } });
		var Condominium01_1 = requireCondominium01();
		Object.defineProperty(exports, "Condominium01", { enumerable: true, get: function () { return __importDefault(Condominium01_1).default; } });
		var Condominium02_1 = requireCondominium02();
		Object.defineProperty(exports, "Condominium02", { enumerable: true, get: function () { return __importDefault(Condominium02_1).default; } });
		var Condominium03_1 = requireCondominium03();
		Object.defineProperty(exports, "Condominium03", { enumerable: true, get: function () { return __importDefault(Condominium03_1).default; } });
		var CreditCard01_1 = requireCreditCard01();
		Object.defineProperty(exports, "CreditCard01", { enumerable: true, get: function () { return __importDefault(CreditCard01_1).default; } });
		var CreditCard02_1 = requireCreditCard02();
		Object.defineProperty(exports, "CreditCard02", { enumerable: true, get: function () { return __importDefault(CreditCard02_1).default; } });
		var CreditCardCheck_1 = requireCreditCardCheck();
		Object.defineProperty(exports, "CreditCardCheck", { enumerable: true, get: function () { return __importDefault(CreditCardCheck_1).default; } });
		var CreditCardClose_1 = requireCreditCardClose();
		Object.defineProperty(exports, "CreditCardClose", { enumerable: true, get: function () { return __importDefault(CreditCardClose_1).default; } });
		var CreditCardDown_1 = requireCreditCardDown();
		Object.defineProperty(exports, "CreditCardDown", { enumerable: true, get: function () { return __importDefault(CreditCardDown_1).default; } });
		var CreditCardDownload_1 = requireCreditCardDownload();
		Object.defineProperty(exports, "CreditCardDownload", { enumerable: true, get: function () { return __importDefault(CreditCardDownload_1).default; } });
		var CreditCardEdit_1 = requireCreditCardEdit();
		Object.defineProperty(exports, "CreditCardEdit", { enumerable: true, get: function () { return __importDefault(CreditCardEdit_1).default; } });
		var CreditCardLock_1 = requireCreditCardLock();
		Object.defineProperty(exports, "CreditCardLock", { enumerable: true, get: function () { return __importDefault(CreditCardLock_1).default; } });
		var CreditCardMinus_1 = requireCreditCardMinus();
		Object.defineProperty(exports, "CreditCardMinus", { enumerable: true, get: function () { return __importDefault(CreditCardMinus_1).default; } });
		var CreditCardPlus_1 = requireCreditCardPlus();
		Object.defineProperty(exports, "CreditCardPlus", { enumerable: true, get: function () { return __importDefault(CreditCardPlus_1).default; } });
		var CreditCardRefresh_1 = requireCreditCardRefresh();
		Object.defineProperty(exports, "CreditCardRefresh", { enumerable: true, get: function () { return __importDefault(CreditCardRefresh_1).default; } });
		var CreditCardSearch_1 = requireCreditCardSearch();
		Object.defineProperty(exports, "CreditCardSearch", { enumerable: true, get: function () { return __importDefault(CreditCardSearch_1).default; } });
		var CreditCardShield_1 = requireCreditCardShield();
		Object.defineProperty(exports, "CreditCardShield", { enumerable: true, get: function () { return __importDefault(CreditCardShield_1).default; } });
		var CreditCardUp_1 = requireCreditCardUp();
		Object.defineProperty(exports, "CreditCardUp", { enumerable: true, get: function () { return __importDefault(CreditCardUp_1).default; } });
		var CreditCardUpload_1 = requireCreditCardUpload();
		Object.defineProperty(exports, "CreditCardUpload", { enumerable: true, get: function () { return __importDefault(CreditCardUpload_1).default; } });
		var CurrencyCircle_1 = requireCurrencyCircle();
		Object.defineProperty(exports, "CurrencyCircle", { enumerable: true, get: function () { return __importDefault(CurrencyCircle_1).default; } });
		var CurrencyNote_1 = requireCurrencyNote();
		Object.defineProperty(exports, "CurrencyNote", { enumerable: true, get: function () { return __importDefault(CurrencyNote_1).default; } });
		var Currency_1 = requireCurrency();
		Object.defineProperty(exports, "Currency", { enumerable: true, get: function () { return __importDefault(Currency_1).default; } });
		var CursorPointer_1 = requireCursorPointer();
		Object.defineProperty(exports, "CursorPointer", { enumerable: true, get: function () { return __importDefault(CursorPointer_1).default; } });
		var Cursor_1 = requireCursor();
		Object.defineProperty(exports, "Cursor", { enumerable: true, get: function () { return __importDefault(Cursor_1).default; } });
		var Diamond_1 = requireDiamond();
		Object.defineProperty(exports, "Diamond", { enumerable: true, get: function () { return __importDefault(Diamond_1).default; } });
		var DirectionCircleDownLeft_1 = requireDirectionCircleDownLeft();
		Object.defineProperty(exports, "DirectionCircleDownLeft", { enumerable: true, get: function () { return __importDefault(DirectionCircleDownLeft_1).default; } });
		var DirectionCircleDownRight_1 = requireDirectionCircleDownRight();
		Object.defineProperty(exports, "DirectionCircleDownRight", { enumerable: true, get: function () { return __importDefault(DirectionCircleDownRight_1).default; } });
		var DirectionCircleDown_1 = requireDirectionCircleDown();
		Object.defineProperty(exports, "DirectionCircleDown", { enumerable: true, get: function () { return __importDefault(DirectionCircleDown_1).default; } });
		var DirectionCircleLeft_1 = requireDirectionCircleLeft();
		Object.defineProperty(exports, "DirectionCircleLeft", { enumerable: true, get: function () { return __importDefault(DirectionCircleLeft_1).default; } });
		var DirectionCircleRight_1 = requireDirectionCircleRight();
		Object.defineProperty(exports, "DirectionCircleRight", { enumerable: true, get: function () { return __importDefault(DirectionCircleRight_1).default; } });
		var DirectionCircleUpLeft_1 = requireDirectionCircleUpLeft();
		Object.defineProperty(exports, "DirectionCircleUpLeft", { enumerable: true, get: function () { return __importDefault(DirectionCircleUpLeft_1).default; } });
		var DirectionCircleUpRight_1 = requireDirectionCircleUpRight();
		Object.defineProperty(exports, "DirectionCircleUpRight", { enumerable: true, get: function () { return __importDefault(DirectionCircleUpRight_1).default; } });
		var DirectionCircleUp_1 = requireDirectionCircleUp();
		Object.defineProperty(exports, "DirectionCircleUp", { enumerable: true, get: function () { return __importDefault(DirectionCircleUp_1).default; } });
		var DirectionDiamondDownLeft_1 = requireDirectionDiamondDownLeft();
		Object.defineProperty(exports, "DirectionDiamondDownLeft", { enumerable: true, get: function () { return __importDefault(DirectionDiamondDownLeft_1).default; } });
		var DirectionDiamondDownRight_1 = requireDirectionDiamondDownRight();
		Object.defineProperty(exports, "DirectionDiamondDownRight", { enumerable: true, get: function () { return __importDefault(DirectionDiamondDownRight_1).default; } });
		var DirectionDiamondDown_1 = requireDirectionDiamondDown();
		Object.defineProperty(exports, "DirectionDiamondDown", { enumerable: true, get: function () { return __importDefault(DirectionDiamondDown_1).default; } });
		var DirectionDiamondLeftDown_1 = requireDirectionDiamondLeftDown();
		Object.defineProperty(exports, "DirectionDiamondLeftDown", { enumerable: true, get: function () { return __importDefault(DirectionDiamondLeftDown_1).default; } });
		var DirectionDiamondLeftUp_1 = requireDirectionDiamondLeftUp();
		Object.defineProperty(exports, "DirectionDiamondLeftUp", { enumerable: true, get: function () { return __importDefault(DirectionDiamondLeftUp_1).default; } });
		var DirectionDiamondLeft_1 = requireDirectionDiamondLeft();
		Object.defineProperty(exports, "DirectionDiamondLeft", { enumerable: true, get: function () { return __importDefault(DirectionDiamondLeft_1).default; } });
		var DirectionDiamondRightDown_1 = requireDirectionDiamondRightDown();
		Object.defineProperty(exports, "DirectionDiamondRightDown", { enumerable: true, get: function () { return __importDefault(DirectionDiamondRightDown_1).default; } });
		var DirectionDiamondRightUp_1 = requireDirectionDiamondRightUp();
		Object.defineProperty(exports, "DirectionDiamondRightUp", { enumerable: true, get: function () { return __importDefault(DirectionDiamondRightUp_1).default; } });
		var DirectionDiamondRight_1 = requireDirectionDiamondRight();
		Object.defineProperty(exports, "DirectionDiamondRight", { enumerable: true, get: function () { return __importDefault(DirectionDiamondRight_1).default; } });
		var DirectionDiamondUpLeft_1 = requireDirectionDiamondUpLeft();
		Object.defineProperty(exports, "DirectionDiamondUpLeft", { enumerable: true, get: function () { return __importDefault(DirectionDiamondUpLeft_1).default; } });
		var DirectionDiamondUpRight_1 = requireDirectionDiamondUpRight();
		Object.defineProperty(exports, "DirectionDiamondUpRight", { enumerable: true, get: function () { return __importDefault(DirectionDiamondUpRight_1).default; } });
		var DirectionDiamondUp_1 = requireDirectionDiamondUp();
		Object.defineProperty(exports, "DirectionDiamondUp", { enumerable: true, get: function () { return __importDefault(DirectionDiamondUp_1).default; } });
		var EspecDimension_1 = requireEspecDimension();
		Object.defineProperty(exports, "EspecDimension", { enumerable: true, get: function () { return __importDefault(EspecDimension_1).default; } });
		var EspecMeasure_1 = requireEspecMeasure();
		Object.defineProperty(exports, "EspecMeasure", { enumerable: true, get: function () { return __importDefault(EspecMeasure_1).default; } });
		var EspecValue_1 = requireEspecValue();
		Object.defineProperty(exports, "EspecValue", { enumerable: true, get: function () { return __importDefault(EspecValue_1).default; } });
		var EspecVolumetry_1 = requireEspecVolumetry();
		Object.defineProperty(exports, "EspecVolumetry", { enumerable: true, get: function () { return __importDefault(EspecVolumetry_1).default; } });
		var EspecWeight01_1 = requireEspecWeight01();
		Object.defineProperty(exports, "EspecWeight01", { enumerable: true, get: function () { return __importDefault(EspecWeight01_1).default; } });
		var EspecWeight02_1 = requireEspecWeight02();
		Object.defineProperty(exports, "EspecWeight02", { enumerable: true, get: function () { return __importDefault(EspecWeight02_1).default; } });
		var EyeOff_1 = requireEyeOff();
		Object.defineProperty(exports, "EyeOff", { enumerable: true, get: function () { return __importDefault(EyeOff_1).default; } });
		var Eye_1 = requireEye();
		Object.defineProperty(exports, "Eye", { enumerable: true, get: function () { return __importDefault(Eye_1).default; } });
		var FaceId01_1 = requireFaceId01();
		Object.defineProperty(exports, "FaceId01", { enumerable: true, get: function () { return __importDefault(FaceId01_1).default; } });
		var FaceId02_1 = requireFaceId02();
		Object.defineProperty(exports, "FaceId02", { enumerable: true, get: function () { return __importDefault(FaceId02_1).default; } });
		var FileLock01_1 = requireFileLock01();
		Object.defineProperty(exports, "FileLock01", { enumerable: true, get: function () { return __importDefault(FileLock01_1).default; } });
		var FileLock02_1 = requireFileLock02();
		Object.defineProperty(exports, "FileLock02", { enumerable: true, get: function () { return __importDefault(FileLock02_1).default; } });
		var FilePlus_1 = requireFilePlus();
		Object.defineProperty(exports, "FilePlus", { enumerable: true, get: function () { return __importDefault(FilePlus_1).default; } });
		var FileShield01_1 = requireFileShield01();
		Object.defineProperty(exports, "FileShield01", { enumerable: true, get: function () { return __importDefault(FileShield01_1).default; } });
		var FileShield02_1 = requireFileShield02();
		Object.defineProperty(exports, "FileShield02", { enumerable: true, get: function () { return __importDefault(FileShield02_1).default; } });
		var FileText01_1 = requireFileText01();
		Object.defineProperty(exports, "FileText01", { enumerable: true, get: function () { return __importDefault(FileText01_1).default; } });
		var FileText02_1 = requireFileText02();
		Object.defineProperty(exports, "FileText02", { enumerable: true, get: function () { return __importDefault(FileText02_1).default; } });
		var FileText03_1 = requireFileText03();
		Object.defineProperty(exports, "FileText03", { enumerable: true, get: function () { return __importDefault(FileText03_1).default; } });
		var FileTextAttach_1 = requireFileTextAttach();
		Object.defineProperty(exports, "FileTextAttach", { enumerable: true, get: function () { return __importDefault(FileTextAttach_1).default; } });
		var FileTextCheck_1 = requireFileTextCheck();
		Object.defineProperty(exports, "FileTextCheck", { enumerable: true, get: function () { return __importDefault(FileTextCheck_1).default; } });
		var FileTextClose_1 = requireFileTextClose();
		Object.defineProperty(exports, "FileTextClose", { enumerable: true, get: function () { return __importDefault(FileTextClose_1).default; } });
		var FileTextDownload_1 = requireFileTextDownload();
		Object.defineProperty(exports, "FileTextDownload", { enumerable: true, get: function () { return __importDefault(FileTextDownload_1).default; } });
		var FileTextHeart_1 = requireFileTextHeart();
		Object.defineProperty(exports, "FileTextHeart", { enumerable: true, get: function () { return __importDefault(FileTextHeart_1).default; } });
		var FileTextMinus_1 = requireFileTextMinus();
		Object.defineProperty(exports, "FileTextMinus", { enumerable: true, get: function () { return __importDefault(FileTextMinus_1).default; } });
		var FileTextPlus_1 = requireFileTextPlus();
		Object.defineProperty(exports, "FileTextPlus", { enumerable: true, get: function () { return __importDefault(FileTextPlus_1).default; } });
		var FileTextQuestion_1 = requireFileTextQuestion();
		Object.defineProperty(exports, "FileTextQuestion", { enumerable: true, get: function () { return __importDefault(FileTextQuestion_1).default; } });
		var FileTextReport_1 = requireFileTextReport();
		Object.defineProperty(exports, "FileTextReport", { enumerable: true, get: function () { return __importDefault(FileTextReport_1).default; } });
		var FileTextSearch_1 = requireFileTextSearch();
		Object.defineProperty(exports, "FileTextSearch", { enumerable: true, get: function () { return __importDefault(FileTextSearch_1).default; } });
		var File_1 = requireFile();
		Object.defineProperty(exports, "File", { enumerable: true, get: function () { return __importDefault(File_1).default; } });
		var FilterTuneHorizontal_1 = requireFilterTuneHorizontal();
		Object.defineProperty(exports, "FilterTuneHorizontal", { enumerable: true, get: function () { return __importDefault(FilterTuneHorizontal_1).default; } });
		var FilterTuneVertical_1 = requireFilterTuneVertical();
		Object.defineProperty(exports, "FilterTuneVertical", { enumerable: true, get: function () { return __importDefault(FilterTuneVertical_1).default; } });
		var Filter_1 = requireFilter();
		Object.defineProperty(exports, "Filter", { enumerable: true, get: function () { return __importDefault(Filter_1).default; } });
		var Fingerprint_1 = requireFingerprint();
		Object.defineProperty(exports, "Fingerprint", { enumerable: true, get: function () { return __importDefault(Fingerprint_1).default; } });
		var Flag01_1 = requireFlag01();
		Object.defineProperty(exports, "Flag01", { enumerable: true, get: function () { return __importDefault(Flag01_1).default; } });
		var Flag02_1 = requireFlag02();
		Object.defineProperty(exports, "Flag02", { enumerable: true, get: function () { return __importDefault(Flag02_1).default; } });
		var Flag03_1 = requireFlag03();
		Object.defineProperty(exports, "Flag03", { enumerable: true, get: function () { return __importDefault(Flag03_1).default; } });
		var FlashOff_1 = requireFlashOff();
		Object.defineProperty(exports, "FlashOff", { enumerable: true, get: function () { return __importDefault(FlashOff_1).default; } });
		var Flash_1 = requireFlash();
		Object.defineProperty(exports, "Flash", { enumerable: true, get: function () { return __importDefault(Flash_1).default; } });
		var FlipBackward_1 = requireFlipBackward();
		Object.defineProperty(exports, "FlipBackward", { enumerable: true, get: function () { return __importDefault(FlipBackward_1).default; } });
		var FlipForward_1 = requireFlipForward();
		Object.defineProperty(exports, "FlipForward", { enumerable: true, get: function () { return __importDefault(FlipForward_1).default; } });
		var FolderBlocked_1 = requireFolderBlocked();
		Object.defineProperty(exports, "FolderBlocked", { enumerable: true, get: function () { return __importDefault(FolderBlocked_1).default; } });
		var FolderCheck_1 = requireFolderCheck();
		Object.defineProperty(exports, "FolderCheck", { enumerable: true, get: function () { return __importDefault(FolderCheck_1).default; } });
		var FolderClose_1 = requireFolderClose();
		Object.defineProperty(exports, "FolderClose", { enumerable: true, get: function () { return __importDefault(FolderClose_1).default; } });
		var FolderDownload_1 = requireFolderDownload();
		Object.defineProperty(exports, "FolderDownload", { enumerable: true, get: function () { return __importDefault(FolderDownload_1).default; } });
		var FolderLocked_1 = requireFolderLocked();
		Object.defineProperty(exports, "FolderLocked", { enumerable: true, get: function () { return __importDefault(FolderLocked_1).default; } });
		var FolderMinus_1 = requireFolderMinus();
		Object.defineProperty(exports, "FolderMinus", { enumerable: true, get: function () { return __importDefault(FolderMinus_1).default; } });
		var FolderPlus_1 = requireFolderPlus();
		Object.defineProperty(exports, "FolderPlus", { enumerable: true, get: function () { return __importDefault(FolderPlus_1).default; } });
		var FolderQuestion_1 = requireFolderQuestion();
		Object.defineProperty(exports, "FolderQuestion", { enumerable: true, get: function () { return __importDefault(FolderQuestion_1).default; } });
		var FolderSearch_1 = requireFolderSearch();
		Object.defineProperty(exports, "FolderSearch", { enumerable: true, get: function () { return __importDefault(FolderSearch_1).default; } });
		var Fuel_1 = requireFuel();
		Object.defineProperty(exports, "Fuel", { enumerable: true, get: function () { return __importDefault(Fuel_1).default; } });
		var Gift01_1 = requireGift01();
		Object.defineProperty(exports, "Gift01", { enumerable: true, get: function () { return __importDefault(Gift01_1).default; } });
		var Gift02_1 = requireGift02();
		Object.defineProperty(exports, "Gift02", { enumerable: true, get: function () { return __importDefault(Gift02_1).default; } });
		var GlobeNavigator_1 = requireGlobeNavigator();
		Object.defineProperty(exports, "GlobeNavigator", { enumerable: true, get: function () { return __importDefault(GlobeNavigator_1).default; } });
		var GlobePin_1 = requireGlobePin();
		Object.defineProperty(exports, "GlobePin", { enumerable: true, get: function () { return __importDefault(GlobePin_1).default; } });
		var Globe_1 = requireGlobe();
		Object.defineProperty(exports, "Globe", { enumerable: true, get: function () { return __importDefault(Globe_1).default; } });
		var Graduate_1 = requireGraduate();
		Object.defineProperty(exports, "Graduate", { enumerable: true, get: function () { return __importDefault(Graduate_1).default; } });
		var Grid01_1 = requireGrid01();
		Object.defineProperty(exports, "Grid01", { enumerable: true, get: function () { return __importDefault(Grid01_1).default; } });
		var Grid02_1 = requireGrid02();
		Object.defineProperty(exports, "Grid02", { enumerable: true, get: function () { return __importDefault(Grid02_1).default; } });
		var Headphone_1 = requireHeadphone();
		Object.defineProperty(exports, "Headphone", { enumerable: true, get: function () { return __importDefault(Headphone_1).default; } });
		var Home01_1 = requireHome01();
		Object.defineProperty(exports, "Home01", { enumerable: true, get: function () { return __importDefault(Home01_1).default; } });
		var Home02_1 = requireHome02();
		Object.defineProperty(exports, "Home02", { enumerable: true, get: function () { return __importDefault(Home02_1).default; } });
		var Home03_1 = requireHome03();
		Object.defineProperty(exports, "Home03", { enumerable: true, get: function () { return __importDefault(Home03_1).default; } });
		var ImageCheck_1 = requireImageCheck();
		Object.defineProperty(exports, "ImageCheck", { enumerable: true, get: function () { return __importDefault(ImageCheck_1).default; } });
		var ImageClose_1 = requireImageClose();
		Object.defineProperty(exports, "ImageClose", { enumerable: true, get: function () { return __importDefault(ImageClose_1).default; } });
		var ImageDownload_1 = requireImageDownload();
		Object.defineProperty(exports, "ImageDownload", { enumerable: true, get: function () { return __importDefault(ImageDownload_1).default; } });
		var ImageLandscape_1 = requireImageLandscape();
		Object.defineProperty(exports, "ImageLandscape", { enumerable: true, get: function () { return __importDefault(ImageLandscape_1).default; } });
		var ImageNext_1 = requireImageNext();
		Object.defineProperty(exports, "ImageNext", { enumerable: true, get: function () { return __importDefault(ImageNext_1).default; } });
		var ImagePlus_1 = requireImagePlus();
		Object.defineProperty(exports, "ImagePlus", { enumerable: true, get: function () { return __importDefault(ImagePlus_1).default; } });
		var ImagePortrait_1 = requireImagePortrait();
		Object.defineProperty(exports, "ImagePortrait", { enumerable: true, get: function () { return __importDefault(ImagePortrait_1).default; } });
		var ImagePrevious_1 = requireImagePrevious();
		Object.defineProperty(exports, "ImagePrevious", { enumerable: true, get: function () { return __importDefault(ImagePrevious_1).default; } });
		var ImageThumb_1 = requireImageThumb();
		Object.defineProperty(exports, "ImageThumb", { enumerable: true, get: function () { return __importDefault(ImageThumb_1).default; } });
		var ImageUpload_1 = requireImageUpload();
		Object.defineProperty(exports, "ImageUpload", { enumerable: true, get: function () { return __importDefault(ImageUpload_1).default; } });
		var Insight01_1 = requireInsight01();
		Object.defineProperty(exports, "Insight01", { enumerable: true, get: function () { return __importDefault(Insight01_1).default; } });
		var Insight02_1 = requireInsight02();
		Object.defineProperty(exports, "Insight02", { enumerable: true, get: function () { return __importDefault(Insight02_1).default; } });
		var Insight03_1 = requireInsight03();
		Object.defineProperty(exports, "Insight03", { enumerable: true, get: function () { return __importDefault(Insight03_1).default; } });
		var Keyboard_1 = requireKeyboard();
		Object.defineProperty(exports, "Keyboard", { enumerable: true, get: function () { return __importDefault(Keyboard_1).default; } });
		var KpiDownLeft_1 = requireKpiDownLeft();
		Object.defineProperty(exports, "KpiDownLeft", { enumerable: true, get: function () { return __importDefault(KpiDownLeft_1).default; } });
		var KpiDownRight_1 = requireKpiDownRight();
		Object.defineProperty(exports, "KpiDownRight", { enumerable: true, get: function () { return __importDefault(KpiDownRight_1).default; } });
		var KpiDown_1 = requireKpiDown();
		Object.defineProperty(exports, "KpiDown", { enumerable: true, get: function () { return __importDefault(KpiDown_1).default; } });
		var KpiLeft_1 = requireKpiLeft();
		Object.defineProperty(exports, "KpiLeft", { enumerable: true, get: function () { return __importDefault(KpiLeft_1).default; } });
		var KpiRight_1 = requireKpiRight();
		Object.defineProperty(exports, "KpiRight", { enumerable: true, get: function () { return __importDefault(KpiRight_1).default; } });
		var KpiUpLeft_1 = requireKpiUpLeft();
		Object.defineProperty(exports, "KpiUpLeft", { enumerable: true, get: function () { return __importDefault(KpiUpLeft_1).default; } });
		var KpiUpRight_1 = requireKpiUpRight();
		Object.defineProperty(exports, "KpiUpRight", { enumerable: true, get: function () { return __importDefault(KpiUpRight_1).default; } });
		var KpiUp_1 = requireKpiUp();
		Object.defineProperty(exports, "KpiUp", { enumerable: true, get: function () { return __importDefault(KpiUp_1).default; } });
		var Layers01_1 = requireLayers01();
		Object.defineProperty(exports, "Layers01", { enumerable: true, get: function () { return __importDefault(Layers01_1).default; } });
		var Layers02_1 = requireLayers02();
		Object.defineProperty(exports, "Layers02", { enumerable: true, get: function () { return __importDefault(Layers02_1).default; } });
		var LayoutAlt01_1 = requireLayoutAlt01();
		Object.defineProperty(exports, "LayoutAlt01", { enumerable: true, get: function () { return __importDefault(LayoutAlt01_1).default; } });
		var LayoutAlt02_1 = requireLayoutAlt02();
		Object.defineProperty(exports, "LayoutAlt02", { enumerable: true, get: function () { return __importDefault(LayoutAlt02_1).default; } });
		var LayoutAlt03_1 = requireLayoutAlt03();
		Object.defineProperty(exports, "LayoutAlt03", { enumerable: true, get: function () { return __importDefault(LayoutAlt03_1).default; } });
		var LayoutAlt04_1 = requireLayoutAlt04();
		Object.defineProperty(exports, "LayoutAlt04", { enumerable: true, get: function () { return __importDefault(LayoutAlt04_1).default; } });
		var LayoutBottom_1 = requireLayoutBottom();
		Object.defineProperty(exports, "LayoutBottom", { enumerable: true, get: function () { return __importDefault(LayoutBottom_1).default; } });
		var LayoutLeft_1 = requireLayoutLeft();
		Object.defineProperty(exports, "LayoutLeft", { enumerable: true, get: function () { return __importDefault(LayoutLeft_1).default; } });
		var LayoutRight_1 = requireLayoutRight();
		Object.defineProperty(exports, "LayoutRight", { enumerable: true, get: function () { return __importDefault(LayoutRight_1).default; } });
		var LayoutTop_1 = requireLayoutTop();
		Object.defineProperty(exports, "LayoutTop", { enumerable: true, get: function () { return __importDefault(LayoutTop_1).default; } });
		var Legal_1 = requireLegal();
		Object.defineProperty(exports, "Legal", { enumerable: true, get: function () { return __importDefault(Legal_1).default; } });
		var LightbulbOn_1 = requireLightbulbOn();
		Object.defineProperty(exports, "LightbulbOn", { enumerable: true, get: function () { return __importDefault(LightbulbOn_1).default; } });
		var Lightbulb_1 = requireLightbulb();
		Object.defineProperty(exports, "Lightbulb", { enumerable: true, get: function () { return __importDefault(Lightbulb_1).default; } });
		var LinkOff_1 = requireLinkOff();
		Object.defineProperty(exports, "LinkOff", { enumerable: true, get: function () { return __importDefault(LinkOff_1).default; } });
		var LinkOn_1 = requireLinkOn();
		Object.defineProperty(exports, "LinkOn", { enumerable: true, get: function () { return __importDefault(LinkOn_1).default; } });
		var Link_1 = requireLink();
		Object.defineProperty(exports, "Link", { enumerable: true, get: function () { return __importDefault(Link_1).default; } });
		var LockLocked01_1 = requireLockLocked01();
		Object.defineProperty(exports, "LockLocked01", { enumerable: true, get: function () { return __importDefault(LockLocked01_1).default; } });
		var LockLocked02_1 = requireLockLocked02();
		Object.defineProperty(exports, "LockLocked02", { enumerable: true, get: function () { return __importDefault(LockLocked02_1).default; } });
		var LockUnlocked01_1 = requireLockUnlocked01();
		Object.defineProperty(exports, "LockUnlocked01", { enumerable: true, get: function () { return __importDefault(LockUnlocked01_1).default; } });
		var LockUnlocked02_1 = requireLockUnlocked02();
		Object.defineProperty(exports, "LockUnlocked02", { enumerable: true, get: function () { return __importDefault(LockUnlocked02_1).default; } });
		var Login_1 = requireLogin();
		Object.defineProperty(exports, "Login", { enumerable: true, get: function () { return __importDefault(Login_1).default; } });
		var Logout_1 = requireLogout();
		Object.defineProperty(exports, "Logout", { enumerable: true, get: function () { return __importDefault(Logout_1).default; } });
		var MailClosed01_1 = requireMailClosed01();
		Object.defineProperty(exports, "MailClosed01", { enumerable: true, get: function () { return __importDefault(MailClosed01_1).default; } });
		var MailClosed02_1 = requireMailClosed02();
		Object.defineProperty(exports, "MailClosed02", { enumerable: true, get: function () { return __importDefault(MailClosed02_1).default; } });
		var MailInbox01_1 = requireMailInbox01();
		Object.defineProperty(exports, "MailInbox01", { enumerable: true, get: function () { return __importDefault(MailInbox01_1).default; } });
		var MailInbox02_1 = requireMailInbox02();
		Object.defineProperty(exports, "MailInbox02", { enumerable: true, get: function () { return __importDefault(MailInbox02_1).default; } });
		var MailOpened01_1 = requireMailOpened01();
		Object.defineProperty(exports, "MailOpened01", { enumerable: true, get: function () { return __importDefault(MailOpened01_1).default; } });
		var MailOpened02_1 = requireMailOpened02();
		Object.defineProperty(exports, "MailOpened02", { enumerable: true, get: function () { return __importDefault(MailOpened02_1).default; } });
		var Map01_1 = requireMap01();
		Object.defineProperty(exports, "Map01", { enumerable: true, get: function () { return __importDefault(Map01_1).default; } });
		var Map02_1 = requireMap02();
		Object.defineProperty(exports, "Map02", { enumerable: true, get: function () { return __importDefault(Map02_1).default; } });
		var MarkCheck_1 = requireMarkCheck();
		Object.defineProperty(exports, "MarkCheck", { enumerable: true, get: function () { return __importDefault(MarkCheck_1).default; } });
		var MarkClose_1 = requireMarkClose();
		Object.defineProperty(exports, "MarkClose", { enumerable: true, get: function () { return __importDefault(MarkClose_1).default; } });
		var MarkMinus_1 = requireMarkMinus();
		Object.defineProperty(exports, "MarkMinus", { enumerable: true, get: function () { return __importDefault(MarkMinus_1).default; } });
		var MarkPlus_1 = requireMarkPlus();
		Object.defineProperty(exports, "MarkPlus", { enumerable: true, get: function () { return __importDefault(MarkPlus_1).default; } });
		var Mark_1 = requireMark();
		Object.defineProperty(exports, "Mark", { enumerable: true, get: function () { return __importDefault(Mark_1).default; } });
		var MarkerPin01_1 = requireMarkerPin01();
		Object.defineProperty(exports, "MarkerPin01", { enumerable: true, get: function () { return __importDefault(MarkerPin01_1).default; } });
		var MarkerPin02_1 = requireMarkerPin02();
		Object.defineProperty(exports, "MarkerPin02", { enumerable: true, get: function () { return __importDefault(MarkerPin02_1).default; } });
		var MarkerPin03_1 = requireMarkerPin03();
		Object.defineProperty(exports, "MarkerPin03", { enumerable: true, get: function () { return __importDefault(MarkerPin03_1).default; } });
		var MarkerPin04_1 = requireMarkerPin04();
		Object.defineProperty(exports, "MarkerPin04", { enumerable: true, get: function () { return __importDefault(MarkerPin04_1).default; } });
		var MarkerPin05_1 = requireMarkerPin05();
		Object.defineProperty(exports, "MarkerPin05", { enumerable: true, get: function () { return __importDefault(MarkerPin05_1).default; } });
		var Medal01_1 = requireMedal01();
		Object.defineProperty(exports, "Medal01", { enumerable: true, get: function () { return __importDefault(Medal01_1).default; } });
		var Medal02_1 = requireMedal02();
		Object.defineProperty(exports, "Medal02", { enumerable: true, get: function () { return __importDefault(Medal02_1).default; } });
		var Menu01_1 = requireMenu01();
		Object.defineProperty(exports, "Menu01", { enumerable: true, get: function () { return __importDefault(Menu01_1).default; } });
		var Menu02_1 = requireMenu02();
		Object.defineProperty(exports, "Menu02", { enumerable: true, get: function () { return __importDefault(Menu02_1).default; } });
		var Menu03_1 = requireMenu03();
		Object.defineProperty(exports, "Menu03", { enumerable: true, get: function () { return __importDefault(Menu03_1).default; } });
		var Menu04_1 = requireMenu04();
		Object.defineProperty(exports, "Menu04", { enumerable: true, get: function () { return __importDefault(Menu04_1).default; } });
		var MessageAlert_1 = requireMessageAlert();
		Object.defineProperty(exports, "MessageAlert", { enumerable: true, get: function () { return __importDefault(MessageAlert_1).default; } });
		var MessageChat_1 = requireMessageChat();
		Object.defineProperty(exports, "MessageChat", { enumerable: true, get: function () { return __importDefault(MessageChat_1).default; } });
		var MessageCheck_1 = requireMessageCheck();
		Object.defineProperty(exports, "MessageCheck", { enumerable: true, get: function () { return __importDefault(MessageCheck_1).default; } });
		var MessageClose_1 = requireMessageClose();
		Object.defineProperty(exports, "MessageClose", { enumerable: true, get: function () { return __importDefault(MessageClose_1).default; } });
		var MessageDots_1 = requireMessageDots();
		Object.defineProperty(exports, "MessageDots", { enumerable: true, get: function () { return __importDefault(MessageDots_1).default; } });
		var MessageHeart_1 = requireMessageHeart();
		Object.defineProperty(exports, "MessageHeart", { enumerable: true, get: function () { return __importDefault(MessageHeart_1).default; } });
		var MessageNotification_1 = requireMessageNotification();
		Object.defineProperty(exports, "MessageNotification", { enumerable: true, get: function () { return __importDefault(MessageNotification_1).default; } });
		var MessagePlus_1 = requireMessagePlus();
		Object.defineProperty(exports, "MessagePlus", { enumerable: true, get: function () { return __importDefault(MessagePlus_1).default; } });
		var MessageQuestion_1 = requireMessageQuestion();
		Object.defineProperty(exports, "MessageQuestion", { enumerable: true, get: function () { return __importDefault(MessageQuestion_1).default; } });
		var MessageSmile_1 = requireMessageSmile();
		Object.defineProperty(exports, "MessageSmile", { enumerable: true, get: function () { return __importDefault(MessageSmile_1).default; } });
		var MessageText_1 = requireMessageText();
		Object.defineProperty(exports, "MessageText", { enumerable: true, get: function () { return __importDefault(MessageText_1).default; } });
		var Message_1 = requireMessage();
		Object.defineProperty(exports, "Message", { enumerable: true, get: function () { return __importDefault(Message_1).default; } });
		var MicrophoneOff_1 = requireMicrophoneOff();
		Object.defineProperty(exports, "MicrophoneOff", { enumerable: true, get: function () { return __importDefault(MicrophoneOff_1).default; } });
		var Microphone_1 = requireMicrophone();
		Object.defineProperty(exports, "Microphone", { enumerable: true, get: function () { return __importDefault(Microphone_1).default; } });
		var Monitor_1 = requireMonitor();
		Object.defineProperty(exports, "Monitor", { enumerable: true, get: function () { return __importDefault(Monitor_1).default; } });
		var MoodContent_1 = requireMoodContent();
		Object.defineProperty(exports, "MoodContent", { enumerable: true, get: function () { return __importDefault(MoodContent_1).default; } });
		var MoodFrown_1 = requireMoodFrown();
		Object.defineProperty(exports, "MoodFrown", { enumerable: true, get: function () { return __importDefault(MoodFrown_1).default; } });
		var MoodHappy_1 = requireMoodHappy();
		Object.defineProperty(exports, "MoodHappy", { enumerable: true, get: function () { return __importDefault(MoodHappy_1).default; } });
		var MoodNeutral_1 = requireMoodNeutral();
		Object.defineProperty(exports, "MoodNeutral", { enumerable: true, get: function () { return __importDefault(MoodNeutral_1).default; } });
		var MoodSad_1 = requireMoodSad();
		Object.defineProperty(exports, "MoodSad", { enumerable: true, get: function () { return __importDefault(MoodSad_1).default; } });
		var MoodSmile_1 = requireMoodSmile();
		Object.defineProperty(exports, "MoodSmile", { enumerable: true, get: function () { return __importDefault(MoodSmile_1).default; } });
		var MoodWink_1 = requireMoodWink();
		Object.defineProperty(exports, "MoodWink", { enumerable: true, get: function () { return __importDefault(MoodWink_1).default; } });
		var MoreHandler_1 = requireMoreHandler();
		Object.defineProperty(exports, "MoreHandler", { enumerable: true, get: function () { return __importDefault(MoreHandler_1).default; } });
		var MoreHorizontal_1 = requireMoreHorizontal();
		Object.defineProperty(exports, "MoreHorizontal", { enumerable: true, get: function () { return __importDefault(MoreHorizontal_1).default; } });
		var MoreVertical_1 = requireMoreVertical();
		Object.defineProperty(exports, "MoreVertical", { enumerable: true, get: function () { return __importDefault(MoreVertical_1).default; } });
		var More_1 = requireMore();
		Object.defineProperty(exports, "More", { enumerable: true, get: function () { return __importDefault(More_1).default; } });
		var MotorcycleBag_1 = requireMotorcycleBag();
		Object.defineProperty(exports, "MotorcycleBag", { enumerable: true, get: function () { return __importDefault(MotorcycleBag_1).default; } });
		var MotorcycleHelmetLeft_1 = requireMotorcycleHelmetLeft();
		Object.defineProperty(exports, "MotorcycleHelmetLeft", { enumerable: true, get: function () { return __importDefault(MotorcycleHelmetLeft_1).default; } });
		var MotorcycleHelmetRight_1 = requireMotorcycleHelmetRight();
		Object.defineProperty(exports, "MotorcycleHelmetRight", { enumerable: true, get: function () { return __importDefault(MotorcycleHelmetRight_1).default; } });
		var Motorcycle_1 = requireMotorcycle();
		Object.defineProperty(exports, "Motorcycle", { enumerable: true, get: function () { return __importDefault(Motorcycle_1).default; } });
		var Mouse_1 = requireMouse();
		Object.defineProperty(exports, "Mouse", { enumerable: true, get: function () { return __importDefault(Mouse_1).default; } });
		var MusicalNote01_1 = requireMusicalNote01();
		Object.defineProperty(exports, "MusicalNote01", { enumerable: true, get: function () { return __importDefault(MusicalNote01_1).default; } });
		var MusicalNote02_1 = requireMusicalNote02();
		Object.defineProperty(exports, "MusicalNote02", { enumerable: true, get: function () { return __importDefault(MusicalNote02_1).default; } });
		var Navigator01Off_1 = requireNavigator01Off();
		Object.defineProperty(exports, "Navigator01Off", { enumerable: true, get: function () { return __importDefault(Navigator01Off_1).default; } });
		var Navigator01On_1 = requireNavigator01On();
		Object.defineProperty(exports, "Navigator01On", { enumerable: true, get: function () { return __importDefault(Navigator01On_1).default; } });
		var Navigator02Off_1 = requireNavigator02Off();
		Object.defineProperty(exports, "Navigator02Off", { enumerable: true, get: function () { return __importDefault(Navigator02Off_1).default; } });
		var Navigator02On_1 = requireNavigator02On();
		Object.defineProperty(exports, "Navigator02On", { enumerable: true, get: function () { return __importDefault(Navigator02On_1).default; } });
		var Notebook_1 = requireNotebook();
		Object.defineProperty(exports, "Notebook", { enumerable: true, get: function () { return __importDefault(Notebook_1).default; } });
		var NotificationBellOff_1 = requireNotificationBellOff();
		Object.defineProperty(exports, "NotificationBellOff", { enumerable: true, get: function () { return __importDefault(NotificationBellOff_1).default; } });
		var NotificationBellOn_1 = requireNotificationBellOn();
		Object.defineProperty(exports, "NotificationBellOn", { enumerable: true, get: function () { return __importDefault(NotificationBellOn_1).default; } });
		var NotificationBell_1 = requireNotificationBell();
		Object.defineProperty(exports, "NotificationBell", { enumerable: true, get: function () { return __importDefault(NotificationBell_1).default; } });
		var NotificationBox_1 = requireNotificationBox();
		Object.defineProperty(exports, "NotificationBox", { enumerable: true, get: function () { return __importDefault(NotificationBox_1).default; } });
		var NotificationMessage_1 = requireNotificationMessage();
		Object.defineProperty(exports, "NotificationMessage", { enumerable: true, get: function () { return __importDefault(NotificationMessage_1).default; } });
		var Number0_1 = requireNumber0();
		Object.defineProperty(exports, "Number0", { enumerable: true, get: function () { return __importDefault(Number0_1).default; } });
		var Number1_1 = requireNumber1();
		Object.defineProperty(exports, "Number1", { enumerable: true, get: function () { return __importDefault(Number1_1).default; } });
		var Number2_1 = requireNumber2();
		Object.defineProperty(exports, "Number2", { enumerable: true, get: function () { return __importDefault(Number2_1).default; } });
		var Number3_1 = requireNumber3();
		Object.defineProperty(exports, "Number3", { enumerable: true, get: function () { return __importDefault(Number3_1).default; } });
		var Number4_1 = requireNumber4();
		Object.defineProperty(exports, "Number4", { enumerable: true, get: function () { return __importDefault(Number4_1).default; } });
		var Number5_1 = requireNumber5();
		Object.defineProperty(exports, "Number5", { enumerable: true, get: function () { return __importDefault(Number5_1).default; } });
		var Number6_1 = requireNumber6();
		Object.defineProperty(exports, "Number6", { enumerable: true, get: function () { return __importDefault(Number6_1).default; } });
		var Number7_1 = requireNumber7();
		Object.defineProperty(exports, "Number7", { enumerable: true, get: function () { return __importDefault(Number7_1).default; } });
		var Number8_1 = requireNumber8();
		Object.defineProperty(exports, "Number8", { enumerable: true, get: function () { return __importDefault(Number8_1).default; } });
		var Number9_1 = requireNumber9();
		Object.defineProperty(exports, "Number9", { enumerable: true, get: function () { return __importDefault(Number9_1).default; } });
		var OpenNew_1 = requireOpenNew();
		Object.defineProperty(exports, "OpenNew", { enumerable: true, get: function () { return __importDefault(OpenNew_1).default; } });
		var Package01_1 = requirePackage01();
		Object.defineProperty(exports, "Package01", { enumerable: true, get: function () { return __importDefault(Package01_1).default; } });
		var Package02_1 = requirePackage02();
		Object.defineProperty(exports, "Package02", { enumerable: true, get: function () { return __importDefault(Package02_1).default; } });
		var PackageCheck_1 = requirePackageCheck();
		Object.defineProperty(exports, "PackageCheck", { enumerable: true, get: function () { return __importDefault(PackageCheck_1).default; } });
		var PackageClose_1 = requirePackageClose();
		Object.defineProperty(exports, "PackageClose", { enumerable: true, get: function () { return __importDefault(PackageClose_1).default; } });
		var PackageCustom01_1 = requirePackageCustom01();
		Object.defineProperty(exports, "PackageCustom01", { enumerable: true, get: function () { return __importDefault(PackageCustom01_1).default; } });
		var PackageCustom02_1 = requirePackageCustom02();
		Object.defineProperty(exports, "PackageCustom02", { enumerable: true, get: function () { return __importDefault(PackageCustom02_1).default; } });
		var PackageCustom03_1 = requirePackageCustom03();
		Object.defineProperty(exports, "PackageCustom03", { enumerable: true, get: function () { return __importDefault(PackageCustom03_1).default; } });
		var PackageMinus_1 = requirePackageMinus();
		Object.defineProperty(exports, "PackageMinus", { enumerable: true, get: function () { return __importDefault(PackageMinus_1).default; } });
		var PackagePlus_1 = requirePackagePlus();
		Object.defineProperty(exports, "PackagePlus", { enumerable: true, get: function () { return __importDefault(PackagePlus_1).default; } });
		var PackageSearch_1 = requirePackageSearch();
		Object.defineProperty(exports, "PackageSearch", { enumerable: true, get: function () { return __importDefault(PackageSearch_1).default; } });
		var PasscodeLock_1 = requirePasscodeLock();
		Object.defineProperty(exports, "PasscodeLock", { enumerable: true, get: function () { return __importDefault(PasscodeLock_1).default; } });
		var Passcode_1 = requirePasscode();
		Object.defineProperty(exports, "Passcode", { enumerable: true, get: function () { return __importDefault(Passcode_1).default; } });
		var Pickup01_1 = requirePickup01();
		Object.defineProperty(exports, "Pickup01", { enumerable: true, get: function () { return __importDefault(Pickup01_1).default; } });
		var Pickup02_1 = requirePickup02();
		Object.defineProperty(exports, "Pickup02", { enumerable: true, get: function () { return __importDefault(Pickup02_1).default; } });
		var PiggyBank_1 = requirePiggyBank();
		Object.defineProperty(exports, "PiggyBank", { enumerable: true, get: function () { return __importDefault(PiggyBank_1).default; } });
		var Pin01_1 = requirePin01();
		Object.defineProperty(exports, "Pin01", { enumerable: true, get: function () { return __importDefault(Pin01_1).default; } });
		var Pin02_1 = requirePin02();
		Object.defineProperty(exports, "Pin02", { enumerable: true, get: function () { return __importDefault(Pin02_1).default; } });
		var Plane_1 = requirePlane();
		Object.defineProperty(exports, "Plane", { enumerable: true, get: function () { return __importDefault(Plane_1).default; } });
		var Print_1 = requirePrint();
		Object.defineProperty(exports, "Print", { enumerable: true, get: function () { return __importDefault(Print_1).default; } });
		var Puzzle_1 = requirePuzzle();
		Object.defineProperty(exports, "Puzzle", { enumerable: true, get: function () { return __importDefault(Puzzle_1).default; } });
		var QrCode01_1 = requireQrCode01();
		Object.defineProperty(exports, "QrCode01", { enumerable: true, get: function () { return __importDefault(QrCode01_1).default; } });
		var QrCode02_1 = requireQrCode02();
		Object.defineProperty(exports, "QrCode02", { enumerable: true, get: function () { return __importDefault(QrCode02_1).default; } });
		var ReceiptCheck_1 = requireReceiptCheck();
		Object.defineProperty(exports, "ReceiptCheck", { enumerable: true, get: function () { return __importDefault(ReceiptCheck_1).default; } });
		var Receipt_1 = requireReceipt();
		Object.defineProperty(exports, "Receipt", { enumerable: true, get: function () { return __importDefault(Receipt_1).default; } });
		var RefreshBackward_1 = requireRefreshBackward();
		Object.defineProperty(exports, "RefreshBackward", { enumerable: true, get: function () { return __importDefault(RefreshBackward_1).default; } });
		var RefreshForward_1 = requireRefreshForward();
		Object.defineProperty(exports, "RefreshForward", { enumerable: true, get: function () { return __importDefault(RefreshForward_1).default; } });
		var ReloadBackward_1 = requireReloadBackward();
		Object.defineProperty(exports, "ReloadBackward", { enumerable: true, get: function () { return __importDefault(ReloadBackward_1).default; } });
		var ReloadForward_1 = requireReloadForward();
		Object.defineProperty(exports, "ReloadForward", { enumerable: true, get: function () { return __importDefault(ReloadForward_1).default; } });
		var Residence01_1 = requireResidence01();
		Object.defineProperty(exports, "Residence01", { enumerable: true, get: function () { return __importDefault(Residence01_1).default; } });
		var Residence02_1 = requireResidence02();
		Object.defineProperty(exports, "Residence02", { enumerable: true, get: function () { return __importDefault(Residence02_1).default; } });
		var Rocket01_1 = requireRocket01();
		Object.defineProperty(exports, "Rocket01", { enumerable: true, get: function () { return __importDefault(Rocket01_1).default; } });
		var Rocket02_1 = requireRocket02();
		Object.defineProperty(exports, "Rocket02", { enumerable: true, get: function () { return __importDefault(Rocket02_1).default; } });
		var Route01_1 = requireRoute01();
		Object.defineProperty(exports, "Route01", { enumerable: true, get: function () { return __importDefault(Route01_1).default; } });
		var Route02_1 = requireRoute02();
		Object.defineProperty(exports, "Route02", { enumerable: true, get: function () { return __importDefault(Route02_1).default; } });
		var Route03_1 = requireRoute03();
		Object.defineProperty(exports, "Route03", { enumerable: true, get: function () { return __importDefault(Route03_1).default; } });
		var Route04_1 = requireRoute04();
		Object.defineProperty(exports, "Route04", { enumerable: true, get: function () { return __importDefault(Route04_1).default; } });
		var Route05_1 = requireRoute05();
		Object.defineProperty(exports, "Route05", { enumerable: true, get: function () { return __importDefault(Route05_1).default; } });
		var Route06_1 = requireRoute06();
		Object.defineProperty(exports, "Route06", { enumerable: true, get: function () { return __importDefault(Route06_1).default; } });
		var Route07_1 = requireRoute07();
		Object.defineProperty(exports, "Route07", { enumerable: true, get: function () { return __importDefault(Route07_1).default; } });
		var Rows02_1 = requireRows02();
		Object.defineProperty(exports, "Rows02", { enumerable: true, get: function () { return __importDefault(Rows02_1).default; } });
		var Rows03_1 = requireRows03();
		Object.defineProperty(exports, "Rows03", { enumerable: true, get: function () { return __importDefault(Rows03_1).default; } });
		var Sale01_1 = requireSale01();
		Object.defineProperty(exports, "Sale01", { enumerable: true, get: function () { return __importDefault(Sale01_1).default; } });
		var Sale02_1 = requireSale02();
		Object.defineProperty(exports, "Sale02", { enumerable: true, get: function () { return __importDefault(Sale02_1).default; } });
		var SaveGroup_1 = requireSaveGroup();
		Object.defineProperty(exports, "SaveGroup", { enumerable: true, get: function () { return __importDefault(SaveGroup_1).default; } });
		var Save_1 = requireSave();
		Object.defineProperty(exports, "Save", { enumerable: true, get: function () { return __importDefault(Save_1).default; } });
		var Scan_1 = requireScan();
		Object.defineProperty(exports, "Scan", { enumerable: true, get: function () { return __importDefault(Scan_1).default; } });
		var ScreenExpand_1 = requireScreenExpand();
		Object.defineProperty(exports, "ScreenExpand", { enumerable: true, get: function () { return __importDefault(ScreenExpand_1).default; } });
		var ScreenMaximize_1 = requireScreenMaximize();
		Object.defineProperty(exports, "ScreenMaximize", { enumerable: true, get: function () { return __importDefault(ScreenMaximize_1).default; } });
		var ScreenMinimize_1 = requireScreenMinimize();
		Object.defineProperty(exports, "ScreenMinimize", { enumerable: true, get: function () { return __importDefault(ScreenMinimize_1).default; } });
		var SearchLarge_1 = requireSearchLarge();
		Object.defineProperty(exports, "SearchLarge", { enumerable: true, get: function () { return __importDefault(SearchLarge_1).default; } });
		var SearchMedium_1 = requireSearchMedium();
		Object.defineProperty(exports, "SearchMedium", { enumerable: true, get: function () { return __importDefault(SearchMedium_1).default; } });
		var Send01_1 = requireSend01();
		Object.defineProperty(exports, "Send01", { enumerable: true, get: function () { return __importDefault(Send01_1).default; } });
		var Send02_1 = requireSend02();
		Object.defineProperty(exports, "Send02", { enumerable: true, get: function () { return __importDefault(Send02_1).default; } });
		var Send03_1 = requireSend03();
		Object.defineProperty(exports, "Send03", { enumerable: true, get: function () { return __importDefault(Send03_1).default; } });
		var Settings01_1 = requireSettings01();
		Object.defineProperty(exports, "Settings01", { enumerable: true, get: function () { return __importDefault(Settings01_1).default; } });
		var Settings02_1 = requireSettings02();
		Object.defineProperty(exports, "Settings02", { enumerable: true, get: function () { return __importDefault(Settings02_1).default; } });
		var Settings03_1 = requireSettings03();
		Object.defineProperty(exports, "Settings03", { enumerable: true, get: function () { return __importDefault(Settings03_1).default; } });
		var Share01_1 = requireShare01();
		Object.defineProperty(exports, "Share01", { enumerable: true, get: function () { return __importDefault(Share01_1).default; } });
		var Share02_1 = requireShare02();
		Object.defineProperty(exports, "Share02", { enumerable: true, get: function () { return __importDefault(Share02_1).default; } });
		var ShieldCheck_1 = requireShieldCheck();
		Object.defineProperty(exports, "ShieldCheck", { enumerable: true, get: function () { return __importDefault(ShieldCheck_1).default; } });
		var ShieldCurrency_1 = requireShieldCurrency();
		Object.defineProperty(exports, "ShieldCurrency", { enumerable: true, get: function () { return __importDefault(ShieldCurrency_1).default; } });
		var ShieldOff_1 = requireShieldOff();
		Object.defineProperty(exports, "ShieldOff", { enumerable: true, get: function () { return __importDefault(ShieldOff_1).default; } });
		var ShieldPlus_1 = requireShieldPlus();
		Object.defineProperty(exports, "ShieldPlus", { enumerable: true, get: function () { return __importDefault(ShieldPlus_1).default; } });
		var ShieldZap_1 = requireShieldZap();
		Object.defineProperty(exports, "ShieldZap", { enumerable: true, get: function () { return __importDefault(ShieldZap_1).default; } });
		var Shield_1 = requireShield();
		Object.defineProperty(exports, "Shield", { enumerable: true, get: function () { return __importDefault(Shield_1).default; } });
		var ShoppingBag01_1 = requireShoppingBag01();
		Object.defineProperty(exports, "ShoppingBag01", { enumerable: true, get: function () { return __importDefault(ShoppingBag01_1).default; } });
		var ShoppingBag02_1 = requireShoppingBag02();
		Object.defineProperty(exports, "ShoppingBag02", { enumerable: true, get: function () { return __importDefault(ShoppingBag02_1).default; } });
		var ShoppingCart01_1 = requireShoppingCart01();
		Object.defineProperty(exports, "ShoppingCart01", { enumerable: true, get: function () { return __importDefault(ShoppingCart01_1).default; } });
		var ShoppingCart02_1 = requireShoppingCart02();
		Object.defineProperty(exports, "ShoppingCart02", { enumerable: true, get: function () { return __importDefault(ShoppingCart02_1).default; } });
		var Smartphone_1 = requireSmartphone();
		Object.defineProperty(exports, "Smartphone", { enumerable: true, get: function () { return __importDefault(Smartphone_1).default; } });
		var SortHorizontal_1 = requireSortHorizontal();
		Object.defineProperty(exports, "SortHorizontal", { enumerable: true, get: function () { return __importDefault(SortHorizontal_1).default; } });
		var SortList_1 = requireSortList();
		Object.defineProperty(exports, "SortList", { enumerable: true, get: function () { return __importDefault(SortList_1).default; } });
		var SortVertical_1 = requireSortVertical();
		Object.defineProperty(exports, "SortVertical", { enumerable: true, get: function () { return __importDefault(SortVertical_1).default; } });
		var Squares01_1 = requireSquares01();
		Object.defineProperty(exports, "Squares01", { enumerable: true, get: function () { return __importDefault(Squares01_1).default; } });
		var Squares02_1 = requireSquares02();
		Object.defineProperty(exports, "Squares02", { enumerable: true, get: function () { return __importDefault(Squares02_1).default; } });
		var Store_1 = requireStore();
		Object.defineProperty(exports, "Store", { enumerable: true, get: function () { return __importDefault(Store_1).default; } });
		var SwitchHorizontal01_1 = requireSwitchHorizontal01();
		Object.defineProperty(exports, "SwitchHorizontal01", { enumerable: true, get: function () { return __importDefault(SwitchHorizontal01_1).default; } });
		var SwitchHorizontal02_1 = requireSwitchHorizontal02();
		Object.defineProperty(exports, "SwitchHorizontal02", { enumerable: true, get: function () { return __importDefault(SwitchHorizontal02_1).default; } });
		var SwitchVertical01_1 = requireSwitchVertical01();
		Object.defineProperty(exports, "SwitchVertical01", { enumerable: true, get: function () { return __importDefault(SwitchVertical01_1).default; } });
		var SwitchVertical02_1 = requireSwitchVertical02();
		Object.defineProperty(exports, "SwitchVertical02", { enumerable: true, get: function () { return __importDefault(SwitchVertical02_1).default; } });
		var Sync01_1 = requireSync01();
		Object.defineProperty(exports, "Sync01", { enumerable: true, get: function () { return __importDefault(Sync01_1).default; } });
		var Sync02_1 = requireSync02();
		Object.defineProperty(exports, "Sync02", { enumerable: true, get: function () { return __importDefault(Sync02_1).default; } });
		var Table_1 = requireTable();
		Object.defineProperty(exports, "Table", { enumerable: true, get: function () { return __importDefault(Table_1).default; } });
		var Tablet_1 = requireTablet();
		Object.defineProperty(exports, "Tablet", { enumerable: true, get: function () { return __importDefault(Tablet_1).default; } });
		var TagGroup_1 = requireTagGroup();
		Object.defineProperty(exports, "TagGroup", { enumerable: true, get: function () { return __importDefault(TagGroup_1).default; } });
		var Tag_1 = requireTag();
		Object.defineProperty(exports, "Tag", { enumerable: true, get: function () { return __importDefault(Tag_1).default; } });
		var Target01_1 = requireTarget01();
		Object.defineProperty(exports, "Target01", { enumerable: true, get: function () { return __importDefault(Target01_1).default; } });
		var Target02_1 = requireTarget02();
		Object.defineProperty(exports, "Target02", { enumerable: true, get: function () { return __importDefault(Target02_1).default; } });
		var Target_1 = requireTarget();
		Object.defineProperty(exports, "Target", { enumerable: true, get: function () { return __importDefault(Target_1).default; } });
		var ThumbsDown_1 = requireThumbsDown();
		Object.defineProperty(exports, "ThumbsDown", { enumerable: true, get: function () { return __importDefault(ThumbsDown_1).default; } });
		var ThumbsUp_1 = requireThumbsUp();
		Object.defineProperty(exports, "ThumbsUp", { enumerable: true, get: function () { return __importDefault(ThumbsUp_1).default; } });
		var Ticket01_1 = requireTicket01();
		Object.defineProperty(exports, "Ticket01", { enumerable: true, get: function () { return __importDefault(Ticket01_1).default; } });
		var Ticket02_1 = requireTicket02();
		Object.defineProperty(exports, "Ticket02", { enumerable: true, get: function () { return __importDefault(Ticket02_1).default; } });
		var TimeBackward_1 = requireTimeBackward();
		Object.defineProperty(exports, "TimeBackward", { enumerable: true, get: function () { return __importDefault(TimeBackward_1).default; } });
		var TimeCheck_1 = requireTimeCheck();
		Object.defineProperty(exports, "TimeCheck", { enumerable: true, get: function () { return __importDefault(TimeCheck_1).default; } });
		var TimeForward_1 = requireTimeForward();
		Object.defineProperty(exports, "TimeForward", { enumerable: true, get: function () { return __importDefault(TimeForward_1).default; } });
		var TimePlus_1 = requireTimePlus();
		Object.defineProperty(exports, "TimePlus", { enumerable: true, get: function () { return __importDefault(TimePlus_1).default; } });
		var TimeRefresh_1 = requireTimeRefresh();
		Object.defineProperty(exports, "TimeRefresh", { enumerable: true, get: function () { return __importDefault(TimeRefresh_1).default; } });
		var TimeSleep_1 = requireTimeSleep();
		Object.defineProperty(exports, "TimeSleep", { enumerable: true, get: function () { return __importDefault(TimeSleep_1).default; } });
		var Time_1 = requireTime();
		Object.defineProperty(exports, "Time", { enumerable: true, get: function () { return __importDefault(Time_1).default; } });
		var Trophy_1 = requireTrophy();
		Object.defineProperty(exports, "Trophy", { enumerable: true, get: function () { return __importDefault(Trophy_1).default; } });
		var Truck_1 = requireTruck();
		Object.defineProperty(exports, "Truck", { enumerable: true, get: function () { return __importDefault(Truck_1).default; } });
		var UserCheck_1 = requireUserCheck();
		Object.defineProperty(exports, "UserCheck", { enumerable: true, get: function () { return __importDefault(UserCheck_1).default; } });
		var UserDown_1 = requireUserDown();
		Object.defineProperty(exports, "UserDown", { enumerable: true, get: function () { return __importDefault(UserDown_1).default; } });
		var UserEdit_1 = requireUserEdit();
		Object.defineProperty(exports, "UserEdit", { enumerable: true, get: function () { return __importDefault(UserEdit_1).default; } });
		var UserGroupCheck_1 = requireUserGroupCheck();
		Object.defineProperty(exports, "UserGroupCheck", { enumerable: true, get: function () { return __importDefault(UserGroupCheck_1).default; } });
		var UserGroupDown_1 = requireUserGroupDown();
		Object.defineProperty(exports, "UserGroupDown", { enumerable: true, get: function () { return __importDefault(UserGroupDown_1).default; } });
		var UserGroupEdit_1 = requireUserGroupEdit();
		Object.defineProperty(exports, "UserGroupEdit", { enumerable: true, get: function () { return __importDefault(UserGroupEdit_1).default; } });
		var UserGroupLeft_1 = requireUserGroupLeft();
		Object.defineProperty(exports, "UserGroupLeft", { enumerable: true, get: function () { return __importDefault(UserGroupLeft_1).default; } });
		var UserGroupMinus_1 = requireUserGroupMinus();
		Object.defineProperty(exports, "UserGroupMinus", { enumerable: true, get: function () { return __importDefault(UserGroupMinus_1).default; } });
		var UserGroupPlus_1 = requireUserGroupPlus();
		Object.defineProperty(exports, "UserGroupPlus", { enumerable: true, get: function () { return __importDefault(UserGroupPlus_1).default; } });
		var UserGroupRemove_1 = requireUserGroupRemove();
		Object.defineProperty(exports, "UserGroupRemove", { enumerable: true, get: function () { return __importDefault(UserGroupRemove_1).default; } });
		var UserGroupRight_1 = requireUserGroupRight();
		Object.defineProperty(exports, "UserGroupRight", { enumerable: true, get: function () { return __importDefault(UserGroupRight_1).default; } });
		var UserGroupUp_1 = requireUserGroupUp();
		Object.defineProperty(exports, "UserGroupUp", { enumerable: true, get: function () { return __importDefault(UserGroupUp_1).default; } });
		var UserGroup_1 = requireUserGroup();
		Object.defineProperty(exports, "UserGroup", { enumerable: true, get: function () { return __importDefault(UserGroup_1).default; } });
		var UserLeft_1 = requireUserLeft();
		Object.defineProperty(exports, "UserLeft", { enumerable: true, get: function () { return __importDefault(UserLeft_1).default; } });
		var UserMinus_1 = requireUserMinus();
		Object.defineProperty(exports, "UserMinus", { enumerable: true, get: function () { return __importDefault(UserMinus_1).default; } });
		var UserPlus_1 = requireUserPlus();
		Object.defineProperty(exports, "UserPlus", { enumerable: true, get: function () { return __importDefault(UserPlus_1).default; } });
		var UserRemove_1 = requireUserRemove();
		Object.defineProperty(exports, "UserRemove", { enumerable: true, get: function () { return __importDefault(UserRemove_1).default; } });
		var UserRight_1 = requireUserRight();
		Object.defineProperty(exports, "UserRight", { enumerable: true, get: function () { return __importDefault(UserRight_1).default; } });
		var UserUp_1 = requireUserUp();
		Object.defineProperty(exports, "UserUp", { enumerable: true, get: function () { return __importDefault(UserUp_1).default; } });
		var User_1 = requireUser();
		Object.defineProperty(exports, "User", { enumerable: true, get: function () { return __importDefault(User_1).default; } });
		var Vacations_1 = requireVacations();
		Object.defineProperty(exports, "Vacations", { enumerable: true, get: function () { return __importDefault(Vacations_1).default; } });
		var Van_1 = requireVan();
		Object.defineProperty(exports, "Van", { enumerable: true, get: function () { return __importDefault(Van_1).default; } });
		var VideoRecorderOff_1 = requireVideoRecorderOff();
		Object.defineProperty(exports, "VideoRecorderOff", { enumerable: true, get: function () { return __importDefault(VideoRecorderOff_1).default; } });
		var VideoRecorder_1 = requireVideoRecorder();
		Object.defineProperty(exports, "VideoRecorder", { enumerable: true, get: function () { return __importDefault(VideoRecorder_1).default; } });
		var WalletClosed_1 = requireWalletClosed();
		Object.defineProperty(exports, "WalletClosed", { enumerable: true, get: function () { return __importDefault(WalletClosed_1).default; } });
		var WalletOpened_1 = requireWalletOpened();
		Object.defineProperty(exports, "WalletOpened", { enumerable: true, get: function () { return __importDefault(WalletOpened_1).default; } });
		var WeatherDay_1 = requireWeatherDay();
		Object.defineProperty(exports, "WeatherDay", { enumerable: true, get: function () { return __importDefault(WeatherDay_1).default; } });
		var WeatherNight_1 = requireWeatherNight();
		Object.defineProperty(exports, "WeatherNight", { enumerable: true, get: function () { return __importDefault(WeatherNight_1).default; } });
		var WeatherRain01_1 = requireWeatherRain01();
		Object.defineProperty(exports, "WeatherRain01", { enumerable: true, get: function () { return __importDefault(WeatherRain01_1).default; } });
		var WeatherRain02_1 = requireWeatherRain02();
		Object.defineProperty(exports, "WeatherRain02", { enumerable: true, get: function () { return __importDefault(WeatherRain02_1).default; } });
		var WeatherRain03_1 = requireWeatherRain03();
		Object.defineProperty(exports, "WeatherRain03", { enumerable: true, get: function () { return __importDefault(WeatherRain03_1).default; } });
		var WeatherRain04_1 = requireWeatherRain04();
		Object.defineProperty(exports, "WeatherRain04", { enumerable: true, get: function () { return __importDefault(WeatherRain04_1).default; } });
		var WeatherRain05_1 = requireWeatherRain05();
		Object.defineProperty(exports, "WeatherRain05", { enumerable: true, get: function () { return __importDefault(WeatherRain05_1).default; } });
		var WeatherTemperature_1 = requireWeatherTemperature();
		Object.defineProperty(exports, "WeatherTemperature", { enumerable: true, get: function () { return __importDefault(WeatherTemperature_1).default; } });
		var WifiOff_1 = requireWifiOff();
		Object.defineProperty(exports, "WifiOff", { enumerable: true, get: function () { return __importDefault(WifiOff_1).default; } });
		var Wifi_1 = requireWifi();
		Object.defineProperty(exports, "Wifi", { enumerable: true, get: function () { return __importDefault(Wifi_1).default; } });
		var ZoomIn_1 = requireZoomIn();
		Object.defineProperty(exports, "ZoomIn", { enumerable: true, get: function () { return __importDefault(ZoomIn_1).default; } });
		var ZoomOut_1 = requireZoomOut();
		Object.defineProperty(exports, "ZoomOut", { enumerable: true, get: function () { return __importDefault(ZoomOut_1).default; } });
		
	} (web));
	return web;
}

var hasRequiredIcons;

function requireIcons () {
	if (hasRequiredIcons) return icons;
	hasRequiredIcons = 1;
	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		var tslib_1 = require$$0;
		tslib_1.__exportStar(requireWeb(), exports);
		
	} (icons));
	return icons;
}

var size = {};

var hasRequiredSize;

function requireSize () {
	if (hasRequiredSize) return size;
	hasRequiredSize = 1;
	Object.defineProperty(size, "__esModule", { value: true });
	size.size = void 0;
	size.size = {
	    large: {
	        width: "32px",
	        height: "32px",
	        strokeWidth: 2.4
	    },
	    medium: {
	        width: "24px",
	        height: "24px",
	        strokeWidth: 2
	    },
	    small: {
	        width: "20px",
	        height: "20px",
	        strokeWidth: 1.667
	    }
	};
	
	return size;
}

var src = {};

var hasRequiredSrc;

function requireSrc () {
	if (hasRequiredSrc) return src;
	hasRequiredSrc = 1;
	Object.defineProperty(src, "__esModule", { value: true });
	var tslib_1 = require$$0;
	var react_1 = tslib_1.__importDefault(require$$1);
	var Icons = tslib_1.__importStar(requireIcons());
	var size_1 = requireSize();
	function Icon(_a) {
	    var _b = _a.name, name = _b === void 0 ? "ActionArchive01" : _b, _c = _a.size, size = _c === void 0 ? "medium" : _c, _d = _a.color, color = _d === void 0 ? "currentColor" : _d;
	    return (react_1.default.createElement(Icons[name], {
	        strokeWidth: 2.4,
	        color: color,
	        strokeLinecap: "round",
	        strokeLinejoin: "round",
	        style: {
	            width: size_1.size[size || "medium"].width,
	            height: size_1.size[size || "medium"].height,
	            flexShrink: 0,
	        },
	    }) || react_1.default.createElement(react_1.default.Fragment, null));
	}
	src.default = Icon;
	
	return src;
}

(function (exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.icons = exports.Icon = void 0;
	var tslib_1 = require$$0;
	var name = tslib_1.__importStar(requireIcons());
	var size_1 = requireSize();
	var src_1 = requireSrc();
	Object.defineProperty(exports, "Icon", { enumerable: true, get: function () { return tslib_1.__importDefault(src_1).default; } });
	exports.icons = { size: size_1.size, name: name };
	
} (dist));

var MuiButton = {
  styleOverrides: {
    root: function root() {
      return {
        // Ajustes para zerar o componente
        borderRadius: "inherit",
        boxShadow: "none",
        boxSizing: "border-box",
        fontFamily: typography$1.family.primary,
        fontSize: "inherit",
        fontWeight: 600,
        height: "inherit",
        letterSpacing: 0,
        lineHeight: "inherit",
        minHeight: "inherit",
        minWidth: "inherit",
        width: "auto",
        // Definições gerais dos botões
        "&:hover": {
          boxShadow: "none"
        }
      };
    },
    fullWidth: false,
    // Definições por variante
    // blank
    blank: {
      backgroundColor: "transparent",
      color: colors.interaction.primary,
      "&:hover": {
        backgroundColor: colors.interaction["primary-container-alpha"],
        color: colors.interaction.primaryDark
      }
    },
    // Contained
    contained: {
      backgroundColor: colors.interaction.primary,
      color: colors.white,
      "&:hover": {
        backgroundColor: colors.interaction.primaryDark
      }
    },
    // Outlined
    outlined: {
      backgroundColor: colors.white,
      border: "1px solid ".concat(colors.interaction.primary),
      color: colors.interaction.primary,
      "&:hover": {
        backgroundColor: colors.white,
        border: "1px solid ".concat(colors.interaction.primaryDark),
        color: colors.interaction.primaryDark
      }
    },
    // Text
    // Desabilita o estilo padrão do MUI
    text: undefined,
    // Definições por tamanho
    // Large
    sizeLarge: {
      fontSize: typography$1.body.text.large["font-size"],
      lineHeight: typography$1.body.text.large["line-height"],
      padding: spacing.inset.medium,
      borderRadius: borders.radius.medium,
      // Ajuste de tamanho do icone nos slots start / end
      ".MuiButton-startIcon .MuiSvgIcon-root": {
        fontSize: dist.icons.size.large
      },
      ".MuiButton-endIcon .MuiSvgIcon-root": {
        fontSize: dist.icons.size.large
      }
    },
    // Medium
    sizeMedium: {
      fontSize: typography$1.body.text.medium["font-size"],
      lineHeight: typography$1.body.text.medium["line-height"],
      padding: spacing.inset.xsmall,
      borderRadius: borders.radius.small,
      // Ajuste de tamanho do icone nos slots start / end
      ".MuiButton-startIcon .MuiSvgIcon-root": {
        fontSize: dist.icons.size.large
      },
      ".MuiButton-endIcon .MuiSvgIcon-root": {
        fontSize: dist.icons.size.large
      }
    },
    // Small
    sizeSmall: {
      fontSize: typography$1.body.text.medium["font-size"],
      lineHeight: typography$1.body.text.medium["line-height"],
      padding: "".concat(spacing.inset.xxsmall, " ").concat(spacing.inset.xxxsmall, " "),
      borderRadius: borders.radius.xsmall,
      // Ajuste de tamanho do icone nos slots start / end
      ".MuiButton-startIcon .MuiSvgIcon-root": {
        fontSize: dist.icons.size.large
      },
      ".MuiButton-endIcon .MuiSvgIcon-root": {
        fontSize: dist.icons.size.large
      }
    }
  }
};

var MuiTable = {
  styleOverrides: {
    root: function root() {
      return {
        padding: spacing.inset.xxlarge,
        tableLayout: "fixed"
      };
    }
  }
};

var MuiTableHead = {
  styleOverrides: {
    root: function root() {
      return {
        " th": {
          borderSpacing: spacing.inline.medium,
          padding: "".concat(spacing.inset.large, " ").concat(spacing.inline.medium, " \n        ").concat(spacing.inset.large, " ").concat(spacing.inset.large),
          borderBottomWidth: borders.width.thick,
          borderBottomColor: colors.neutrals["outline-low"],
          color: colors.neutrals["on-surface-variant"],
          fontWeight: typography$1.subtitle.medium["font-weight"],
          fontSize: typography$1.subtitle.medium["font-size"],
          lineHeight: typography$1.subtitle.medium["line-height"]
        }
      };
    }
  }
};

var MuiTableCell = {
  styleOverrides: {
    root: function root() {
      return {
        fontFamily: typography$1.family.primary,
        letterSpacing: 0,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        "&:first-child": {
          paddingLeft: spacing.inset.large
        },
        "&:last-child": {
          paddingRight: spacing.inset.large
        }
      };
    }
  },
  variants: [{
    props: {
      variant: "iconColumn"
    },
    style: {
      width: "80px",
      textOverflow: "unset"
    }
  }]
};

var MuiTableRow = {
  styleOverrides: {
    root: function root() {
      return {
        " td": {
          borderSpacing: spacing.inline.medium,
          padding: "".concat(spacing.inset.large, " ").concat(spacing.inline.medium, " \n        ").concat(spacing.inset.large, " ").concat(spacing.inset.large),
          borderBottomWidth: borders.width.thin,
          borderBottomColor: colors.neutrals["outline-low"],
          color: colors.neutrals["on-surface"],
          fontWeight: typography$1.subtitle.small["font-weight"],
          fontSize: typography$1.subtitle.small["font-size"],
          lineHeight: typography$1.subtitle.small["line-height"]
        },
        "&:hover": {
          backgroundColor: colors.interaction["secondary-alpha"]
        }
      };
    }
  }
};

var MuiPagination = {
  styleOverrides: {
    root: function root(_ref) {
      var ownerState = _ref.ownerState;
      return {
        padding: "".concat(spacing.inset.large, " ").concat(spacing.inset.xsmall),
        borderTop: ownerState.showDivisor && "".concat(borders.width.thin, " solid ").concat(colors.neutrals["outline-low"]),
        "& .MuiPagination-ul": {
          gap: spacing.inline.quark
        },
        "& .MuiPaginationItem-previousNext": {
          display: ownerState.count < 3 && "none",
          padding: spacing.inset.xxsmall
        },
        "& .MuiPaginationItem-root": {
          backgroundColor: colors.interaction["on-primary"],
          color: colors.interaction["on-secondary"],
          "&:hover": {
            backgroundColor: colors.interaction["secondary-alpha"],
            color: colors.interaction["on-secondary"]
          },
          "&.Mui-selected": {
            backgroundColor: colors.interaction["primary"],
            color: colors.interaction["on-primary"],
            textAlign: "center",
            fontFamily: typography$1.family.primary,
            fontSize: PrivateTokens.navigation.font.large["font-size"],
            lineHeight: PrivateTokens.navigation.font.large["line-height"],
            fontWeight: PrivateTokens.navigation.font.large["font-weight"],
            "&:hover": {
              backgroundColor: colors.interaction["primary-hover"],
              color: colors.interaction["on-primary"]
            }
          },
          "&.Mui-disabled": {
            backgroundColor: colors.interaction["on-primary"],
            color: colors.interaction["on-secondary"],
            opacity: "1"
          }
        },
        "& .MuiButtonBase-root": {
          padding: "0px",
          margin: "0px",
          textAlign: "center",
          fontFamily: typography$1.family.primary,
          fontSize: PrivateTokens.navigation.font.large["font-size"],
          lineHeight: PrivateTokens.navigation.font.large["line-height"],
          fontWeight: PrivateTokens.navigation.font.large["font-weight"]
        },
        "& .MuiPaginationItem-ellipsis": {
          width: "16px",
          minWidth: "16px",
          padding: "0px",
          margin: "0px",
          textAlign: "center",
          fontFamily: typography$1.family.primary,
          fontSize: PrivateTokens.minimal.font.small["font-size"],
          lineHeight: PrivateTokens.minimal.font.small["line-height"],
          fontWeight: PrivateTokens.minimal.font.small["font-weight"]
        }
      };
    }
  },
  defaultProps: {
    showDivisor: true
  }
};

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$1 = "/* montserrat-cyrillic-ext-400-normal */\n@font-face {\n  font-family: 'Montserrat';\n  font-style: normal;\n  font-display: swap;\n  font-weight: 400;\n  src: url(./files/montserrat-cyrillic-ext-400-normal.woff2) format('woff2'), url(./files/montserrat-cyrillic-ext-400-normal.woff) format('woff');\n  unicode-range: U+0460-052F,U+1C80-1C88,U+20B4,U+2DE0-2DFF,U+A640-A69F,U+FE2E-FE2F;\n}\n\n/* montserrat-cyrillic-400-normal */\n@font-face {\n  font-family: 'Montserrat';\n  font-style: normal;\n  font-display: swap;\n  font-weight: 400;\n  src: url(./files/montserrat-cyrillic-400-normal.woff2) format('woff2'), url(./files/montserrat-cyrillic-400-normal.woff) format('woff');\n  unicode-range: U+0301,U+0400-045F,U+0490-0491,U+04B0-04B1,U+2116;\n}\n\n/* montserrat-vietnamese-400-normal */\n@font-face {\n  font-family: 'Montserrat';\n  font-style: normal;\n  font-display: swap;\n  font-weight: 400;\n  src: url(./files/montserrat-vietnamese-400-normal.woff2) format('woff2'), url(./files/montserrat-vietnamese-400-normal.woff) format('woff');\n  unicode-range: U+0102-0103,U+0110-0111,U+0128-0129,U+0168-0169,U+01A0-01A1,U+01AF-01B0,U+0300-0301,U+0303-0304,U+0308-0309,U+0323,U+0329,U+1EA0-1EF9,U+20AB;\n}\n\n/* montserrat-latin-ext-400-normal */\n@font-face {\n  font-family: 'Montserrat';\n  font-style: normal;\n  font-display: swap;\n  font-weight: 400;\n  src: url(./files/montserrat-latin-ext-400-normal.woff2) format('woff2'), url(./files/montserrat-latin-ext-400-normal.woff) format('woff');\n  unicode-range: U+0100-02AF,U+0304,U+0308,U+0329,U+1E00-1E9F,U+1EF2-1EFF,U+2020,U+20A0-20AB,U+20AD-20C0,U+2113,U+2C60-2C7F,U+A720-A7FF;\n}\n\n/* montserrat-latin-400-normal */\n@font-face {\n  font-family: 'Montserrat';\n  font-style: normal;\n  font-display: swap;\n  font-weight: 400;\n  src: url(./files/montserrat-latin-400-normal.woff2) format('woff2'), url(./files/montserrat-latin-400-normal.woff) format('woff');\n  unicode-range: U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+0304,U+0308,U+0329,U+2000-206F,U+2074,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD;\n}";
styleInject(css_248z$1);

var MuiCssBaseline = {
  styleOverrides: {
    html: {
      fontFamily: "Montserrat, sans-serif"
    }
  }
};

var MuiIconButton = {
  variants: [{
    props: {
      variant: 'contained',
      type: 'primary'
    },
    style: {
      color: "".concat(colors.interaction['on-primary'], " !important"),
      background: "".concat(colors.interaction.primary, " !important"),
      "&:hover": {
        background: colors.interaction['primary-hover']
      },
      "&:focus": {
        background: colors.interaction['secondary-inverse-alpha']
      }
    }
  }, {
    props: {
      variant: 'blank',
      type: 'primary'
    },
    style: {
      color: "".concat(colors.interaction.primary, " !important"),
      "&:hover": {
        background: colors.interaction['primary-container-alpha']
      },
      "&:focus": {
        background: colors.interaction['primary-container-hover-alpha']
      }
    }
  }],
  styleOverrides: {
    root: function root() {
      return {
        borderRadius: borders.radius.circle
      };
    },
    sizeLarge: {
      padding: spacing.inset.medium,
      "div[role='img']": {
        width: "".concat(dist.icons.size.medium, " !important"),
        height: "".concat(dist.icons.size.medium, " !important")
      }
    },
    sizeMedium: {
      padding: spacing.inset.xsmall,
      "div[role='img']": {
        width: "".concat(dist.icons.size.medium, " !important"),
        height: "".concat(dist.icons.size.medium, " !important")
      }
    },
    sizeSmall: {
      padding: spacing.inset.xxsmall,
      "div[role='img']": {
        width: "".concat(dist.icons.size.small, " !important"),
        height: "".concat(dist.icons.size.small, " !important")
      }
    },
    colorSecondary: {
      color: colors.interaction['on-secondary'],
      "&:hover": {
        background: colors.interaction["secondary-alpha"]
      },
      "&:focus": {
        background: colors.interaction['secondary-container-alpha']
      }
    }
  }
};

var MuiAlert = {
  styleOverrides: {
    root: function root(_ref) {
      var ownerState = _ref.ownerState;
      var isSmall = ownerState.size === "small";
      var fontSize = typography$1.body.text.large["font-size"];
      var fontWeight = typography$1.body.text.large["font-weight"];
      var lineHeight = typography$1.body.text.large["line-height"];
      var borderRadius = borders.radius.small;
      var border = "none";
      if (isSmall) {
        fontSize = typography$1.body.text.medium["font-size"];
        fontWeight = typography$1.body.text.medium["font-weight"];
        lineHeight = typography$1.body.text.medium["line-height"];
        borderRadius = borders.radius.xsmall;
      }
      if (!ownerState.type || ownerState.type === "blank") {
        border = "1px solid ".concat(colors.neutrals["outline-low"]);
      }
      return {
        border: border,
        borderRadius: borderRadius,
        paddingLeft: spacing.inset.xsmall,
        paddingRight: ownerState.actionButton ? spacing.inset.xxxsmall : spacing.inset.xsmall,
        paddingBottom: spacing.inset.xxsmall,
        paddingTop: spacing.inset.xxsmall,
        backgroundColor: function () {
          switch (ownerState.type) {
            case 'positive':
              return colors.feedback['positive-container'];
            case 'alert':
              return colors.feedback['alert-container'];
            case 'negative':
              return colors.feedback['negative-container'];
            case 'insight':
              return colors.feedback['insight-container'];
            case 'neutral':
              return colors.neutrals['surface-container-low'];
            default:
              return colors.neutrals.surface;
          }
        }(),
        '& .MuiAlert-action': ownerState.actionButton ? {
          padding: 0,
          display: 'flex',
          alignItems: 'center',
          marginRight: 0,
          minWidth: spacing.inline.medium
        } : {
          display: 'none'
        },
        '& .MuiAlert-action .MuiButtonBase-root': {
          '&.MuiIconButton-sizeMedium': {
            padding: spacing.inset.xxsmall
          },
          '&.MuiIconButton-sizeLarge': {
            padding: spacing.inset.xxsmall
          }
        },
        '& .MuiAlert-message': {
          fontFamily: typography$1.family.primary,
          padding: 0,
          marginRight: ownerState.actionButton ? "".concat(spacing.inline.xxsmall) : 0,
          fontSize: fontSize,
          fontWeight: fontWeight,
          lineHeight: lineHeight,
          color: colors.feedback['on-container'],
          display: '-webkit-box',
          WebkitBoxOrient: 'vertical',
          WebkitLineClamp: 2,
          overflow: 'hidden',
          textAlign: 'start',
          alignSelf: 'center'
        }
      };
    }
  }
};

function ownKeys$4(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$4(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$4(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$4(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var MuiAvatar = {
  styleOverrides: {
    root: function root(_ref) {
      var _children$type;
      var ownerState = _ref.ownerState,
        children = _ref.children;
      var iconStyles = {};
      if ((children === null || children === void 0 || (_children$type = children.type) === null || _children$type === void 0 ? void 0 : _children$type.name) === 'Icon') {
        var borderRadiusSize = {
          small: borders.radius.xsmall,
          medium: borders.radius.medium,
          large: borders.radius.large
        };
        var contentSize = {
          small: spacing.inline.small,
          medium: spacing.inline.medium,
          large: spacing.inline.xxlarge
        };
        var iconSize = {
          small: dist.icons.size.small,
          medium: dist.icons.size.medium,
          large: dist.icons.size.large
        };
        iconStyles = {
          borderRadius: borderRadiusSize[ownerState.size],
          height: contentSize[ownerState.size],
          width: contentSize[ownerState.size],
          backgroundColor: colors.interaction["secondary-alpha"],
          "div[role='img']": {
            width: "".concat(iconSize[ownerState.size], " !important"),
            height: "".concat(iconSize[ownerState.size], " !important")
          }
        };
      }
      return _objectSpread$4({}, iconStyles);
    }
  }
};

var _templateObject$3;
var myAnimation$1 = keyframes(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteral(["\n  0% {\n    transform: scale(1);\n  }\n  100% {\n    transform: scale(1.2);\n  }\n"])));
var MuiCheckbox = {
  styleOverrides: {
    root: {
      width: 20,
      height: 20,
      borderRadius: borders.radius.quark,
      borderColor: colors.neutrals["on-surface-variant"],
      padding: "2px",
      "& .MuiTouchRipple-root": {
        borderRadius: borders.radius.circle,
        top: "-5px",
        left: "-6px",
        height: "32px",
        width: "32px"
      },
      "&:hover": {
        "& .MuiTouchRipple-root": {
          backgroundColor: colors.interaction["secondary-alpha"]
        }
      },
      "&.Mui-checked": {
        animation: "".concat(myAnimation$1, " 200ms linear"),
        color: colors.interaction.primary,
        "&:hover": {
          "& .MuiTouchRipple-root": {
            backgroundColor: colors.interaction["primary-container-alpha"]
          }
        }
      }
    },
    checkedIcon: /*#__PURE__*/require$$1.createElement(dist.Icon, {
      size: "medium",
      name: "ActionCheck"
    })
  }
};

var _templateObject$2;
var myAnimation = keyframes(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral(["\n  0% {\n    transform: scale(1);\n  }\n  100% {\n    transform: scale(1.2);\n  }\n"])));
var MuiRadio = {
  styleOverrides: {
    root: {
      width: 20,
      height: 20,
      borderColor: colors.neutrals["on-surface-variant"],
      padding: spacing.inset.quark,
      "& .MuiTouchRipple-root": {
        borderRadius: borders.radius.circle,
        top: "-5px",
        left: "-6px",
        height: "32px",
        width: "32px"
      },
      "&:hover": {
        "& .MuiTouchRipple-root": {
          backgroundColor: colors.interaction["secondary-alpha"]
        }
      },
      "&.Mui-checked": {
        animation: "".concat(myAnimation, " 200ms linear"),
        color: colors.interaction.primary,
        "&:hover": {
          "& .MuiTouchRipple-root": {
            backgroundColor: colors.interaction["primary-container-alpha"]
          }
        }
      }
    }
  }
};

var components = {
  // CssBaseline
  MuiCssBaseline: MuiCssBaseline,
  // Display Data
  MuiAvatar: MuiAvatar,
  // Tipografia
  MuiTypography: MuiTypography,
  // Botoes
  MuiButton: MuiButton,
  MuiIconButton: MuiIconButton,
  // Feedback
  MuiAlert: MuiAlert,
  // Tabela
  MuiTable: MuiTable,
  MuiTableHead: MuiTableHead,
  MuiTableCell: MuiTableCell,
  MuiTableRow: MuiTableRow,
  // Navegação
  MuiPagination: MuiPagination,
  // Inputs
  MuiCheckbox: MuiCheckbox,
  MuiRadio: MuiRadio
};

var body = {
  text: {
    large: {
      fontFamily: typography$1.family.primary,
      fontSize: typography$1.body.text.large["font-size"],
      fontWeight: typography$1.body.text.large["font-weight"],
      lineHeight: typography$1.body.text.large["line-height"]
    },
    medium: {
      fontFamily: typography$1.family.primary,
      fontSize: typography$1.body.text.medium["font-size"],
      fontWeight: typography$1.body.text.medium["font-weight"],
      lineHeight: typography$1.body.text.medium["line-height"]
    }
  },
  link: {
    large: {
      fontFamily: typography$1.family.primary,
      fontSize: typography$1.body.link.large["font-size"],
      fontWeight: typography$1.body.link.large["font-weight"],
      lineHeight: typography$1.body.link.large["line-height"]
    },
    medium: {
      fontFamily: typography$1.family.primary,
      fontSize: typography$1.body.link.medium["font-size"],
      fontWeight: typography$1.body.link.medium["font-weight"],
      lineHeight: typography$1.body.link.medium["line-height"]
    }
  },
  highlight: {
    large: {
      fontFamily: typography$1.family.primary,
      fontSize: typography$1.body.highlight.large["font-size"],
      fontWeight: typography$1.body.highlight.large["font-weight"],
      lineHeight: typography$1.body.highlight.large["line-height"]
    },
    medium: {
      fontFamily: typography$1.family.primary,
      fontSize: typography$1.body.highlight.medium["font-size"],
      fontWeight: typography$1.body.highlight.medium["font-weight"],
      lineHeight: typography$1.body.highlight.medium["line-height"]
    }
  }
};

var display = {
  large: {
    fontFamily: typography$1.family.primary,
    fontSize: typography$1.display.large["font-size"],
    fontWeight: typography$1.display.large["font-weight"],
    lineHeight: typography$1.display.large["line-height"]
  },
  medium: {
    fontFamily: typography$1.family.primary,
    fontSize: typography$1.display.medium["font-size"],
    fontWeight: typography$1.display.medium["font-weight"],
    lineHeight: typography$1.display.medium["line-height"]
  },
  small: {
    fontFamily: typography$1.family.primary,
    fontSize: typography$1.display.small["font-size"],
    fontWeight: typography$1.display.small["font-weight"],
    lineHeight: typography$1.display.small["line-height"]
  }
};

var heading = {
  extraLarge: {
    fontFamily: typography$1.family.primary,
    fontSize: typography$1.heading["extra-large"]["font-size"],
    fontWeight: typography$1.heading["extra-large"]["font-weight"],
    lineHeight: typography$1.heading["extra-large"]["line-height"]
  },
  large: {
    fontFamily: typography$1.family.primary,
    fontSize: typography$1.heading.large["font-size"],
    fontWeight: typography$1.heading.large["font-weight"],
    lineHeight: typography$1.heading.large["line-height"]
  },
  medium: {
    fontFamily: typography$1.family.primary,
    fontSize: typography$1.heading.medium["font-size"],
    fontWeight: typography$1.heading.medium["font-weight"],
    lineHeight: typography$1.heading.medium["line-height"]
  },
  small: {
    fontFamily: typography$1.family.primary,
    fontSize: typography$1.heading.small["font-size"],
    fontWeight: typography$1.heading.small["font-weight"],
    lineHeight: typography$1.heading.small["line-height"]
  }
};

var subtitle = {
  large: {
    fontFamily: typography$1.family.primary,
    fontSize: typography$1.subtitle.large["font-size"],
    fontWeight: typography$1.subtitle.large["font-weight"],
    lineHeight: typography$1.subtitle.large["line-height"]
  },
  medium: {
    fontFamily: typography$1.family.primary,
    fontSize: typography$1.subtitle.medium["font-size"],
    fontWeight: typography$1.subtitle.medium["font-weight"],
    lineHeight: typography$1.subtitle.medium["line-height"]
  },
  small: {
    fontFamily: typography$1.family.primary,
    fontSize: typography$1.subtitle.small["font-size"],
    fontWeight: typography$1.subtitle.small["font-weight"],
    lineHeight: typography$1.subtitle.small["line-height"]
  }
};

var support = {
  overline: {
    medium: {
      fontFamily: typography$1.family.primary,
      fontSize: typography$1.support.overline.medium["font-size"],
      fontWeight: typography$1.support.overline.medium["font-weight"],
      lineHeight: typography$1.support.overline.medium["line-height"],
      textTransform: typography$1.support.overline.medium["text-transform"],
      letterSpacing: typography$1.support.overline.medium["letter-spacing"]
    },
    small: {
      fontFamily: typography$1.family.primary,
      fontSize: typography$1.support.overline.small["font-size"],
      fontWeight: typography$1.support.overline.small["font-weight"],
      lineHeight: typography$1.support.overline.small["line-height"],
      textTransform: typography$1.support.overline.small["text-transform"],
      letterSpacing: typography$1.support.overline.small["letter-spacing"]
    }
  },
  caption: {
    fontFamily: typography$1.family.primary,
    fontSize: typography$1.support.caption["font-size"],
    fontWeight: typography$1.support.caption["font-weight"],
    lineHeight: typography$1.support.caption["line-height"],
    textTransform: typography$1.support.caption["text-transform"]
  }
};

var typography = {
  fontFamily: typography$1.family.primary,
  displayLarge: display.large,
  displayMedium: display.medium,
  displaySmall: display.small,
  headingExtraLarge: heading.extraLarge,
  headingLarge: heading.large,
  headingMedium: heading.medium,
  headingSmall: heading.small,
  subtitleLarge: subtitle.large,
  subtitleMedium: subtitle.medium,
  subtitleSmall: subtitle.small,
  bodyTextLarge: body.text.large,
  bodyTextMedium: body.text.medium,
  bodyLinkLarge: body.link.large,
  bodyLinkMedium: body.link.medium,
  bodyHighlightLarge: body.highlight.large,
  bodyHighlightMedium: body.highlight.medium,
  overline: support.overline.medium,
  overlineSmall: support.overline.small,
  caption: support.caption,
  // Desabilitar variantes [MUI]
  h1: undefined,
  h2: undefined,
  h3: undefined,
  h4: undefined,
  h5: undefined,
  h6: undefined,
  subtitle1: undefined,
  subtitle2: undefined,
  body1: undefined,
  body2: undefined,
  button: undefined
};

var theme = {
  // Definições para o Sistema Tipográfico
  typography: typography,
  //  icons,
  // componentes
  components: components
};
var loggiDesignSystem = createTheme(theme);

var StyledDiv$2 = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  marginLeft: "auto"
});
var IconMenu = function IconMenu(_ref) {
  var menuIcons = _ref.menuIcons;
  return /*#__PURE__*/require$$1.createElement(require$$1.Fragment, null, menuIcons && /*#__PURE__*/require$$1.createElement(Stack, {
    direction: "row",
    gap: spacing.inline.quark
  }, Object.entries(menuIcons).map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      key = _ref3[0],
      value = _ref3[1];
    return /*#__PURE__*/require$$1.createElement(IconButton, {
      variant: "blank",
      padding: spacing.inset.xxsmall,
      key: "icon ".concat(key, " ").concat(value.icon),
      size: "small",
      onClick: value.path
    }, /*#__PURE__*/require$$1.createElement(dist.Icon, {
      name: value.icon,
      size: "small",
      color: colors.neutrals["on-surface"]
    }));
  })));
};
var styledMenu = {
  paper: {
    elevation: 0,
    sx: {
      overflow: "visible",
      filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
      mt: 1.5,
      "& .MuiAvatar-root": {
        width: 32,
        height: 32,
        ml: -0.5,
        mr: 1
      },
      "&:before": {
        content: '""',
        display: "block",
        position: "absolute",
        top: 0,
        right: 14,
        width: 10,
        height: 10,
        bgcolor: "background.paper",
        transform: "translateY(-50%) rotate(45deg)",
        zIndex: 0
      }
    }
  }
};
var IconAvatar = function IconAvatar(_ref4) {
  var imgAvatar = _ref4.imgAvatar,
    menuAvatar = _ref4.menuAvatar,
    anchorElUser = _ref4.anchorElUser,
    handleOpenUserMenu = _ref4.handleOpenUserMenu,
    handleCloseUserMenu = _ref4.handleCloseUserMenu;
  return /*#__PURE__*/require$$1.createElement(Stack, null, /*#__PURE__*/require$$1.createElement(IconButton, {
    onClick: handleOpenUserMenu,
    sx: {
      p: 0
    }
  }, /*#__PURE__*/require$$1.createElement(Avatar, {
    size: "medium",
    src: imgAvatar
  })), menuAvatar && /*#__PURE__*/require$$1.createElement(Menu, {
    id: "menu-appbar",
    anchorEl: anchorElUser,
    keepMounted: true,
    open: Boolean(anchorElUser),
    onClose: handleCloseUserMenu,
    slotProps: styledMenu,
    transformOrigin: {
      horizontal: "right",
      vertical: "top"
    },
    anchorOrigin: {
      horizontal: "right",
      vertical: "bottom"
    }
  }, Object.entries(menuAvatar).map(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
      key = _ref6[0],
      value = _ref6[1];
    return /*#__PURE__*/require$$1.createElement(MenuItem, {
      component: "a",
      key: "menu ".concat(key, " ").concat(value.label),
      href: value.path,
      onClick: handleCloseUserMenu
    }, /*#__PURE__*/require$$1.createElement(ListItemIcon, null, /*#__PURE__*/require$$1.createElement(dist.Icon, {
      name: value.icon,
      size: "small"
    })), value.label);
  })));
};
var DiagonalLine = function DiagonalLine() {
  return /*#__PURE__*/require$$1.createElement(Stack, {
    width: "1px",
    height: "24px",
    marginLeft: "20px",
    marginRight: "20px",
    sx: {
      transform: "rotate(30deg)",
      backgroundColor: colors.interaction["secondary-container-alpha"]
    }
  });
};
var MenuAppBar = function MenuAppBar(_ref7) {
  var _ref7$menuIcons = _ref7.menuIcons,
    menuIcons = _ref7$menuIcons === void 0 ? null : _ref7$menuIcons,
    _ref7$imgAvatar = _ref7.imgAvatar,
    imgAvatar = _ref7$imgAvatar === void 0 ? "" : _ref7$imgAvatar,
    _ref7$menuAvatar = _ref7.menuAvatar,
    menuAvatar = _ref7$menuAvatar === void 0 ? null : _ref7$menuAvatar,
    _ref7$anchorElUser = _ref7.anchorElUser,
    anchorElUser = _ref7$anchorElUser === void 0 ? null : _ref7$anchorElUser,
    _ref7$handleOpenUserM = _ref7.handleOpenUserMenu,
    handleOpenUserMenu = _ref7$handleOpenUserM === void 0 ? function () {} : _ref7$handleOpenUserM,
    _ref7$handleCloseUser = _ref7.handleCloseUserMenu,
    handleCloseUserMenu = _ref7$handleCloseUser === void 0 ? function () {} : _ref7$handleCloseUser;
  return /*#__PURE__*/require$$1.createElement(StyledDiv$2, null, /*#__PURE__*/require$$1.createElement(IconMenu, {
    menuIcons: menuIcons
  }), /*#__PURE__*/require$$1.createElement(DiagonalLine, null), /*#__PURE__*/require$$1.createElement(IconAvatar, {
    imgAvatar: imgAvatar,
    menuAvatar: menuAvatar,
    anchorElUser: anchorElUser,
    handleOpenUserMenu: handleOpenUserMenu,
    handleCloseUserMenu: handleCloseUserMenu
  }));
};
MenuAppBar.propTypes = {
  menuIcons: PropTypes.object,
  menuAvatar: PropTypes.object,
  imgAvatar: PropTypes.string,
  anchorElUser: PropTypes.object,
  handleOpenUserMenu: PropTypes.func,
  handleCloseUserMenu: PropTypes.func
};

// Constantes
var VARIANTS$1 = {
  BASIC: "basic",
  SUBMIT: "submit"
};
var TYPES = {
  DEFAULT: false,
  CLEAR: true
};
var SIZES = {
  REGULAR: "regular",
  SMALL: "small"
};

// Estilos
var sizeStyles = {
  basic: {
    small: {
      fieldTypography: PrivateTokens.inputField.fields.small,
      maxHeight: "48px",
      height: "48px",
      inputTextMarginLeft: spacing.inline.nano,
      inputLabelLeft: "48px",
      inputVerticalPadding: spacing.inline.nano,
      inputLeftPadding: spacing.inset.medium,
      inputRightPadding: spacing.inset.nano
    },
    regular: {
      fieldTypography: PrivateTokens.inputField.fields.regular,
      maxHeight: "56px",
      height: "56px",
      inputTextMarginLeft: spacing.inline.nano,
      inputLabelLeft: "45px",
      inputVerticalPadding: spacing.inline.xxxsmall,
      inputLeftPadding: spacing.inset.medium,
      inputRightPadding: spacing.inset.nano
    }
  },
  submit: {
    small: {
      fieldTypography: PrivateTokens.inputField.fields.small,
      maxHeight: "48px",
      height: "48px",
      inputTextMarginLeft: spacing.inline.nano,
      inputLabelLeft: "20px",
      inputVerticalPadding: spacing.inline.nano,
      inputLeftPadding: spacing.inset.medium,
      inputRightPadding: spacing.inset.nano
    },
    regular: {
      fieldTypography: PrivateTokens.inputField.fields.regular,
      maxHeight: "56px",
      height: "56px",
      inputTextMarginLeft: "0px",
      inputLabelLeft: "15px",
      inputVerticalPadding: spacing.inline.xxxsmall,
      inputLeftPadding: spacing.inset.medium,
      inputRightPadding: spacing.inset.nano
    }
  }
};
var getStyles = function getStyles(_ref) {
  var size = _ref.size,
    variant = _ref.variant;
  var _sizeStyles$variant$s = sizeStyles[variant][size],
    fieldTypography = _sizeStyles$variant$s.fieldTypography,
    inputLabelLeft = _sizeStyles$variant$s.inputLabelLeft,
    inputVerticalPadding = _sizeStyles$variant$s.inputVerticalPadding,
    inputLeftPadding = _sizeStyles$variant$s.inputLeftPadding,
    inputRightPadding = _sizeStyles$variant$s.inputRightPadding,
    height = _sizeStyles$variant$s.height,
    maxHeight = _sizeStyles$variant$s.maxHeight,
    inputTextMarginLeft = _sizeStyles$variant$s.inputTextMarginLeft;
  return {
    width: "100%",
    '& fieldset': {
      transition: 'border 0.2s linear'
    },
    '& .MuiInputLabel-root.Mui-focused': {
      color: colors.interaction["on-secondary"]
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: "".concat(colors.neutrals["outline-low"], " !important")
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: "".concat(colors.neutrals["outline-high"], " !important")
    },
    '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderWidth: '1px !important',
      borderColor: "".concat(colors.interaction["primary"], " !important")
    },
    "& .MuiInputBase-root": {
      fontFamily: typography$1.family.primary,
      borderRadius: borders.radius.circle,
      padding: "".concat(inputVerticalPadding, " ").concat(inputRightPadding, " ").concat(inputVerticalPadding, " ").concat(inputLeftPadding),
      maxHeight: maxHeight,
      height: height
    },
    "& .MuiInputBase-input": {
      fontFamily: typography$1.family.primary,
      fontWeight: fieldTypography.type["font-weight"],
      fontSize: fieldTypography.type["font-size"],
      lineHeight: fieldTypography.type["line-height"],
      marginLeft: inputTextMarginLeft,
      padding: "".concat(spacing.inset.quark, " 12px ").concat(spacing.inset.quark, " 0px")
    },
    "& .MuiInputLabel-root": {
      fontFamily: typography$1.family.primary,
      fontWeight: fieldTypography.placeholder["font-weight"],
      fontSize: fieldTypography.placeholder["font-size"],
      lineHeight: fieldTypography.placeholder["line-height"],
      top: "50%",
      transform: "translateY(-50%)",
      paddingRight: "23px",
      left: inputLabelLeft,
      "&.MuiFormLabel-filled": {
        opacity: 0
      },
      "&.Mui-focused": {
        opacity: 0
      }
    }
  };
};
var getComponent = function getComponent(_ref2) {
  var size = _ref2.size,
    variant = _ref2.variant;
  return styled(TextField)(getStyles({
    size: size,
    variant: variant
  }));
};
var BasicTextField = function BasicTextField(_ref3) {
  var fullWidth = _ref3.fullWidth,
    label = _ref3.label,
    helperText = _ref3.helperText,
    handleChange = _ref3.handleChange,
    onKeyPress = _ref3.onKeyPress,
    value = _ref3.value,
    clear = _ref3.clear,
    size = _ref3.size;
    _ref3.iconName;
    var handleClearButtonClick = _ref3.handleClearButtonClick,
    StyledTextField = _ref3.StyledTextField;
  return /*#__PURE__*/require$$1.createElement(require$$1.Fragment, null, /*#__PURE__*/require$$1.createElement(StyledTextField, {
    fullWidth: fullWidth,
    variant: "outlined",
    label: label,
    InputLabelProps: {
      shrink: false
    },
    onChange: handleChange,
    onKeyPress: onKeyPress,
    value: value,
    sx: {
      '&:hover .MuiButtonBase-root.MuiIconButton-root[title="Limpar"]': {
        visibility: !value || !clear ? "hidden" : "visible",
        display: !value || !clear ? "none" : "inline-flex"
      },
      '&:not(:hover) .MuiButtonBase-root.MuiIconButton-root[title="Limpar"]': {
        visibility: "hidden !important",
        display: "none"
      }
    },
    InputProps: {
      startAdornment: /*#__PURE__*/require$$1.createElement(InputAdornment, {
        style: {
          padding: "".concat(spacing.inset.quark, " 0px")
        }
      }, /*#__PURE__*/require$$1.createElement(dist.Icon, {
        name: "SearchMedium",
        color: colors.interaction["on-secondary"],
        size: size === "regular" ? "medium" : "small"
      })),
      endAdornment: /*#__PURE__*/require$$1.createElement(InputAdornment, {
        style: {
          padding: "".concat(spacing.inset.quark, " 0px")
        }
      }, /*#__PURE__*/require$$1.createElement(IconButton, {
        title: "Limpar",
        variant: "blank",
        size: "small",
        color: "secondary",
        onClick: handleClearButtonClick
      }, /*#__PURE__*/require$$1.createElement(dist.Icon, {
        name: "ActionClose",
        size: "small"
      })))
    }
  }), /*#__PURE__*/require$$1.createElement("span", {
    style: {
      marginLeft: "12px",
      fontSize: "12px",
      fontWeight: "400",
      lineHeight: "16px",
      letterSpacing: "0em",
      textAlign: "left",
      color: colors.interaction["on-secondary"]
    }
  }, helperText));
};
var SubmitTextField = function SubmitTextField(_ref4) {
  var fullWidth = _ref4.fullWidth,
    label = _ref4.label,
    helperText = _ref4.helperText,
    handleChange = _ref4.handleChange,
    onSubmit = _ref4.onSubmit,
    onKeyPress = _ref4.onKeyPress,
    value = _ref4.value,
    clear = _ref4.clear,
    size = _ref4.size,
    iconName = _ref4.iconName,
    handleClearButtonClick = _ref4.handleClearButtonClick,
    StyledTextField = _ref4.StyledTextField;
  return /*#__PURE__*/require$$1.createElement(require$$1.Fragment, null, /*#__PURE__*/require$$1.createElement(StyledTextField, {
    fullWidth: fullWidth,
    variant: "outlined",
    label: label,
    InputLabelProps: {
      shrink: false
    },
    onChange: handleChange,
    onKeyPress: onKeyPress,
    value: value,
    sx: {
      '&:hover .MuiButtonBase-root.MuiIconButton-root[title="Limpar"]': {
        visibility: !value || !clear ? "hidden" : "visible",
        display: !value || !clear ? "none" : "inline-flex"
      },
      '&:not(:hover) .MuiButtonBase-root.MuiIconButton-root[title="Limpar"]': {
        visibility: "hidden !important",
        display: "none"
      }
    },
    InputProps: {
      endAdornment: /*#__PURE__*/require$$1.createElement(InputAdornment, null, /*#__PURE__*/require$$1.createElement(IconButton, {
        title: "Limpar",
        variant: "blank",
        size: "small",
        color: "secondary",
        onClick: handleClearButtonClick
      }, /*#__PURE__*/require$$1.createElement(dist.Icon, {
        name: "ActionClose",
        size: "small"
      })), /*#__PURE__*/require$$1.createElement(IconButton, {
        variant: "contained",
        size: size === "regular" ? "medium" : "small",
        type: "primary",
        onClick: onSubmit
      }, /*#__PURE__*/require$$1.createElement(dist.Icon, {
        name: iconName,
        size: size === "regular" ? "medium" : "small"
      })))
    }
  }), /*#__PURE__*/require$$1.createElement("span", {
    style: {
      marginLeft: "12px",
      fontSize: "12px",
      fontWeight: "400",
      lineHeight: "16px",
      letterSpacing: "0em",
      textAlign: "left",
      color: colors.interaction["on-secondary"]
    }
  }, helperText));
};
var variantComponents = {
  basic: BasicTextField,
  submit: SubmitTextField
};
var Search = function Search(_ref5) {
  var _ref5$size = _ref5.size,
    size = _ref5$size === void 0 ? "regular" : _ref5$size,
    _ref5$variant = _ref5.variant,
    variant = _ref5$variant === void 0 ? "basic" : _ref5$variant,
    _ref5$clear = _ref5.clear,
    clear = _ref5$clear === void 0 ? false : _ref5$clear,
    _ref5$iconName = _ref5.iconName,
    iconName = _ref5$iconName === void 0 ? "SearchLarge" : _ref5$iconName,
    _ref5$onChange = _ref5.onChange,
    onChange = _ref5$onChange === void 0 ? function () {} : _ref5$onChange,
    _ref5$onSubmit = _ref5.onSubmit,
    onSubmit = _ref5$onSubmit === void 0 ? function () {} : _ref5$onSubmit,
    _ref5$onKeyPress = _ref5.onKeyPress,
    onKeyPress = _ref5$onKeyPress === void 0 ? function () {} : _ref5$onKeyPress,
    _ref5$label = _ref5.label,
    label = _ref5$label === void 0 ? "Pesquisar..." : _ref5$label,
    defaultValue = _ref5.defaultValue;
  var _useState = useState(defaultValue),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var handleChange = useCallback(function (event) {
    setValue(event.target.value);
    onChange(event.target.value);
  }, [onChange]);
  var handleClearButtonClick = function handleClearButtonClick() {
    setValue("");
    onChange("");
  };
  var StyledTextField = useMemo(function () {
    return getComponent({
      size: size,
      variant: variant
    });
  }, [size, variant, clear]);
  useEffect(function () {
    setValue(value);
  }, [clear, value]);
  var VariantComponent = variantComponents[variant];
  return /*#__PURE__*/require$$1.createElement(VariantComponent, {
    StyledTextField: StyledTextField,
    fullWidth: true,
    label: label,
    handleChange: handleChange,
    onSubmit: onSubmit,
    onKeyPress: onKeyPress,
    value: value,
    clear: clear,
    iconName: iconName,
    handleClearButtonClick: handleClearButtonClick,
    size: size
  });
};
Search.propTypes = {
  size: PropTypes.oneOf(Object.values(SIZES)),
  variant: PropTypes.oneOf(Object.values(VARIANTS$1)),
  label: PropTypes.string,
  iconName: PropTypes.string,
  clear: PropTypes.oneOf(Object.values(TYPES)),
  defaultValue: PropTypes.string,
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
  onKeyPress: PropTypes.func
};

var StyledAppBar = styled(MuiAppBar)(function (_ref) {
  var theme = _ref.theme;
  return {
    boxShadow: "none",
    width: "100%",
    backgroundColor: colors.neutrals.surface,
    padding: spacing.inset.large,
    justify: "space-between",
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  };
});
var StyledDiv$1 = styled("div")({
  width: "30%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  alignSelf: "stretch"
});
var SearchAppBar = function SearchAppBar(_ref2) {
  var search = _ref2.search,
    handleSearchChange = _ref2.handleSearchChange,
    handleSearchKeyPress = _ref2.handleSearchKeyPress,
    handleSearchSubmit = _ref2.handleSearchSubmit,
    defaultSearchValue = _ref2.defaultSearchValue;
  return /*#__PURE__*/require$$1.createElement(require$$1.Fragment, null, search && /*#__PURE__*/require$$1.createElement(StyledDiv$1, null, /*#__PURE__*/require$$1.createElement(Search, {
    variant: "basic",
    size: "small",
    iconName: "SearchLarge",
    onChange: handleSearchChange,
    onKeyPress: handleSearchKeyPress,
    onSubmit: handleSearchSubmit,
    label: "Pesquisar...",
    defaultValue: defaultSearchValue
  })));
};
var AppBarMobile = function AppBarMobile(_ref3) {
  var handleClickBack = _ref3.handleClickBack;
  var handleClick = function handleClick() {
    if (handleClickBack) {
      handleClickBack();
    }
  };
  return /*#__PURE__*/require$$1.createElement(MuiAppBar, {
    sx: {
      bgcolor: colors.neutrals.surface,
      boxShadow: 0
    },
    position: "sticky"
  }, /*#__PURE__*/require$$1.createElement(Box, {
    pl: spacing.inset.xxsmall,
    display: "flex",
    alignContent: "left"
  }, /*#__PURE__*/require$$1.createElement(IconButton, {
    variant: "blank",
    color: "secondary",
    onClick: handleClick,
    size: "medium"
  }, /*#__PURE__*/require$$1.createElement(dist.Icon, {
    name: "ArrowLeft",
    color: colors.interaction["on-secondary"],
    size: "medium"
  }))));
};
var AppBar = function AppBar(_ref4) {
  var _ref4$mobile = _ref4.mobile,
    mobile = _ref4$mobile === void 0 ? false : _ref4$mobile,
    _ref4$position = _ref4.position,
    position = _ref4$position === void 0 ? "fixed" : _ref4$position;
    _ref4.navigation;
    var _ref4$divisor = _ref4.divisor,
    divisor = _ref4$divisor === void 0 ? false : _ref4$divisor,
    _ref4$search = _ref4.search,
    search = _ref4$search === void 0 ? true : _ref4$search,
    _ref4$imgAvatar = _ref4.imgAvatar,
    imgAvatar = _ref4$imgAvatar === void 0 ? "" : _ref4$imgAvatar,
    _ref4$menuAvatar = _ref4.menuAvatar,
    menuAvatar = _ref4$menuAvatar === void 0 ? null : _ref4$menuAvatar,
    _ref4$menuIcons = _ref4.menuIcons,
    menuIcons = _ref4$menuIcons === void 0 ? null : _ref4$menuIcons,
    _ref4$handleSearchCha = _ref4.handleSearchChange,
    handleSearchChange = _ref4$handleSearchCha === void 0 ? function () {} : _ref4$handleSearchCha,
    _ref4$handleSearchKey = _ref4.handleSearchKeyPress,
    handleSearchKeyPress = _ref4$handleSearchKey === void 0 ? function () {} : _ref4$handleSearchKey,
    _ref4$handleSearchSub = _ref4.handleSearchSubmit,
    handleSearchSubmit = _ref4$handleSearchSub === void 0 ? function () {} : _ref4$handleSearchSub,
    _ref4$handleClickBack = _ref4.handleClickBack,
    handleClickBack = _ref4$handleClickBack === void 0 ? function () {} : _ref4$handleClickBack,
    _ref4$defaultSearchVa = _ref4.defaultSearchValue,
    defaultSearchValue = _ref4$defaultSearchVa === void 0 ? "" : _ref4$defaultSearchVa;
  if (mobile) return /*#__PURE__*/require$$1.createElement(AppBarMobile, {
    handleClickBack: handleClickBack
  });
  var _React$useState = require$$1.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    anchorElUser = _React$useState2[0],
    setAnchorElUser = _React$useState2[1];
  var handleOpenUserMenu = function handleOpenUserMenu(event) {
    setAnchorElUser(event.currentTarget);
  };
  var handleCloseUserMenu = function handleCloseUserMenu() {
    setAnchorElUser(null);
  };
  return /*#__PURE__*/require$$1.createElement(StyledAppBar, {
    position: position,
    sx: {
      borderBottom: divisor ? "1px solid ".concat(colors.neutrals["outline-low"]) : "none"
    }
  }, /*#__PURE__*/require$$1.createElement(Toolbar, {
    disableGutters: true,
    variant: "dense"
  }, /*#__PURE__*/require$$1.createElement(SearchAppBar, {
    search: search,
    handleSearchChange: handleSearchChange,
    handleSearchKeyPress: handleSearchKeyPress,
    handleSearchSubmit: handleSearchSubmit,
    defaultSearchValue: defaultSearchValue
  }), /*#__PURE__*/require$$1.createElement(MenuAppBar, {
    imgAvatar: imgAvatar,
    menuIcons: menuIcons,
    menuAvatar: menuAvatar,
    anchorElUser: anchorElUser,
    handleOpenUserMenu: handleOpenUserMenu,
    handleCloseUserMenu: handleCloseUserMenu
  })));
};
AppBar.propTypes = {
  mobile: PropTypes.bool,
  navigation: PropTypes.oneOf(["primary", "secondary"]),
  position: PropTypes.oneOf(["fixed", "absolute", "sticky", "static", "relative"]),
  divisor: PropTypes.bool,
  search: PropTypes.bool,
  menuIcons: PropTypes.object,
  menuAvatar: PropTypes.object,
  imgAvatar: PropTypes.string,
  handleSearchChange: PropTypes.func,
  handleSearchKeyPress: PropTypes.func,
  handleSearchSubmit: PropTypes.func,
  defaultSearchValue: PropTypes.string,
  handleClickBack: PropTypes.func
};

function ownKeys$3(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$3(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$3(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$3(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var mediumSizeStyles = function mediumSizeStyles(selected) {
  return {
    "& .MuiChip-label": {
      padding: spacing.inset.small,
      fontFamily: typography$1.family.primary,
      fontSize: PrivateTokens.chip.font.medium["font-size"],
      lineHeight: PrivateTokens.chip.font.medium["line-height"],
      fontWeight: PrivateTokens.chip.font.medium["font-weight"],
      color: selected ? colors.interaction.primary : colors.interaction["on-secondary"]
    },
    "& .MuiTouchRipple-root": {
      width: "calc(100% - ".concat(spacing.inset.small, ")"),
      height: "57px",
      left: "7px",
      top: "-5px",
      color: selected ? colors.interaction["primary-container-hover-alpha"] : colors.neutrals.outline,
      overflow: "hidden",
      zIndex: "-1"
    }
  };
};
var smallSizeStyles = function smallSizeStyles(selected) {
  return {
    "& .MuiChip-label": {
      padding: "".concat(spacing.inset.xxsmall, " ").concat(spacing.inset.xxxsmall),
      fontFamily: typography$1.family.primary,
      fontSize: PrivateTokens.chip.font.small["font-size"],
      lineHeight: PrivateTokens.chip.font.small["line-height"],
      fontWeight: PrivateTokens.chip.font.small["font-weight"],
      color: selected ? colors.interaction.primary : colors.interaction["on-secondary"]
    },
    "& .MuiTouchRipple-root": {
      width: "calc(100% - ".concat(spacing.inset.xxxsmall, ")"),
      height: "43px",
      left: "4px",
      top: "-2px",
      color: selected ? colors.interaction["primary-container-hover-alpha"] : colors.neutrals.outline,
      overflow: "hidden",
      zIndex: "-1"
    }
  };
};
var notSelectedStateStyles = {
  backgroundColor: colors.neutrals.surface,
  borderColor: colors.neutrals["outline-low"],
  "&:hover": {
    backgroundColor: colors.interaction["secondary-alpha"],
    borderColor: colors.neutrals.outline
  }
};
var selectedStateStyles = {
  backgroundColor: colors.interaction["primary-container-alpha"],
  borderColor: colors.interaction["primary-container-alpha"],
  borderStyle: "solid",
  backgroundClip: "padding-box",
  "&:hover": {
    backgroundColor: colors.interaction["primary-container-alpha"],
    borderColor: colors.interaction.primary,
    borderStyle: "solid"
  }
};
var StyledChip = styled(MuiChip)(function (_ref) {
  _ref.theme;
    var selected = _ref.selected,
    size = _ref.size;
  return _objectSpread$3(_objectSpread$3(_objectSpread$3({
    borderRadius: borders.radius.circle,
    borderWidth: borders.width.thin,
    borderStyle: !selected && "solid",
    height: "auto",
    overflow: "hidden",
    "&:active": {
      boxShadow: "none"
    },
    "&& .MuiTouchRipple-rippleVisible": {
      animation: "300ms linear",
      transition: "none"
    }
  }, size === "medium" && _objectSpread$3({}, mediumSizeStyles(selected))), size === "small" && _objectSpread$3({}, smallSizeStyles(selected))), selected ? _objectSpread$3({}, selectedStateStyles) : _objectSpread$3({}, notSelectedStateStyles));
});
var StyledDiv = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: spacing.inline.quark
});
var IconLabel = function IconLabel(_ref2) {
  var label = _ref2.label,
    name = _ref2.name,
    color = _ref2.color;
  return /*#__PURE__*/require$$1.createElement(StyledDiv, null, label, /*#__PURE__*/require$$1.createElement(dist.Icon, {
    name: name,
    size: "small",
    color: color
  }));
};
var Chip = function Chip(_ref3) {
  var label = _ref3.label,
    _ref3$size = _ref3.size,
    size = _ref3$size === void 0 ? "medium" : _ref3$size,
    _ref3$icon = _ref3.icon,
    icon = _ref3$icon === void 0 ? false : _ref3$icon,
    _ref3$selected = _ref3.selected,
    selected = _ref3$selected === void 0 ? false : _ref3$selected,
    _ref3$expanded = _ref3.expanded,
    expanded = _ref3$expanded === void 0 ? false : _ref3$expanded,
    onClick = _ref3.onClick;
  var iconColor = selected ? colors.interaction.primary : colors.neutrals["on-surface"];
  var iconName = expanded ? "ChevronUp" : "ChevronDown";
  var handleClick = function handleClick(event) {
    if (onClick) {
      onClick(event);
    }
  };
  return /*#__PURE__*/require$$1.createElement(StyledChip, {
    onClick: handleClick,
    label: icon ? /*#__PURE__*/require$$1.createElement(IconLabel, {
      label: label,
      name: iconName,
      color: iconColor
    }) : label,
    size: size,
    selected: selected
  });
};
Chip.propTypes = {
  label: PropTypes.string.isRequired,
  size: PropTypes.oneOf(["medium", "small"]),
  onClick: PropTypes.func,
  icon: PropTypes.bool,
  selected: PropTypes.bool,
  expanded: PropTypes.bool
};

var StyledListItemContainer = styled(Box)(function (_ref) {
  var showBorder = _ref.showBorder;
  return {
    borderBottom: showBorder && "1px solid ".concat(colors.neutrals["outline-low"]),
    ":hover": {
      backgroundColor: colors.interaction["secondary-alpha"],
      borderBottomColor: colors.neutrals.outline
    }
  };
});
var StyledContentBox$1 = styled(Box)({
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  padding: "".concat(spacing.inset.medium, " ").concat(spacing.inset.large),
  gap: spacing.inline.xsmall
});
var StyledStack$3 = styled(Stack)({
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  flexGrow: 1
});
var ListItem = function ListItem(_ref2) {
  var children = _ref2.children,
    onClick = _ref2.onClick;
    _ref2.showBorder;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    startSelection = _useState2[0],
    setStartSelection = _useState2[1];
  var handleMouseUp = function handleMouseUp(event) {
    var endSelection = event.clientX;
    if (startSelection === endSelection && onClick) {
      onClick();
    }
    setStartSelection(null);
  };
  var handleMouseDown = function handleMouseDown(event) {
    setStartSelection(event.clientX);
  };
  return /*#__PURE__*/require$$1.createElement(StyledListItemContainer, {
    onPointerDown: handleMouseDown,
    onPointerUp: handleMouseUp
  }, /*#__PURE__*/require$$1.createElement(StyledContentBox$1, null, /*#__PURE__*/require$$1.createElement(StyledStack$3, {
    direction: "column"
  }, children), /*#__PURE__*/require$$1.createElement(Stack, null, /*#__PURE__*/require$$1.createElement(dist.Icon, {
    color: colors.neutrals["on-surface"],
    name: "ChevronRight",
    size: "small"
  }))));
};
ListItem.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  showBorder: PropTypes.bool
};

var StyledMenuItem$1 = styled(MenuItem)(function (_ref) {
  var active = _ref.active;
  return {
    fontFamily: typography$1.family.primary,
    fontSize: PrivateTokens.menu.font.medium["font-size"],
    lineHeight: PrivateTokens.menu.font.medium["line-height"],
    fontWeight: PrivateTokens.menu.font.medium["font-weight"],
    padding: "".concat(spacing.inset.xsmall, " ").concat(spacing.inset.medium),
    alignItems: "center",
    color: active ? colors.interaction.primary : colors.neutrals["on-surface-variant"],
    backgroundColor: active && colors.interaction["primary-container-alpha"],
    "&:hover": {
      backgroundColor: active ? colors.interaction["primary-container-hover"] : colors.interaction["secondary-alpha"],
      color: active ? colors.interaction["on-primary-container"] : colors.interaction["on-secondary"],
      "& svg": {
        color: colors.interaction["on-primary-container"]
      }
    },
    "& svg": {
      color: colors.interaction.primary
    }
  };
});
var StyledMenuList$1 = styled(MenuList)(function () {
  return {
    padding: "0px",
    boxShadow: PrivateTokens.elevation.vertical.small["box-shadow"]
  };
});
var MenuDropdown = function MenuDropdown(_ref2) {
  var items = _ref2.items,
    _ref2$variant = _ref2.variant,
    variant = _ref2$variant === void 0 ? "default" : _ref2$variant,
    onSelect = _ref2.onSelect,
    _ref2$withActiveItemI = _ref2.withActiveItemIcon,
    withActiveItemIcon = _ref2$withActiveItemI === void 0 ? true : _ref2$withActiveItemI,
    _ref2$defaultSelected = _ref2.defaultSelected,
    defaultSelected = _ref2$defaultSelected === void 0 ? {} : _ref2$defaultSelected,
    _ref2$multiSelect = _ref2.multiSelect,
    multiSelect = _ref2$multiSelect === void 0 ? false : _ref2$multiSelect;
  var _useState = useState(defaultSelected),
    _useState2 = _slicedToArray(_useState, 2),
    activeItem = _useState2[0],
    setActiveItem = _useState2[1];
  var _useState3 = useState(multiSelect && defaultSelected.length > 0 ? defaultSelected : []),
    _useState4 = _slicedToArray(_useState3, 2),
    activeItems = _useState4[0],
    setActiveItems = _useState4[1];
  var handleMultiSelectItemClick = function handleMultiSelectItemClick(item) {
    var newActiveItems = activeItems !== null && activeItems !== void 0 && activeItems.map(function (i) {
      return i.value;
    }).includes(item.value) ? activeItems.filter(function (selectedItem) {
      return selectedItem.value !== item.value;
    }) : [].concat(_toConsumableArray(activeItems), [item]);
    setActiveItems(newActiveItems);
    if (onSelect) {
      onSelect(newActiveItems);
    }
  };
  var handleItemClick = function handleItemClick(item) {
    setActiveItem(item);
    if (onSelect) {
      onSelect(item);
    }
  };
  var handleClickFunction = multiSelect ? handleMultiSelectItemClick : handleItemClick;
  var isSelected = function isSelected(item) {
    return multiSelect ? activeItems.map(function (i) {
      return i.value;
    }).includes(item.value) : activeItem.value === item.value;
  };
  var DefaultMenuDropdown = /*#__PURE__*/require$$1.createElement(StyledMenuList$1, null, items.map(function (item) {
    return /*#__PURE__*/require$$1.createElement(StyledMenuItem$1, {
      key: item.value,
      disableRipple: true,
      active: isSelected(item),
      onClick: function onClick() {
        return handleClickFunction(item);
      }
    }, /*#__PURE__*/require$$1.createElement(Box, {
      flexGrow: 1,
      textAlign: "left"
    }, /*#__PURE__*/require$$1.createElement(Typography, null, item.label)), /*#__PURE__*/require$$1.createElement(ListItemIcon, {
      textAlign: "right",
      sx: {
        visibility: withActiveItemIcon && isSelected(item) ? "visible" : "hidden"
      }
    }, /*#__PURE__*/require$$1.createElement(dist.Icon, {
      name: "ActionCheck",
      size: "medium"
    })));
  }));
  var ChipMenuDropdown = /*#__PURE__*/require$$1.createElement(Box, {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    gap: spacing.stack.nano,
    py: spacing.inset.large,
    px: spacing.inset.medium,
    boxShadow: PrivateTokens.elevation.vertical.small["box-shadow"]
  }, items.map(function (option) {
    return /*#__PURE__*/require$$1.createElement(Chip, {
      key: option.value,
      label: option.label,
      size: "small",
      selected: isSelected(option),
      icon: withActiveItemIcon && isSelected(option) && /*#__PURE__*/require$$1.createElement(dist.Icon, {
        name: "ActionCheck",
        size: "small"
      }),
      onClick: function onClick() {
        return handleClickFunction(option);
      }
    });
  }));
  return variant === "default" ? DefaultMenuDropdown : ChipMenuDropdown;
};
MenuDropdown.propTypes = {
  withActiveItemIcon: PropTypes.bool,
  variant: PropTypes.oneOf(["default", "chips"]),
  defaultSelected: PropTypes.oneOfType([PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  }), PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  }))]),
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  })),
  onSelect: PropTypes.func,
  multiSelect: PropTypes.bool
};

var _templateObject$1, _templateObject2$1;
var StyledWrapStack = styled(Stack)(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n  flex-wrap: wrap;\n"])));
var StyledInlineStack = styled(Stack)(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["\n  overflow-x: auto; \n  scrollbar-width: none; \n  -ms-overflow-style: none;\n  &::-webkit-scrollbar {\n    display: none;\n  }\n"])));

/**
 * MenuShortcut is a component that displays a group of MenuShortcutTrailItem components.
 * @param {object} props - Props for MenuShortcut component.
 * @param {string} [props.display=inline] - Specifies how the items should be displayed. Possible values: "wrap" for wrapping items or "inline" for inline display.
 * @param {React.ReactNode} props.children - The MenuShortcutTrailItem components to be grouped.
 */
var MenuShortcut = function MenuShortcut(_ref) {
  var _ref$display = _ref.display,
    display = _ref$display === void 0 ? "inline" : _ref$display,
    children = _ref.children;
  var SyledStack = StyledInlineStack;
  if (display === 'wrap') {
    SyledStack = StyledWrapStack;
  }
  return /*#__PURE__*/require$$1.createElement(SyledStack, {
    direction: "row",
    py: spacing.stack.xxsmall,
    px: spacing.inset.large,
    gap: spacing.inline.xxsmall
  }, children);
};
MenuShortcut.propTypes = {
  display: PropTypes.oneOf(['wrap', 'inline']),
  children: PropTypes.node.isRequired
};

var FIXED_MENU_SHORTCUT_ITEM_WIDTH = "88px";

/**
 * MenuShortcutTrailItem is a component that represents an item in a menu shortcut.
 * @param {object} props - Props for MenuShortcutTrailItem component.
 * @param {string} props.label - The label of the menu item.
 * @param {string} props.iconName - The name of the icon to display.
 * @param {function} [props.onClick] - Function to be called when the item is clicked.
 */
var MenuShortcutTrailItem = function MenuShortcutTrailItem(_ref) {
  var label = _ref.label,
    iconName = _ref.iconName,
    onClick = _ref.onClick;
  return /*#__PURE__*/require$$1.createElement(Stack, {
    width: FIXED_MENU_SHORTCUT_ITEM_WIDTH,
    alignItems: "center",
    gap: spacing.stack.xxxsmall
  }, /*#__PURE__*/require$$1.createElement(Stack, {
    direction: "row",
    px: spacing.inset.xsmall
  }, /*#__PURE__*/require$$1.createElement(Stack, {
    p: spacing.inset.medium,
    borderRadius: borders.radius.large,
    backgroundColor: colors.interaction['secondary-alpha'],
    onClick: onClick
  }, /*#__PURE__*/require$$1.createElement(dist.Icon, {
    name: iconName,
    size: "large",
    color: colors.neutrals['on-surface']
  }))), /*#__PURE__*/require$$1.createElement(Typography, {
    variant: "subtitleSmall",
    textAlign: "center",
    color: colors.neutrals['on-surface']
  }, label));
};
MenuShortcutTrailItem.propTypes = {
  label: PropTypes.string.isRequired,
  iconName: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
};

function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}

let e={data:""},t=t=>"object"==typeof window?((t?t.querySelector("#_goober"):window._goober)||Object.assign((t||document.head).appendChild(document.createElement("style")),{innerHTML:" ",id:"_goober"})).firstChild:t||e,l=/(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g,a=/\/\*[^]*?\*\/|  +/g,n=/\n+/g,o=(e,t)=>{let r="",l="",a="";for(let n in e){let c=e[n];"@"==n[0]?"i"==n[1]?r=n+" "+c+";":l+="f"==n[1]?o(c,n):n+"{"+o(c,"k"==n[1]?"":t)+"}":"object"==typeof c?l+=o(c,t?t.replace(/([^,])+/g,e=>n.replace(/(^:.*)|([^,])+/g,t=>/&/.test(t)?t.replace(/&/g,e):e?e+" "+t:t)):n):null!=c&&(n=/^--/.test(n)?n:n.replace(/[A-Z]/g,"-$&").toLowerCase(),a+=o.p?o.p(n,c):n+":"+c+";");}return r+(t&&a?t+"{"+a+"}":a)+l},c={},s=e=>{if("object"==typeof e){let t="";for(let r in e)t+=r+s(e[r]);return t}return e},i=(e,t,r,i,p)=>{let u=s(e),d=c[u]||(c[u]=(e=>{let t=0,r=11;for(;t<e.length;)r=101*r+e.charCodeAt(t++)>>>0;return "go"+r})(u));if(!c[d]){let t=u!==e?e:(e=>{let t,r,o=[{}];for(;t=l.exec(e.replace(a,""));)t[4]?o.shift():t[3]?(r=t[3].replace(n," ").trim(),o.unshift(o[0][r]=o[0][r]||{})):o[0][t[1]]=t[2].replace(n," ").trim();return o[0]})(e);c[d]=o(p?{["@keyframes "+d]:t}:t,r?"":"."+d);}let f=r&&c.g?c.g:null;return r&&(c.g=c[d]),((e,t,r,l)=>{l?t.data=t.data.replace(l,e):-1===t.data.indexOf(e)&&(t.data=r?e+t.data:t.data+e);})(c[d],t,i,f),d},p=(e,t,r)=>e.reduce((e,l,a)=>{let n=t[a];if(n&&n.call){let e=n(r),t=e&&e.props&&e.props.className||/^go/.test(e)&&e;n=t?"."+t:e&&"object"==typeof e?e.props?"":o(e,""):!1===e?"":e;}return e+l+(null==n?"":n)},"");function u(e){let r=this||{},l=e.call?e(r.p):e;return i(l.unshift?l.raw?p(l,[].slice.call(arguments,1),r.p):l.reduce((e,t)=>Object.assign(e,t&&t.call?t(r.p):t),{}):l,t(r.target),r.g,r.o,r.k)}u.bind({g:1});u.bind({k:1});

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

var noOp = function noOp() {
  return '';
};

var SnackbarContext$1 = /*#__PURE__*/require$$1.createContext({
  enqueueSnackbar: noOp,
  closeSnackbar: noOp
});

var breakpoints = {
  downXs: '@media (max-width:599.95px)',
  upSm: '@media (min-width:600px)'
};

var capitalise = function capitalise(text) {
  return text.charAt(0).toUpperCase() + text.slice(1);
};

var originKeyExtractor = function originKeyExtractor(anchor) {
  return "" + capitalise(anchor.vertical) + capitalise(anchor.horizontal);
};
var isDefined = function isDefined(value) {
  return !!value || value === 0;
};

var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';

var Transition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    var appear = props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props["in"]) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else if (props.unmountOnExit || props.mountOnEnter) {
      initialStatus = UNMOUNTED;
    } else {
      initialStatus = EXITED;
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref["in"];

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  };

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props["in"]) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else if (status === ENTERING || status === ENTERED) {
        nextStatus = EXITING;
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var enter = timeout;
    var exit = timeout;

    if (timeout != null && typeof timeout !== 'number' && typeof timeout !== 'string') {
      exit = timeout.exit;
      enter = timeout.enter;
    }

    return {
      exit: exit,
      enter: enter
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var isAppearing = mounting;
    var timeouts = this.getTimeouts();

    if (!mounting && !enter) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        if (_this2.props.onEntered) {
          _this2.props.onEntered(_this2.node, isAppearing);
        }
      });
      return;
    }

    if (this.props.onEnter) {
      this.props.onEnter(this.node, isAppearing);
    }

    this.safeSetState({
      status: ENTERING
    }, function () {
      if (_this2.props.onEntering) {
        _this2.props.onEntering(_this2.node, isAppearing);
      }

      _this2.onTransitionEnd(timeouts.enter, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          if (_this2.props.onEntered) {
            _this2.props.onEntered(_this2.node, isAppearing);
          }
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit) {
      this.safeSetState({
        status: EXITED
      }, function () {
        if (_this3.props.onExited) {
          _this3.props.onExited(_this3.node);
        }
      });
      return;
    }

    if (this.props.onExit) {
      this.props.onExit(this.node);
    }

    this.safeSetState({
      status: EXITING
    }, function () {
      if (_this3.props.onExiting) {
        _this3.props.onExiting(_this3.node);
      }

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          if (_this3.props.onExited) {
            _this3.props.onExited(_this3.node);
          }
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null && this.nextCallback.cancel) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function () {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback();
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!this.node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      this.props.addEndListener(this.node, this.nextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return children(status, childProps);
  };

  _createClass(Transition, [{
    key: "node",
    get: function get() {
      var _this$props$nodeRef;

      var node = (_this$props$nodeRef = this.props.nodeRef) === null || _this$props$nodeRef === void 0 ? void 0 : _this$props$nodeRef.current;

      if (!node) {
        throw new Error('notistack - Custom snackbar is not refForwarding');
      }

      return node;
    }
  }]);

  return Transition;
}(require$$1.Component);

function noop() {//
}

Transition.defaultProps = {
  "in": false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};

/**
 * Credit to MUI team @ https://mui.com
 */
/**
 * passes {value} to {ref}
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */

function setRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}

function useForkRef(refA, refB) {
  /**
   * This will create a new function if the ref props change and are defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */
  return useMemo(function () {
    if (refA == null && refB == null) {
      return null;
    }

    return function (refValue) {
      setRef(refA, refValue);
      setRef(refB, refValue);
    };
  }, [refA, refB]);
}

function getTransitionProps(props) {
  var timeout = props.timeout,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style,
      mode = props.mode;
  return {
    duration: typeof timeout === 'object' ? timeout[mode] || 0 : timeout,
    easing: style.transitionTimingFunction,
    delay: style.transitionDelay
  };
}

/**
 * Credit to MUI team @ https://mui.com
 */
var defaultEasing = {
  // This is the most common easing curve.
  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
/**
 * CSS hack to force a repaint
 */

var reflow = function reflow(node) {
  // We have to do something with node.scrollTop.
  // Otherwise it's removed from the compiled code by optimisers
  // eslint-disable-next-line no-self-assign
  node.scrollTop = node.scrollTop;
};

var formatMs = function formatMs(milliseconds) {
  return Math.round(milliseconds) + "ms";
};

function createTransition(props, options) {
  if (props === void 0) {
    props = ['all'];
  }

  var _ref = options || {},
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? 300 : _ref$duration,
      _ref$easing = _ref.easing,
      easing = _ref$easing === void 0 ? defaultEasing.easeInOut : _ref$easing,
      _ref$delay = _ref.delay,
      delay = _ref$delay === void 0 ? 0 : _ref$delay;

  var properties = Array.isArray(props) ? props : [props];
  return properties.map(function (animatedProp) {
    var formattedDuration = typeof duration === 'string' ? duration : formatMs(duration);
    var formattedDelay = typeof delay === 'string' ? delay : formatMs(delay);
    return animatedProp + " " + formattedDuration + " " + easing + " " + formattedDelay;
  }).join(',');
}

function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

function ownerWindow(node) {
  var doc = ownerDocument(node);
  return doc.defaultView || window;
}
/**
 * Corresponds to 10 frames at 60 Hz.
 * A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
 */


function debounce(func, wait) {
  if (wait === void 0) {
    wait = 166;
  }

  var timeout;

  function debounced() {
    var _this = this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var later = function later() {
      // @ts-ignore
      func.apply(_this, args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  }

  debounced.clear = function () {
    clearTimeout(timeout);
  };

  return debounced;
}
/**
 * Translate the node so it can't be seen on the screen.
 * Later, we're going to translate the node back to its original location with `none`.
 */


function getTranslateValue(direction, node) {
  var rect = node.getBoundingClientRect();
  var containerWindow = ownerWindow(node);
  var transform;

  if (node.fakeTransform) {
    transform = node.fakeTransform;
  } else {
    var computedStyle = containerWindow.getComputedStyle(node);
    transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
  }

  var offsetX = 0;
  var offsetY = 0;

  if (transform && transform !== 'none' && typeof transform === 'string') {
    var transformValues = transform.split('(')[1].split(')')[0].split(',');
    offsetX = parseInt(transformValues[4], 10);
    offsetY = parseInt(transformValues[5], 10);
  }

  switch (direction) {
    case 'left':
      return "translateX(" + (containerWindow.innerWidth + offsetX - rect.left) + "px)";

    case 'right':
      return "translateX(-" + (rect.left + rect.width - offsetX) + "px)";

    case 'up':
      return "translateY(" + (containerWindow.innerHeight + offsetY - rect.top) + "px)";

    default:
      // down
      return "translateY(-" + (rect.top + rect.height - offsetY) + "px)";
  }
}

function setTranslateValue(direction, node) {
  if (!node) return;
  var transform = getTranslateValue(direction, node);

  if (transform) {
    node.style.webkitTransform = transform;
    node.style.transform = transform;
  }
}

var Slide = /*#__PURE__*/forwardRef(function (props, ref) {
  var children = props.children,
      _props$direction = props.direction,
      direction = _props$direction === void 0 ? 'down' : _props$direction,
      inProp = props["in"],
      style = props.style,
      _props$timeout = props.timeout,
      timeout = _props$timeout === void 0 ? 0 : _props$timeout,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onExit = props.onExit,
      onExited = props.onExited,
      other = _objectWithoutPropertiesLoose(props, ["children", "direction", "in", "style", "timeout", "onEnter", "onEntered", "onExit", "onExited"]);

  var nodeRef = useRef(null);
  var handleRefIntermediary = useForkRef(children.ref, nodeRef);
  var handleRef = useForkRef(handleRefIntermediary, ref);

  var handleEnter = function handleEnter(node, isAppearing) {
    setTranslateValue(direction, node);
    reflow(node);

    if (onEnter) {
      onEnter(node, isAppearing);
    }
  };

  var handleEntering = function handleEntering(node) {
    var easing = (style === null || style === void 0 ? void 0 : style.transitionTimingFunction) || defaultEasing.easeOut;
    var transitionProps = getTransitionProps({
      timeout: timeout,
      mode: 'enter',
      style: _extends({}, style, {
        transitionTimingFunction: easing
      })
    });
    node.style.webkitTransition = createTransition('-webkit-transform', transitionProps);
    node.style.transition = createTransition('transform', transitionProps);
    node.style.webkitTransform = 'none';
    node.style.transform = 'none';
  };

  var handleExit = function handleExit(node) {
    var easing = (style === null || style === void 0 ? void 0 : style.transitionTimingFunction) || defaultEasing.sharp;
    var transitionProps = getTransitionProps({
      timeout: timeout,
      mode: 'exit',
      style: _extends({}, style, {
        transitionTimingFunction: easing
      })
    });
    node.style.webkitTransition = createTransition('-webkit-transform', transitionProps);
    node.style.transition = createTransition('transform', transitionProps);
    setTranslateValue(direction, node);

    if (onExit) {
      onExit(node);
    }
  };

  var handleExited = function handleExited(node) {
    // No need for transitions when the component is hidden
    node.style.webkitTransition = '';
    node.style.transition = '';

    if (onExited) {
      onExited(node);
    }
  };

  var updatePosition = useCallback(function () {
    if (nodeRef.current) {
      setTranslateValue(direction, nodeRef.current);
    }
  }, [direction]);
  useEffect(function () {
    // Skip configuration where the position is screen size invariant.
    if (inProp || direction === 'down' || direction === 'right') {
      return undefined;
    }

    var handleResize = debounce(function () {
      if (nodeRef.current) {
        setTranslateValue(direction, nodeRef.current);
      }
    });
    var containerWindow = ownerWindow(nodeRef.current);
    containerWindow.addEventListener('resize', handleResize);
    return function () {
      handleResize.clear();
      containerWindow.removeEventListener('resize', handleResize);
    };
  }, [direction, inProp]);
  useEffect(function () {
    if (!inProp) {
      // We need to update the position of the drawer when the direction change and
      // when it's hidden.
      updatePosition();
    }
  }, [inProp, updatePosition]);
  return createElement(Transition, Object.assign({
    appear: true,
    nodeRef: nodeRef,
    onEnter: handleEnter,
    onEntered: onEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    "in": inProp,
    timeout: timeout
  }, other), function (state, childProps) {
    return cloneElement(children, _extends({
      ref: handleRef,
      style: _extends({
        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
      }, style, {}, children.props.style)
    }, childProps));
  });
});
Slide.displayName = 'Slide';

var SvgIcon = function SvgIcon(props) {
  return require$$1.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    focusable: "false",
    style: {
      fontSize: 20,
      marginInlineEnd: 8,
      userSelect: 'none',
      width: '1em',
      height: '1em',
      display: 'inline-block',
      fill: 'currentColor',
      flexShrink: 0
    }
  }, props));
};

var CheckIcon = function CheckIcon() {
  return require$$1.createElement(SvgIcon, null, require$$1.createElement("path", {
    d: "M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M10 17L5 12L6.41\n        10.59L10 14.17L17.59 6.58L19 8L10 17Z"
  }));
};

var WarningIcon = function WarningIcon() {
  return require$$1.createElement(SvgIcon, null, require$$1.createElement("path", {
    d: "M13,14H11V10H13M13,18H11V16H13M1,21H23L12,2L1,21Z"
  }));
};

var ErrorIcon = function ErrorIcon() {
  return require$$1.createElement(SvgIcon, null, require$$1.createElement("path", {
    d: "M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,\n        6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,\n        13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z"
  }));
};

var InfoIcon = function InfoIcon() {
  return require$$1.createElement(SvgIcon, null, require$$1.createElement("path", {
    d: "M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,\n        0 22,12A10,10 0 0,0 12,2Z"
  }));
};

var defaultIconVariants = {
  "default": undefined,
  success: /*#__PURE__*/require$$1.createElement(CheckIcon, null),
  warning: /*#__PURE__*/require$$1.createElement(WarningIcon, null),
  error: /*#__PURE__*/require$$1.createElement(ErrorIcon, null),
  info: /*#__PURE__*/require$$1.createElement(InfoIcon, null)
};

var defaults = {
  maxSnack: 3,
  persist: false,
  hideIconVariant: false,
  disableWindowBlurListener: false,
  variant: 'default',
  autoHideDuration: 5000,
  iconVariant: defaultIconVariants,
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left'
  },
  TransitionComponent: Slide,
  transitionDuration: {
    enter: 225,
    exit: 195
  }
};
/**
 * Derives the right autoHideDuration taking into account the following
 * prority order: 1: Options, 2: Props, 3: default fallback
 */

var getAutoHideDuration = function getAutoHideDuration(optionsDuration, propsDuration) {
  var isNumberOrNull = function isNumberOrNull(numberish) {
    return typeof numberish === 'number' || numberish === null;
  };

  if (isNumberOrNull(optionsDuration)) return optionsDuration;
  if (isNumberOrNull(propsDuration)) return propsDuration;
  return defaults.autoHideDuration;
};
/**
 * Derives the right transitionDuration taking into account the following
 * prority order: 1: Options, 2: Props, 3: default fallback
 */


var getTransitionDuration = function getTransitionDuration(optionsDuration, propsDuration) {
  var is = function is(item, types) {
    return types.some(function (t) {
      return typeof item === t;
    });
  };

  if (is(optionsDuration, ['string', 'number'])) {
    return optionsDuration;
  }

  if (is(optionsDuration, ['object'])) {
    return _extends({}, defaults.transitionDuration, {}, is(propsDuration, ['object']) && propsDuration, {}, optionsDuration);
  }

  if (is(propsDuration, ['string', 'number'])) {
    return propsDuration;
  }

  if (is(propsDuration, ['object'])) {
    return _extends({}, defaults.transitionDuration, {}, propsDuration);
  }

  return defaults.transitionDuration;
};

var merge = function merge(options, props) {
  return function (name, shouldObjectMerge) {
    if (shouldObjectMerge === void 0) {
      shouldObjectMerge = false;
    }

    if (shouldObjectMerge) {
      return _extends({}, defaults[name], {}, props[name], {}, options[name]);
    }

    if (name === 'autoHideDuration') {
      return getAutoHideDuration(options.autoHideDuration, props.autoHideDuration);
    }

    if (name === 'transitionDuration') {
      return getTransitionDuration(options.transitionDuration, props.transitionDuration);
    }

    return options[name] || props[name] || defaults[name];
  };
};

function makeStyles(styles) {
  return Object.entries(styles).reduce(function (acc, _ref) {
    var _extends2;

    var key = _ref[0],
        value = _ref[1];
    return _extends({}, acc, (_extends2 = {}, _extends2[key] = u(value), _extends2));
  }, {});
}
var ComponentClasses = {
  SnackbarContainer: 'notistack-SnackbarContainer',
  Snackbar: 'notistack-Snackbar',
  CollapseWrapper: 'notistack-CollapseWrapper',
  MuiContent: 'notistack-MuiContent',
  MuiContentVariant: function MuiContentVariant(variant) {
    return "notistack-MuiContent-" + variant;
  }
};

var classes = /*#__PURE__*/makeStyles({
  root: {
    height: 0
  },
  entered: {
    height: 'auto'
  }
});
var collapsedSize = '0px';
var timeout = 175;
var Collapse = /*#__PURE__*/forwardRef(function (props, ref) {
  var children = props.children,
      inProp = props["in"],
      onExited = props.onExited;
  var wrapperRef = useRef(null);
  var nodeRef = useRef(null);
  var handleRef = useForkRef(ref, nodeRef);

  var getWrapperSize = function getWrapperSize() {
    return wrapperRef.current ? wrapperRef.current.clientHeight : 0;
  };

  var handleEnter = function handleEnter(node) {
    node.style.height = collapsedSize;
  };

  var handleEntering = function handleEntering(node) {
    var wrapperSize = getWrapperSize();

    var _getTransitionProps = getTransitionProps({
      timeout: timeout,
      mode: 'enter'
    }),
        transitionDuration = _getTransitionProps.duration,
        easing = _getTransitionProps.easing;

    node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : transitionDuration + "ms";
    node.style.height = wrapperSize + "px";
    node.style.transitionTimingFunction = easing || '';
  };

  var handleEntered = function handleEntered(node) {
    node.style.height = 'auto';
  };

  var handleExit = function handleExit(node) {
    node.style.height = getWrapperSize() + "px";
  };

  var handleExiting = function handleExiting(node) {
    reflow(node);

    var _getTransitionProps2 = getTransitionProps({
      timeout: timeout,
      mode: 'exit'
    }),
        transitionDuration = _getTransitionProps2.duration,
        easing = _getTransitionProps2.easing;

    node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : transitionDuration + "ms";
    node.style.height = collapsedSize;
    node.style.transitionTimingFunction = easing || '';
  };

  return createElement(Transition, {
    "in": inProp,
    unmountOnExit: true,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: onExited,
    onExiting: handleExiting,
    nodeRef: nodeRef,
    timeout: timeout
  }, function (state, childProps) {
    return createElement("div", Object.assign({
      ref: handleRef,
      className: clsx(classes.root, state === 'entered' && classes.entered),
      style: _extends({
        pointerEvents: 'all',
        overflow: 'hidden',
        minHeight: collapsedSize,
        transition: createTransition('height')
      }, state === 'entered' && {
        overflow: 'visible'
      }, {}, state === 'exited' && !inProp && {
        visibility: 'hidden'
      })
    }, childProps), createElement("div", {
      ref: wrapperRef,
      className: ComponentClasses.CollapseWrapper,
      // Hack to get children with a negative margin to not falsify the height computation.
      style: {
        display: 'flex',
        width: '100%'
      }
    }, children));
  });
});
Collapse.displayName = 'Collapse';

var direction = {
  right: 'left',
  left: 'right',
  bottom: 'up',
  top: 'down'
};
var getSlideDirection = function getSlideDirection(anchorOrigin) {
  if (anchorOrigin.horizontal !== 'center') {
    return direction[anchorOrigin.horizontal];
  }

  return direction[anchorOrigin.vertical];
};
/** Tranforms classes name */

var toSnackbarAnchorOrigin = function toSnackbarAnchorOrigin(anchorOrigin) {
  return "anchorOrigin" + originKeyExtractor(anchorOrigin);
};
/**
 * Omit SnackbarContainer class keys that are not needed for SnackbarItem
 */

var keepSnackbarClassKeys = function keepSnackbarClassKeys(classes) {
  if (classes === void 0) {
    classes = {};
  }

  var containerClasses = {
    containerRoot: true,
    containerAnchorOriginTopCenter: true,
    containerAnchorOriginBottomCenter: true,
    containerAnchorOriginTopRight: true,
    containerAnchorOriginBottomRight: true,
    containerAnchorOriginTopLeft: true,
    containerAnchorOriginBottomLeft: true
  };
  return Object.keys(classes).filter(function (key) {
    return !containerClasses[key];
  }).reduce(function (obj, key) {
    var _extends2;

    return _extends({}, obj, (_extends2 = {}, _extends2[key] = classes[key], _extends2));
  }, {});
};

var noOp$1 = function noOp() {
  /* */
};
/**
 * Credit to MUI team @ https://mui.com
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */


function createChainedFunction(funcs, snackbarId) {
  // @ts-ignore
  return funcs.reduce(function (acc, func) {
    if (func === null || func === undefined) {
      return acc;
    }

    return function chainedFunction() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var argums = [].concat(args);

      if (snackbarId && argums.indexOf(snackbarId) === -1) {
        argums.push(snackbarId);
      } // @ts-ignore


      acc.apply(this, argums);
      func.apply(this, argums);
    };
  }, noOp$1);
}

/**
 * Credit to MUI team @ https://mui.com
 * https://github.com/facebook/react/issues/14099#issuecomment-440013892
 */
var useEnhancedEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;
function useEventCallback(fn) {
  var ref = useRef(fn);
  useEnhancedEffect(function () {
    ref.current = fn;
  });
  return useCallback(function () {
    return (// @ts-expect-error hide `this`
      (ref.current).apply(void 0, arguments)
    );
  }, []);
}

/**
 * Credit to MUI team @ https://mui.com
 */
var Snackbar = /*#__PURE__*/forwardRef(function (props, ref) {
  var children = props.children,
      className = props.className,
      autoHideDuration = props.autoHideDuration,
      _props$disableWindowB = props.disableWindowBlurListener,
      disableWindowBlurListener = _props$disableWindowB === void 0 ? false : _props$disableWindowB,
      onClose = props.onClose,
      id = props.id,
      open = props.open,
      _props$SnackbarProps = props.SnackbarProps,
      SnackbarProps = _props$SnackbarProps === void 0 ? {} : _props$SnackbarProps;
  var timerAutoHide = useRef();
  var handleClose = useEventCallback(function () {
    if (onClose) {
      onClose.apply(void 0, arguments);
    }
  });
  var setAutoHideTimer = useEventCallback(function (autoHideDurationParam) {
    if (!onClose || autoHideDurationParam == null) {
      return;
    }

    if (timerAutoHide.current) {
      clearTimeout(timerAutoHide.current);
    }

    timerAutoHide.current = setTimeout(function () {
      handleClose(null, 'timeout', id);
    }, autoHideDurationParam);
  });
  useEffect(function () {
    if (open) {
      setAutoHideTimer(autoHideDuration);
    }

    return function () {
      if (timerAutoHide.current) {
        clearTimeout(timerAutoHide.current);
      }
    };
  }, [open, autoHideDuration, setAutoHideTimer]);
  /**
   * Pause the timer when the user is interacting with the Snackbar
   * or when the user hide the window.
   */

  var handlePause = function handlePause() {
    if (timerAutoHide.current) {
      clearTimeout(timerAutoHide.current);
    }
  };
  /**
   * Restart the timer when the user is no longer interacting with the Snackbar
   * or when the window is shown back.
   */


  var handleResume = useCallback(function () {
    if (autoHideDuration != null) {
      setAutoHideTimer(autoHideDuration * 0.5);
    }
  }, [autoHideDuration, setAutoHideTimer]);

  var handleMouseEnter = function handleMouseEnter(event) {
    if (SnackbarProps.onMouseEnter) {
      SnackbarProps.onMouseEnter(event);
    }

    handlePause();
  };

  var handleMouseLeave = function handleMouseLeave(event) {
    if (SnackbarProps.onMouseLeave) {
      SnackbarProps.onMouseLeave(event);
    }

    handleResume();
  };

  useEffect(function () {
    if (!disableWindowBlurListener && open) {
      window.addEventListener('focus', handleResume);
      window.addEventListener('blur', handlePause);
      return function () {
        window.removeEventListener('focus', handleResume);
        window.removeEventListener('blur', handlePause);
      };
    }

    return undefined;
  }, [disableWindowBlurListener, handleResume, open]);
  return createElement("div", Object.assign({
    ref: ref
  }, SnackbarProps, {
    className: clsx(ComponentClasses.Snackbar, className),
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  }), children);
});
Snackbar.displayName = 'Snackbar';

var _root;
var classes$1 = /*#__PURE__*/makeStyles({
  root: (_root = {
    display: 'flex',
    flexWrap: 'wrap',
    flexGrow: 1
  }, _root[breakpoints.upSm] = {
    flexGrow: 'initial',
    minWidth: '288px'
  }, _root)
});
var SnackbarContent$1 = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, ["className"]);

  return require$$1.createElement("div", Object.assign({
    ref: ref,
    className: clsx(classes$1.root, className)
  }, props));
});
SnackbarContent$1.displayName = 'SnackbarContent';

var classes$2 = /*#__PURE__*/makeStyles({
  root: {
    backgroundColor: '#313131',
    fontSize: '0.875rem',
    lineHeight: 1.43,
    letterSpacing: '0.01071em',
    color: '#fff',
    alignItems: 'center',
    padding: '6px 16px',
    borderRadius: '4px',
    boxShadow: '0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)'
  },
  lessPadding: {
    paddingLeft: 8 * 2.5 + "px"
  },
  "default": {
    backgroundColor: '#313131'
  },
  success: {
    backgroundColor: '#43a047'
  },
  error: {
    backgroundColor: '#d32f2f'
  },
  warning: {
    backgroundColor: '#ff9800'
  },
  info: {
    backgroundColor: '#2196f3'
  },
  message: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px 0'
  },
  action: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto',
    paddingLeft: '16px',
    marginRight: '-8px'
  }
});
var ariaDescribedby = 'notistack-snackbar';
var MaterialDesignContent = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  var id = props.id,
      message = props.message,
      componentOrFunctionAction = props.action,
      iconVariant = props.iconVariant,
      variant = props.variant,
      hideIconVariant = props.hideIconVariant,
      style = props.style,
      className = props.className;
  var icon = iconVariant[variant];
  var action = componentOrFunctionAction;

  if (typeof action === 'function') {
    action = action(id);
  }

  return require$$1.createElement(SnackbarContent$1, {
    ref: forwardedRef,
    role: "alert",
    "aria-describedby": ariaDescribedby,
    style: style,
    className: clsx(ComponentClasses.MuiContent, ComponentClasses.MuiContentVariant(variant), classes$2.root, classes$2[variant], className, !hideIconVariant && icon && classes$2.lessPadding)
  }, require$$1.createElement("div", {
    id: ariaDescribedby,
    className: classes$2.message
  }, !hideIconVariant ? icon : null, message), action && require$$1.createElement("div", {
    className: classes$2.action
  }, action));
});
MaterialDesignContent.displayName = 'MaterialDesignContent';
var MaterialDesignContent$1 = /*#__PURE__*/memo(MaterialDesignContent);

var styles = /*#__PURE__*/makeStyles({
  wrappedRoot: {
    width: '100%',
    position: 'relative',
    transform: 'translateX(0)',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    minWidth: '288px'
  }
});

var SnackbarItem = function SnackbarItem(props) {
  var timeout = useRef();

  var _useState = useState(true),
      collapsed = _useState[0],
      setCollapsed = _useState[1];

  var handleClose = createChainedFunction([props.snack.onClose, props.onClose]);

  var handleEntered = function handleEntered() {
    if (props.snack.requestClose) {
      handleClose(null, 'instructed', props.snack.id);
    }
  };

  var handleExitedScreen = useCallback(function () {
    timeout.current = setTimeout(function () {
      setCollapsed(function (col) {
        return !col;
      });
    }, 125);
  }, []);
  useEffect(function () {
    return function () {
      if (timeout.current) {
        clearTimeout(timeout.current);
      }
    };
  }, []);
  var snack = props.snack,
      allClasses = props.classes,
      _props$Component = props.Component,
      Component = _props$Component === void 0 ? MaterialDesignContent$1 : _props$Component;
  var classes = useMemo(function () {
    return keepSnackbarClassKeys(allClasses);
  }, [allClasses]);

  var open = snack.open,
      SnackbarProps = snack.SnackbarProps,
      TransitionComponent = snack.TransitionComponent,
      TransitionProps = snack.TransitionProps,
      transitionDuration = snack.transitionDuration,
      disableWindowBlurListener = snack.disableWindowBlurListener,
      componentOrFunctionContent = snack.content,
      otherSnack = _objectWithoutPropertiesLoose(snack, ["open", "SnackbarProps", "TransitionComponent", "TransitionProps", "transitionDuration", "disableWindowBlurListener", "content", "entered", "requestClose", "onEnter", "onEntered", "onExit", "onExited"]);

  var transitionProps = _extends({
    direction: getSlideDirection(otherSnack.anchorOrigin),
    timeout: transitionDuration
  }, TransitionProps);

  var content = componentOrFunctionContent;

  if (typeof content === 'function') {
    content = content(otherSnack.id, otherSnack.message);
  }

  var callbacks = ['onEnter', 'onEntered', 'onExit', 'onExited'].reduce(function (acc, cbName) {
    var _extends2;

    return _extends({}, acc, (_extends2 = {}, _extends2[cbName] = createChainedFunction([props.snack[cbName], props[cbName]], otherSnack.id), _extends2));
  }, {});
  return require$$1.createElement(Collapse, {
    "in": collapsed,
    onExited: callbacks.onExited
  }, require$$1.createElement(Snackbar, {
    open: open,
    id: otherSnack.id,
    disableWindowBlurListener: disableWindowBlurListener,
    autoHideDuration: otherSnack.autoHideDuration,
    className: clsx(styles.wrappedRoot, classes.root, classes[toSnackbarAnchorOrigin(otherSnack.anchorOrigin)]),
    SnackbarProps: SnackbarProps,
    onClose: handleClose
  }, require$$1.createElement(TransitionComponent, Object.assign({}, transitionProps, {
    appear: true,
    "in": open,
    onExit: callbacks.onExit,
    onExited: handleExitedScreen,
    onEnter: callbacks.onEnter,
    // order matters. first callbacks.onEntered to set entered: true,
    // then handleEntered to check if there's a request for closing
    onEntered: createChainedFunction([callbacks.onEntered, handleEntered], otherSnack.id)
  }), content || require$$1.createElement(Component, Object.assign({}, otherSnack)))));
};

var _root$1, _rootDense, _left, _right, _center;
var indents = {
  view: {
    "default": 20,
    dense: 4
  },
  snackbar: {
    "default": 6,
    dense: 2
  }
};
var collapseWrapper = "." + ComponentClasses.CollapseWrapper;
var xsWidthMargin = 16;
var styles$1 = /*#__PURE__*/makeStyles({
  root: (_root$1 = {
    boxSizing: 'border-box',
    display: 'flex',
    maxHeight: '100%',
    position: 'fixed',
    zIndex: 1400,
    height: 'auto',
    width: 'auto',
    transition: /*#__PURE__*/createTransition(['top', 'right', 'bottom', 'left', 'max-width'], {
      duration: 300,
      easing: 'ease'
    }),
    // container itself is invisible and should not block clicks, clicks should be passed to its children
    // a pointerEvents: all is applied in the collapse component
    pointerEvents: 'none'
  }, _root$1[collapseWrapper] = {
    padding: indents.snackbar["default"] + "px 0px",
    transition: 'padding 300ms ease 0ms'
  }, _root$1.maxWidth = "calc(100% - " + indents.view["default"] * 2 + "px)", _root$1[breakpoints.downXs] = {
    width: '100%',
    maxWidth: "calc(100% - " + xsWidthMargin * 2 + "px)"
  }, _root$1),
  rootDense: (_rootDense = {}, _rootDense[collapseWrapper] = {
    padding: indents.snackbar.dense + "px 0px"
  }, _rootDense),
  top: {
    top: indents.view["default"] - indents.snackbar["default"] + "px",
    flexDirection: 'column'
  },
  bottom: {
    bottom: indents.view["default"] - indents.snackbar["default"] + "px",
    flexDirection: 'column-reverse'
  },
  left: (_left = {
    left: indents.view["default"] + "px"
  }, _left[breakpoints.upSm] = {
    alignItems: 'flex-start'
  }, _left[breakpoints.downXs] = {
    left: xsWidthMargin + "px"
  }, _left),
  right: (_right = {
    right: indents.view["default"] + "px"
  }, _right[breakpoints.upSm] = {
    alignItems: 'flex-end'
  }, _right[breakpoints.downXs] = {
    right: xsWidthMargin + "px"
  }, _right),
  center: (_center = {
    left: '50%',
    transform: 'translateX(-50%)'
  }, _center[breakpoints.upSm] = {
    alignItems: 'center'
  }, _center)
});

var SnackbarContainer = function SnackbarContainer(props) {
  var _props$classes = props.classes,
      classes = _props$classes === void 0 ? {} : _props$classes,
      anchorOrigin = props.anchorOrigin,
      dense = props.dense,
      children = props.children;
  var combinedClassname = clsx(ComponentClasses.SnackbarContainer, styles$1[anchorOrigin.vertical], styles$1[anchorOrigin.horizontal], styles$1.root, // root should come after others to override maxWidth
  classes.containerRoot, classes["containerAnchorOrigin" + originKeyExtractor(anchorOrigin)], dense && styles$1.rootDense);
  return require$$1.createElement("div", {
    className: combinedClassname
  }, children);
};

var SnackbarContainer$1 = /*#__PURE__*/memo(SnackbarContainer);

/* eslint-disable */
var __DEV__ = process.env.NODE_ENV !== 'production';

var messages = {
  NO_PERSIST_ALL: "Reached maxSnack while all enqueued snackbars have 'persist' flag. Notistack will dismiss the oldest snackbar anyway to allow other ones in the queue to be presented."
};
var warning = (function (messageKey) {
  if (!__DEV__) return;
  var message = messages[messageKey];

  if (typeof console !== 'undefined') {
    console.error("WARNING - notistack: " + message);
  }

  try {
    throw new Error(message);
  } catch (x) {}
});

var isOptions = function isOptions(messageOrOptions) {
  var isMessage = typeof messageOrOptions === 'string' || isValidElement(messageOrOptions);
  return !isMessage;
};

var SnackbarProvider$1 = /*#__PURE__*/function (_Component) {
  _inheritsLoose(SnackbarProvider, _Component);

  function SnackbarProvider(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    /**
     * Adds a new snackbar to the queue to be presented.
     * Returns generated or user defined key referencing the new snackbar or null
     */

    _this.enqueueSnackbar = function (messageOrOptions, optsOrUndefined) {
      if (optsOrUndefined === void 0) {
        optsOrUndefined = {};
      }

      if (messageOrOptions === undefined || messageOrOptions === null) {
        throw new Error('enqueueSnackbar called with invalid argument');
      }

      var opts = isOptions(messageOrOptions) ? messageOrOptions : optsOrUndefined;
      var message = isOptions(messageOrOptions) ? messageOrOptions.message : messageOrOptions;

      var key = opts.key,
          preventDuplicate = opts.preventDuplicate,
          options = _objectWithoutPropertiesLoose(opts, ["key", "preventDuplicate"]);

      var hasSpecifiedKey = isDefined(key);
      var id = hasSpecifiedKey ? key : new Date().getTime() + Math.random();
      var merger = merge(options, _this.props);

      var snack = _extends({
        id: id
      }, options, {
        message: message,
        open: true,
        entered: false,
        requestClose: false,
        persist: merger('persist'),
        action: merger('action'),
        content: merger('content'),
        variant: merger('variant'),
        anchorOrigin: merger('anchorOrigin'),
        disableWindowBlurListener: merger('disableWindowBlurListener'),
        autoHideDuration: merger('autoHideDuration'),
        hideIconVariant: merger('hideIconVariant'),
        TransitionComponent: merger('TransitionComponent'),
        transitionDuration: merger('transitionDuration'),
        TransitionProps: merger('TransitionProps', true),
        iconVariant: merger('iconVariant', true),
        style: merger('style', true),
        SnackbarProps: merger('SnackbarProps', true),
        className: clsx(_this.props.className, options.className)
      });

      if (snack.persist) {
        snack.autoHideDuration = undefined;
      }

      _this.setState(function (state) {
        if (preventDuplicate === undefined && _this.props.preventDuplicate || preventDuplicate) {
          var compareFunction = function compareFunction(item) {
            return hasSpecifiedKey ? item.id === id : item.message === message;
          };

          var inQueue = state.queue.findIndex(compareFunction) > -1;
          var inView = state.snacks.findIndex(compareFunction) > -1;

          if (inQueue || inView) {
            return state;
          }
        }

        return _this.handleDisplaySnack(_extends({}, state, {
          queue: [].concat(state.queue, [snack])
        }));
      });

      return id;
    };
    /**
     * Reducer: Display snack if there's space for it. Otherwise, immediately
     * begin dismissing the oldest message to start showing the new one.
     */


    _this.handleDisplaySnack = function (state) {
      var snacks = state.snacks;

      if (snacks.length >= _this.maxSnack) {
        return _this.handleDismissOldest(state);
      }

      return _this.processQueue(state);
    };
    /**
     * Reducer: Display items (notifications) in the queue if there's space for them.
     */


    _this.processQueue = function (state) {
      var queue = state.queue,
          snacks = state.snacks;

      if (queue.length > 0) {
        return _extends({}, state, {
          snacks: [].concat(snacks, [queue[0]]),
          queue: queue.slice(1, queue.length)
        });
      }

      return state;
    };
    /**
     * Reducer: Hide oldest snackbar on the screen because there exists a new one which we have to display.
     * (ignoring the one with 'persist' flag. i.e. explicitly told by user not to get dismissed).
     *
     * Note 1: If there is already a message leaving the screen, no new messages are dismissed.
     * Note 2: If the oldest message has not yet entered the screen, only a request to close the
     *         snackbar is made. Once it entered the screen, it will be immediately dismissed.
     */


    _this.handleDismissOldest = function (state) {
      if (state.snacks.some(function (item) {
        return !item.open || item.requestClose;
      })) {
        return state;
      }

      var popped = false;
      var ignore = false;
      var persistentCount = state.snacks.reduce(function (acc, current) {
        return acc + (current.open && current.persist ? 1 : 0);
      }, 0);

      if (persistentCount === _this.maxSnack) {
        process.env.NODE_ENV !== "production" ? warning('NO_PERSIST_ALL') : void 0;
        ignore = true;
      }

      var snacks = state.snacks.map(function (item) {
        if (!popped && (!item.persist || ignore)) {
          popped = true;

          if (!item.entered) {
            return _extends({}, item, {
              requestClose: true
            });
          }

          if (item.onClose) {
            item.onClose(null, 'maxsnack', item.id);
          }

          if (_this.props.onClose) {
            _this.props.onClose(null, 'maxsnack', item.id);
          }

          return _extends({}, item, {
            open: false
          });
        }

        return _extends({}, item);
      });
      return _extends({}, state, {
        snacks: snacks
      });
    };
    /**
     * Set the entered state of the snackbar with the given key.
     */


    _this.handleEnteredSnack = function (node, isAppearing, key) {
      if (!isDefined(key)) {
        throw new Error('handleEnteredSnack Cannot be called with undefined key');
      }

      _this.setState(function (_ref) {
        var snacks = _ref.snacks;
        return {
          snacks: snacks.map(function (item) {
            return item.id === key ? _extends({}, item, {
              entered: true
            }) : _extends({}, item);
          })
        };
      });
    };
    /**
     * Hide a snackbar after its timeout.
     */


    _this.handleCloseSnack = function (event, reason, key) {
      // should not use createChainedFunction for onClose.
      // because this.closeSnackbar called this function
      if (_this.props.onClose) {
        _this.props.onClose(event, reason, key);
      }

      var shouldCloseAll = key === undefined;

      _this.setState(function (_ref2) {
        var snacks = _ref2.snacks,
            queue = _ref2.queue;
        return {
          snacks: snacks.map(function (item) {
            if (!shouldCloseAll && item.id !== key) {
              return _extends({}, item);
            }

            return item.entered ? _extends({}, item, {
              open: false
            }) : _extends({}, item, {
              requestClose: true
            });
          }),
          queue: queue.filter(function (item) {
            return item.id !== key;
          })
        };
      });
    };
    /**
     * Close snackbar with the given key
     */


    _this.closeSnackbar = function (key) {
      // call individual snackbar onClose callback passed through options parameter
      var toBeClosed = _this.state.snacks.find(function (item) {
        return item.id === key;
      });

      if (isDefined(key) && toBeClosed && toBeClosed.onClose) {
        toBeClosed.onClose(null, 'instructed', key);
      }

      _this.handleCloseSnack(null, 'instructed', key);
    };
    /**
     * When we set open attribute of a snackbar to false (i.e. after we hide a snackbar),
     * it leaves the screen and immediately after leaving animation is done, this method
     * gets called. We remove the hidden snackbar from state and then display notifications
     * waiting in the queue (if any). If after this process the queue is not empty, the
     * oldest message is dismissed.
     */


    _this.handleExitedSnack = function (node, key) {
      if (!isDefined(key)) {
        throw new Error('handleExitedSnack Cannot be called with undefined key');
      }

      _this.setState(function (state) {
        var newState = _this.processQueue(_extends({}, state, {
          snacks: state.snacks.filter(function (item) {
            return item.id !== key;
          })
        }));

        if (newState.queue.length === 0) {
          return newState;
        }

        return _this.handleDismissOldest(newState);
      });
    };

    _this.enqueueSnackbar;
    _this.closeSnackbar;
    _this.state = {
      snacks: [],
      queue: [],
      contextValue: {
        enqueueSnackbar: _this.enqueueSnackbar.bind(_assertThisInitialized(_this)),
        closeSnackbar: _this.closeSnackbar.bind(_assertThisInitialized(_this))
      }
    };
    return _this;
  }

  var _proto = SnackbarProvider.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var contextValue = this.state.contextValue;
    var _this$props = this.props,
        domRoot = _this$props.domRoot,
        children = _this$props.children,
        _this$props$dense = _this$props.dense,
        dense = _this$props$dense === void 0 ? false : _this$props$dense,
        _this$props$Component = _this$props.Components,
        Components = _this$props$Component === void 0 ? {} : _this$props$Component,
        classes = _this$props.classes;
    var categ = this.state.snacks.reduce(function (acc, current) {
      var _extends2;

      var category = originKeyExtractor(current.anchorOrigin);
      var existingOfCategory = acc[category] || [];
      return _extends({}, acc, (_extends2 = {}, _extends2[category] = [].concat(existingOfCategory, [current]), _extends2));
    }, {});
    var snackbars = Object.keys(categ).map(function (origin) {
      var snacks = categ[origin];
      var nomineeSnack = snacks[0];
      return require$$1.createElement(SnackbarContainer$1, {
        key: origin,
        dense: dense,
        anchorOrigin: nomineeSnack.anchorOrigin,
        classes: classes
      }, snacks.map(function (snack) {
        return require$$1.createElement(SnackbarItem, {
          key: snack.id,
          snack: snack,
          classes: classes,
          Component: Components[snack.variant],
          onClose: _this2.handleCloseSnack,
          onEnter: _this2.props.onEnter,
          onExit: _this2.props.onExit,
          onExited: createChainedFunction([_this2.handleExitedSnack, _this2.props.onExited], snack.id),
          onEntered: createChainedFunction([_this2.handleEnteredSnack, _this2.props.onEntered], snack.id)
        });
      }));
    });
    return require$$1.createElement(SnackbarContext$1.Provider, {
      value: contextValue
    }, children, domRoot ? createPortal(snackbars, domRoot) : snackbars);
  };

  _createClass(SnackbarProvider, [{
    key: "maxSnack",
    get: function get() {
      return this.props.maxSnack || defaults.maxSnack;
    }
  }]);

  return SnackbarProvider;
}(Component);

var useSnackbar$1 = (function () {
  return useContext(SnackbarContext$1);
});

var styledStackProps$1 = ['isMobile', 'size', 'verticalButton', 'lightVariant'];
var consumeProps$1 = function consumeProps(propsList) {
  return {
    shouldForwardProp: function shouldForwardProp(prop) {
      return !propsList.includes(prop);
    }
  };
};
var StyledStack$2 = styled$1(Stack, consumeProps$1(styledStackProps$1))({
  padding: "".concat(spacing.inset.xsmall, " ").concat(spacing.inset.medium),
  columnGap: spacing.inline.xxxsmall,
  rowGap: 0,
  boxShadow: PrivateTokens.elevation.vertical.small["box-shadow"]
});
StyledStack$2 = styled$1(StyledStack$2)(function (_ref) {
  var isMobile = _ref.isMobile,
    size = _ref.size;
  return {
    borderRadius: isMobile ? undefined : borders.radius.xsmall,
    maxWidth: isMobile ? '100%' : 'auto',
    width: isMobile ? '100%' : size == 'large' ? '432px' : '328px'
  };
});
StyledStack$2 = styled$1(StyledStack$2)(function (_ref2) {
  var verticalButton = _ref2.verticalButton;
  return {
    flexDirection: verticalButton ? 'column' : 'row',
    alignItems: verticalButton ? 'unset' : 'center',
    justifyContent: verticalButton ? 'center' : 'space-between'
  };
});
StyledStack$2 = styled$1(StyledStack$2)(function (_ref3) {
  var lightVariant = _ref3.lightVariant;
  return {
    backgroundColor: lightVariant ? colors.neutrals.surface : colors.neutrals["surface-container-high"],
    color: lightVariant ? colors.neutrals["on-surface"] : colors.neutrals["on-surface-inverse"]
  };
});
var StyledButton = styled$1(Button, consumeProps$1(['lightVariant']))(function (_ref4) {
  var lightVariant = _ref4.lightVariant;
  return {
    color: lightVariant ? colors.interaction.primary : colors.neutrals["on-surface-inverse"]
  };
});

/**
 * @param {Object} props 
 * @param {string} props.message
 * @param {'positive' | 'alert' | 'negative'} props.variant
 * @param {'large' | 'small'} [props.size] defaults to `'large'`
 * @param {string} [props.buttonLabel] only applicable when `size` is "large"
 * @param {() => void} [props.onButtonClick] callback to handle button click
 * 
 * only applicable when `size` is "large"
 * @param {boolean} [props.verticalButton] defaults to `false`
 * 
 * only applicable when `size` is "large".
 * @param {boolean} [props.lightVariant] defaults to `false`
 * @param {boolean} [props.isMobile] defaults to `false`
 * 
 * @param {React.ForwardedRef<any>} ref
 */
var SnackbarContent = function SnackbarContent(_ref5) {
  var message = _ref5.message,
    variant = _ref5.variant,
    _ref5$size = _ref5.size,
    size = _ref5$size === void 0 ? 'large' : _ref5$size,
    buttonLabel = _ref5.buttonLabel,
    onButtonClick = _ref5.onButtonClick,
    _ref5$verticalButton = _ref5.verticalButton,
    verticalButton = _ref5$verticalButton === void 0 ? false : _ref5$verticalButton,
    _ref5$lightVariant = _ref5.lightVariant,
    lightVariant = _ref5$lightVariant === void 0 ? false : _ref5$lightVariant,
    _ref5$isMobile = _ref5.isMobile,
    isMobile = _ref5$isMobile === void 0 ? false : _ref5$isMobile;
  var isLargeVariant = size == 'large';
  var canRenderButton = isLargeVariant && buttonLabel;
  return /*#__PURE__*/require$$1.createElement(StyledStack$2, {
    size: size,
    verticalButton: verticalButton,
    lightVariant: lightVariant,
    isMobile: isMobile
  }, /*#__PURE__*/require$$1.createElement(IconAndMessage, {
    message: message,
    iconVariant: variant,
    textSize: size
  }), canRenderButton && /*#__PURE__*/require$$1.createElement(StyledButton, {
    lightVariant: lightVariant,
    sx: {
      alignSelf: 'end'
    },
    onClick: onButtonClick,
    size: "small"
  }, buttonLabel));
};
SnackbarContent.propTypes = {
  message: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['positive', 'alert', 'negative']).isRequired,
  size: PropTypes.oneOf(['large', 'small']),
  buttonLabel: PropTypes.string,
  onButtonClick: PropTypes.func,
  verticalButton: PropTypes.bool,
  isMobile: PropTypes.bool
};

/** @param {{iconVariant: 'positive' | 'alert' | 'negative', textSize: 'small' | 'large'}} param0 */
function IconAndMessage(_ref6) {
  var message = _ref6.message,
    iconVariant = _ref6.iconVariant,
    textSize = _ref6.textSize;
  var textVariant = textSize == 'small' ? 'bodyTextMedium' : 'bodyTextLarge';
  return /*#__PURE__*/require$$1.createElement(Stack, {
    direction: "row",
    gap: spacing.inline.xxxsmall
  }, /*#__PURE__*/require$$1.createElement(VariantIcon, {
    variant: iconVariant
  }), /*#__PURE__*/require$$1.createElement(Typography, {
    variant: textVariant,
    color: "inherit"
  }, message));
}

/** @param {{variant: 'positive' | 'alert' | 'negative'}} */
var VariantIcon = function VariantIcon(_ref7) {
  var variant = _ref7.variant;
  switch (variant) {
    case 'positive':
      return /*#__PURE__*/require$$1.createElement(dist.Icon, {
        name: "CircleSuccess",
        size: "medium",
        color: colors.feedback.positive
      });
    case 'alert':
      return /*#__PURE__*/require$$1.createElement(dist.Icon, {
        name: "CircleAlert",
        size: "medium",
        color: colors.feedback.alert
      });
    case 'negative':
      return /*#__PURE__*/require$$1.createElement(dist.Icon, {
        name: "CircleError",
        size: "medium",
        color: colors.feedback.negative
      });
  }
};

var css_248z = ".notistack-SnackbarContainer {\n  left: 0 !important;\n  right: auto !important;\n  bottom: 0 !important;\n  transform: none !important;\n  width: 100% !important;\n  max-width: none !important;\n}\n\n.notistack-SnackbarContainer>div {\n  max-width: 100% !important;\n  display: flex;\n}\n\n.notistack-CollapseWrapper {\n  padding: 0 !important;\n}";
styleInject(css_248z);

/** @typedef {string|number} SnackbarKey */

/** 
 * @typedef {Object} ShowSnackbarProps
 * @property {string} message
 * @property {'positive' | 'alert' | 'negative'} variant
 * @property {'large' | 'small'} [size] defaults to `'large'`
 * @property {string} [buttonLabel] only applicable when `size` is "large"
 * @property {(snackbarKey: SnackbarKey) => void} [onButtonClick] callback to handle button click. Only applicable when `size` is "large"
 * @property {boolean} [verticalButton] defaults to `false`. Only applicable when `size` is "large".
 * @property {boolean} [lightVariant] defaults to `false`
 * @property {boolean} [isMobile] defaults to `false`
 */

/** 
 * @typedef {Object} ShowSnackbarOptions
 * @property {import('notistack').SharedProps['onClose']} [onClose]
 * @property {'top' | 'bottom'} [anchorOrigin] defaults to `bottom` when isMobile, and 'top' when isMobile is false
 * @property {boolean} [preventDuplicate]
 * @property {number} [autoHideDuration]
 */

var SnackbarContext = /*#__PURE__*/createContext({
  isMobile: false,
  lightVariant: false
});
SnackbarContext.displayName = 'SnackbarContext';

/**
 * @param {Object} props 
 * @param {React.ReactNode | React.ReactNode[]} props.children
 * @param {boolean} [props.isMobile] defaults to `false`
 * @param {boolean} [props.lightVariant] defaults to `false`
 */
function SnackbarProvider(props) {
  var isMobile = props.isMobile,
    lightVariant = props.lightVariant;
  return /*#__PURE__*/require$$1.createElement(SnackbarContext.Provider, {
    value: {
      isMobile: isMobile,
      lightVariant: lightVariant
    }
  }, /*#__PURE__*/require$$1.createElement(SnackbarProvider$1, {
    maxSnack: 4
  }, props.children));
}
SnackbarProvider.propTypes = {
  isMobile: PropTypes.bool,
  lightVariant: PropTypes.bool,
  children: PropTypes.node
};

/**
 * Hook for showing and controlling snackbars. Allows showing multiple by stacking.
 */
var useSnackbar = function useSnackbar() {
  var _useNotistackSnackbar = useSnackbar$1(),
    closeSnackbar = _useNotistackSnackbar.closeSnackbar,
    enqueueSnackbar = _useNotistackSnackbar.enqueueSnackbar;
  var ctx = useContext(SnackbarContext);

  /**
   * @param {ShowSnackbarProps} props
   * @param {ShowSnackbarOptions} [options]
   * @returns {SnackbarKey}
   */
  var showSnackbar = function showSnackbar(props, options) {
    var _props$isMobile, _props$lightVariant, _options$anchorOrigin;
    (_props$isMobile = props.isMobile) !== null && _props$isMobile !== void 0 ? _props$isMobile : props.isMobile = ctx.isMobile;
    (_props$lightVariant = props.lightVariant) !== null && _props$lightVariant !== void 0 ? _props$lightVariant : props.lightVariant = ctx.lightVariant;
    return enqueueSnackbar(props.message, {
      preventDuplicate: options === null || options === void 0 ? void 0 : options.preventDuplicate,
      autoHideDuration: options === null || options === void 0 ? void 0 : options.autoHideDuration,
      anchorOrigin: {
        horizontal: props.isMobile ? 'center' : 'right',
        vertical: (_options$anchorOrigin = options === null || options === void 0 ? void 0 : options.anchorOrigin) !== null && _options$anchorOrigin !== void 0 ? _options$anchorOrigin : props.isMobile ? 'bottom' : 'top'
      },
      onClose: options === null || options === void 0 ? void 0 : options.onClose,
      content: function content(key) {
        return /*#__PURE__*/require$$1.createElement(Box, {
          display: "flex",
          width: props.isMobile ? '100vw' : 'auto',
          marginBottom: props.isMobile ? spacing.stack.quark : spacing.stack.xxxsmall,
          marginX: props.isMobile ? 0 : spacing.inset.large
        }, /*#__PURE__*/require$$1.createElement(SnackbarContent, _extends$1({}, props, {
          onButtonClick: function onButtonClick() {
            return props.onButtonClick(key);
          }
        })));
      }
    });
  };
  return {
    /** Cria e mostra um novo snackbar na pilha. */
    showSnackbar: showSnackbar,
    /** 
     * Fecha o Snackbar com o `id` fornecido. Se nenhum id for fornecido, fecha todos abertos. 
     * @type {(key?: SnackbarKey | undefined) => void}
     */
    dismissSnackbar: closeSnackbar
  };
};

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;
var VARIANTS = {
  STATUS: 'status',
  PROMO: 'promo'
};
var StyledStack$1 = styled(Stack)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  flex-direction: row;\n  align-items: center;\n  padding: ", ";\n  border-radius: ", ";\n"])), function (_ref) {
  var variant = _ref.variant;
  return variant === VARIANTS.PROMO ? "".concat(spacing.inset.nano, " ").concat(spacing.inset.xxxsmall, " ").concat(spacing.inset.nano, " ").concat(spacing.inset.nano) : "".concat(spacing.inset.nano, " ").concat(spacing.inset.xxxsmall);
}, borders.radius.nano);
var StyledCircle = styled(Stack)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  border-radius: ", ";\n  background-color: ", ";\n  width: ", ";\n  height: ", ";\n"])), borders.radius.circle, colors.neutrals["on-surface-variant"], function (_ref2) {
  var size = _ref2.size;
  return size === 'small' ? spacing.inset.xxxsmall : spacing.inset.xxsmall;
}, function (_ref3) {
  var size = _ref3.size;
  return size === 'small' ? spacing.inset.xxxsmall : spacing.inset.xxsmall;
});
var StyledNeutralStack = styled(StyledStack$1)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  border: ", " solid ", ";\n"])), borders.width.thin, colors.neutrals.outline);
var StyledPositiveStack = styled(StyledStack$1)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  border: ", " solid ", ";\n  background-color: ", ";\n"])), borders.width.thin, colors.feedback["positive-container"], colors.feedback["positive-container"]);
var StyledNegativeStack = styled(StyledStack$1)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  border: ", " solid ", ";\n  background-color: ", ";\n"])), borders.width.thin, colors.feedback["negative-container"], colors.feedback["negative-container"]);
var StyledAlertStack = styled(StyledStack$1)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  border: ", " solid ", ";\n  background-color: ", ";\n"])), borders.width.thin, colors.feedback["alert-container"], colors.feedback["alert-container"]);
var StyledHighPriorityStack = styled(StyledStack$1)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  border: ", " solid ", ";\n  background-color: ", ";\n"])), borders.width.thin, colors.neutrals['surface-container-high'], colors.neutrals['surface-container-high']);
var StyledPositiveCircle = styled(StyledCircle)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  background-color: ", ";\n"])), colors.feedback.positive);
var StyledNegativeCircle = styled(StyledCircle)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  background-color: ", ";\n"])), colors.feedback.negative);
var variantStyles = {
  status: {
    positive: {
      stackComponent: StyledPositiveStack,
      circleComponent: StyledPositiveCircle
    },
    negative: {
      stackComponent: StyledNegativeStack,
      circleComponent: StyledNegativeCircle
    },
    neutral: {
      stackComponent: StyledNeutralStack,
      circleComponent: StyledCircle
    },
    gap: {
      small: spacing.inline.quark,
      medium: spacing.inline.nano
    }
  },
  promo: {
    alert: {
      high: {
        stackComponent: StyledHighPriorityStack
      },
      medium: {
        stackComponent: StyledAlertStack
      }
    },
    positive: {
      high: {
        stackComponent: StyledHighPriorityStack
      },
      medium: {
        stackComponent: StyledPositiveStack
      }
    },
    gap: {
      small: spacing.inline.quark,
      medium: spacing.inline.quark
    }
  }
};
var Tag = function Tag(_ref4) {
  var label = _ref4.label,
    _ref4$status = _ref4.status,
    status = _ref4$status === void 0 ? 'neutral' : _ref4$status,
    _ref4$iconName = _ref4.iconName,
    iconName = _ref4$iconName === void 0 ? "CheckVerified02" : _ref4$iconName,
    variant = _ref4.variant,
    _ref4$size = _ref4.size,
    size = _ref4$size === void 0 ? 'medium' : _ref4$size,
    _ref4$priority = _ref4.priority,
    priority = _ref4$priority === void 0 ? 'medium' : _ref4$priority;
  var StackComponent, TagIcon;
  var fontSize = size === 'small' ? 'subtitleSmall' : 'subtitleMedium';
  var textColor = priority === 'high' ? colors.neutrals['on-surface-inverse'] : colors.neutrals["on-container"];
  if (variant === VARIANTS.STATUS) {
    var _variantStyles$status;
    var CircleComponent = (_variantStyles$status = variantStyles.status[status]) === null || _variantStyles$status === void 0 ? void 0 : _variantStyles$status.circleComponent;
    TagIcon = /*#__PURE__*/require$$1.createElement(CircleComponent, {
      size: size
    });
    StackComponent = variantStyles[variant][status].stackComponent;
  } else if (variant === VARIANTS.PROMO) {
    TagIcon = /*#__PURE__*/require$$1.createElement(dist.Icon, {
      name: iconName,
      size: size,
      color: status === 'positive' ? colors.feedback.positive : colors.feedback.alert
    });
    StackComponent = variantStyles[variant][status][priority].stackComponent;
  }
  return /*#__PURE__*/require$$1.createElement(StackComponent, {
    variant: variant,
    gap: variantStyles[variant].gap[size]
  }, TagIcon, /*#__PURE__*/require$$1.createElement(Typography, {
    color: textColor,
    variant: fontSize
  }, label));
};
Tag.propTypes = {
  label: PropTypes.string.isRequired,
  variant: PropTypes.string.isRequired,
  status: PropTypes.string,
  iconName: PropTypes.string,
  priority: PropTypes.string,
  size: PropTypes.string
};

function ownKeys$2(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$2(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var DrawerHeader$1 = function DrawerHeader(_ref) {
  var hasBackButton = _ref.hasBackButton,
    hasCloseButton = _ref.hasCloseButton,
    handleClickBack = _ref.handleClickBack,
    handleClickClose = _ref.handleClickClose;
  return /*#__PURE__*/require$$1.createElement(require$$1.Fragment, null, hasCloseButton && /*#__PURE__*/require$$1.createElement(Box, {
    py: spacing.inset.large,
    px: spacing.inset.medium
  }, /*#__PURE__*/require$$1.createElement(IconButton, {
    onClick: handleClickClose
  }, /*#__PURE__*/require$$1.createElement(dist.Icon, {
    name: "ActionClose"
  }))), hasBackButton && /*#__PURE__*/require$$1.createElement(Box, {
    py: spacing.inset.large,
    px: spacing.inset.medium
  }, /*#__PURE__*/require$$1.createElement(IconButton, {
    onClick: handleClickBack
  }, /*#__PURE__*/require$$1.createElement(dist.Icon, {
    name: "ArrowLeft"
  }))));
};
var Drawer$1 = function Drawer(_ref2) {
  var mobile = _ref2.mobile,
    _ref2$open = _ref2.open,
    open = _ref2$open === void 0 ? false : _ref2$open,
    children = _ref2.children,
    _ref2$onClickClose = _ref2.onClickClose,
    onClickClose = _ref2$onClickClose === void 0 ? function () {} : _ref2$onClickClose,
    _ref2$onClickBack = _ref2.onClickBack,
    onClickBack = _ref2$onClickBack === void 0 ? function () {} : _ref2$onClickBack,
    _ref2$backButton = _ref2.backButton,
    backButton = _ref2$backButton === void 0 ? false : _ref2$backButton,
    _ref2$closeButton = _ref2.closeButton,
    closeButton = _ref2$closeButton === void 0 ? true : _ref2$closeButton;
  var _useState = useState(open),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  useEffect(function () {
    setIsOpen(open);
  }, [open]);
  return /*#__PURE__*/require$$1.createElement(MuiDrawer, {
    ModalProps: {
      keepMounted: false
    },
    PaperProps: {
      sx: _objectSpread$2({}, mobile ? {
        width: "100%",
        paddingTop: spacing.stack.xxxsmall
      } : {})
    },
    open: isOpen,
    anchor: "right"
  }, /*#__PURE__*/require$$1.createElement(DrawerHeader$1, {
    handleClickBack: onClickBack,
    hasBackButton: backButton,
    hasCloseButton: closeButton,
    handleClickClose: onClickClose
  }), children);
};
Drawer$1.defaultProps = {
  open: false,
  closeButton: true,
  backButton: false,
  onClickClose: function onClickClose() {},
  onClickBack: function onClickBack() {}
};
Drawer$1.propTypes = {
  open: PropTypes.bool.isRequired,
  mobile: PropTypes.bool.isRequired,
  closeButton: PropTypes.bool,
  backButton: PropTypes.bool,
  children: PropTypes.node.isRequired,
  onClickClose: PropTypes.func,
  onClickBack: PropTypes.func
};

var TIMELINE_VARIANT = "timeline";
var STEPPER_VARIANTS = [TIMELINE_VARIANT];
var StyledActiveIcon = styled("div")(function () {
  return {
    width: "9px",
    height: "9px",
    border: "3px solid ".concat(colors.interaction.primary),
    borderRadius: "50%"
  };
});
var StyledCustomIcon = styled("div")(function () {
  return {
    width: "9px",
    height: "9px",
    border: "3px solid ".concat(colors.neutrals.outline),
    borderRadius: "50%"
  };
});
var StyledMuiStepper = styled(MuiStepper)(function () {
  return {
    paddingTop: spacing.inline.xxsmall,
    "& .MuiStepConnector-root > .MuiStepConnector-lineVertical": {
      display: "none"
    }
  };
});
var StyledStepLabel = styled(StepLabel)(function () {
  return {
    marginLeft: "4.5px",
    padding: "0px",
    marginTop: "20px"
  };
});
var StyledStepLabelContentWrapper = styled(Box$1)(function () {
  return {
    marginLeft: "11px",
    padding: "0px"
  };
});
var StyledStepContentWrapper = styled(Box$1)(function () {
  return {
    marginBottom: spacing.inline.xxsmall,
    marginLeft: "6px",
    padding: "0px"
  };
});
var StyledStepContent = styled(StepContent)(function () {
  return {
    paddingTop: "16px",
    marginLeft: "9px",
    marginTop: "-8px",
    paddingLeft: spacing.inline.xxsmall,
    borderLeft: "1px solid ".concat(colors.neutrals["outline-low"])
  };
});
var TimelineItem = function TimelineItem(_ref) {
  var date = _ref.date,
    title = _ref.title,
    subtitle = _ref.subtitle,
    description = _ref.description,
    _ref$active = _ref.active,
    active = _ref$active === void 0 ? false : _ref$active;
  var CustomIcon = active ? StyledActiveIcon : StyledCustomIcon;
  return /*#__PURE__*/require$$1.createElement(Box$1, {
    sx: {
      marginTop: "-20px"
    }
  }, /*#__PURE__*/require$$1.createElement(StyledStepLabel, {
    StepIconComponent: CustomIcon
  }, /*#__PURE__*/require$$1.createElement(StyledStepLabelContentWrapper, null, /*#__PURE__*/require$$1.createElement(Typography, {
    color: colors.neutrals["on-surface-variant"],
    variant: "overlineSmall"
  }, date))), /*#__PURE__*/require$$1.createElement(StyledStepContent, null, /*#__PURE__*/require$$1.createElement(StyledStepContentWrapper, null, /*#__PURE__*/require$$1.createElement(Typography, {
    pb: spacing.stack.nano,
    variant: "subtitleLarge"
  }, title), subtitle && /*#__PURE__*/require$$1.createElement(Typography, {
    pb: spacing.stack.nano,
    variant: "subtitleMedium"
  }, subtitle), description && /*#__PURE__*/require$$1.createElement(Typography, {
    color: colors.neutrals["on-surface-variant"],
    pb: spacing.stack.nano,
    variant: "bodyTextMedium"
  }, description))));
};
TimelineItem.propTypes = {
  date: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  description: PropTypes.string,
  active: PropTypes.bool.isRequired
};
var Stepper = function Stepper(_ref2) {
  var activeStep = _ref2.activeStep;
    _ref2.variant;
    var _ref2$items = _ref2.items,
    items = _ref2$items === void 0 ? [] : _ref2$items,
    _ref2$pagination = _ref2.pagination,
    pagination = _ref2$pagination === void 0 ? false : _ref2$pagination,
    _ref2$paginationItems = _ref2.paginationItems,
    paginationItems = _ref2$paginationItems === void 0 ? 2 : _ref2$paginationItems;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    paginationOpen = _useState2[0],
    setPaginationOpen = _useState2[1];
  var _useState3 = useState(pagination ? items.slice(0, paginationItems) : items),
    _useState4 = _slicedToArray(_useState3, 2),
    displayedItems = _useState4[0],
    setDisplayedItems = _useState4[1];
  var handleShowMoreClick = function handleShowMoreClick() {
    var newPaginationOpen = !paginationOpen;
    setDisplayedItems(newPaginationOpen ? items : items.slice(0, paginationItems));
    setPaginationOpen(newPaginationOpen);
  };
  return /*#__PURE__*/require$$1.createElement(StyledMuiStepper, {
    activeStep: activeStep,
    orientation: "vertical"
  }, /*#__PURE__*/require$$1.createElement(Box$1, {
    display: "flex",
    flexDirection: "column"
  }, /*#__PURE__*/require$$1.createElement(Box$1, {
    flexGrow: 1,
    overflow: "hidden"
  }, displayedItems.map(function (_ref3, index) {
    var date = _ref3.date,
      title = _ref3.title,
      subtitle = _ref3.subtitle,
      description = _ref3.description;
    return /*#__PURE__*/require$$1.createElement(Step, {
      active: true,
      key: "".concat(title, " ").concat(index)
    }, /*#__PURE__*/require$$1.createElement(TimelineItem, {
      active: activeStep === index,
      date: date,
      title: title,
      subtitle: subtitle,
      description: description
    }));
  })), pagination && /*#__PURE__*/require$$1.createElement(Box$1, {
    px: spacing.inset.xsmall,
    py: spacing.inset.medium,
    justifyContent: "left"
  }, /*#__PURE__*/require$$1.createElement(Button, {
    onClick: handleShowMoreClick,
    endIcon: paginationOpen ? /*#__PURE__*/require$$1.createElement(dist.Icon, {
      name: "ChevronUp"
    }) : /*#__PURE__*/require$$1.createElement(dist.Icon, {
      name: "ChevronDown",
      size: "small"
    }),
    variant: "text"
  }, paginationOpen ? "Mostrar menos" : "Mostrar mais"))));
};
Stepper.propTypes = {
  activeStep: PropTypes.number,
  pagination: PropTypes.bool.isRequired,
  paginationItems: PropTypes.number,
  variant: PropTypes.oneOf(STEPPER_VARIANTS),
  items: PropTypes.arrayOf(PropTypes.shape({
    date: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    description: PropTypes.string
  }))
};

var StyledMuiAccordion = styled(MuiAccordion)(function () {
  return {
    '& .MuiAccordionSummary-content': {
      paddingLeft: spacing.inset.xxxsmall
    },
    '&:not(:last-child)': {
      borderBottom: 0
    },
    '&::before': {
      display: 'none'
    }
  };
});
var StyledAccordionContent = styled(AccordionDetails)(function () {
  return {
    padding: spacing.inset.large
  };
});
var StyledAccordionSummary = styled(AccordionSummary)(function () {
  return {
    padding: spacing.inset.large,
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
      transform: 'rotate(90deg)'
    }
  };
});
var Accordion = function Accordion(_ref) {
  var children = _ref.children,
    title = _ref.title;
    _ref.size;
    _ref.arrow;
    _ref.draggable;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    expanded = _useState2[0],
    setExpanded = _useState2[1];
  var handleChange = function handleChange() {
    var newExpanded = !expanded;
    setExpanded(newExpanded);
  };
  return /*#__PURE__*/require$$1.createElement(StyledMuiAccordion, {
    square: true,
    disableGutters: true,
    elevation: 0,
    expanded: expanded,
    onChange: handleChange
  }, /*#__PURE__*/require$$1.createElement(StyledAccordionSummary, {
    expandIcon: /*#__PURE__*/require$$1.createElement(dist.Icon, {
      name: "ChevronRight",
      size: "small",
      color: colors.neutrals["on-surface"]
    })
  }, /*#__PURE__*/require$$1.createElement(Typography, {
    variant: "subtitleMedium"
  }, title)), /*#__PURE__*/require$$1.createElement(StyledAccordionContent, null, children));
};
Accordion.propTypes = {
  size: PropTypes.oneOf(['medium', 'large']),
  children: PropTypes.node.isRequired,
  arrow: PropTypes.oneOf(['start', 'end']),
  draggable: PropTypes.bool,
  title: PropTypes.string.isRequired
};

var MobileDialog = function MobileDialog(_ref) {
  var children = _ref.children,
    onClose = _ref.onClose,
    open = _ref.open;
  return /*#__PURE__*/require$$1.createElement(MuiDialog, {
    onClose: onClose,
    open: open,
    PaperComponent: function PaperComponent(props) {
      return /*#__PURE__*/require$$1.createElement(Paper, _extends$1({
        style: {
          margin: 0,
          position: "absolute",
          bottom: 0,
          left: 0,
          maxWidth: "100%",
          width: "100%",
          borderTopLeftRadius: borders.radius.xxlarge,
          borderTopRightRadius: borders.radius.xxlarge
        }
      }, props));
    },
    sx: {
      borderRadius: borders.radius.xxlarge
    }
  }, children);
};
var DesktopDialog = function DesktopDialog(_ref2) {
  var children = _ref2.children,
    onClose = _ref2.onClose,
    open = _ref2.open;
  return /*#__PURE__*/require$$1.createElement(MuiDialog, {
    onClose: onClose,
    open: open,
    PaperComponent: function PaperComponent(props) {
      return /*#__PURE__*/require$$1.createElement(Paper, _extends$1({
        style: {
          borderRadius: borders.radius.xxlarge
        }
      }, props));
    }
  }, children);
};
var Dialog = function Dialog(_ref3) {
  var _ref3$mobile = _ref3.mobile,
    mobile = _ref3$mobile === void 0 ? false : _ref3$mobile,
    open = _ref3.open,
    handleClose = _ref3.handleClose,
    children = _ref3.children;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    openDialog = _useState2[0],
    setOpenDialog = _useState2[1];
  var DialogComponent = mobile ? MobileDialog : DesktopDialog;
  useEffect(function () {
    setOpenDialog(open);
  }, [open]);
  return /*#__PURE__*/require$$1.createElement(DialogComponent, {
    open: openDialog,
    onClose: handleClose
  }, /*#__PURE__*/require$$1.createElement(Box, {
    py: spacing.inset.large
  }, /*#__PURE__*/require$$1.createElement(Box, {
    pb: spacing.inline.xxsmall,
    px: spacing.inset.large
  }, /*#__PURE__*/require$$1.createElement(IconButton, {
    onClick: handleClose
  }, /*#__PURE__*/require$$1.createElement(dist.Icon, {
    name: "ActionClose"
  }))), /*#__PURE__*/require$$1.createElement(Box, null, children)));
};
Dialog.propTypes = {
  mobile: PropTypes.bool.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired
};

function ownKeys$1(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var DRAWER_WIDTH_CLOSE = 104;
var DRAWER_WIDTH_OPEN = 368;
var openedMixin = function openedMixin(scopedTheme) {
  return {
    width: DRAWER_WIDTH_OPEN,
    transition: scopedTheme.transitions.create('width', {
      easing: scopedTheme.transitions.easing.sharp,
      duration: scopedTheme.transitions.duration.enteringScreen
    }),
    overflowX: 'hidden'
  };
};
var closedMixin = function closedMixin(scopedTheme) {
  return _defineProperty({
    transition: scopedTheme.transitions.create('width', {
      easing: scopedTheme.transitions.easing.sharp,
      duration: scopedTheme.transitions.duration.leavingScreen
    }),
    overflowX: 'hidden',
    width: DRAWER_WIDTH_CLOSE
  }, scopedTheme.breakpoints.up('sm'), {
    width: DRAWER_WIDTH_CLOSE
  });
};
var DrawerHeader = styled$2('div')(function (ctx) {
  return {
    marginTop: spacing.stack.xxxsmall,
    width: '100%',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: spacing.stack.small
  };
});
var Drawer = styled$2(MuiDrawer, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'open';
  }
})(function (ctx) {
  return _objectSpread$1(_objectSpread$1({
    width: DRAWER_WIDTH_CLOSE,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    borderRight: "1px solid ".concat(colors.neutrals["outline-low"]),
    padding: "".concat(spacing.inset.large, " 0px ").concat(spacing.inset.large, " 0px"),
    backgroundColor: colors.neutrals.surface,
    gap: spacing.stack.small
  }, ctx.open && _objectSpread$1(_objectSpread$1({}, openedMixin(ctx.theme)), {}, {
    '& .MuiDrawer-paper': openedMixin(ctx.theme)
  })), !ctx.open && _objectSpread$1(_objectSpread$1({}, closedMixin(ctx.theme)), {}, {
    '& .MuiDrawer-paper': closedMixin(ctx.theme)
  }));
});
var menuItemHeight = parseInt(dist.icons.size.medium) + parseInt(spacing.inset.xsmall) + parseInt(spacing.inset.xsmall);
var StyledMenuItems = styled$2(MenuItem)(function (_ref2) {
  _ref2.active;
  return {
    fontFamily: typography$1.family.primary,
    textTransform: 'capitalize',
    padding: "".concat(spacing.inset.xsmall, " ").concat(spacing.inset.medium),
    height: menuItemHeight,
    borderRadius: borders.radius.small,
    transitionDelay: "0.1s"
  };
});
var StyledMenuItem = styled$2(StyledMenuItems)(function (_ref3) {
  var active = _ref3.active;
  return {
    fontSize: active ? PrivateTokens.menu.font.large["font-size"] : PrivateTokens.menu.font.medium["font-size"],
    lineHeight: active ? PrivateTokens.menu.font.large["line-height"] : PrivateTokens.menu.font.medium["line-height"],
    fontWeight: active ? PrivateTokens.menu.font.large["font-weight"] : PrivateTokens.menu.font.medium["font-weight"],
    color: active ? colors.interaction["primary"] : colors.neutrals["on-surface-variant"],
    backgroundColor: active ? colors.interaction["primary-container"] : colors.neutrals["surface"],
    "&:hover": {
      fontSize: PrivateTokens.menu.font.large["font-size"],
      lineHeight: PrivateTokens.menu.font.large["line-height"],
      fontWeight: PrivateTokens.menu.font.large["font-weight"],
      color: active ? colors.interaction["primary"] : colors.neutrals["on-surface-variant"],
      backgroundColor: active ? colors.interaction["primary-container"] : colors.neutrals["outline-low"],
      "& svg": {
        color: active ? colors.interaction["primary"] : colors.neutrals["on-surface"]
      }
    },
    "& svg": {
      color: active ? colors.interaction["primary"] : colors.neutrals["on-surface-variant"]
    }
  };
});
var StyledExpandabledMenuItem = styled$2(StyledMenuItems)(function () {
  return {
    fontSize: PrivateTokens.menu.font.medium["font-size"],
    lineHeight: PrivateTokens.menu.font.medium["line-height"],
    fontWeight: PrivateTokens.menu.font.medium["font-weight"],
    color: colors.interaction["primary"],
    "&:hover": {
      fontSize: PrivateTokens.menu.font.medium["font-size"],
      lineHeight: PrivateTokens.menu.font.medium["line-height"],
      fontWeight: PrivateTokens.menu.font.medium["font-weight"],
      color: colors.interaction["primary"],
      backgroundColor: colors.interaction["primary-container"],
      "& svg": {
        color: colors.interaction["primary"]
      }
    },
    "& svg": {
      color: colors.interaction["primary"]
    }
  };
});
var StyledMenuList = styled$2(List)(function () {
  return {
    padding: "0px"
  };
});
var StyledContentBox = styled$2(Box)({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: spacing.inline.xxxsmall,
  width: '100%'
});
var StyledIconBox = styled$2(Box)({
  display: "flex",
  alignItems: "center",
  alignSelf: 'stretch',
  justifyContent: "end"
});
var StyledStack = styled$2(Stack)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'start',
  alignSelf: 'stretch',
  padding: "0px ".concat(spacing.inset.large, " 0px ").concat(spacing.inset.large, " "),
  border: "0px 1px 0px 0px",
  opacity: "0px",
  color: colors.neutrals.surface
});
var MenuItems = function MenuItems(_ref4) {
  var menuItem = _ref4.menuItem,
    openDrawer = _ref4.openDrawer,
    handleItemClick = _ref4.handleItemClick,
    selectedValue = _ref4.selectedValue;
  return /*#__PURE__*/require$$1.createElement(StyledMenuItem, {
    key: menuItem.value,
    disableRipple: true,
    active: selectedValue === menuItem.value,
    onClick: function onClick() {
      handleItemClick(menuItem);
    }
  }, /*#__PURE__*/require$$1.createElement(StyledContentBox, null, /*#__PURE__*/require$$1.createElement(Stack, null, /*#__PURE__*/require$$1.createElement(dist.Icon, {
    name: menuItem.icon,
    size: "medium"
  })), /*#__PURE__*/require$$1.createElement(Stack, {
    sx: _objectSpread$1({}, !openDrawer && {
      display: 'none'
    })
  }, menuItem.label)));
};
var ExpandableMenuItems = function ExpandableMenuItems(_ref5) {
  var menuItem = _ref5.menuItem,
    openDrawer = _ref5.openDrawer,
    handleItemClick = _ref5.handleItemClick,
    selectedValue = _ref5.selectedValue;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var handleOpenSubMenu = function handleOpenSubMenu() {
    setOpen(!open);
  };
  useEffect(function () {
    if (selectedValue === menuItem.value) {
      setOpen(true);
    } else if (open) {
      setOpen(false);
    }
  }, [selectedValue]);
  return /*#__PURE__*/require$$1.createElement("div", {
    component: "nav"
  }, /*#__PURE__*/require$$1.createElement(StyledMenuItem, {
    key: menuItem.value,
    disableRipple: true,
    active: open || selectedValue === menuItem.value,
    onClick: function onClick() {
      handleOpenSubMenu();
    }
  }, /*#__PURE__*/require$$1.createElement(StyledContentBox, null, /*#__PURE__*/require$$1.createElement(Stack, null, /*#__PURE__*/require$$1.createElement(dist.Icon, {
    name: menuItem.icon,
    size: "medium"
  })), /*#__PURE__*/require$$1.createElement(Stack, {
    sx: _objectSpread$1({}, !openDrawer && {
      display: 'none'
    })
  }, menuItem.label)), /*#__PURE__*/require$$1.createElement(StyledIconBox, {
    sx: _objectSpread$1({}, !openDrawer && {
      display: 'none'
    })
  }, open && openDrawer ? /*#__PURE__*/require$$1.createElement(dist.Icon, {
    name: "ChevronDown",
    size: "small"
  }) : /*#__PURE__*/require$$1.createElement(dist.Icon, {
    name: "ChevronRight",
    size: "small"
  }))), /*#__PURE__*/require$$1.createElement(Collapse$1, {
    "in": open && openDrawer,
    timeout: "auto",
    unmountOnExit: true
  }, /*#__PURE__*/require$$1.createElement(List, {
    component: "div",
    disablePadding: true
  }, menuItem.subMenu.map(function (item) {
    return /*#__PURE__*/require$$1.createElement(StyledExpandabledMenuItem, {
      sx: {
        pl: 4
      },
      key: item.value,
      disableRipple: true,
      onClick: function onClick() {
        return handleItemClick(item);
      }
    }, /*#__PURE__*/require$$1.createElement(StyledContentBox, null, /*#__PURE__*/require$$1.createElement(Stack, null, /*#__PURE__*/require$$1.createElement(dist.Icon, {
      name: item.icon,
      size: "medium"
    })), /*#__PURE__*/require$$1.createElement(Stack, {
      sx: _objectSpread$1({}, !openDrawer && {
        display: 'none'
      })
    }, item.label)));
  }))));
};
var SideBarMenuList = function SideBarMenuList(_ref6) {
  var _ref6$menuList = _ref6.menuList,
    menuList = _ref6$menuList === void 0 ? [] : _ref6$menuList,
    _ref6$openDrawer = _ref6.openDrawer,
    openDrawer = _ref6$openDrawer === void 0 ? false : _ref6$openDrawer,
    _ref6$selectedValue = _ref6.selectedValue,
    selectedValue = _ref6$selectedValue === void 0 ? {} : _ref6$selectedValue,
    _ref6$onSelectItem = _ref6.onSelectItem,
    onSelectItem = _ref6$onSelectItem === void 0 ? function () {} : _ref6$onSelectItem;
  var handleItemClick = function handleItemClick(item) {
    if (onSelectItem) {
      onSelectItem(item.value);
    }
  };
  var hasSubMenu = function hasSubMenu(item) {
    return Array.isArray(item.subMenu) && item.subMenu.length > 0;
  };
  var createList = function createList(menuList) {
    var menu = [];
    menuList.map(function (menuItem) {
      if (hasSubMenu(menuItem)) {
        menu.push( /*#__PURE__*/require$$1.createElement(ExpandableMenuItems, {
          menuItem: menuItem,
          openDrawer: openDrawer,
          handleItemClick: handleItemClick,
          selectedValue: selectedValue,
          key: menuItem.label
        }));
      } else {
        menu.push( /*#__PURE__*/require$$1.createElement(MenuItems, {
          menuItem: menuItem,
          openDrawer: openDrawer,
          handleItemClick: handleItemClick,
          selectedValue: selectedValue,
          key: menuItem.label
        }));
      }
    });
    return menu.concat();
  };
  return /*#__PURE__*/require$$1.createElement(require$$1.Fragment, null, menuList && menuList.length > 0 && /*#__PURE__*/require$$1.createElement(StyledStack, null, /*#__PURE__*/require$$1.createElement(StyledMenuList, {
    sx: {
      width: '100%'
    },
    component: "nav",
    "aria-labelledby": "sidebar-menu"
  }, createList(menuList))));
};
var Brand = function Brand(_ref7) {
  var path = _ref7.path;
  return /*#__PURE__*/require$$1.createElement(Box, {
    sx: {
      display: 'flex',
      justifyContent: 'center',
      alignSelf: 'center',
      padding: spacing.inset.xxxsmall
    }
  }, /*#__PURE__*/require$$1.createElement(Avatar, {
    size: "large",
    src: path
  }));
};
var StyledBoxDiagonalLine = styled$2(Box)({
  width: "1px",
  height: "24px",
  marginLeft: "10px",
  marginRight: "10px",
  alignSelf: "center",
  transform: "rotate(30deg)",
  backgroundColor: colors.interaction["secondary-container-alpha"]
});
var StyledTypographyProductName = styled$2(Typography)({
  fontFamily: typography$1.family.primary,
  color: colors.neutrals['on-surface-variant'],
  fontSize: typography$1.heading.small["font-size"],
  fontWeight: typography$1.subtitle.large["font-weight"],
  lineHeight: typography$1.heading.small["line-height"],
  letterSpacing: '0.15px',
  textTransform: 'capitalize'
});
var ProductName = function ProductName(_ref8) {
  var openDrawer = _ref8.openDrawer,
    productName = _ref8.productName,
    showProductName = _ref8.showProductName;
  return /*#__PURE__*/require$$1.createElement(require$$1.Fragment, null, showProductName && /*#__PURE__*/require$$1.createElement(Box, {
    sx: _objectSpread$1({
      display: 'flex',
      justifyContent: 'center',
      alignSelf: 'center'
    }, !openDrawer && {
      display: 'none'
    })
  }, /*#__PURE__*/require$$1.createElement(StyledBoxDiagonalLine, null), /*#__PURE__*/require$$1.createElement(Box, {
    paddingLeft: spacing.inset.xxsmall,
    paddingRight: spacing.inset.xxsmall
  }, /*#__PURE__*/require$$1.createElement(StyledTypographyProductName, null, productName))));
};
var menuAvatarProps = {
  paper: {
    elevation: 0,
    sx: {
      overflow: 'visible',
      filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
      mt: 1.5,
      '& .MuiAvatar-root': {
        width: 32,
        height: 32,
        ml: -0.5,
        mr: 1
      },
      '&:before': {
        content: '""',
        display: 'block',
        position: 'absolute',
        top: 0,
        right: 14,
        width: 10,
        height: 10,
        bgcolor: 'background.paper',
        transform: 'translateY(-50%) rotate(45deg)',
        zIndex: 0
      }
    }
  }
};
var AvatarUSer = function AvatarUSer(_ref9) {
  var openDrawer = _ref9.openDrawer,
    imgAvatar = _ref9.imgAvatar,
    menuAvatar = _ref9.menuAvatar,
    showAvatar = _ref9.showAvatar,
    anchorElUser = _ref9.anchorElUser,
    handleOpenUserMenu = _ref9.handleOpenUserMenu,
    handleCloseUserMenu = _ref9.handleCloseUserMenu;
  var hasMenuAvatar = menuAvatar && menuAvatar.length > 0;
  return /*#__PURE__*/require$$1.createElement(require$$1.Fragment, null, showAvatar && /*#__PURE__*/require$$1.createElement(Box, {
    sx: _objectSpread$1({
      display: 'flex',
      justifyContent: 'center',
      alignSelf: 'center'
    }, !openDrawer && {
      display: 'none'
    })
  }, /*#__PURE__*/require$$1.createElement(IconButton, {
    onClick: handleOpenUserMenu,
    sx: {
      padding: 0
    }
  }, /*#__PURE__*/require$$1.createElement(Avatar, {
    size: "medium",
    src: imgAvatar
  })), hasMenuAvatar && /*#__PURE__*/require$$1.createElement(Menu, {
    id: "menu-avatar",
    anchorEl: anchorElUser,
    keepMounted: true,
    open: Boolean(anchorElUser),
    onClose: handleCloseUserMenu,
    slotProps: menuAvatarProps,
    transformOrigin: {
      horizontal: 'right',
      vertical: 'top'
    },
    anchorOrigin: {
      horizontal: 'right',
      vertical: 'bottom'
    }
  }, menuAvatar.map(function (item) {
    return /*#__PURE__*/require$$1.createElement(MenuItem, {
      component: "a",
      key: "menu-avatar ".concat(item.value, " ").concat(item.label),
      href: item.path,
      onClick: handleCloseUserMenu
    }, /*#__PURE__*/require$$1.createElement(ListItemIcon, null, /*#__PURE__*/require$$1.createElement(dist.Icon, {
      name: item.icon,
      size: 'small'
    })), item.label);
  }))));
};
var SideBarHead = function SideBarHead(_ref10) {
  var openDrawer = _ref10.openDrawer,
    imgBrand = _ref10.imgBrand,
    productName = _ref10.productName,
    showProductName = _ref10.showProductName,
    showAvatar = _ref10.showAvatar,
    imgAvatar = _ref10.imgAvatar,
    menuAvatar = _ref10.menuAvatar,
    anchorElUser = _ref10.anchorElUser,
    handleOpenUserMenu = _ref10.handleOpenUserMenu,
    handleCloseUserMenu = _ref10.handleCloseUserMenu;
  return /*#__PURE__*/require$$1.createElement(DrawerHeader, null, /*#__PURE__*/require$$1.createElement(Box, {
    sx: {
      display: 'flex',
      paddingLeft: spacing.inset.large,
      paddingRight: spacing.inset.large
    }
  }, /*#__PURE__*/require$$1.createElement(Box, {
    sx: {
      width: '100%',
      display: 'flex',
      justifyContent: 'start'
    }
  }, /*#__PURE__*/require$$1.createElement(Brand, {
    path: imgBrand
  }), /*#__PURE__*/require$$1.createElement(ProductName, {
    openDrawer: openDrawer,
    showProductName: showProductName,
    productName: productName
  })), /*#__PURE__*/require$$1.createElement(Box, {
    sx: {
      width: '100%',
      display: 'flex',
      justifyContent: 'end'
    }
  }, /*#__PURE__*/require$$1.createElement(AvatarUSer, {
    openDrawer: openDrawer,
    imgAvatar: imgAvatar,
    menuAvatar: menuAvatar,
    showAvatar: showAvatar,
    anchorElUser: anchorElUser,
    handleOpenUserMenu: handleOpenUserMenu,
    handleCloseUserMenu: handleCloseUserMenu
  }))));
};
var StyledTypographyVersion = styled$2(Typography)({
  alignSelf: 'stretch',
  color: colors.neutrals['on-surface-variant'],
  fontFamily: typography$1.family.primary,
  fontSize: PrivateTokens.minimal.font.small["font-size"],
  lineHeight: PrivateTokens.minimal.font.small["line-height"]
});
var StyledTypographyVersionLetter = styled$2(StyledTypographyVersion)({
  fontWeight: typography$1.heading.small["font-weight"]
});
var StyledTypographyVersionNumber = styled$2(StyledTypographyVersion)({
  fontWeight: typography$1.heading.large["font-weight"]
});
var SideBarVersion = function SideBarVersion(_ref11) {
  var version = _ref11.version,
    showVersion = _ref11.showVersion;
  return /*#__PURE__*/require$$1.createElement(require$$1.Fragment, null, showVersion && /*#__PURE__*/require$$1.createElement(Box, {
    height: "47px",
    width: "100%",
    paddingRight: spacing.inset.large,
    marginBottom: spacing.stack.xxxsmall,
    sx: {
      display: '-webkit-inline-box',
      justifyContent: 'end',
      alignSelf: 'end',
      alignItems: 'end'
    }
  }, /*#__PURE__*/require$$1.createElement(Stack, {
    direction: "row",
    gap: spacing.stack.quark
  }, /*#__PURE__*/require$$1.createElement(StyledTypographyVersionLetter, null, /*#__PURE__*/require$$1.createElement("em", null, "v")), /*#__PURE__*/require$$1.createElement(StyledTypographyVersionNumber, null, /*#__PURE__*/require$$1.createElement("em", null, version)))));
};
var Sidebar = function Sidebar(_ref12) {
  var _ref12$imgBrand = _ref12.imgBrand,
    imgBrand = _ref12$imgBrand === void 0 ? "" : _ref12$imgBrand,
    _ref12$imgAvatar = _ref12.imgAvatar,
    imgAvatar = _ref12$imgAvatar === void 0 ? "" : _ref12$imgAvatar,
    _ref12$menuAvatar = _ref12.menuAvatar,
    menuAvatar = _ref12$menuAvatar === void 0 ? null : _ref12$menuAvatar,
    _ref12$showAvatar = _ref12.showAvatar,
    showAvatar = _ref12$showAvatar === void 0 ? false : _ref12$showAvatar,
    _ref12$productName = _ref12.productName,
    productName = _ref12$productName === void 0 ? "Product" : _ref12$productName,
    _ref12$showProductNam = _ref12.showProductName,
    showProductName = _ref12$showProductNam === void 0 ? true : _ref12$showProductNam,
    _ref12$menuList = _ref12.menuList,
    menuList = _ref12$menuList === void 0 ? null : _ref12$menuList,
    _ref12$selectedValue = _ref12.selectedValue,
    selectedValue = _ref12$selectedValue === void 0 ? 0 : _ref12$selectedValue,
    _ref12$onSelectItem = _ref12.onSelectItem,
    onSelectItem = _ref12$onSelectItem === void 0 ? function () {} : _ref12$onSelectItem,
    _ref12$version = _ref12.version,
    version = _ref12$version === void 0 ? "1.0" : _ref12$version,
    _ref12$showVersion = _ref12.showVersion,
    showVersion = _ref12$showVersion === void 0 ? true : _ref12$showVersion;
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    openDrawer = _useState4[0],
    setOpenDrawer = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    anchorElUser = _useState6[0],
    setAnchorElUser = _useState6[1];
  var handleOpenUserMenu = function handleOpenUserMenu(event) {
    setAnchorElUser(event.currentTarget);
  };
  var handleCloseUserMenu = function handleCloseUserMenu() {
    setAnchorElUser(null);
  };
  var handleDrawerOpen = function handleDrawerOpen() {
    setOpenDrawer(true);
  };
  var handleDrawerClose = function handleDrawerClose() {
    setOpenDrawer(false);
  };
  return /*#__PURE__*/require$$1.createElement(Box, null, /*#__PURE__*/require$$1.createElement(Drawer, {
    open: openDrawer,
    onMouseOver: handleDrawerOpen,
    onMouseOut: handleDrawerClose,
    variant: "permanent",
    sx: {
      p: 0
    }
  }, /*#__PURE__*/require$$1.createElement(Stack, {
    display: "flex",
    width: "100%",
    height: "100%",
    sx: {
      gap: spacing.stack.small
    }
  }, /*#__PURE__*/require$$1.createElement(SideBarHead, {
    openDrawer: openDrawer,
    imgBrand: imgBrand,
    productName: productName,
    showProductName: showProductName,
    imgAvatar: imgAvatar,
    menuAvatar: menuAvatar,
    showAvatar: showAvatar,
    anchorElUser: anchorElUser,
    handleOpenUserMenu: handleOpenUserMenu,
    handleCloseUserMenu: handleCloseUserMenu
  }), /*#__PURE__*/require$$1.createElement(SideBarMenuList, {
    openDrawer: openDrawer,
    menuList: menuList,
    selectedValue: selectedValue,
    onSelectItem: onSelectItem
  })), /*#__PURE__*/require$$1.createElement(SideBarVersion, {
    version: version,
    showVersion: showVersion
  })));
};
Sidebar.propTypes = {
  imgBrand: PropTypes.string,
  imgAvatar: PropTypes.string,
  menuAvatar: PropTypes.array,
  showAvatar: PropTypes.bool,
  productName: PropTypes.string,
  showProductName: PropTypes.bool,
  menuList: PropTypes.array,
  selectedValue: PropTypes.number,
  onSelectItem: PropTypes.func,
  version: PropTypes.string,
  showVersion: PropTypes.bool
};

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var styledStackProps = ['selected', 'divisor'];
var consumeProps = function consumeProps(propsList) {
  return {
    shouldForwardProp: function shouldForwardProp(prop) {
      return !propsList.includes(prop);
    }
  };
};
var StyledBreadcrumbItem = styled('li', consumeProps(styledStackProps))(function (_ref) {
  var selected = _ref.selected;
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "40px",
    padding: "0 ".concat(spacing.inset.xxsmall, " 0 ").concat(spacing.inset.xxsmall),
    gap: spacing.inline.nano,
    borderRadius: borders.radius.xsmall,
    fontFamily: '"Montserrat", sans-serif !important',
    fontSize: "14px",
    fontWeight: "500",
    lineHeight: "16px",
    letterSpacing: "0em",
    textAlign: "left",
    cursor: "pointer",
    transition: "background-color 0.5s ease",
    "&:hover": {
      background: colors.neutrals["surface-container"]
    },
    color: "".concat(selected ? colors.interaction.primary : colors.interaction["on-secondary"], " !important"),
    background: selected ? colors.interaction["primary-container-alpha"] : "transparent"
  };
});
var StyledTypography = styled(Typography)(function () {
  return {
    fontFamily: '"Montserrat", sans-serif !important',
    fontSize: "14px",
    fontWeight: "500",
    lineHeight: "16px",
    letterSpacing: "0em",
    textAlign: "left"
  };
});
var StyledBreadcrumbsContainer = styled('div', consumeProps(styledStackProps))(function (_ref2) {
  var divisor = _ref2.divisor;
  return _objectSpread({
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    padding: "".concat(spacing.inset.xxsmall, " 0 ").concat(spacing.inset.xxsmall, " 0"),
    gap: spacing.inline.xxxsmall
  }, divisor ? {
    borderWidth: '1px 0px 1px 0px',
    borderStyle: 'solid',
    borderColor: colors.neutrals["outline-low"]
  } : {});
});
var StyledLink = styled(Link$1, consumeProps(styledStackProps))(function (_ref3) {
  var selected = _ref3.selected;
  return {
    display: "flex",
    alignItems: "center",
    gap: spacing.inline.nano,
    textDecoration: "none !important",
    underline: "none !important",
    color: selected ? "".concat(colors.interaction.primary, " !important") : "".concat(colors.interaction["on-secondary"], " !important")
  };
});
var StyledIcon = styled(dist.Icon)({
  marginRight: spacing.inline.nano
});
var Slash = styled.span({
  color: colors.neutrals.outline,
  fontSize: '18px',
  userSelect: 'none',
  cursor: 'default'
});

/**
 * Breadcrumbs component for hierarchical navigation.
 * @param {object} props - Component props.
 * @param {{href: string, icon: string,label: string}[]} props.items - List of breadcrumb items.
 * @param {boolean} [props.action=false] -(default to false) Indicates whether to display an action button.
 * @param {string} [props.actionIconName=''] -(default to '') Name of the action icon (loggi lib icons).
 * @param {Function} props.onActionClick - Callback function for clicking the action.
 * @param {Function} props.onItemClick - Callback function for clicking on a breadcrumb item.
 * @param {Function} props.selectedCondition - Function to determine if an item is selected.
 * @param {boolean} [props.divisor=false] -(default to false) Indicates whether to display a divider between items.
 * @returns {JSX.Element} Breadcrumbs component.
 */
var Breadcrumbs = function Breadcrumbs(_ref4) {
  var _ref4$items = _ref4.items,
    items = _ref4$items === void 0 ? [] : _ref4$items,
    _ref4$action = _ref4.action,
    action = _ref4$action === void 0 ? false : _ref4$action,
    _ref4$actionIconName = _ref4.actionIconName,
    actionIconName = _ref4$actionIconName === void 0 ? '' : _ref4$actionIconName,
    _ref4$onActionClick = _ref4.onActionClick,
    onActionClick = _ref4$onActionClick === void 0 ? function () {
      return false;
    } : _ref4$onActionClick,
    _ref4$onItemClick = _ref4.onItemClick,
    onItemClick = _ref4$onItemClick === void 0 ? function () {
      return false;
    } : _ref4$onItemClick,
    _ref4$selectedConditi = _ref4.selectedCondition,
    selectedCondition = _ref4$selectedConditi === void 0 ? function () {
      return false;
    } : _ref4$selectedConditi,
    _ref4$divisor = _ref4.divisor,
    divisor = _ref4$divisor === void 0 ? false : _ref4$divisor;
  return /*#__PURE__*/require$$1.createElement(StyledBreadcrumbsContainer, {
    divisor: divisor
  }, action && actionIconName && /*#__PURE__*/require$$1.createElement(IconButton, {
    variant: "blank",
    size: "small",
    color: "secondary",
    onClick: onActionClick
  }, /*#__PURE__*/require$$1.createElement(dist.Icon, {
    name: actionIconName,
    size: "small"
  })), items.map(function (item, index) {
    var selected = selectedCondition(index);
    return /*#__PURE__*/require$$1.createElement(require$$1.Fragment, {
      key: index
    }, /*#__PURE__*/require$$1.createElement(StyledBreadcrumbItem, {
      key: index,
      selected: selected,
      onClick: function onClick() {
        return onItemClick(index);
      }
    }, item.icon && /*#__PURE__*/require$$1.createElement(StyledIcon, {
      name: item.icon,
      size: "small",
      color: selected ? colors.interaction.primary : colors.neutrals["on-surface"]
    }), item.href ? /*#__PURE__*/require$$1.createElement(StyledLink, {
      selected: selected,
      href: item.href
    }, item.label) : /*#__PURE__*/require$$1.createElement(StyledTypography, {
      color: selected ? colors.interaction.primary : colors.neutrals["on-surface"]
    }, item.label)), index < items.length - 1 && /*#__PURE__*/require$$1.createElement(Slash, null, "/"));
  }));
};
Breadcrumbs.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    icon: PropTypes.string,
    label: PropTypes.string.isRequired,
    href: PropTypes.string
  })).isRequired,
  action: PropTypes.bool,
  actionIconName: PropTypes.string,
  selectedCondition: PropTypes.func.isRequired,
  divisor: PropTypes.bool,
  onActionClick: PropTypes.func.isRequired,
  onItemClick: PropTypes.func.isRequired
};

export { Accordion, AppBar, Breadcrumbs, Chip, Dialog, Drawer$1 as Drawer, ListItem, MenuDropdown, MenuShortcut, MenuShortcutTrailItem, Search, Sidebar, SnackbarContent, SnackbarProvider, Stepper, Tag, loggiDesignSystem, useSnackbar };
//# sourceMappingURL=index.js.map
